/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-self-assign */
/* eslint-disable no-control-regex */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/accessible-emoji */
// ════════════════════════════════════════════════════════════════
// SelfAssessment.jsx — GSA Rewrite (Chat Container)
//
// Shell: app shell (header, progress, chat area, input bar),
//        conversationHistory accumulator, step router,
//        QnA strip system, input bar routing
// Screens: Intro → ProblemArea → PainLocation →
//          SafetyScreening → CPG → Subtype → SelfAssessmentQ2 →
//          PreNPRS → TestIntro → MovementTest1 →
//          SelfReportROM → SelfReportTempo → RPE → FeelAffect →
//          Feedback2 → Personalize → Plan
// Cross-cutting: ExitHandler, InactivityModal, HardStop
// Imported screens: PainLocationScreen, SafetyScreeningScreen
// ════════════════════════════════════════════════════════════════

import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useAssessment } from "./assessmentState";
import { useScreenVoice } from "./useScreenVoice";
import { generatePayloadForScreen, parseDataAfterInfo, buildBucketState, buildPersonalizeState, buildMovementBucket, lowestEmptyMovementField, PLAN_GROUP1_BUBBLE_1_FALLBACK, PLAN_GROUP1_BUBBLE_2_FALLBACK, PLAN_GROUP2_CLOSING, PLAN_GROUP3_BUBBLE_1_FALLBACK, PLAN_GROUP3_BUBBLE_2_FALLBACK, PLAN_PRICING_BUBBLE, PLAN_PRICING_INTRO_FALLBACK, PLAN_PRICING_TIERS_FALLBACK, PLAN_PRICING_PROMO_FALLBACK } from "./generatePayloadForScreen";
import { QnAOverlay } from "./screens/QnAOverlay";
import { INPUT_PLACEHOLDERS, LBP_STARTERS, PROBLEM_AREA_STARTERS, MYRA_MESSAGES, resolveMessage, emphasizeReadyToMoveOn } from "./GSA_MYRA_MESSAGES";
import * as CONST from "./GSA_CONSTANTS";
import PainLocationScreen from "./screens/PainLocationScreen";
import SafetyScreeningScreen from "./screens/SafetyScreeningScreen";
import QuestionnaireScreen, { getAccessQuestionnaireConfig, QUESTIONNAIRE_FALLBACK_MSGS, ConsentScreen } from "./screens/QuestionnaireScreen";
import qStyles from "./screens/QuestionnaireScreen.module.css";
import styles from "./SelfAssessment.module.css";
import styles2 from "./HomeScreen.module.css";
import { AnalyticsService } from "./analytics/AnalyticsService";
import MyraInteraction from "./MyraInteractionController";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd";
import MyraChatService from "../voice-agent/MyraChatService";
import { CustomHeader } from "./screens/HomeScreen";
import { useHistory, useLocation } from "react-router-dom";
import { IS_VOICE_ENABLED } from "./CONSTANTS";

// ════════════════════════════════════════════════════════════════
// UTILITY CLASSES
// ════════════════════════════════════════════════════════════════

function requestFlutterLogoutForAssessmentStart() {
  if (typeof window.logoutUser !== "function") return;

  try {
    window.logoutUser();
  } catch (e) {
    console.warn("Unable to logout Flutter user before assessment start", e);
  }
}

class TimeTracker {
  constructor() {
    this.landingStartTime = null;
    this.gsaStartTime = null;
  }

  // Call this when landing page loads
  startLandingTimer() {
    this.landingStartTime = Date.now();
    console.log("Landing timer started");
  }

  // Call this when user clicks "Start GSA"
  startGSATimer() {
    this.gsaStartTime = Date.now();
    console.log("GSA timer started");

    // Also calculate time spent on landing
    if (this.landingStartTime) {
      const landingDurationSec = Math.round((this.gsaStartTime - this.landingStartTime) / 1000);
      return {
        gsaStartedAt: new Date().toISOString(),
        timeOnLandingSec: landingDurationSec,
      };
    }

    return {
      gsaStartedAt: new Date().toISOString(),
      timeOnLandingSec: null,
    };
  }

  // Call this on each screen to get updated GSA duration
  getGSADuration() {
    if (!this.gsaStartTime) return null;
    return Math.round((Date.now() - this.gsaStartTime) / 1000);
  }
  getLandingDuration() {
    if (!this.landingStartTime) return null;
    return Math.round((Date.now() - this.landingStartTime) / 1000);
  }

  // Reset all timers (when user restarts)
  reset() {
    this.landingStartTime = null;
    this.gsaStartTime = null;
  }
}

class ScreenFlowTracker {
  constructor(initialFlow = []) {
    this._flow = Array.isArray(initialFlow) ? [...initialFlow] : [];
    this._current = null;
  }
  enterScreen(name) {
    this._current = { screen: name, enter: Date.now() };
  }
  exitScreen(name, meta = {}) {
    if (this._current) {
      this._current.exit = Date.now();
      this._current.duration = this._current.exit - this._current.enter;
      Object.assign(this._current, meta);
      this._flow.push(this._current);
      this._current = null;
    }
  }
  recordEvent(screenName, event, value = null) {
    const target = this._current?.screen === screenName ? this._current : [...this._flow].reverse().find((screen) => screen.screen === screenName);
    if (!target || !event) return null;
    if (!Array.isArray(target.events)) target.events = [];
    const entry = { event, timestamp: new Date().toISOString() };
    if (value !== undefined && value !== null) entry.value = value;
    target.events.push(entry);
    return entry;
  }
  getScreenFlow() {
    if (!this._current) return this._flow;
    const now = Date.now();
    return [
      ...this._flow,
      {
        ...this._current,
        exit: now,
        duration: now - this._current.enter,
      },
    ];
  }
}

// ════════════════════════════════════════════════════════════════
// SHELL CONSTANTS & HELPERS
// ════════════════════════════════════════════════════════════════

const SCREEN_HEADINGS = MYRA_MESSAGES.screenHeadings;

// Max user path is 17 screens. Each visited screen has an `order` (1–17).
// Progress is derived: (order / 17) × 100.
// Screens skipped by the user (e.g., self_assessment for non-LBP) cause
// natural jumps because the next screen visited has a higher order.
const MAX_SCREEN_COUNT = 17;
const orderToProgress = (order) => Math.round((order / MAX_SCREEN_COUNT) * 100);

const STEP_CONFIG = {
  intro: { label: SCREEN_HEADINGS.intro, order: 1, progress: orderToProgress(1) },
  problem_area: { label: SCREEN_HEADINGS.problem_area, order: 2, progress: orderToProgress(2) },
  pain_location: { label: SCREEN_HEADINGS.pain_location, order: 3, progress: orderToProgress(3) },
  cpg_questions: { label: SCREEN_HEADINGS.cpg_questions, order: 4, progress: orderToProgress(4) },
  subtype_questioning: { label: SCREEN_HEADINGS.subtype_questioning, order: 5, progress: orderToProgress(5) },
  self_assessment: { label: SCREEN_HEADINGS.self_assessment, order: 6, progress: orderToProgress(6) },
  nprs_symptoms: { label: SCREEN_HEADINGS.nprs_symptoms, order: 7, progress: orderToProgress(7) },
  safety_screening: { label: SCREEN_HEADINGS.safety_screening, order: 8, progress: orderToProgress(8) },
  test1_demo: { label: SCREEN_HEADINGS.test1_demo, order: 9, progress: orderToProgress(9) },
  movement_test_1: { label: SCREEN_HEADINGS.movement_test_1, order: 10, progress: orderToProgress(10) },
  // movement_q1/q2 share order 11 (effort, pain) and movement_q3/q4 share
  // order 12 (pace, range) so the progress bar still advances twice across
  // the four screens, matching what it did across the old two screens.
  // This mirrors the existing self_report_rom/self_report_tempo pairing
  // below rather than renumbering every step after 12 (see handoff Q3).
  movement_q1: { label: SCREEN_HEADINGS.movement_q1, order: 11, progress: orderToProgress(11) },
  movement_q2: { label: SCREEN_HEADINGS.movement_q2, order: 11, progress: orderToProgress(11) },
  movement_q3: { label: SCREEN_HEADINGS.movement_q3, order: 12, progress: orderToProgress(12) },
  movement_q4: { label: SCREEN_HEADINGS.movement_q4, order: 12, progress: orderToProgress(12) },
  self_report_rom: { label: SCREEN_HEADINGS.self_report_rom, order: 11, progress: orderToProgress(11) },
  self_report_tempo: { label: SCREEN_HEADINGS.self_report_tempo, order: 12, progress: orderToProgress(12) },
  rpe: { label: SCREEN_HEADINGS.rpe, order: 13, progress: orderToProgress(13) },
  feel_affect: { label: SCREEN_HEADINGS.feel_affect, order: 14, progress: orderToProgress(14) },
  feedback2: { label: SCREEN_HEADINGS.feedback2, order: 15, progress: orderToProgress(15) },
  personalize: { label: SCREEN_HEADINGS.personalize, order: 16, progress: orderToProgress(16) },
  plan: { label: SCREEN_HEADINGS.plan, order: 17, progress: 100 },
  questionnaire: { label: SCREEN_HEADINGS.questionnaire || "Your Starting Point", progress: 100 },
  consent_screen: { label: SCREEN_HEADINGS.consent_screen || "Enrollment Consent", progress: 100 },
  hard_stop: { label: SCREEN_HEADINGS.hard_stop, progress: 100 },
};

// The four post-movement-test question screens, in ask order, and the one
// bucket field each one is responsible for. Fixed mapping (not derived from
// bucket state at load time) — matches the `field` key already on each
// MYRA_MESSAGES.movementQuestions.qN block. Referenced by every guard that
// used to test `currentStep === "movement_q1" || currentStep === "movement_q2"`,
// by the screen-hop logic, and by MovementQuestionScreen itself.
const MOVEMENT_QUESTION_SCREENS = ["movement_q1", "movement_q2", "movement_q3", "movement_q4"];
const MOVEMENT_FIELD_TO_SCREEN = { rpe: "movement_q1", feelAffect: "movement_q2", tempo: "movement_q3", rom: "movement_q4" };
const isMovementQuestionScreen = (step) => MOVEMENT_QUESTION_SCREENS.includes(step);

// Known landing-chat intent values. Used by handleInlineChat's
// unknown-intent warning to surface prompt drift or backend bugs.
// TODO: move to a shared constants module when the intent vocabulary
// stabilizes across Landing, MidJourney, Q&A, and PostSession prompts.
const KNOWN_LANDING_INTENTS = ["intake_problemArea", "intake_selectedZones", "intake_side", "intake_cpg", "intake_subtype", "intake_subtypeQ1", "intake_subtypeQ2", "intake_subtypeAnswer", "intake_painLevel", "symptom_engagement", "safety_screen_conversation", "safety_screen_outcome", "safety_doctor_cleared", "bridge", "start_gsa_request", "noise_discard", "movement_answer", "movement_outcome", "movement_concern", "movement_conflict", "route_to_open_conversation", "readiness_confirmed", "unclear_input"];

const AREA_MAP = { "lower back": "LBP", back: "LBP", hip: "HIP", thigh: "THIGH", knee: "KNEE", leg: "KNEE" };
function detectAreaKeyword(text) {
  const lower = text.toLowerCase();
  for (const [kw, id] of Object.entries(AREA_MAP)) {
    if (lower.includes(kw)) return id;
  }
  return null;
}

// ── Spec 1 helpers (intro-payload field reconciliation) ──────
//
// Translates a Claude-extracted CPG option id (e.g., "cpg-radiating",
// "hip-cpg-mobility") into the full option object from CONSTANTS, which
// carries id, label, value, info, and (for HKT) cpgForBackend, routesTo,
// subtypeQuestionIndex / directSubtype.
//
// LBP options live in CPG_OPTIONS_LEG and CPG_OPTIONS_BACK (searched
// together — leg-pain branching only matters for the visible question,
// not for option lookup).
// HKT options live in CLINICAL_PATHS[area].cpgQuestion.options.
function normalizeSubtypeLookupValue(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");
}

function optionMatchesLookupValue(option, value) {
  if (!option || value === undefined || value === null) return false;
  const rawValue = String(value).trim();
  const normalizedValue = normalizeSubtypeLookupValue(rawValue);
  return option.id === rawValue || option.value === rawValue || normalizeSubtypeLookupValue(option.label) === normalizedValue;
}

function lookupCpgOption(optionId, area) {
  if (!optionId) return null;

  // Prefer the active area's options when the area is known.
  if (area === "LBP") {
    const lbpOption = [...CONST.CPG_OPTIONS_LEG, ...CONST.CPG_OPTIONS_BACK].find((o) => optionMatchesLookupValue(o, optionId));
    if (lbpOption) return lbpOption;
  } else if (area && CONST.CLINICAL_PATHS?.[area]) {
    const areaOption = CONST.CLINICAL_PATHS?.[area]?.cpgQuestion?.options?.find((o) => optionMatchesLookupValue(o, optionId));
    if (areaOption) return areaOption;
  }

  // LBP options
  const lbpOption = [...CONST.CPG_OPTIONS_LEG, ...CONST.CPG_OPTIONS_BACK].find((o) => optionMatchesLookupValue(o, optionId));

  if (lbpOption) return lbpOption;

  // All clinical path options
  for (const areaKey of Object.keys(CONST.CLINICAL_PATHS || {})) {
    const found = CONST.CLINICAL_PATHS?.[areaKey]?.cpgQuestion?.options?.find((o) => optionMatchesLookupValue(o, optionId));

    if (found) return found;
  }

  return null;
}

// Translates a Claude-extracted subtype option id (HKT only, e.g.,
// "hip-sub-lateral") into the option object from
// CLINICAL_PATHS[area].subtypeQuestions[*].options. Each option carries
// id, label, info, value (the subtype constant like
// "ANTERIOR_CHAIN_MOBILITY_DEFICIT").
function lookupSubtypeOption(optionId, area) {
  if (!optionId || !area || area === "LBP") return null;
  const subtypeQuestions = CONST.CLINICAL_PATHS[area]?.subtypeQuestions || [];
  for (const q of subtypeQuestions) {
    const opt = q.options?.find((o) => optionMatchesLookupValue(o, optionId));
    if (opt) return opt;
  }
  return null;
}

function logExtractedValidationRejection(field, value, reason, extra = {}) {
  console.warn("[Landing] Validation rejected extracted field", {
    field,
    value,
    reason,
    ...extra,
  });
}

function isKnownMovementTestName(testName) {
  return Boolean(testName) && testName !== "your first movement check" && Object.values(CONST.TEST_MAP || {}).some((test) => test?.name === testName);
}

// Translates Claude's extracted-field names into the field names the GSA
// screens read on mount. Pass currentAssessmentData so the helper can read
// prior state for multi-turn extractions (e.g., subtypeQ1 set last turn,
// subtypeQ2 arriving now — needs both to compute probableSubtype via
// getSubtype). Pure: does not mutate currentAssessmentData.
function mapExtractedToAssessmentData(extracted, currentAssessmentData = {}) {
  const out = {};
  const validProblemAreas = ["LBP", "HIP", "THIGH", "KNEE"];
  const validSafetyOutcomes = ["CONTINUE", "ADVISORY", "STOP", "ACCESS_EXCLUDED"];
  const validSymptomDurations = ["ACUTE", "SUBACUTE", "CHRONIC"];
  const validSides = ["left", "right", "both"];
  const normalizeSideValue = (value) => {
    if (value === undefined || value === null) return null;
    const normalized = String(value).trim().toLowerCase();
    return validSides.includes(normalized) ? normalized : null;
  };
  const applySelectedZones = (selectedZones, area) => {
    const uniqueZones = Array.from(new Set(selectedZones));
    out.selectedZones = uniqueZones;
    out.pinpointSelections = uniqueZones.map((z) => {
      const [side, ...zoneParts] = z.split(":");
      return { side, zone: zoneParts.join(":") };
    });
    out.primaryZone = uniqueZones[0];
    out.secondaryZones = uniqueZones.slice(1);
    if (area === "LBP") {
      out.isLegPain = CONST.hasLegPain(uniqueZones);
    }
    const selectedSides = Array.from(new Set(out.pinpointSelections.map((item) => item.side).filter(Boolean)));
    if (!out.side && selectedSides.length === 1) out.side = selectedSides[0];
    if (!out.side && selectedSides.includes("left") && selectedSides.includes("right")) out.side = "both";
    if (currentAssessmentData.pendingSelectedZones) out.pendingSelectedZones = [];
  };

  // problemArea
  if (extracted.problemArea !== undefined) {
    if (validProblemAreas.includes(extracted.problemArea)) {
      out.problemArea = extracted.problemArea;
      out.selected_problem_area = CONST.CLINICAL_PATHS[extracted.problemArea]?.name || extracted.problemArea;
      // Mirror the existing chip-click behaviour at line ~2479.
      window.problemArea = extracted.problemArea;
    } else {
      logExtractedValidationRejection("problemArea", extracted.problemArea, "not in canonical problem areas");
    }
  }

  // side — Router prompt emits this separately from selectedZones.
  if (extracted.side !== undefined) {
    const sideValue = normalizeSideValue(extracted.side);
    if (sideValue) {
      out.side = sideValue;
    } else {
      logExtractedValidationRejection("side", extracted.side, "not in canonical side values");
    }
  }

  // selectedZones — derive PainLocationScreen's expected side:zone fields.
  // Router prompt may emit plain zone names plus a separate side field.
  if (extracted.selectedZones !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    const zonesBySide = CONST.CLINICAL_PATHS?.[area]?.zones;
    if (!area || !zonesBySide) {
      logExtractedValidationRejection("selectedZones", extracted.selectedZones, "problem area missing or invalid", { area });
    } else if (!Array.isArray(extracted.selectedZones) || extracted.selectedZones.length === 0) {
      logExtractedValidationRejection("selectedZones", extracted.selectedZones, "empty or not array", { area });
    } else {
      const invalidZones = [];
      const selectedZones = [];
      const pendingZones = [];
      const sideForPlainZones = out.side || normalizeSideValue(currentAssessmentData.side);
      const validPlainZones = new Set([...(zonesBySide.left || []), ...(zonesBySide.right || [])]);

      extracted.selectedZones.forEach((rawZone) => {
        const zoneString = String(rawZone).trim();
        const [maybeSide, ...zoneParts] = zoneString.split(":");
        const sidePrefixed = (maybeSide === "left" || maybeSide === "right") && zoneParts.length > 0;

        if (sidePrefixed) {
          const zone = zoneParts.join(":");
          if (!zone || !zonesBySide?.[maybeSide]?.includes(zone)) {
            invalidZones.push(zoneString);
          } else {
            selectedZones.push(`${maybeSide}:${zone}`);
          }
          return;
        }

        if (!validPlainZones.has(zoneString)) {
          invalidZones.push(zoneString);
        } else if (sideForPlainZones === "left" || sideForPlainZones === "right") {
          selectedZones.push(`${sideForPlainZones}:${zoneString}`);
        } else if (sideForPlainZones === "both") {
          selectedZones.push(`left:${zoneString}`);
          selectedZones.push(`right:${zoneString}`);
        } else {
          pendingZones.push(zoneString);
        }
      });

      if (invalidZones.length > 0) {
        logExtractedValidationRejection("selectedZones", extracted.selectedZones, "invalid zone for area", { area, invalidZones });
      } else if (selectedZones.length > 0) {
        applySelectedZones(selectedZones, area);
      } else if (pendingZones.length > 0) {
        out.pendingSelectedZones = Array.from(new Set(pendingZones));
      }
    }
  }

  if (!out.selectedZones && out.side && Array.isArray(currentAssessmentData.pendingSelectedZones) && currentAssessmentData.pendingSelectedZones.length > 0) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    const zonesBySide = CONST.CLINICAL_PATHS?.[area]?.zones;
    if (area && zonesBySide) {
      const selectedZones = [];
      const invalidZones = [];
      const validPlainZones = new Set([...(zonesBySide.left || []), ...(zonesBySide.right || [])]);
      currentAssessmentData.pendingSelectedZones.forEach((zone) => {
        const zoneString = String(zone).trim();
        if (!validPlainZones.has(zoneString)) {
          invalidZones.push(zoneString);
        } else if (out.side === "left" || out.side === "right") {
          selectedZones.push(`${out.side}:${zoneString}`);
        } else if (out.side === "both") {
          selectedZones.push(`left:${zoneString}`);
          selectedZones.push(`right:${zoneString}`);
        }
      });
      if (invalidZones.length > 0) {
        logExtractedValidationRejection("selectedZones", currentAssessmentData.pendingSelectedZones, "invalid pending zone for area", { area, invalidZones });
      } else if (selectedZones.length > 0) {
        applySelectedZones(selectedZones, area);
      }
    }
  }

  // cpgAnswer — option id → cpgValue/cpgForBackend/cpgCategory + (if direct) probableSubtype
  if (extracted.cpgAnswer !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    const cpgOption = lookupCpgOption(extracted.cpgAnswer, area);
    if (cpgOption) {
      out.cpgAnswer = cpgOption.id;
      out.cpgValue = cpgOption.value;
      out.cpgForBackend = cpgOption.cpgForBackend || cpgOption.value;
      out.cpgCategory = cpgOption.value;
      if (cpgOption.routesTo === "direct" && cpgOption.directSubtype) {
        out.subtype = cpgOption.directSubtype;
        out.probableSubtype = cpgOption.directSubtype;
      } else if (cpgOption.routesTo === "subtypeQuestion" && area && area !== "LBP") {
        const subtypeQuestion = CONST.CLINICAL_PATHS?.[area]?.subtypeQuestions?.[cpgOption.subtypeQuestionIndex || 0];
        const zoneMap = area === "HIP" && cpgOption.id === "hip-cpg-mobility" ? CONST.HIP_MOB_Q1_ZONE_TO_OPTION : area === "THIGH" ? CONST.THIGH_Q1_ZONE_TO_OPTION : null;
        const pinpointSelections = out.pinpointSelections || currentAssessmentData.pinpointSelections || [];
        const q1Decision = zoneMap && subtypeQuestion ? CONST.planSubtypeQ1Decision(pinpointSelections, zoneMap, subtypeQuestion.options) : { mode: "plain" };
        if (q1Decision.mode === "skip" && q1Decision.option) {
          out.subtypeAnswer = q1Decision.option.value;
          out.subtype = q1Decision.option.value;
          out.probableSubtype = q1Decision.option.value;
          if (CONST.SUBTYPE_TO_CPG_MAP[area]?.[q1Decision.option.value]) {
            out.cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[area][q1Decision.option.value];
          }
        }
      }
    } else {
      logExtractedValidationRejection("cpgAnswer", extracted.cpgAnswer, "not in canonical options", { area });
    }
  }

  // subtypeQ1 (LBP)
  if (extracted.subtypeQ1 !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    if (area !== "LBP") {
      logExtractedValidationRejection("subtypeQ1", extracted.subtypeQ1, "field not applicable for area", { area });
    } else {
      const q1Value = String(extracted.subtypeQ1).trim();
      const q1Option = CONST.Q1_OPTIONS.find((o) => o.value === q1Value);
      if (q1Option) {
        out.subtypeQ1 = q1Option.value;
      } else {
        logExtractedValidationRejection("subtypeQ1", extracted.subtypeQ1, "not in canonical LBP Q1 options", { area });
      }
    }
  }

  // subtypeQ2 (LBP) — compute probableSubtype if Q1 is also known
  if (extracted.subtypeQ2 !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    if (area !== "LBP") {
      logExtractedValidationRejection("subtypeQ2", extracted.subtypeQ2, "field not applicable for area", { area });
    } else {
      const q2Value = typeof extracted.subtypeQ2 === "string" ? extracted.subtypeQ2.trim().toLowerCase() : extracted.subtypeQ2;
      if (q2Value === "yes" || q2Value === "no") {
        out.subtypeQ2 = q2Value;
        const q1 = out.subtypeQ1 || currentAssessmentData.subtypeQ1;
        if (CONST.Q1_OPTIONS.some((o) => o.value === q1)) {
          const subtype = CONST.getSubtype(q1, q2Value);
          out.subtype = subtype;
          out.probableSubtype = subtype;
        }
        // LBP CPG options have no routesTo/directSubtype.
        // Back-only path: cpgToSubtype() resolves subtype from cpgValue.
        // Leg-pain path: subtype comes from Q1/Q2 — don't set here.
        const zones = out.selectedZones || currentAssessmentData.selectedZones;
        const isLegPain = zones ? CONST.hasLegPain(zones) : false;
        if (!isLegPain && currentAssessmentData.cpgValue) {
          const cpgDerived = CONST.cpgToSubtype(currentAssessmentData.cpgValue);
          // Conflict guard: the directional answer (out.subtype, from Q1/Q2) and
          // the CPG-derived subtype can disagree. When they do, resolve
          // conservatively to NEUTRAL_SENSITIVE rather than silently dropping the
          // directional answer. When they agree, or only one exists, keep it.
          const directional = out.subtype;
          const isDirectional = (s) => s === "FLEXION_INTOLERANT" || s === "EXTENSION_INTOLERANT" || s === "ROTATIONAL_INTOLERANT";
          if (cpgDerived) {
            if (isDirectional(directional) && cpgDerived !== directional) {
              out.subtype = "NEUTRAL_SENSITIVE";
              out.probableSubtype = "NEUTRAL_SENSITIVE";
              console.log("[Landing] Conservative conflict resolution: directional", directional, "vs cpg", cpgDerived, "-> NEUTRAL_SENSITIVE");
            } else {
              out.subtype = cpgDerived;
              out.probableSubtype = cpgDerived;
            }
          }
        }
      } else {
        logExtractedValidationRejection("subtypeQ2", extracted.subtypeQ2, "not yes or no", { area });
      }
    }
  }

  // subtypeAnswer (HKT) — option id → subtype constant via the option's value
  if (extracted.subtypeAnswer !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    const subtypeOption = lookupSubtypeOption(extracted.subtypeAnswer, area);
    if (!area || area === "LBP") {
      logExtractedValidationRejection("subtypeAnswer", extracted.subtypeAnswer, "field not applicable for area", { area });
    } else if (!subtypeOption) {
      logExtractedValidationRejection("subtypeAnswer", extracted.subtypeAnswer, "not in canonical options", { area });
    } else {
      out.subtypeAnswer = subtypeOption.value;
      out.subtype = subtypeOption.value;
      out.probableSubtype = subtypeOption.value;

      if (CONST.SUBTYPE_TO_CPG_MAP[area]?.[subtypeOption.value]) {
        out.cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[area][subtypeOption.value];
        console.log(`[Landing] Remapped cpgForBackend for ${area} subtype ${subtypeOption.value}:`, out.cpgForBackend);
      }
    }
  }
  // painLevel
  if (extracted.painLevel !== undefined) {
    if (Number.isInteger(extracted.painLevel) && extracted.painLevel >= 0 && extracted.painLevel <= 10) {
      out.painLevel = extracted.painLevel;
    } else {
      logExtractedValidationRejection("painLevel", extracted.painLevel, "not an integer from 0 to 10", { actualType: typeof extracted.painLevel });
    }
  }

  // safety - Claude may return this inside extracted instead of action
  if (extracted.safety !== undefined) {
    const rawSafety = String(extracted.safety).trim();
    const safetyValue = rawSafety.startsWith("SAFETY_") ? rawSafety.slice("SAFETY_".length) : rawSafety;
    if (validSafetyOutcomes.includes(safetyValue)) {
      out.safety = safetyValue;
      out.safetyOutcome = safetyValue;
    } else {
      logExtractedValidationRejection("safety", extracted.safety, "not in canonical safety outcomes");
    }
  }

  // Phase 2 movement-question fields — prompt emits canonical values only.
  if (extracted.rpe !== undefined) {
    const rpeValue = Number(extracted.rpe);
    if ([1, 3, 5, 7, 9].includes(rpeValue)) {
      out.rpe = rpeValue;
    } else {
      logExtractedValidationRejection("rpe", extracted.rpe, "not in canonical RPE values");
    }
  }

  if (extracted.feelAffect !== undefined) {
    const feelValue = String(extracted.feelAffect).trim().toUpperCase();
    if (["IMPROVED", "TOLERABLE", "WORSENED"].includes(feelValue)) {
      out.feelAffect = feelValue;
      out.symptomResponse = feelValue;
      out.symptomResponse1 = feelValue;
    } else {
      logExtractedValidationRejection("feelAffect", extracted.feelAffect, "not in canonical symptom response values");
    }
  }

  if (extracted.tempo !== undefined) {
    const tempoValue = String(extracted.tempo).trim();
    const tempoOption = CONST.SELF_REPORT_TEMPO.options.find((opt) => opt.id === tempoValue);
    if (tempoOption) {
      out.selfReportTempo = tempoValue;
      out.selfReportSpeed = tempoValue;
      out.selfReportPace = tempoValue;
      out.selfReportSpeedPoints = tempoOption.points;
    } else {
      logExtractedValidationRejection("tempo", extracted.tempo, "not in canonical tempo values");
    }
  }

  if (extracted.rom !== undefined) {
    const romValue = String(extracted.rom).trim();
    const romOption = CONST.SELF_REPORT_ROM.options.find((opt) => opt.id === romValue);
    if (romOption) {
      out.selfReportRom = romValue;
      out.selfReportRomPoints = romOption.points;
    } else {
      logExtractedValidationRejection("rom", extracted.rom, "not in canonical ROM values");
    }
  }

  if (extracted.comparison !== undefined) {
    const comparisonValue = String(extracted.comparison).trim().toUpperCase();
    if (["BETTER", "WORSE", "CANNOT_TRY"].includes(comparisonValue)) {
      out.symptomResponseConfirm = comparisonValue;
    } else {
      logExtractedValidationRejection("comparison", extracted.comparison, "not in canonical comparison values");
    }
  }

  // Pass-through for free-text and biometric fields. Claude's extraction
  // tables (prompts-extract.js lines 832–945) define these. The
  // Personalize pre-fill effect (Delta 9.1) reads them and remaps to the
  // screen's local form-state names where they differ (e.g., weightLbs →
  // weight, activityLevel → activity).
  if (extracted.symptomDuration !== undefined) {
    if (validSymptomDurations.includes(extracted.symptomDuration)) {
      out.symptomDuration = extracted.symptomDuration;
    } else {
      logExtractedValidationRejection("symptomDuration", extracted.symptomDuration, "not in canonical symptom durations");
    }
  }

  const passThroughKeys = ["pain_location", "pain_severity", "pain_character", "aggravators", "relief_factors", "time_pattern", "leg_arm_symptoms", "functional_limitations", "prior_treatment", "treatment_outcome", "onset_trigger", "sleep_impact", "fear_or_hesitation", "recovery_goals", "conditions_disclosed", "age", "weightLbs", "heightFt", "heightIn", "activityLevel", "floorCapability", "balance", "goals"];
  passThroughKeys.forEach((k) => {
    if (extracted[k] !== undefined) out[k] = extracted[k];
  });

  // Defensive: If we have both cpgAnswer and subtypeAnswer/probableSubtype for HKT,
  // ensureing it that cpgForBackend is correct even if previous logic missed it
  const finalArea = out.problemArea || currentAssessmentData.problemArea;
  if (finalArea && finalArea !== "LBP") {
    const subtypeValue = out.subtype || out.probableSubtype || currentAssessmentData.subtype || currentAssessmentData.probableSubtype;
    if (subtypeValue && CONST.SUBTYPE_TO_CPG_MAP[finalArea]?.[subtypeValue]) {
      // Only override if cpgForBackend isn't already correctly mapped
      const expectedCpg = CONST.SUBTYPE_TO_CPG_MAP[finalArea][subtypeValue];
      if (out.cpgForBackend !== expectedCpg) {
        console.log(`[Landing] Defensive cpgForBackend correction for ${finalArea}:`, { from: out.cpgForBackend, to: expectedCpg, subtype: subtypeValue });
        out.cpgForBackend = expectedCpg;
      }
    }
  }

  return out;
}

function _delay(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

// Given a bucket_state object (from buildBucketState in
// generatePayloadForScreen.js), returns the step key of the first GSA
// screen that hasn't been captured conversationally. Used by the bucket
// router in handleInlineChat after Claude signals start_gsa_request.
//
// Returns one of: "problem_area", "pain_location", "cpg_questions",
// "subtype_questioning", "self_assessment", "nprs_symptoms", or
// "safety_screening" when everything is captured.
function findFirstMissingScreen(bucketState) {
  window.showChips = true;

  if (isKnownMovementTestName(bucketState.reveal) && (bucketState.safety === "CONTINUE" || bucketState.safety === "ADVISORY")) {
    return "movement_test_1";
  }

  if (!bucketState.problemArea) return "problem_area";
  if (!bucketState.selectedZones) return "pain_location";
  if (!bucketState.cpgAnswer) return "cpg_questions";

  if (bucketState.problemArea === "LBP") {
    if (!bucketState.subtypeQ1) return "subtype_questioning";
    if (!bucketState.subtypeQ2) return "self_assessment";
  } else {
    // HKT: subtypeAnswer is required only if the chosen CPG option routes
    // through a subtype question. routesTo === "direct" means subtype is
    // already set via directSubtype, so no subtype screen needed.
    const cpgOption = lookupCpgOption(bucketState.cpgAnswer, bucketState.problemArea);
    if (cpgOption?.routesTo !== "direct") {
      const subtypeOption = lookupSubtypeOption(bucketState.subtypeAnswer, bucketState.problemArea);
      if (!bucketState.subtypeAnswer || !(bucketState.subtype || bucketState.probableSubtype || subtypeOption?.value)) {
        return "subtype_questioning";
      }
    }
  }

  if (bucketState.painLevel === null || bucketState.painLevel === undefined) {
    return "nprs_symptoms";
  }

  // Fields 1–7 are filled. Now check safety and reveal.

  // Defensive: STOP is unreachable here because the bucket router does
  // not call findFirstMissingScreen when safety === "STOP". Return null
  // as a sentinel; the caller treats null as "do not transition."
  if (bucketState.safety === "STOP") return null;
  // ACCESS: a required clinical exclusion is terminal in the same way.
  if (bucketState.safety === "ACCESS_EXCLUDED") return null;

  // Safety not yet resolved — fall back to the structured screen.
  // ACCESS adds "Q2": question one resolved, question two still open, so
  // the beat is NOT finished and must not fall through to movement test 1.
  if (bucketState.safety === null || bucketState.safety === undefined || bucketState.safety === "START" || bucketState.safety === "Q2") {
    // Defect 4 fix: SafetyScreeningScreen is the self-pay checklist and has
    // no ACCESS awareness — it re-asks items already covered on the
    // eligibility screen and never asks ACCESS's second safety question.
    // Delta 3 flagged this as a gap and recommended suppressing this
    // fallback on ACCESS rather than showing the wrong screen. Treat an
    // unresolved ACCESS safety beat the same as STOP above — "do not
    // transition" — until the chat-driven prompt/Router path resolves it,
    // instead of routing an ACCESS beneficiary into the self-pay screen.
    if (window.is_access_user === true) {
      return null;
    }
    return "safety_screening";
  }

  // safety is "CONTINUE" or "ADVISORY". Skip safety_screening.
  // Now check reveal.

  // if (!isKnownMovementTestName(bucketState.reveal)) {
  //   return "test1_demo";
  // }

  // Reveal also done. Land on the first step past test1_demo.
  return "movement_test_1";
}

// function buildFrontendSafetyOpener(questionBank = {}, problemArea) {
//   const safety = questionBank.safety || {};
//   return [safety.setupBeat, safety.question || "Do you have any pre-existing conditions or symptoms that would make it unsafe to perform at-home exercises?", safety.nuggetByArea?.[problemArea] || safety.nugget].filter(Boolean).join(" ").trim();
// }
function buildFrontendSafetyOpener(questionBank = {}, problemArea, stage = "q1") {
  const isAccess = window.is_access_user === true;
  const block = isAccess ? questionBank.safetyAccess || {} : questionBank.safety || {};

  let parts;
  if (isAccess && stage === "q2") {
    parts = [block.questionTwoByArea?.[problemArea], block.nuggetTwo];
  } else {
    parts = [block.setupBeat, block.question || "Do you have any pre-existing conditions or symptoms that would make it unsafe to perform at-home exercises?", block.nuggetByArea?.[problemArea] || block.nugget];
  }

  const combined = parts.filter(Boolean).join(" ").trim();

  // Force "Let me know if any apply, or if none do." onto its own line,
  // regardless of how it's punctuated/spaced in the source nugget text.
  return combined.replace(/\s*Let me know if any apply,?\s*or if none do\.?/i, "\n\nLet me know if any apply, or if <strong>none</strong> do.");
}

function mapRouterBucketStateToAssessmentData(bucketState = {}, currentAssessmentData = {}) {
  if (!bucketState || typeof bucketState !== "object") return {};
  const { safety, subtype, probableSubtype, ...bucketForExtractor } = bucketState;
  const normalizedBucket = { ...bucketForExtractor };
  if (typeof normalizedBucket.selectedZones === "string") {
    normalizedBucket.selectedZones = [normalizedBucket.selectedZones];
  }
  const out = mapExtractedToAssessmentData(normalizedBucket, currentAssessmentData);
  if (subtype !== undefined && subtype !== null) out.subtype = subtype;
  if (probableSubtype !== undefined && probableSubtype !== null) out.probableSubtype = probableSubtype;
  if (safety !== undefined && safety !== null) {
    if (["START", "Q2", "CONTINUE", "ADVISORY", "STOP", "ACCESS_EXCLUDED"].includes(safety)) {
      out.safety = safety;
      if (safety !== "START") out.safetyOutcome = safety;
    } else {
      logExtractedValidationRejection("safety", safety, "not in canonical router safety states");
    }
  }
  return out;
}

function buildMovementCompletionRoute(movementData = {}) {
  const data = movementData || {};
  const symptomValue = data.feelAffect || data.symptomResponse;
  const tempoValue = data.selfReportTempo || data.selfReportSpeed || data.selfReportPace;
  const romValue = data.selfReportRom;
  const { rom, dur } = parseDataAfterInfo();
  const problemArea = data.problemArea || "LBP";
  const currentSubtype = data.probableSubtype || data.subtype || "NEUTRAL_SENSITIVE";
  const tempoOption = CONST.SELF_REPORT_TEMPO.options.find((opt) => opt.id === tempoValue);
  const romOption = CONST.SELF_REPORT_ROM.options.find((opt) => opt.id === romValue);

  const finalFields = {
    rpe: data.rpe,
    rom,
    duration: dur,
    submitted_rpe_1: true,
    feelAffect: symptomValue,
    symptomResponse: symptomValue,
    symptomResponse1: symptomValue,
    submitted_symptoms_2: true,
    selfReportTempo: tempoValue,
    selfReportSpeed: tempoValue,
    selfReportPace: tempoValue,
    selfReportSpeedPoints: tempoOption?.points ?? null,
    selfReportRom: romValue,
    selfReportRomPoints: romOption?.points ?? null,
    cameraUsed: false,
    completed_speed_screen: true,
    completed_rom_screen: true,
    diagnosisChanged: false,
    degradation: null,
    timing: null,
    finalPainSubtype: currentSubtype,
    probableSubtype: currentSubtype,
    wasOverridden: false,
    overrideReason: null,
  };

  if (symptomValue === "WORSENED") {
    let finalSubtype = currentSubtype;
    let cpgForBackend = data.cpgForBackend;
    if (problemArea === "LBP") {
      finalSubtype = "NEUTRAL_SENSITIVE";
    } else {
      finalSubtype = CONST.CLINICAL_PATHS[problemArea]?.overrideTarget || currentSubtype;
      if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[finalSubtype]) {
        cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][finalSubtype];
      }
    }
    return {
      fields: {
        ...finalFields,
        diagnosisChanged: true,
        degradation: problemArea === "LBP" ? "First Test Felt Worse — LBP reclassified to Neutral Sensitive" : "First Test Felt Worse — reclassified to override target",
        timing: "post_test1_symptom",
        finalPainSubtype: finalSubtype,
        probableSubtype: finalSubtype,
        cpgForBackend,
        wasOverridden: true,
        overrideReason: "First Test Felt Worse",
      },
      // nextStep: "personalize",
      nextStep: window.is_access_user ? "personalize" : "plan",
    };
  }

  if (problemArea === "LBP" && currentSubtype === "ROTATIONAL_INTOLERANT" && symptomValue === "IMPROVED") {
    return {
      fields: {
        ...finalFields,
        diagnosisChanged: true,
        degradation: "Directional Preference Overwrite — positive extension response",
        timing: "post_test1_symptom",
        finalPainSubtype: "FLEXION_INTOLERANT",
        probableSubtype: "FLEXION_INTOLERANT",
        wasOverridden: true,
        overrideReason: "Directional Preference Overwrite — positive extension response",
      },
      // nextStep: "personalize",
      nextStep: window.is_access_user ? "personalize" : "plan",
    };
  }

  const test2 = CONST.getNegativeTest(currentSubtype, problemArea);
  return {
    fields: finalFields,
    // nextStep: "personalize",
    nextStep: window.is_access_user ? "personalize" : "plan",
  };
}

// Returns true when every bucket field needed to advance the user out of
// the landing chat is captured and safety has resolved to a non-STOP state.
// Used by handleInlineChat's auto-trigger path so the GSA transition fires
// even when Claude omits the start_gsa_request intent. The movement-test
// reveal may still be missing; findFirstMissingScreen will land those users
// on test1_demo instead of leaving them stranded in landing chat.
//
// LBP requires both subtype questions. HKT requires subtypeAnswer only when
// the CPG option routes through a subtype question. Direct-route CPG
// options (routesTo === "direct") already carry directSubtype, so no
// subtype screen is needed.
function isReadyForAutoTransition(bucketState) {
  if (!bucketState) return false;
  if (bucketState.reveal && !isKnownMovementTestName(bucketState.reveal)) {
    return false;
  }
  if (!bucketState.problemArea) return false;
  if (!bucketState.selectedZones) return false;
  if (!bucketState.cpgAnswer) return false;

  if (bucketState.problemArea === "LBP") {
    if (!bucketState.subtypeQ1) return false;
    if (!bucketState.subtypeQ2) return false;
  } else {
    const cpgOption = lookupCpgOption(bucketState.cpgAnswer, bucketState.problemArea);
    if (cpgOption?.routesTo !== "direct") {
      const subtypeOption = lookupSubtypeOption(bucketState.subtypeAnswer, bucketState.problemArea);
      if (!bucketState.subtypeAnswer || !(bucketState.subtype || bucketState.probableSubtype || subtypeOption?.value)) {
        return false;
      }
    }
  }

  if (typeof bucketState.painLevel !== "number") return false;
  if (bucketState.safety !== "CONTINUE" && bucketState.safety !== "ADVISORY") return false;

  return true;
}

function recordChatScreenEntry(screenName, timerRef) {
  const now = Date.now();
  const tracker = timerRef.current;
  // Close previous screen if open
  if (tracker.currentScreen && tracker.startTime) {
    const durationMs = now - tracker?.startTime;
    tracker.screenDurations[tracker.currentScreen] = (tracker.screenDurations[tracker.currentScreen] || 0) + durationMs;
  }
  tracker.currentScreen = screenName;
  tracker.startTime = now;
}

function closeChatScreenEntry(timerRef) {
  const now = Date.now();
  const tracker = timerRef.current;
  if (tracker.currentScreen && tracker.startTime) {
    const durationMs = now - tracker?.startTime;
    tracker.screenDurations[tracker.currentScreen] = (tracker.screenDurations[tracker.currentScreen] || 0) + durationMs;
    tracker.currentScreen = null;
    tracker.startTime = null;
  }
}

let _historyId = 0;
function nextId() {
  return ++_historyId;
}

function normalizeDisplayedTextForPrompt(text = "") {
  return String(text || "")
    .replace(/<br\s*\/?\s*>/gi, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
}

function buildDisplayedChatHistoryForPrompt(entries = []) {
  return (Array.isArray(entries) ? entries : [])
    .map((entry) => {
      if (!entry) return null;
      if (entry.type === "user") {
        const content = normalizeDisplayedTextForPrompt(entry.text);
        return content ? { role: "user", content } : null;
      }
      if (entry.type === "myra" || entry.type === "myra-initial") {
        const content = normalizeDisplayedTextForPrompt(entry.text);
        return content ? { role: "assistant", content } : null;
      }
      if (entry.type === "frozen-widget") {
        if (entry.widgetType === "hard_stop_card") {
          const detail = normalizeDisplayedTextForPrompt(entry.data?.detail);
          const content = ["We recommend in-person care", detail].filter(Boolean).join(": ");
          return content ? { role: "assistant", content } : null;
        }
        if (entry.widgetType === "safety_stop_card") {
          const detail = normalizeDisplayedTextForPrompt(entry.data?.detail);
          const content = ["We recommend waiting", detail].filter(Boolean).join(": ");
          return content ? { role: "assistant", content } : null;
        }
        if (entry.widgetType === "safety_advisory_card") {
          const detail = normalizeDisplayedTextForPrompt(entry.data?.detail);
          const choice = entry.data?.choice === "leave" ? "You chose to come back later." : "";
          const content = ["Something to consider before continuing", detail, choice].filter(Boolean).join(" ");
          return content ? { role: "assistant", content } : null;
        }
        if (entry.widgetType === "access_exclusion_card") {
          const detail = normalizeDisplayedTextForPrompt(entry.data?.detail);
          const content = ["This program is not the right fit right now", detail].filter(Boolean).join(": ");
          return content ? { role: "assistant", content } : null;
        }
        if (entry.widgetType === "questionnaire_summary") {
          const sections = entry.data?.sections || [];
          const lines = sections.flatMap((section) => (section.questions || []).map((q) => `${normalizeDisplayedTextForPrompt(q.questionText)}: ${q.answerText ? normalizeDisplayedTextForPrompt(q.answerText) : "Skipped"}`));
          const content = lines.length ? `Baseline questionnaire completed. Answers:\n${lines.join("\n")}` : null;
          return content ? { role: "assistant", content } : null;
        }
      }
      if (entry.type === "plan-card") {
        const names = (entry.data?.exercises || []).map((ex) => ex?.name).filter(Boolean);
        const content = names.length ? `Plan card displayed: ${names.join(", ")}` : "Plan card displayed.";
        return { role: "assistant", content };
      }
      return null;
    })
    .filter(Boolean);
}

function getPlanAdvanceAck(group) {
  if (group === 1 && !window.is_access_user) return "Alright, here is your plan.";
  if (group === 2) return "Great, here is how I can help from here.";
  return "Great, let's get you started.";
}

function getPinpointChipStyle(zonesBySide = {}) {
  const allZones = [...(zonesBySide.left || []), ...(zonesBySide.right || [])];
  const maxLen = allZones.reduce((max, zone) => Math.max(max, String(zone).length), 0);
  const widthCh = Math.max(8, Math.min(18, maxLen + 2));
  return { width: `${widthCh}ch` };
}

function getNestedMessage(root, dottedPath) {
  return dottedPath.split(".").reduce((acc, part) => (acc ? acc[part] : undefined), root);
}

function getDemoVideo1Message(problemArea, subtype, testName) {
  const setupByArea = MYRA_MESSAGES.demoVideo?.DEMO_VIDEO_1_SETUP_BEAT_BY_AREA || {};
  return resolveMessage(setupByArea[problemArea] || setupByArea.LBP || "", { testName });
}

function getMovementCompletionSummary(testName) {
  return resolveMessage(MYRA_MESSAGES.movementTest?.completionSummary || "Done with the {testName}. That gives me what I need. Let me ask you a couple of follow-up questions.", { testName });
}

function getFeedback2AckMessage(value, speech) {
  const speechText = typeof speech === "string" ? speech.trim() : "";
  if (speechText) return speechText;

  const closeByOutcome = MYRA_MESSAGES.feedback2?.FEEDBACK_2_CLOSE_BY_OUTCOME || {};
  return value === "BETTER" ? closeByOutcome.BETTER : closeByOutcome.WORSE;
}

function getFeedback2OptionLabel(option) {
  return MYRA_MESSAGES.feedback2?.options?.[option.id]?.label || option.label;
}

function getSelfReportRomDisplayOption(option) {
  const copy = MYRA_MESSAGES.selfReportRom?.options?.[option.id] || {};
  return {
    ...option,
    title: copy.title || option.title,
    subtitle: copy.subtitle || option.subtitle,
  };
}

function getSelfReportRomDisplayOptions(options) {
  return options.map(getSelfReportRomDisplayOption);
}

function MovementRevealReadyChip({ label, guideText, onClick }) {
  return (
    <div className={styles.inlineUi2}>
      <div className={styles.chipPairStack}>
        <div className={styles.chipPair}>
          <button type="button" className={`${styles.optionCard} ${styles.chipPair}`} onClick={onClick}>
            {label}
          </button>
        </div>
      </div>
      {guideText && <div style={{ fontSize: "12px", fontWeight: 500, color: "#6b7280", fontStyle: "italic", padding: "4px 0 0 4px", marginTop: "2px" }}>{guideText}</div>}
    </div>
  );
}

function MovementRevealReadyFrozen({ label }) {
  return (
    <div className={styles.inlineUi2}>
      <div className={styles.chipPairStack}>
        <div className={`${styles.chipPair} ${styles.frozen} ${styles.selected}`}>
          <div className={`${styles.optionCard} ${styles.chipPair} ${styles.frozen} ${styles.selected}`}>{label}</div>
        </div>
      </div>
    </div>
  );
}
function formatMoney(n) {
  const num = Number(n);
  return "$" + (Number.isInteger(num) ? num : num.toFixed(2));
}

function PricingCard({ entryId, tiers = [], promo = null, onSignUp, onTierSelect, assessmentData, updateAssessmentData, onReachedPhase3 }) {
  const initialTierId = useMemo(() => {
    const rec = tiers.find((t) => t.recommended);
    // return rec?.id || tiers[0]?.id || null;
    return null;
  }, [tiers]);
  const [selectedTierId, setSelectedTierId] = useState(initialTierId);
  const cardRootRef = useRef(null);
  const visibilityFiredRef = useRef(false);
  useEffect(() => {
    if (typeof onReachedPhase3 !== "function") return;
    const el = cardRootRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !visibilityFiredRef.current) {
            visibilityFiredRef.current = true;
            onReachedPhase3();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }, // fires once ~30% of the card is in view
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [onReachedPhase3]);

  // A promo can target one specific tier ("weekly" | "four" | "eight")
  // or all tiers at once ("all") — matches the prototype's promo panel.
  const getPromoForTier = (tierId) => {
    if (!promo) return null;
    if (promo.tier === "all" || promo.tier === tierId) return promo;
    return null;
  };

  const handleCta = () => {
    const appliedPromo = getPromoForTier(selectedTierId);
    const promoPayload = appliedPromo
      ? {
          tier: appliedPromo.tier,
          discountPercentage: appliedPromo.discountPercent,
          appliesToFutureWeeks: !!appliedPromo.appliesToFutureWeeks,
          expiresAt: appliedPromo.expiresAt || null,
        }
      : null;
    const productId = selectedTierId === "weekly" ? "2" : selectedTierId === "four" ? "3" : selectedTierId === "eight" ? "1" : null;
    const updatedData = {
      ...assessmentData,
      selectedPricingTier: selectedTierId,
      subscriptionPlan: selectedTierId,
      productId: productId,
      selectedPricingPromo: promoPayload,
      discountPercentage: appliedPromo?.discountPercent,
    };

    if (typeof updateAssessmentData === "function") {
      updateAssessmentData(updatedData);
    }
    AnalyticsService.trackStep(updatedData);
    console.log("APPLIED PROMO IS : ", appliedPromo);
    onSignUp?.(updatedData);
  };

  return (
    <div data-entry-id={entryId} data-entry-kind="myra" className={styles.planPricingContainer} ref={cardRootRef}>
      <div data-message-content="true" className={styles.priceBlock}>
        {tiers.map((tier) => {
          const isSelected = selectedTierId === tier.id;
          const tierPromo = getPromoForTier(tier.id);
          const discounted = tierPromo ? +(tier.price * (1 - tierPromo.discountPercent / 100)).toFixed(2) : null;
          const discountedRollover = tierPromo && tierPromo.appliesToFutureWeeks ? +(tier.rollover * (1 - tierPromo.discountPercent / 100)).toFixed(2) : null;

          return (
            <div
              key={tier.id}
              className={`${styles.tier} ${isSelected ? styles.tierSelected : ""}`}
              onClick={() => {
                setSelectedTierId(tier.id);
                onTierSelect?.(tier.id);
              }}
            >
              {tier.recommended && <div className={`${styles.tierBadge} ${styles.tierBadgeRec}`}>Recommended</div>}
              {tierPromo && <div className={`${styles.tierBadge} ${styles.tierBadgePromo}`}>Introductory offer {tierPromo.discountPercent}% off</div>}

              <div className={`${styles.tierRadio} ${isSelected ? styles.tierRadioSelected : ""}`}>
                <i className={`${styles.tierRadioCheck} ${isSelected ? styles.tierRadioCheckVisible : ""}`}>✓</i>
              </div>

              <div>
                <div className={styles.tierName}>{tier.label}</div>
                <div className={styles.tierDesc}>{tier.description}</div>
              </div>

              <div className={styles.tierPrice}>
                <div className={styles.tierPriceNow}>
                  {tierPromo && <span className={styles.tierPriceWas}>{formatMoney(tier.price)}</span>}
                  {formatMoney(tierPromo ? discounted : tier.price)}
                </div>
                <div className={styles.tierPriceRoll}>
                  then {tierPromo && tierPromo.appliesToFutureWeeks && <span className={styles.tierPriceRollWas}>{formatMoney(tier.rollover)}</span>}
                  {formatMoney(tierPromo && tierPromo.appliesToFutureWeeks ? discountedRollover : tier.rollover)}/wk
                </div>
              </div>
            </div>
          );
        })}

        <div className={styles.pricingFineprint}>No card needed at sign up. Your first session is free.</div>
        <button className={styles.pricingCta} onClick={handleCta}>
          Sign me up to try my free first session
        </button>
      </div>
    </div>
  );
}

// Stripped-down Group 3 CTA for ACCESS users: no tiers, no promo, just the
// same pricingCta button/copy so it renders identically to PricingCard's
// button. Clicking it drives the exact same handleSignUp path.
function AccessSignupCta({ entryId, onSignUp, onReachedPhase3 }) {
  const cardRootRef = useRef(null);
  const visibilityFiredRef = useRef(false);

  useEffect(() => {
    if (typeof onReachedPhase3 !== "function") return;
    const el = cardRootRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !visibilityFiredRef.current) {
            visibilityFiredRef.current = true;
            onReachedPhase3();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [onReachedPhase3]);

  return (
    <div data-entry-id={entryId} data-entry-kind="myra" className={styles.planPricingContainer} ref={cardRootRef}>
      <div data-message-content="true" className={styles.priceBlock}>
        <button className={styles.pricingCta} onClick={() => onSignUp?.()} disabled={window.is_access_user === true && window._accessSignupLocked === true}>
          Sign me up to try my free first session
        </button>
      </div>
    </div>
  );
}
// ── "Why I built this plan" chip + bottom sheet ──
// Lives in the plan card header. Reads the two Group 1 bubbles directly
// (they no longer render into the chat, see dev handoff §4a/4d).
function PlanWhyChip({ bubble1, bubble2, onOpen }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onOpen?.();
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <button type="button" className={styles.planWhyChip} onClick={handleOpen}>
        Why I built this plan &rsaquo;
      </button>
      {open && (
        <>
          <div className={styles.planWhySheetOverlay} onClick={handleClose} />
          <div className={styles.planWhySheet}>
            <div className={styles.planWhySheetGrab} />
            <div className={styles.planWhySheetHead}>
              <div className={styles.planWhySheetTitle}>Why this plan</div>
              <button type="button" className={styles.planWhySheetClose} onClick={handleClose}>
                Close
              </button>
            </div>
            <div className={styles.planWhySheetBody}>
              <div className={styles.msgRowMyra}>
                <div className={styles.msgAvatar}>M</div>
                <div data-message-content="true" className={styles.msgBubbleMyra} dangerouslySetInnerHTML={{ __html: bubble1 }} />
              </div>
              <div className={styles.msgRowMyra}>
                <div className={styles.msgAvatar}>M</div>
                <div data-message-content="true" className={styles.msgBubbleMyra} dangerouslySetInnerHTML={{ __html: bubble2 }} />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

// ── Reaction chips under the plan card ──
// Chips never freeze: the tapped chip fills teal, the others return to
// outline, and every press appends a new echo/reply exchange (existing
// history entry types + showMyraMessage, so typing dots and analytics stay
// on the standard paths). See dev handoff §4e.
function PlanReactionChips({ pushToHistory, showMyraMessage, updateHistoryEntryData, isVoiceMode, speakChatTextIfVoice, trackFeedback, ctaEntryIdRef, ctaOnSignUp, onReachedPhase3, replies }) {
  const [selectedKind, setSelectedKind] = useState(null);
  const busyRef = useRef(false);

  const ECHOES = {
    looks_great: "Looks great.",
    change_it: "I would like to change it.",
    have_question: "I have a question.",
  };
  const LABELS = {
    looks_great: "Looks great",
    change_it: "Change it",
    have_question: "I have a question",
  };
  // Matches the thumbs-up / thumbs-down glyphs in rp-prototype-final.html
  // (.chip svg). "I have a question" has no icon in the prototype either.
  const ICONS = {
    looks_great: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
      </svg>
    ),
    change_it: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
      </svg>
    ),
    have_question: null,
  };

  // The "Show the details" toggle is injected as plain markup right after
  // the </ul> inside the group3 support bubble itself (see
  // markGroup3ListFoldable), matching the prototype's DOM order. It isn't a
  // React node here, so folding/revealing it and wiring its click both go
  // through document-level DOM handling, the same way the list itself is
  // folded.
  const foldGroup3List = () => {
    document.querySelectorAll(`.${styles.planSupportListFoldable}`).forEach((el) => el.classList.add(styles.planSupportListFolded));
    document.querySelectorAll(`.${styles.planSupportToggle}`).forEach((el) => el.classList.remove(styles.planSupportToggleHidden));
  };

  useEffect(() => {
    const handleShowDetailsClick = (e) => {
      const toggle = e.target.closest?.("[data-plan-support-toggle]");
      if (!toggle) return;
      document.querySelectorAll(`.${styles.planSupportListFoldable}`).forEach((el) => el.classList.remove(styles.planSupportListFolded));
      document.querySelectorAll(`.${styles.planSupportToggle}`).forEach((el) => el.classList.add(styles.planSupportToggleHidden));
    };
    document.addEventListener("click", handleShowDetailsClick);
    return () => document.removeEventListener("click", handleShowDetailsClick);
  }, []);

  async function handleTap(kind) {
    if (busyRef.current || kind === selectedKind) return;
    busyRef.current = true;
    setSelectedKind(kind);
    foldGroup3List();
    trackFeedback?.(kind);

    // the currently-anchored CTA hides; it (or a fresh one) re-anchors below the reply
    if (ctaEntryIdRef?.current) {
      updateHistoryEntryData?.(ctaEntryIdRef.current, { hidden: true });
    }

    pushToHistory({ type: "user", text: ECHOES[kind], id: nextId() });

    const replyText = replies?.[kind];
    await showMyraMessage(replyText, 1000);
    if (isVoiceMode) speakChatTextIfVoice(replyText);

    if (kind === "have_question") {
      // CTA stays hidden until "Looks great" or "Change it" is pressed
    } else {
      const newCta = { type: "access-cta", id: nextId(), data: { onSignUp: ctaOnSignUp, onReachedPhase3 } };
      pushToHistory(newCta);
      if (ctaEntryIdRef) ctaEntryIdRef.current = newCta.id;
    }

    busyRef.current = false;
  }

  return (
    <div className={styles.inlineUi}>
      <div className={styles.planReactionChipStack}>
        {["looks_great", "change_it", "have_question"].map((kind) => (
          <button key={kind} type="button" className={`${styles.planReactionChip} ${selectedKind === kind ? styles.selected : ""}`} onClick={() => handleTap(kind)}>
            {ICONS[kind]}
            {LABELS[kind]}
          </button>
        ))}
      </div>
    </div>
  );
}

const SEND_ICON = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);
const CHAT_ICON_SVG = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
const VOICE_ICON_SVG = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
  </svg>
);
const CHEVRON_DOWN = (
  <svg className={styles.accordionChevron} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

// ── Intro CTA config (data-driven, extensible) ──
const INTRO_CTAS = [
  // { id: "video", label: "Watch a Video", type: "info" },
  { id: "start", label: MYRA_MESSAGES.intro.ctaLabels.start, type: "start" },
  // { id: "assessment", label: "Learn more about the assessment...", type: "info" },
  // { id: "myra", label: "Who is Myra?", type: "info" },
];

function getAssessmentSteps() {
  if (MYRA_MESSAGES.intro?.assessmentSteps) return MYRA_MESSAGES.intro.assessmentSteps;
  return [
    { title: "A few questions about your pain", body: "I'll ask where your pain started and a few targeted questions about what it feels like — sharp, dull, radiating. This helps me understand what's going on so I can pick the right movement checks for you." },
    { title: "A quick safety check", body: "Before any movements, I'll run through a short checklist to make sure it's safe to continue. If anything comes up, I'll recommend you see a provider first — your safety always comes first." },
    { title: "1–2 simple movement checks", body: "I'll pick 1 or 2 gentle movements based on your answers. I'll show you a demo video first, then guide you through it. The goal is never to push through pain — it's to help me understand your starting point." },
    { title: "A few optional personal details", body: "After the movement checks, you can share details like your age, activity level, and goals. The more I know, the more accurate your plan. If you skip this, I'll still build a plan with conservative assumptions." },
    { title: "Your personalized recovery plan", body: "Based on everything I've learned, I'll create a recovery plan with exercises tailored to you — including what to do, how often, and why each exercise was chosen." },
  ];
}

function isVirdioArHost() {
  if (typeof window === "undefined") return false;
  const host = (window.location?.hostname || window.location?.host || "").replace(/^www\./i, "").toLowerCase();
  return host.startsWith("virdio-ar");
}

function isFilledStateValue(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") return Object.keys(value).length > 0;
  return true;
}

function formatStateValue(value) {
  if (!isFilledStateValue(value)) return "empty";
  if (Array.isArray(value)) return value.map((item) => (typeof item === "object" ? JSON.stringify(item) : String(item))).join(", ");
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

function AssessmentStateFixedPanel({ assessmentData, currentStep, conversationCount }) {
  const data = assessmentData || {};
  const bucketState = buildBucketState(data);
  const personalizeState = buildPersonalizeState(data);
  const movementState = {
    testName: data.testName || data.rom_test1_name || null,
    viewed_test1_reveal: data.viewed_test1_reveal || null,
    rom_test1_started: data.rom_test1_started || null,
    selfReportRom: data.selfReportRom || null,
    selfReportSpeed: data.selfReportSpeed || data.selfReportPace || null,
    rpe: data.rpe ?? null,
    rom: data.rom || null,
    duration: data.duration || null,
    symptomResponse: data.symptomResponse || null,
    symptomResponseConfirm: data.symptomResponseConfirm || null,
    rom2: data.rom2 || null,
    duration2: data.duration2 || null,
  };

  const sections = [
    { title: "Session", rows: { currentStep, chatMessages: conversationCount || null } },
    { title: "Bucket", rows: bucketState },
    { title: "Movement", rows: movementState },
    { title: "Personalize", rows: personalizeState },
  ];

  return (
    <aside className={styles.arStatePanel} aria-label="Assessment state">
      <div className={styles.arStatePanelTitle}>Assessment State</div>
      {sections.map((section) => (
        <div key={section.title} className={styles.arStatePanelSection}>
          <div className={styles.arStatePanelSectionTitle}>{section.title}</div>
          {Object.entries(section.rows).map(([key, value]) => {
            const filled = isFilledStateValue(value);
            return (
              <label key={key} className={styles.arStatePanelRow}>
                <input type="checkbox" checked={filled} readOnly />
                <span className={styles.arStatePanelKey}>{key}</span>
                <span className={filled ? styles.arStatePanelValue : styles.arStatePanelValueEmpty}>{formatStateValue(value)}</span>
              </label>
            );
          })}
        </div>
      ))}
    </aside>
  );
}
function LbpStarterCarousel({ inputText, setInputText, chatInputRef, assessmentData, updateAssessmentData, pushToHistory, showMyraMessage, partnerLink }) {
  const problemArea = assessmentData?.problemArea;
  const starterPhrases = PROBLEM_AREA_STARTERS[problemArea] || LBP_STARTERS;
  const railRef = useRef(null);
  const [usedIds, setUsedIds] = useState(new Set());
  // Rail order: "info" plus one entry per starterPhrases index. "How I help
  // you" starts first; tapping it moves it to the end and everything after
  // it shifts forward, same as removing an item from the front of a queue.
  const [itemOrder, setItemOrder] = useState(() => ["info", ...starterPhrases.map((_, i) => i)]);
  const [arrowState, setArrowState] = useState({ left: true, right: false });
  const dragRef = useRef({ isDown: false, startX: 0, startScroll: 0, moved: false });

  // swipes refs
  const swipeTrackedRef = useRef(false);
  const programmaticScrollRef = useRef(false);
  const programmaticScrollTimeoutRef = useRef(null);

  const updateArrows = useCallback(() => {
    const rail = railRef.current;
    if (!rail) return;
    const maxScroll = rail.scrollWidth - rail.clientWidth;
    setArrowState({
      left: rail.scrollLeft <= 2,
      right: rail.scrollLeft >= maxScroll - 2,
    });
  }, []);
  const trackCarouselSwipe = useCallback(() => {
    if (swipeTrackedRef.current) return;
    swipeTrackedRef.current = true;

    const updatedData = {
      ...assessmentData,
      user_swipes_carosuel: true,
    };
    updateAssessmentData(updatedData);
    if (AnalyticsService) AnalyticsService.trackStep(updatedData);
  }, [assessmentData, updateAssessmentData]);

  useEffect(() => {
    const t = setTimeout(updateArrows, 100);
    window.addEventListener("resize", updateArrows);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", updateArrows);
      clearTimeout(programmaticScrollTimeoutRef.current);
    };
  }, [updateArrows]);

  // const nudge = (dir) => railRef.current?.scrollBy({ left: dir * 140, behavior: "smooth" });
  const nudge = (dir) => {
    trackCarouselSwipe();

    programmaticScrollRef.current = true;
    railRef.current?.scrollBy({ left: dir * 140, behavior: "smooth" });

    clearTimeout(programmaticScrollTimeoutRef.current);
    programmaticScrollTimeoutRef.current = setTimeout(() => {
      programmaticScrollRef.current = false;
    }, 500);
  };
  const handleScroll = useCallback(() => {
    updateArrows();
    if (!programmaticScrollRef.current) {
      trackCarouselSwipe();
    }
  }, [updateArrows, trackCarouselSwipe]);

  // ── Pointer drag-to-scroll (mouse), matches prototype's swallow-click-if-dragged ──
  const onPointerDown = (e) => {
    dragRef.current = { isDown: true, startX: e.clientX, startScroll: railRef.current.scrollLeft, moved: false };
  };
  const onPointerMove = (e) => {
    const d = dragRef.current;
    if (!d.isDown) return;
    const dx = e.clientX - d.startX;
    if (Math.abs(dx) > 6) {
      d.moved = true;
      railRef.current.scrollLeft = d.startScroll - dx;
    }
  };
  const onPointerUp = () => {
    dragRef.current.isDown = false;
  };
  const onRailClickCapture = (e) => {
    if (dragRef.current.moved) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const fill = (id, text) => {
    if (usedIds.has(id)) return;

    const trimmedPrev = inputText.trim();
    let newText;
    if (trimmedPrev.length === 0) {
      newText = text;
    } else {
      const existing = trimmedPrev.replace(/\.\s*$/, "");
      let joined = text.trim().replace(/\.\s*$/, "");
      // Skip lowercasing when the phrase opens with the standalone pronoun "I"
      // (e.g. "I get...", "I'm...") so we don't produce a lowercase "i".
      const startsWithStandaloneI = /^I(?:['\u2019]|\s|$)/.test(joined);
      joined = startsWithStandaloneI ? joined : joined.charAt(0).toLowerCase() + joined.slice(1);
      newText = `${existing}, and ${joined}. `;
    }

    setInputText(newText);
    setUsedIds((prev) => new Set(prev).add(id));

    const updatedData = {
      ...assessmentData,
      first_typed_message: newText,
    };
    updateAssessmentData(updatedData);
    if (AnalyticsService) AnalyticsService.trackStep(updatedData);

    const el = chatInputRef.current;
    if (el) {
      el.focus();
      el.setSelectionRange(el.value.length, el.value.length);
    }
  };
  const handleInfoClick = useCallback(async () => {
    const bulletsHtml = `Here is how I help you get moving again<ul class="${styles.infoBullets}"><li>I ask a few questions about your back, so I can understand how it is affecting you.</li><li>I guide you through one gentle movement, and you tell me how it felt.</li><li>From there, I choose from over 100 stretches and exercises to support your recovery.</li><li>And anytime you have a question along the way, I am right here.</li></ul>`;

    // Move "How I help you" to the end of the rail; everything after it
    // shifts forward to fill the gap.
    setItemOrder((prev) => {
      const idx = prev.indexOf("info");
      if (idx === -1) return prev;
      return [...prev.slice(0, idx), ...prev.slice(idx + 1), "info"];
    });

    await showMyraMessage(bulletsHtml, 500);
    let painArea = problemArea === "LBP" ? "lower back" : problemArea?.toLowerCase();
    await showMyraMessage(`When you are ready, tell me a little about what's been going on with your ${painArea}.`, 900);

    // Scroll back to the first item.
    programmaticScrollRef.current = true;
    railRef.current?.scrollTo({ left: 0, behavior: "smooth" });
    clearTimeout(programmaticScrollTimeoutRef.current);
    programmaticScrollTimeoutRef.current = setTimeout(() => {
      programmaticScrollRef.current = false;
    }, 500);
  }, [showMyraMessage]);

  return (
    <div className={styles.starterZone}>
      <div className={partnerLink ? styles.starterLabelPartner : styles.starterLabel}>Tap any that fit, or tell me in your own words.</div>
      <div className={styles.railRow}>
        <button className={styles.railArrow} disabled={arrowState.left} onClick={() => nudge(-1)}>
          ‹
        </button>
        <div className={styles.starterRail} ref={railRef} onScroll={handleScroll} onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={onPointerUp} onPointerCancel={onPointerUp} onClickCapture={onRailClickCapture}>
          {itemOrder.map((item, idx) => {
            if (item === "info") {
              return !partnerLink ? (
                <React.Fragment key="info">
                  {idx !== 0 && <div className={styles.railDivider} />}
                  <button type="button" className={styles.infoItem} onClick={handleInfoClick}>
                    <span className={styles.infoIcon}>i</span>
                    How I help you
                  </button>
                  {idx === 0 && <div className={styles.railDivider} />}
                </React.Fragment>
              ) : null;
            }
            const text = starterPhrases[item];
            const used = usedIds.has(item);
            return (
              <button key={item} type="button" className={`${styles.starterItem} ${used ? styles.used : ""}`} onClick={() => fill(item, text)}>
                <span className={styles.starterPlus}>{used ? "✓" : "+"}</span>
                <span className={styles.starterText}>{text.trim().replace(/\.$/, "")}</span>
              </button>
            );
          })}
          {partnerLink && (
            <>
              <div className={styles.railDivider} />
              <button type="button" className={styles.infoItem} onClick={handleInfoClick}>
                <span className={styles.infoIcon}>i</span>
                How I help you
              </button>
            </>
          )}
        </div>
        <button className={styles.railArrow} disabled={arrowState.right} onClick={() => nudge(1)}>
          ›
        </button>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ════════════════════════════════════════════════════════════════

export default function SelfAssessment2({ displayMode = "fullscreen", onStartAssessment, onMyraEngagement }) {
  const { assessmentData, updateAssessmentData, resetAssessmentData } = useAssessment();
  const [currentStep, setCurrentStep] = useState("intro");
  const [exitCurrentStep, setExitCurrentStep] = useState(false);
  const [landingChipArea, setLandingChipArea] = useState(null);
  const [hideCtaBtn, setHideCtaBtn] = useState(false);
  const [showInitiallyHideHeader, setShowInitiallyHideHeader] = useState(false); // purpose is to hide the myra header until the assessment is started

  useEffect(() => {
    window.updateAssessmentDataGlobal = updateAssessmentData;
  }, [updateAssessmentData]);

  // ── Conversation history (message accumulator) ──
  const [conversationHistory, setConversationHistory] = useState([]);
  const conversationHistoryRef = useRef([]);
  const frontendChatTurnNumberRef = useRef(0);
  const logFrontendDisplayedChatEntryRef = useRef(null);
  const loggedFrontendEntryIdsRef = useRef(new Set());
  const [typingVisible, setTypingVisible] = useState(false);
  const [nprsPainSelected, setNprsPainSelected] = useState(false);
  const [introExternalAction, setIntroExternalAction] = useState(null);

  // ── Input bar ──
  const [inputText, setInputText] = useState("");
  const [showIntroCtas, setShowIntroCtas] = useState(false);
  const [ctaUsed, setCtaUsed] = useState(new Set());
  const [introProminent, setIntroProminent] = useState(false);
  const [inputRows, setInputRows] = useState(1);

  // ── Shell UI ──
  const [progressPercent, setProgressPercent] = useState(5);
  const [stepLabel, setStepLabel] = useState("Getting Started");
  const [mode, setMode] = useState(MyraInteraction.getMode() || "chat");
  // this use effect checks if mic access cancel , back to chat mode ui updated
  useEffect(() => {
    const unsubs = [
      MyraInteraction.on("modeChange", ({ mode }) => setMode(mode)),
      MyraInteraction.on("micDenied", () => setMode("chat")), //
    ];
    return () => unsubs.forEach((fn) => fn());
  }, []);

  const [fromVirdioHealth, setFromVirdioHealth] = useState(false);

  // ── Intent detection (stubbed) ──
  const [detectedArea, setDetectedArea] = useState(null);
  const [detectedDuration, setDetectedDuration] = useState(null); // eslint-disable-line
  const [detectedTrigger, setDetectedTrigger] = useState(null); // eslint-disable-line
  // Intent matching logic deferred — separate project

  // user from the new lbp landing page with data
  const location = useLocation();
  const [completedFlowData, setCompletedFlowData] = useState(null);

  useEffect(() => {
    const saveAccessDataToBackend = async (data) => {
      try {
        // Build payload with only the fields we have
        const payload = {};

        // Only add fields if they exist in the data object
        if (data.sessionId) payload.sessionId = data.sessionId || window.trSessionId;
        if (data.startedAt) payload.startedAt = data.startedAt;
        if (data.stoppedAt) payload.stoppedAt = data.stoppedAt;
        if (data.selectedArea) payload.area = data.selectedArea;
        if (data.selectedState) payload.state = data.selectedState;
        if (data.screenAns) payload.coverageAnswers = data.screenAns;
        if (data.exclusionItemsShown) payload.exclusionItemsShown = data.exclusionItemsShown;
        if (data.exclusionItemsFired) payload.exclusionItemsFired = data.exclusionItemsFired;
        if (data.exclAlone !== undefined && data.exclAlone !== null) {
          payload.aloneAnswer = data.exclAlone;
        }
        if (data.aloneAsked !== undefined) payload.aloneAsked = data.aloneAsked;
        if (data.outcomeType) payload.outcome = data.outcomeType;
        if (data.wordingVersion) payload.wordingVersion = data.wordingVersion;
        if (data.submittedToCms !== undefined) payload.submittedToCms = data.submittedToCms;
        if (data.submissionId) payload.submissionId = data.submissionId;
        if (data.submissionRecordId !== undefined && data.submissionRecordId !== null) {
          payload.submissionRecordId = data.submissionRecordId;
        }
        if (data.firstName) payload.legalFirstName = data.firstName;
        if (data.lastName) payload.legalLastName = data.lastName;
        if (data.dobM) payload.dobMonth = parseInt(data.dobM);
        if (data.dobD) payload.dobDay = parseInt(data.dobD);
        if (data.dobY) payload.dobYear = parseInt(data.dobY);
        if (data.sex) payload.gender = data.sex;
        if (data.mbi) {
          // Clean MBI (removed dashes)
          const cleanMbi = data.mbi.replace(/[^0-9A-Z]/gi, "").toUpperCase();
          payload.medicareNumber = cleanMbi;
        }
        if (data.saveContact) {
          payload.saveContact = data.saveContact;
        }

        // If no data to save, skip
        if (Object.keys(payload).length === 0) {
          console.log("[AccessData] No data to save");
          return;
        }

        const response = await fetch(CONST.SAVE_ACCESS_DATA, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (result.success) {
          console.log("[AccessData] Saved successfully:", result);
        } else {
          console.error("[AccessData] Save failed:", result.message);
        }
      } catch (error) {
        console.error("[AccessData] API call error:", error);
      }
    };
    if (location.state?.completedFlowData) {
      setCompletedFlowData(location.state.completedFlowData);
      window.completedFlowData = location.state.completedFlowData;

      // ===== SET window.accessPrescreenAnswers =====
      const data = location.state.completedFlowData;
      window.accessPrescreenAnswers = {
        wordingVersion: data.wordingVersion || "excl-2026-08-04-r4-draft",
        answeredAt: data.stoppedAt || data.startedAt,
        items: {
          injury: data.exclTicks?.includes("injury") || false,
          surgery: data.exclTicks?.includes("surgery") || false,
          recovering: data.exclTicks?.includes("recovering") || false,
          fracture: data.exclTicks?.includes("fracture") || false,
          osteoporosis: data.exclTicks?.includes("osteoporosis") || false,
          weightbearing: data.exclTicks?.includes("weightbearing") || false,
          pregnancy: data.exclTicks?.includes("pregnancy") || false,
          hospice: data.exclTicks?.includes("hospice") || false,
        },
        ableToExerciseAlone: data.exclAlone === "yes" ? true : data.exclAlone === "no" ? false : true,
        submissionId: data.submissionId || null,
        submissionRecordId: data.submissionRecordId || null,
      };
      saveAccessDataToBackend(data);
      return;
    }

    const saved = localStorage.getItem("virdio_lbp_preferences");
    if (saved) {
      try {
        const data = JSON.parse(saved);
        setCompletedFlowData(data);
        window.completedFlowData = data;

        // ===== SET window.accessPrescreenAnswers from localStorage =====
        window.accessPrescreenAnswers = {
          wordingVersion: data.wordingVersion || "excl-2026-08-04-r4-draft",
          answeredAt: data.stoppedAt || data.startedAt,
          items: {
            injury: data.exclTicks?.includes("injury") || false,
            surgery: data.exclTicks?.includes("surgery") || false,
            recovering: data.exclTicks?.includes("recovering") || false,
            fracture: data.exclTicks?.includes("fracture") || false,
            osteoporosis: data.exclTicks?.includes("osteoporosis") || false,
            weightbearing: data.exclTicks?.includes("weightbearing") || false,
            pregnancy: data.exclTicks?.includes("pregnancy") || false,
            hospice: data.exclTicks?.includes("hospice") || false,
          },
          ableToExerciseAlone: data.exclAlone === "yes" ? true : data.exclAlone === "no" ? false : true,
          submissionId: data.submissionId || null,
          submissionRecordId: data.submissionRecordId || null,
        };
        saveAccessDataToBackend(data);
      } catch (e) {
        // ignore malformed cache
      }
    }
  }, [location.state]);

  // ── Scroll management ──
  const chatAreaRef = useRef(null);
  const chatEndSentinelRef = useRef(null);
  const chatInputRef = useRef(null);
  const chatScrollStateRef = useRef({
    following: true,
    activeTarget: { type: "bottom" },
    unreadMyraIds: [],
    // Bumped every time a new active target is set. A scheduled re-scroll captures
    // the value at scheduling time and skips itself if a newer target has since
    // been set, so a stale earlier message can never re-assert itself.
    generation: 0,
  });
  const knownHistoryEntryIdsRef = useRef(new Set());
  const programmaticScrollRef = useRef(false);
  const smoothScrollInProgressRef = useRef(false);
  const lastSmoothScrollTargetRef = useRef(null);
  const programmaticScrollTimerRef = useRef(null);
  const manualScrollIntentRef = useRef(false);
  const manualScrollIntentTimerRef = useRef(null);
  const targetSyncRafRef = useRef(null);
  const targetSyncTimerRef = useRef(null);
  const messageSettleTimersRef = useRef(new Set());
  const jumpStateRafRef = useRef(null);
  const jumpShowTimerRef = useRef(null);
  const jumpVisibleRef = useRef(false);
  const keepInputFocusedOnJumpRef = useRef(false);
  const landingEnterTimeRef = useRef(null);

  // ── Keyboard-aware "jump to hidden content" pill ──
  const [hasContentBelow, setHasContentBelow] = useState(false);

  // ── QnA overlay ──
  const [qaOpen, setQaOpen] = useState(false);
  const qaRef = useRef(null);

  // ── Cross-cutting overlays ──
  const [showExitHandler, setShowExitHandler] = useState(false);
  const [showInactivityModal, setShowInactivityModal] = useState(false);

  // LBP SWIPEABLE CARDS SHOW/HIDE
  const [showLbpStarters, setShowLbpStarters] = useState(false);

  // ── Screen-specific command refs (for input bar routing) ──
  const introAdvanceRef = useRef(null);
  const introCtaHandlerRef = useRef(null);
  const paCommandRef = useRef(null);

  // ── Bucket-router transition guard ──
  // Prevents the start_gsa_request block and the auto-trigger block in
  // handleInlineChat from both firing in the same turn. Set to true the
  // first time either block decides to fire the GSA transition. Never
  // reset — once currentStep advances past "intro", neither block can
  // re-enter (both gate on currentStep === "intro").
  const transitionFiredRef = useRef(false);
  // ── Inline-chat in-flight guard ──
  // Mirrors MyraInteractionController.sendChatMessage's _chatLoading guard:
  // blocks concurrent/duplicate sends (double-tap, Enter+send race, replayed
  // trigger events) from re-posting a user message while a turn is in flight.
  const inlineChatBusyRef = useRef(false);
  // Pending chat TTS lines; doSay callback drains one-by-one (no VoiceService queue).
  const speakChatQueueRef = useRef([]);
  const pendingPostTapRef = useRef(null);
  const postTapTimerRef = useRef(null);
  const chatScreenTimerRef = useRef({
    currentScreen: null,
    startTime: null,
    screenDurations: {},
  });

  // ── QA strip tracking ──
  const qaStripIdsRef = useRef(new Set());

  // ── Embedded → fullscreen transition tracking ──
  const prevDisplayModeRef = useRef(displayMode);

  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const [problemArea, setProblemArea] = useState(null);
  const [hideContent, setHideContent] = useState(false);

  // analytics states:
  const [isComeFromGoogle, setIsComeFromGoogle] = useState(localStorage.getItem("variant") ? true : false);
  const [isUserCameBackAgain, setIsUserCameBackAgain] = useState(false);
  const [userVariant, setUserVariant] = useState(null);
  const [partnerLink] = useState(() => new URLSearchParams(window.location.search).get("link"));
  const [placeholderText, setPlaceholderText] = useState(isComeFromGoogle ? INPUT_PLACEHOLDERS.google_default : INPUT_PLACEHOLDERS.default);
  const history = useHistory();
  const { pathname, search } = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    const isSelfAssessmentRoute = pathname === "/" || pathname === "/intake/lower-back";

    if (displayMode === "embedded" || !isSelfAssessmentRoute) {
      delete root.dataset.selfAssessmentActive;
      return undefined;
    }

    root.dataset.selfAssessmentActive = "true";

    return () => {
      delete root.dataset.selfAssessmentActive;
    };
  }, [displayMode, pathname]);

  // Voice Status
  const [voiceTranscript, setVoiceTranscript] = useState("");
  const [voiceStatus, setVoiceStatus] = useState("");
  const [qaSilencePhase, setQaSilencePhase] = useState("listening");

  const [chatBucketTest, setChatBucketTest] = useState([]);
  const [inLineChatHistory, setInLineChatHistory] = useState([]);
  const [showRationale, setShowRationale] = useState({});
  function toggleRationale(index) {
    setShowRationale((prev) => ({ ...prev, [index]: !prev[index] }));
  }

  // this ref t ensure safety_stops only shows once
  const safetyStopCardShownRef = useRef(false);
  const accessExcludedCardShownRef = useRef(false);
  const [nativeWarningArmed, setNativeWarningArmed] = useState(false);
  const nativeExitAnalyticsFiredRef = useRef(false);
  function isFlutterTakeoverActive() {
    const loader = document.getElementById("flutter-loader");
    const loaderVisible = loader && getComputedStyle(loader).display !== "none";

    const flutterRoot = document.getElementById("OnDemandPlayingRoot");
    const flutterRootVisible = flutterRoot && getComputedStyle(flutterRoot).display !== "none";

    return !!(loaderVisible || flutterRootVisible);
  }
  useEffect(() => {
    setNativeWarningArmed(true);
    window.__suppressNativeUnloadWarning = true;
    return () => {
      window.__suppressNativeUnloadWarning = false;
      setNativeWarningArmed(false);
    };
  }, []);
  useEffect(() => {
    const isAccessUser = location.state?.completedFlowData?.isAccessUser === true;
    if (isAccessUser) {
      localStorage.setItem("accessUser", "1");
    } else {
      localStorage.removeItem("accessUser");
    }
    window.is_access_user = isAccessUser;
    const updatedData = {
      is_access_user: isAccessUser,
    };
    AnalyticsService.trackStep(updatedData);
  }, []);
  // user saved mail and we send a notifation, user came from that notification
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const accessUserFromMail = params.get("accessUserFromMail");

    if (accessUserFromMail === "true") {
      window.is_access_user = true;
      const updatedData = {
        is_access_user: accessUserFromMail,
      };
      AnalyticsService.trackStep(updatedData);
    }
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!window.__suppressNativeUnloadWarning) return;
      if (isFlutterTakeoverActive()) return;
      if (!nativeWarningArmed) return;
      const step = currentStepRef.current;
      const noWarnSteps = ["hard_stop", "plan", "safety_stop", "safety_advisory"];
      if (noWarnSteps.includes(step)) return;
      if (!window.currentScreen) return;
      if (window.currentScreen === "intro" || window.currentScreen === "plan") return;

      // Only warn if there's an actual in-progress session worth protecting.
      const hasSession = !!(window.trSessionId || localStorage.getItem("trSessionId"));
      if (!hasSession) return;

      e.preventDefault();
      e.returnValue = ""; // required for the dialog to appear; text itself is ignored by browsers
      return "";
    };

    // pagehide only fires on an actual unload — never when the user clicks
    // "Cancel" on the beforeunload dialog — so this is safe from false positives.
    const handleNativeExitAnalytics = () => {
      if (!window.__suppressNativeUnloadWarning) return;
      if (nativeExitAnalyticsFiredRef.current) return;
      if (!nativeWarningArmed) return;
      if (isFlutterTakeoverActive()) return;

      const step = currentStepRef.current;
      const noWarnSteps = ["hard_stop"];
      if (noWarnSteps.includes(step)) return;

      const hasSession = !!(window.trSessionId || localStorage.getItem("trSessionId"));
      if (!hasSession) return;

      nativeExitAnalyticsFiredRef.current = true;

      if (AnalyticsService?.trackStep) {
        AnalyticsService.trackStep({
          ...assessmentData,
          event_name: "exit_gsa",
          exitReason: "want_to_leave",
          exitStep: window.currentScreen || STEP_CONFIG[currentStep] || "intro",
          context_type: "browser_close",
          outcome: "EXIT",
          feedback: null,
          comm_mode: MyraInteraction?.getCurrentMode?.() || "button",
          timestamp: new Date().toISOString(),
          screenFlow: window.screenTracker?.getScreenFlow() || [],
        });
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("pagehide", handleNativeExitAnalytics);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("pagehide", handleNativeExitAnalytics);
    };
  }, [assessmentData, currentStep]);

  // setting the input rows:
  useEffect(() => {
    const el = chatInputRef.current;
    if (!el) return;
    el.rows = 1; // reset to measure natural scrollHeight at 1 row
    const lineHeight = 20;
    let scrollHeight = el.scrollHeight;
    // iOS keyboard-up: empty textarea.scrollHeight ignores placeholder — estimate from width
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const text = inputText?.trim();
    if (isIOS && !text && placeholderText) {
      el.value = placeholderText;
      scrollHeight = el.scrollHeight;
      el.value = "";
    }

    const neededRows = Math.floor((scrollHeight - 22) / lineHeight);
    setInputRows(Math.max(1, Math.min(2, neededRows)));
  }, [inputText]);

  // input
  const [inputType, setInputType] = useState("text");
  useEffect(() => {
    if (currentStep === "nprs_symptoms") {
      setInputType("number");
    } else {
      setInputType("text");
    }
    setExitCurrentStep(currentStep);
    window.currentScreen = currentStep;
  }, [currentStep]);
  const currentStepRef = useRef(currentStep);
  useEffect(() => {
    currentStepRef.current = currentStep;
  }, [currentStep]);

  useEffect(() => {
    conversationHistoryRef.current = conversationHistory;
  }, [conversationHistory]);

  const [showVideoOverlay, setShowVideoOverlay] = useState(false);
  const [exerciseVideoUrl, setExerciseVideoUrl] = useState(null);

  const heroVideoRef = useRef(null);
  const handleHomeVideoClicked = () => {
    setShowVideoOverlay(true);
    window.isHomeVideoWatch = true;
    updateAssessmentData({ homeVideoWatch: true });
    setTimeout(() => {
      if (heroVideoRef.current) {
        heroVideoRef.current.play().catch((err) => {
          console.error("Video play failed:", err);
          // Most browsers require user interaction first
          // The video will have controls so user can manually play
        });
      }
    }, 100);

    // Track video engagement for analytics
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        ...assessmentData,
        homeVideoWatch: true,
        event: "intro_video_opened",
        timestamp: new Date().toISOString(),
        analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
        session_last_update: new Date().toISOString(),
      });
    }
  };
  const handleWhoIsMyraClick = async () => {
    const question = "Who is Myra?";
    const answer = MYRA_MESSAGES.intro?.whoIsMyra || "I'm Myra, your recovery coach from Virdio Health. I'm powered by AI — not a human — but I'm designed to guide you through understanding and recovering from muscle and joint pain. I work alongside doctors of physical therapy and evidence-based research to help you do recovery at home, under your own guidance. I'm not a doctor, physical therapist, or clinician.";
    const type = "myra";
    pushToHistory({ type: "user", text: question, id: nextId(), skipChatLog: true });
    await _delay(400);
    const qaItem = { id: nextId(), question, answer, type };
    await showMyraMessage(answer, 800);
    await _delay(1000);
  };

  useEffect(() => {
    const el = document.getElementById("debugVoice");
    if (!el) return;

    const observer = new MutationObserver(() => {
      setVoiceTranscript(el.innerHTML.trim());
    });

    observer.observe(el, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!voiceTranscript || mode !== "voice") return;

    const interval = setInterval(() => {
      const silenceMs = VoiceService.getSilenceDurationMs?.() || 0;
      if (silenceMs < 2000) {
        setQaSilencePhase("listening");
      } else if (silenceMs < 3000) {
        setQaSilencePhase("still");
      } else {
        setQaSilencePhase("thinking");
      }
    }, 200);

    return () => clearInterval(interval);
  }, [voiceTranscript, mode]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("qa") === "1") {
      localStorage.setItem("qa_flag_altModeSwitch", "true");
    }
  }, []);

  useEffect(() => {
    const initialStep = location.state?.initialStep;
    if (initialStep && STEP_CONFIG[initialStep]) {
      setFromVirdioHealth(true);
      setCurrentStep(initialStep);
    }
    const searchParams = new URLSearchParams(location.search);
    const hasStart = searchParams.has("start") || (searchParams.has("step") && searchParams.get("step") == "startnow");
    if (hasStart) {
      setFromVirdioHealth(true);
    }
  }, []);

  useEffect(() => {
    if (mode !== "voice") {
      setVoiceStatus("");
      return;
    }

    const computeStatus = () => {
      const agentState = window.mayraCode?.getState?.();
      const isAgentSpeaking = agentState?.isAgentSpeaking || VoiceService._isAgentSpeaking;
      const isListening = agentState?.isListening || VoiceService._isListening;
      const connectionStatus = VoiceService.getConnectionStatus?.() || "";

      const QNA_FLOWS = ["flow_plan_v2", "flow_landing_page", "flow_post_session_qa", "flow_gsa"];
      const isQnAFlow = QNA_FLOWS.includes(window.currentFlow);

      let statusText = "";

      if (connectionStatus === "not_initialized") {
        statusText = "";
      } else if (connectionStatus === "disconnected") {
        statusText = "Connection lost, reconnecting…";
      } else if (connectionStatus === "reconnecting") {
        statusText = "Connecting...";
      } else if (isAgentSpeaking) {
        statusText = "Speaking...";
      } else if (connectionStatus === "Processing_Question") {
        statusText = "Processing your question...";
      } else if (connectionStatus === "Forced_Status" && window.forcedStatusMyra) {
        statusText = window.forcedStatusMyra;
      } else if (connectionStatus === "Preparing_Response") {
        statusText = "Preparing response…";
      } else if (voiceTranscript && isListening) {
        if (qaSilencePhase === "listening") {
          statusText = "Listening…";
        } else if (qaSilencePhase === "still") {
          statusText = "Still listening…";
        } else if (qaSilencePhase === "thinking") {
          statusText = "Thinking…";
        }
      } else if (isListening) {
        statusText = isQnAFlow ? "Ask me anything..." : "Listening...";
      } else {
        statusText = "";
      }

      setVoiceStatus(statusText);
    };

    // Poll every 200ms so speaking/listening changes are reflected quickly
    computeStatus();
    const interval = setInterval(computeStatus, 200);
    return () => clearInterval(interval);
  }, [mode, voiceTranscript, qaSilencePhase]);

  const PROBLEM_AREA_OPTIONS = ["LBP", "HIP", "THIGH", "KNEE"].map((id) => ({
    id,
    label: MYRA_MESSAGES.problemArea.optionsById[id].label,
  }));

  const handleChipClick = async (option) => {
    const el = chatInputRef.current;
    if (el && document.activeElement !== el) {
      el.focus();
    }
    // triggers when user clicks on the any cta button or type something in the input
    if (window.gtag) {
      console.log("USER-PRESSED CTA GTAG-TRIGGERS");
      window.gtagFirstTimeTrigger = true;
      window.gtag("event", "conversion", {
        send_to: "AW-18002481001/4AZGCNCA7YUcEOmeoIhD",
      });
    }
    window.firstMessageTyped = true; // user uses clicks on the chip so we are setting it to true so the first message update will not trigger inside handleInlineChat

    setShowInitiallyHideHeader(true); // assessment-started show the header
    setShowIntroCtas(true);
    setHideContent(true);
    window.hideNavbarBtm = true;
    requestFlutterLogoutForAssessmentStart();

    const selectedArea = option?.id;
    window.showChips = true;
    setHideContent(true);
    setLandingChipArea(selectedArea);
    window.problemArea = selectedArea;
    setProblemArea(selectedArea);
    const updatedData = {
      started_assessment: true,
      myraInteractionMode: mode || "chat",
      isComeFromGoogle: isComeFromGoogle,
      fromPartnerLink: partnerLink ? partnerLink : null,
      isUserCameBackAgain: isUserCameBackAgain,
      variant: userVariant,
      analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
      problemArea: selectedArea,
      selected_problem_area: CONST.CLINICAL_PATHS?.[selectedArea]?.name || selectedArea,
      clicked_landing_cta: true,
      landing_cta_body_part: selectedArea || problemArea || null,
      session_last_update: new Date().toISOString(),
      is_access_user: window.is_access_user ? true : false,
    };
    if (["LBP", "HIP", "THIGH", "KNEE"].includes(selectedArea)) {
      setShowLbpStarters(true);
    }
    // localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    updateAssessmentData(updatedData);

    const phrasePerArea = {
      LBP: "My lower back hurts",
      HIP: "My hip hurts",
      THIGH: "My thigh hurts",
      KNEE: "My knee hurts",
    };

    const message = phrasePerArea[selectedArea];

    if (message) {
      const userEntry = { type: "user", text: message, id: nextId(), skipChatLog: true };
      pushToHistory(userEntry);
    }
    setPlaceholderText(INPUT_PLACEHOLDERS?.chip_clicked_by_area?.[selectedArea] || INPUT_PLACEHOLDERS?.chip_clicked || "Tell me what's going on with your back…");

    const combinedMessage = MYRA_MESSAGES.problemArea.autoResponse[selectedArea];

    await showMyraMessage(combinedMessage, 900);
    const seededTurns = [...(message ? [{ role: "user", content: message }] : []), ...(combinedMessage ? [{ role: "assistant", content: combinedMessage }] : [])];
    const nextInlineHistory = [...inlineChatHistoryRef.current, ...seededTurns];
    inlineChatHistoryRef.current = nextInlineHistory;
    setInLineChatHistory(nextInlineHistory);
  };

  // select problem area when user arrives from the LBP landing flow (eligible or ineligible)
  useEffect(() => {
    const flowData = location.state?.completedFlowData;
    if (!introProminent || !flowData || (flowData?.isAccessUser !== false && !window.is_access_user)) return;
    const area = flowData?.selectedArea;
    if (!["LBP", "HIP", "THIGH", "KNEE"].includes(area) || !area) return;
    handleChipClick({ id: area });
  }, [introProminent, location.state]);

  // Exposing  the start function for the static HTML catch-and-replay system.
  // as its thenCalled by window.__intakeReactReady__() if the user tapped before React booted.
  useEffect(() => {
    window.__intakeStartAssessment__ = ({ area } = {}) => {
      // 1. Set the problem area if one was passed (from a chip tap on the static page)
      if (area) {
        window.problemArea = area;
      }

      // 2. Read area from the page declaration if not passed explicitly
      const resolvedArea = area || window.__INTAKE_AREA__ || null;
      if (resolvedArea) {
        updateAssessmentData({
          problemArea: resolvedArea,
          selected_problem_area: resolvedArea,
        });
      }
      // 3. handle chip clicked with the resolved area (if any)
      // handleChipClick({ id: resolvedArea });
    };

    return () => {
      window.__intakeStartAssessment__ = null;
    };
  }, [handleChipClick]);

  // ═══════════════════════════════════════════════════════════
  // INITIALIZATION
  // ═══════════════════════════════════════════════════════════

  useEffect(() => {
    window.trSessionId = localStorage?.getItem("trSessionId") || null;
    if (!window?.trSessionId && AnalyticsService) AnalyticsService?.startSession();
    // if (!window.timeTracker) {
    window.timeTracker = new TimeTracker();
    window.timeTracker.startGSATimer();
    window.timeTracker.startLandingTimer();
    // }
    // if (!window.screenTracker) {
    const existingScreenFlow = window.screenTracker?.getScreenFlow?.() || [];
    window.screenTracker = new ScreenFlowTracker(existingScreenFlow);
    // }
    localStorage.setItem("cameFromGsaV2", "false");

    // ── Journey auto-save every 5s ──
    // First save fires immediately (t=0) so we capture the landing entry.
    // Subsequent saves every 5s capture incremental progress. This means
    // a 0–5s exit has one record, a 5–10s exit has two, etc.
    const triggerJourneySave = () => {
      if (AnalyticsService) {
        const currentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");
        saveUserJourney({ ...assessmentData, ...currentData });
      }
    };

    // Immediate save at t=0 (page load / landing entry)
    triggerJourneySave();

    // Periodic save every 5 seconds
    window._journeyAutoSaveInterval = setInterval(triggerJourneySave, 5000);

    // Belt-and-suspenders: ensure started_assessment is written even for direct
    // entries that bypass HomeScreen.handleStartAssessment (e.g., /problem-area
    // deep links from subpages, returning sessions). HomeScreen still sets this
    // during its landing-to-GSA transition; this is a safety net, not a replacement.
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        ...assessmentData,
        //started_assessment: true,
        session_last_update: new Date().toISOString(),
      });
    }

    window.globalCrossClicked = () => setShowExitHandler(true);
    window.updateMicModalCancel = () => {
      const updated = { ...assessmentData, userCancelMic: true };
      updateAssessmentData(updated);
      if (AnalyticsService) AnalyticsService?.trackStep(updated);
    };

    return () => {
      window.globalCrossClicked = null;
      window.updateMicModalCancel = null;
      if (window._journeyAutoSaveInterval) {
        clearInterval(window._journeyAutoSaveInterval);
        window._journeyAutoSaveInterval = null;
      }
    };
  }, []);

  // setting the placeholder
  // useEffect(() => {
  //   const placeholder = currentStep === "feedback2" ? INPUT_PLACEHOLDERS.default : INPUT_PLACEHOLDERS[currentStep] || INPUT_PLACEHOLDERS.default;
  //   setPlaceholderText(placeholder);
  // }, [currentStep]);
  useEffect(() => {
    const placeholder = currentStep === "feedback2" ? (isComeFromGoogle ? INPUT_PLACEHOLDERS.google_default : INPUT_PLACEHOLDERS.default) : INPUT_PLACEHOLDERS[currentStep] || (isComeFromGoogle ? INPUT_PLACEHOLDERS.google_default : INPUT_PLACEHOLDERS.default);
    setPlaceholderText(placeholder);
  }, [currentStep, isComeFromGoogle]);

  // useEffect(() => {
  //   if (displayMode === "fullscreen" && currentStep === "intro") {
  //     setCurrentStep("problem_area");
  //     pushToHistory({ type: "section-header", label: STEP_CONFIG.problem_area.label, id: nextId() });
  //   }
  // }, [displayMode, currentStep]);

  // ── Global AUTO_PAUSE command ──
  useEffect(() => {
    const timer = setTimeout(() => {
      const existing = window.currentCommandsAudio || {};
      window.currentCommandsAudio = {
        ...existing,
        AUTO_PAUSE: () => {
          if (isVoiceMode) {
            VoiceService?.doSay("I've paused. Take your time...");
          } else {
            setShowInactivityModal(true);
          }
        },
      };
    }, 200);
    return () => clearTimeout(timer);
  }, [currentStep]);

  // ── Embedded → fullscreen deferred advance ──
  // useEffect(() => {
  //   if (prevDisplayModeRef.current === "embedded" && displayMode === "fullscreen" && currentStep === "intro") {
  //     if (!window.trSessionId && AnalyticsService) AnalyticsService.startSession();
  //     localStorage.setItem("startedSelf", "1");
  //     if (window.gtag) window.gtag("event", "conversion", { send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD", value: 1.0, currency: "USD" });
  //     setCurrentStep("problem_area");
  //   }
  //   prevDisplayModeRef.current = displayMode;
  // }, [displayMode]);

  const pushToHistory = useCallback((...entries) => {
    const validEntries = entries.filter(Boolean);
    validEntries.forEach((entry) => {
      // logFrontendDisplayedChatEntryRef.current?.(entry);
      if (!entry.skipChatLog) {
        logFrontendDisplayedChatEntryRef.current?.(entry);
      }
    });
    conversationHistoryRef.current = [...conversationHistoryRef.current, ...validEntries];
    setConversationHistory((prev) => {
      const next = [...prev, ...validEntries];
      conversationHistoryRef.current = next;
      return next;
    });
  }, []);

  // Patches an already-pushed history entry's `data` in place. Used to hide
  // the plan sign-up CTA so a freshly re-pushed one appears "re-anchored"
  // below the latest reaction-chip reply (history is append-only; entries
  // themselves are never deleted or reordered).
  const updateHistoryEntryData = useCallback((entryId, dataPatch) => {
    setConversationHistory((prev) => {
      const next = prev.map((e) => (e.id === entryId ? { ...e, data: { ...e.data, ...dataPatch } } : e));
      conversationHistoryRef.current = next;
      return next;
    });
  }, []);

  useEffect(() => {
    if (!MyraInteraction.getMode()) {
      MyraInteraction.switchMode("chat", true);
    }
  }, []);

  // ═══════════════════════════════════════════════════════════
  // PERSISTENCE
  // ═══════════════════════════════════════════════════════════

  const persistAndNavigate = useCallback(
    (newFields, nextStep) => {
      const updatedData = {
        ...assessmentData,
        ...newFields,
        screenFlow: window.screenTracker?.getScreenFlow() || [],
        session_last_update: new Date().toISOString(),
      };
      updatedData.analyticsId = window.trSessionId;
      updateAssessmentData(updatedData);
      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
      if (AnalyticsService) AnalyticsService.trackStep(updatedData);

      console.log("Steps", currentStep, nextStep, STEP_CONFIG[nextStep]);

      // Push divider + section header for the incoming screen
      // Skip section header if the next step shares the same label as the current step
      const nextConfig = STEP_CONFIG[nextStep];
      const skipDividerForSteps = ["pain_location", ...MOVEMENT_QUESTION_SCREENS];
      const shouldSkipDivider = skipDividerForSteps.includes(nextStep) || (currentStep === "safety_screening" && nextStep === "test1_demo");
      const shouldAllowLabel = currentStep === "subtype_questioning" && nextStep === "self_assessment";
      if (nextConfig && nextStep !== "hard_stop") {
        const currentConfig = STEP_CONFIG[currentStep];
        if (window.test2WasSkipped) {
          console.log("SKIPPING HEADER AND DIVIDER , 2nd movement check moves to plan-recommendation");
        } else if (shouldSkipDivider) {
          console.log("SKIPPING HEADER AND DIVIDER , SETTING IT FROM THE PRE_NPRS_SCREEN");
        } else if (currentConfig && currentConfig.label === nextConfig.label && !shouldAllowLabel) {
          pushToHistory({ type: "divider", id: nextId() });
        } else {
          pushToHistory({ type: "divider", id: nextId() }, { type: "section-header", label: nextConfig.label, id: nextId() });
        }
      }

      setCurrentStep(nextStep);
    },
    [assessmentData, updateAssessmentData, pushToHistory, currentStep],
  );

  useEffect(() => {
    window.advanceToNoCameraExercise = () => {
      console.log("[advanceToNoCameraExercise] camera → no-camera switch, advancing route");

      // Release the camera if the user had granted it for the camera path.
      if (window.turnOffCamera) {
        try {
          window.turnOffCamera();
        } catch (e) {
          console.warn("turnOffCamera failed:", e);
        }
      }

      // Set noCameraMode flag and advance the route.
      localStorage.setItem("noCameraMode", "true");
      // window.currnetScreen = "self_report_rom";

      // Show the no-camera video player; hide the camera/AR siblings.
      const videoPlayer = document.getElementById("player_ondemand");
      if (videoPlayer) {
        videoPlayer.classList.remove("hide");
        // Kick the video to play (poster shows otherwise; autoplay can be blocked
        // until user gesture, which has already happened by this point in the flow)
        const v = videoPlayer.querySelector("video");
        if (v) {
          try {
            v.currentTime = 0;
            const p = v.play();
            if (p && typeof p.catch === "function") {
              p.catch((err) => console.warn("video play prevented:", err));
            }
          } catch (e) {
            console.warn("video play threw:", e);
          }
        }
      }

      // Hide the camera/AR surfaces so they don't overlap the video.
      const agoraLocal = document.getElementById("agora_ondemand_local");
      if (agoraLocal) agoraLocal.style.display = "none";
      const agoraWaiting = document.getElementById("agora_ondemand_local_waiting");
      if (agoraWaiting) agoraWaiting.style.display = "none";
      const startBtn = document.getElementById("buttonExpandCamera");
      if (startBtn) startBtn.style.display = "none";

      const ODRoot = document.getElementById("OnDemandPlayingRoot");
      if (ODRoot) ODRoot.style.display = "block";

      const assesDiv = document.getElementById("assesmentDiv");
      if (assesDiv) assesDiv.style.display = "none";
    };

    return () => {
      window.advanceToNoCameraExercise = null;
    };
  }, [currentStep, persistAndNavigate, pushToHistory]);

  useEffect(() => {
    window.hideNoCameraVideoPlayer = () => {
      console.log("[hideNoCameraVideoPlayer] Hiding no-camera video player and restoring camera");

      // Hide the no-camera video player
      const videoPlayer = document.getElementById("player_ondemand");
      if (videoPlayer) {
        const video = videoPlayer.querySelector("video");
        if (video) {
          try {
            video.pause();
            video.currentTime = 0;
          } catch (e) {
            console.warn("Failed to stop video:", e);
          }
        }

        videoPlayer.classList.add("hide");
      }

      localStorage.setItem("noCameraMode", "false");
    };

    return () => {
      window.hideNoCameraVideoPlayer = null;
    };
  }, []);

  useEffect(() => {
    if (mode === "chat") {
      VoiceService._releaseMic();
      VoiceService.stopAllVoiceActivity();
    }
  }, [mode, qaOpen]);

  // ═══════════════════════════════════════════════════════════
  // SCROLL MANAGEMENT
  // One controller owns every vertical chat scroll decision.
  // ═══════════════════════════════════════════════════════════

  const CHAT_BOTTOM_TOLERANCE = 10;
  const AUTO_SCROLL_SETTLE_TOLERANCE = 5;

  const isMyraHistoryEntry = useCallback((entry) => ["myra", "myra-initial", "myra-initial2", "divider", "section-header", "voice-indicator", "voice-indicator2", "plan-card", "pricing-card", "access-cta"].includes(entry?.type), []);

  // The height actually visible on screen. Fullscreen iOS Safari is measured
  // inside the shell because that shell already follows the visual viewport.
  // Other layouts still use the viewport intersection and clamp to clientHeight.
  const getVisibleChatHeight = useCallback(() => {
    const el = chatAreaRef.current;
    if (!el) return 0;

    // In fullscreen iOS Safari the shell is already sized to visualViewport.height
    // and shifted to visualViewport.offsetTop. Cap it by the actual visual
    // viewport while the keyboard or shell is still settling.
    if (window.isIOSSafari === true && displayMode !== "embedded") {
      const vv = window.visualViewport;
      if (vv) {
        const rect = el.getBoundingClientRect();
        const visible = Math.min(rect.bottom, vv.offsetTop + vv.height) - Math.max(rect.top, vv.offsetTop);
        return Math.max(0, Math.min(el.clientHeight, visible));
      }
      return el.clientHeight;
    }

    const rect = el.getBoundingClientRect();
    const vv = window.visualViewport;
    if (vv) {
      const vvBottom = vv.offsetTop + vv.height;
      const visible = Math.min(rect.bottom, vvBottom) - Math.max(rect.top, vv.offsetTop);
      return Math.max(0, Math.min(el.clientHeight, visible));
    }
    return el.clientHeight;
  }, [displayMode]);

  const getDistanceFromBottom = useCallback(() => {
    const el = chatAreaRef.current;
    if (!el) return 0;
    return Math.max(0, el.scrollHeight - el.scrollTop - el.clientHeight);
  }, []);

  // More-below visibility is a scroll-content question, not a message-target
  // question. Measure one stable sentinel at the actual end of the chat content
  // against the chat area's clipped bottom edge. This remains accurate while
  // iOS is moving the visual viewport and while consecutive Myra entries are
  // still extending the active message target.
  const getJumpDistanceFromBottom = useCallback(() => {
    const el = chatAreaRef.current;
    const sentinel = chatEndSentinelRef.current;
    if (!el) return 0;

    if (sentinel) {
      const containerBottom = el.getBoundingClientRect().bottom;
      const sentinelBottom = sentinel.getBoundingClientRect().bottom;
      return Math.max(0, Math.floor(sentinelBottom - containerBottom));
    }

    return Math.max(0, Math.floor(el.scrollHeight - el.scrollTop - el.clientHeight));
  }, []);

  const getMyraMessageElement = useCallback((entryId) => {
    const el = chatAreaRef.current;
    if (!el || entryId === null || entryId === undefined) return null;
    return el.querySelector(`[data-entry-id="${entryId}"][data-entry-kind="myra"]`);
  }, []);

  const getTypingElement = useCallback(() => {
    const el = chatAreaRef.current;
    if (!el) return null;
    return el.querySelector('[data-chat-typing="true"]');
  }, []);

  const getMyraScreenContentElement = useCallback(() => {
    const el = chatAreaRef.current;
    if (!el) return null;
    return el.querySelector('[data-chat-myra-screen-content="true"]');
  }, []);

  const getChatLoadingElement = useCallback(() => {
    const el = chatAreaRef.current;
    if (!el) return null;
    return el.querySelector('[data-chat-loading="true"]');
  }, []);

  // Does this Myra message, consecutive Myra message block, and optional
  // typing indicator fit inside the height actually visible on screen?
  const messageFitsInView = useCallback(
    (entryId, endEntryId = entryId, includeTyping = false, includeScreenContent = false) => {
      const entryEl = getMyraMessageElement(entryId);
      const endEntryEl = includeTyping ? getTypingElement() : includeScreenContent ? getMyraScreenContentElement() || getMyraMessageElement(endEntryId) : getMyraMessageElement(endEntryId);
      if (!entryEl || !endEntryEl) return true;
      const contentEl = entryEl.querySelector('[data-message-content="true"]') || entryEl;
      const endContentEl = includeTyping ? endEntryEl : endEntryEl.querySelector('[data-message-content="true"]') || endEntryEl;
      const blockHeight = endContentEl.getBoundingClientRect().bottom - contentEl.getBoundingClientRect().top;
      return blockHeight <= getVisibleChatHeight() - 12;
    },
    [getMyraMessageElement, getMyraScreenContentElement, getTypingElement, getVisibleChatHeight],
  );

  const markProgrammaticScroll = useCallback((behavior) => {
    programmaticScrollRef.current = true;
    smoothScrollInProgressRef.current = behavior === "smooth";
    if (programmaticScrollTimerRef.current) {
      clearTimeout(programmaticScrollTimerRef.current);
    }
    programmaticScrollTimerRef.current = setTimeout(
      () => {
        programmaticScrollRef.current = false;
        smoothScrollInProgressRef.current = false;
        programmaticScrollTimerRef.current = null;
      },
      behavior === "smooth" ? 800 : 100,
    );
  }, []);

  const performScroll = useCallback(
    (requestedTop, behavior = "auto") => {
      const el = chatAreaRef.current;
      if (!el) return false;

      const maxScrollTop = Math.max(0, el.scrollHeight - el.clientHeight);
      const targetTop = Math.max(0, Math.min(requestedTop, maxScrollTop));
      const reducedMotion = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
      const resolvedBehavior = reducedMotion ? "auto" : behavior;

      // Deferred layout synchronization can differ from the completed smooth
      // position by a few subpixel-rounded pixels. Ignore that imperceptible auto
      // correction so the message does not visibly snap after the smooth scroll.
      if (resolvedBehavior === "auto" && Math.abs(el.scrollTop - targetTop) <= AUTO_SCROLL_SETTLE_TOLERANCE) {
        return true;
      }

      const lastSmoothTarget = lastSmoothScrollTargetRef.current;
      if (resolvedBehavior === "auto" && lastSmoothTarget?.generation === chatScrollStateRef.current.generation && performance.now() - lastSmoothTarget.timestamp <= 1200 && Math.abs(targetTop - lastSmoothTarget.top) <= CHAT_BOTTOM_TOLERANCE && Math.abs(el.scrollTop - lastSmoothTarget.top) <= CHAT_BOTTOM_TOLERANCE) {
        return true;
      }

      markProgrammaticScroll(resolvedBehavior);

      if (resolvedBehavior === "smooth") {
        lastSmoothScrollTargetRef.current = {
          top: targetTop,
          generation: chatScrollStateRef.current.generation,
          timestamp: performance.now(),
        };
        el.scrollTo({ top: targetTop, behavior: "smooth" });
      } else {
        const previousScrollBehavior = el.style.scrollBehavior;
        el.style.scrollBehavior = "auto";
        el.scrollTop = targetTop;
        el.style.scrollBehavior = previousScrollBehavior;
      }

      return true;
    },
    [markProgrammaticScroll],
  );

  const positionAtBottom = useCallback(
    (behavior = "auto") => {
      const el = chatAreaRef.current;
      if (!el) return false;
      // Rest the last line just above the visible bottom. The difference between
      // the box height and the visible height is the slice hidden by the keyboard;
      // subtracting it keeps the tail on screen instead of behind the keyboard.
      const hiddenBelow = Math.max(0, el.clientHeight - getVisibleChatHeight());
      return performScroll(el.scrollHeight - hiddenBelow, behavior);
    },
    [performScroll, getVisibleChatHeight],
  );

  const positionMessageAtTop = useCallback(
    (entryId, behavior = "auto") => {
      const el = chatAreaRef.current;
      const entryEl = getMyraMessageElement(entryId);
      if (!el || !entryEl) return false;

      const rect = el.getBoundingClientRect();
      const vv = window.visualViewport;
      // The fullscreen iOS shell already follows visualViewport.offsetTop. Use
      // the chat box's own top so a viewport-pan event cannot be counted twice
      // while Safari is animating the keyboard.
      const visibleTop = window.isIOSSafari === true && displayMode !== "embedded" ? rect.top : vv ? Math.max(rect.top, vv.offsetTop) : rect.top;
      const contentEl = entryEl.querySelector('[data-message-content="true"]') || entryEl;
      const contentRect = contentEl.getBoundingClientRect();
      const paddingTop = Number.parseFloat(window.getComputedStyle(contentEl).paddingTop || "0") || 0;
      const firstLineTop = contentRect.top + paddingTop;
      const targetTop = el.scrollTop + (firstLineTop - visibleTop) - 10;
      return performScroll(targetTop, behavior);
    },
    [displayMode, getMyraMessageElement, performScroll],
  );

  // Rest THIS message's last line just above the input box. Anchors to the
  // message itself, not the conversation bottom, so a user reply bubble sitting
  // below or above it never becomes what shows above the input.
  const positionMessageAtBottom = useCallback(
    (entryId, behavior = "auto", includeScreenContent = false) => {
      const el = chatAreaRef.current;
      const entryEl = includeScreenContent ? getMyraScreenContentElement() || getMyraMessageElement(entryId) : getMyraMessageElement(entryId);
      if (!el || !entryEl) return false;

      const rect = el.getBoundingClientRect();
      const vv = window.visualViewport;
      // The fullscreen iOS shell already ends above the keyboard. Use the chat
      // box's own bottom instead of intersecting it with the moving viewport again.
      const visibleBottom = window.isIOSSafari === true && displayMode !== "embedded" ? rect.bottom : vv ? Math.min(rect.bottom, vv.offsetTop + vv.height) : rect.bottom;
      const contentEl = entryEl.querySelector('[data-message-content="true"]') || entryEl;
      const contentRect = contentEl.getBoundingClientRect();
      const paddingBottom = Number.parseFloat(window.getComputedStyle(contentEl).paddingBottom || "0") || 0;
      const lastLineBottom = contentRect.bottom - paddingBottom;
      const targetTop = el.scrollTop + (lastLineBottom - visibleBottom) + 10;
      return performScroll(targetTop, behavior);
    },
    [displayMode, getMyraMessageElement, getMyraScreenContentElement, performScroll],
  );

  const positionTypingAtBottom = useCallback(
    (behavior = "auto") => {
      const el = chatAreaRef.current;
      const typingEl = getTypingElement();
      if (!el || !typingEl) return false;

      const rect = el.getBoundingClientRect();
      const vv = window.visualViewport;
      const visibleBottom = window.isIOSSafari === true && displayMode !== "embedded" ? rect.bottom : vv ? Math.min(rect.bottom, vv.offsetTop + vv.height) : rect.bottom;
      const targetTop = el.scrollTop + (typingEl.getBoundingClientRect().bottom - visibleBottom) + 10;
      return performScroll(targetTop, behavior);
    },
    [displayMode, getTypingElement, performScroll],
  );

  const addUnreadMyraIds = useCallback((entryIds) => {
    if (!entryIds?.length) return;
    const state = chatScrollStateRef.current;
    const existing = new Set(state.unreadMyraIds);
    entryIds.forEach((entryId) => {
      if (entryId !== null && entryId !== undefined && !existing.has(entryId)) {
        state.unreadMyraIds.push(entryId);
        existing.add(entryId);
      }
    });
  }, []);

  const markMyraMessageRead = useCallback((entryId) => {
    const state = chatScrollStateRef.current;
    state.unreadMyraIds = state.unreadMyraIds.filter((id) => id !== entryId);
  }, []);

  const pruneVisibleUnreadMyra = useCallback(() => {
    const el = chatAreaRef.current;
    if (!el) return;

    const containerRect = el.getBoundingClientRect();
    const state = chatScrollStateRef.current;
    state.unreadMyraIds = state.unreadMyraIds.filter((entryId) => {
      const entryEl = getMyraMessageElement(entryId);
      if (!entryEl) return false;

      const contentEl = entryEl.querySelector('[data-message-content="true"]') || entryEl;
      const contentRect = contentEl.getBoundingClientRect();
      const paddingTop = Number.parseFloat(window.getComputedStyle(contentEl).paddingTop || "0") || 0;
      const firstLineTop = contentRect.top + paddingTop;

      return firstLineTop >= containerRect.bottom - 2;
    });
  }, [getMyraMessageElement]);

  const getActiveTargetContentBelow = useCallback(
    (target = null) => {
      const el = chatAreaRef.current;
      if (!el) return null;

      const visibleHeight = getVisibleChatHeight();
      if (visibleHeight <= 0) return 0;

      const rect = el.getBoundingClientRect();
      const vv = window.visualViewport;
      const visibleTop = window.isIOSSafari === true && displayMode !== "embedded" ? rect.top : vv ? Math.max(rect.top, vv.offsetTop) : rect.top;
      const visibleBottom = visibleTop + visibleHeight;
      const scrollableDistance = Math.max(0, Math.floor(el.scrollHeight - el.scrollTop - el.clientHeight));

      if (target?.type === "message") {
        const endEntryId = target.endId || target.id;
        const typingEl = target.includeTyping ? getTypingElement() : null;
        const endEntryEl = typingEl || (target.keepFollowing === true ? getMyraScreenContentElement() || getMyraMessageElement(endEntryId) : getMyraMessageElement(endEntryId));
        if (!endEntryEl) return null;

        const endContentEl = typingEl || endEntryEl.querySelector('[data-message-content="true"]') || endEntryEl;
        const paddingBottom = Number.parseFloat(window.getComputedStyle(endContentEl).paddingBottom || "0") || 0;
        // Fullscreen iOS already clips the chat at its own bottom edge above the
        // input. During keyboard settling, clientHeight can remain stale for a
        // frame even though the rendered message visibly extends below that edge.
        // Use the real clipped edge for the active block and do not discard that
        // geometry with the stale physical-scroll cap. A manual scroll used to
        // refresh clientHeight, which is why the button appeared only afterward.
        const activeVisibleBottom = window.isIOSSafari === true && displayMode !== "embedded" ? rect.bottom : visibleBottom;
        const activeContentBelow = Math.max(0, Math.floor(endContentEl.getBoundingClientRect().bottom - paddingBottom - activeVisibleBottom));
        return window.isIOSSafari === true && displayMode !== "embedded" ? Math.max(activeContentBelow, scrollableDistance) : Math.min(activeContentBelow, scrollableDistance);
      }

      let lastContentBottom = visibleBottom;

      Array.from(el.children).forEach((child) => {
        const style = window.getComputedStyle(child);
        if (style.display === "none" || style.visibility === "hidden" || style.position === "fixed" || style.position === "absolute") return;

        const childRect = child.getBoundingClientRect();
        if (childRect.width <= 0 && childRect.height <= 0) return;

        const paddingBottom = Number.parseFloat(style.paddingBottom || "0") || 0;
        lastContentBottom = Math.max(lastContentBottom, childRect.bottom - paddingBottom);
      });

      const renderedContentBelow = Math.max(0, Math.floor(lastContentBottom - visibleBottom));
      return Math.min(renderedContentBelow, scrollableDistance);
    },
    [displayMode, getMyraMessageElement, getMyraScreenContentElement, getTypingElement, getVisibleChatHeight],
  );

  const refreshJumpState = useCallback(
    (markVisibleUnreadAsRead = false) => {
      const el = chatAreaRef.current;
      if (!el) return;

      if (markVisibleUnreadAsRead) {
        pruneVisibleUnreadMyra();
      }

      const state = chatScrollStateRef.current;

      // Recovery Plan generation is a live loading state, not unread content. Keep
      // it at the conversation bottom and never show the paging control over it.
      if (getChatLoadingElement()) {
        if (!state.following || state.activeTarget?.type !== "bottom") {
          state.generation += 1;
          state.following = true;
          state.activeTarget = { type: "bottom" };
          state.unreadMyraIds = [];
        }
        positionAtBottom("auto");
        if (jumpShowTimerRef.current) {
          clearTimeout(jumpShowTimerRef.current);
          jumpShowTimerRef.current = null;
        }
        if (jumpVisibleRef.current) {
          jumpVisibleRef.current = false;
          setHasContentBelow(false);
        }
        return;
      }

      // Visibility is based only on whether the actual end of the chat content is
      // below the chat area's visible bottom. Message targets remain responsible
      // only for deciding where a More below click should page.
      const contentBelow = getJumpDistanceFromBottom();
      if (contentBelow < CHAT_BOTTOM_TOLERANCE) {
        state.unreadMyraIds = [];
      }
      const shouldShow = contentBelow >= CHAT_BOTTOM_TOLERANCE;

      if (!shouldShow) {
        if (jumpShowTimerRef.current) {
          clearTimeout(jumpShowTimerRef.current);
          jumpShowTimerRef.current = null;
        }
        if (jumpVisibleRef.current) {
          jumpVisibleRef.current = false;
          setHasContentBelow(false);
        }
        return;
      }

      if (jumpVisibleRef.current || jumpShowTimerRef.current) return;

      jumpShowTimerRef.current = setTimeout(() => {
        jumpShowTimerRef.current = null;

        const currentState = chatScrollStateRef.current;
        if (getChatLoadingElement()) {
          positionAtBottom("auto");
          return;
        }

        const currentContentBelow = getJumpDistanceFromBottom();
        if (currentContentBelow < CHAT_BOTTOM_TOLERANCE) {
          currentState.unreadMyraIds = [];
        }

        if (currentContentBelow >= CHAT_BOTTOM_TOLERANCE) {
          jumpVisibleRef.current = true;
          setHasContentBelow(true);
        }
      }, 500);
    },
    [getChatLoadingElement, getJumpDistanceFromBottom, positionAtBottom, pruneVisibleUnreadMyra],
  );

  const queueJumpStateRefresh = useCallback(
    (markVisibleUnreadAsRead = false) => {
      if (jumpStateRafRef.current) return;
      jumpStateRafRef.current = requestAnimationFrame(() => {
        jumpStateRafRef.current = null;
        refreshJumpState(markVisibleUnreadAsRead);
      });
    },
    [refreshJumpState],
  );

  const applyActiveScrollTarget = useCallback(
    (behavior = "auto") => {
      const state = chatScrollStateRef.current;
      const target = state.activeTarget;
      if (!target) return false;

      if (target.type === "bottom") {
        if (!state.following) return false;
        return positionAtBottom(behavior);
      }

      if (target.type === "message") {
        // Once the user pages through this Myra block, preserve that page instead
        // of allowing later layout/keyboard settles to re-anchor the block.
        if (target.paged === true) return false;

        // Re-measure on every settle. Consecutive Myra entries and the typing
        // indicator immediately after them are one scroll block.
        const endEntryId = target.endId || target.id;
        if (target.includeTyping && getTypingElement()) {
          if (messageFitsInView(target.id, endEntryId, true)) {
            return positionTypingAtBottom(behavior);
          }
          return positionMessageAtTop(target.id, behavior);
        }
        const includeScreenContent = target.keepFollowing === true;
        if (messageFitsInView(target.id, endEntryId, false, includeScreenContent)) {
          return positionMessageAtBottom(endEntryId, behavior, includeScreenContent);
        }
        return positionMessageAtTop(target.id, behavior);
      }

      return false;
    },
    [getTypingElement, messageFitsInView, positionAtBottom, positionMessageAtTop, positionMessageAtBottom, positionTypingAtBottom],
  );

  const scheduleTargetSync = useCallback(() => {
    if (targetSyncRafRef.current) {
      cancelAnimationFrame(targetSyncRafRef.current);
    }
    if (targetSyncTimerRef.current) {
      clearTimeout(targetSyncTimerRef.current);
    }

    // Snapshot the generation now. If a newer message sets a new target before
    // these deferred callbacks run, they skip themselves instead of yanking the
    // view back to the older message.
    const gen = chatScrollStateRef.current.generation;
    const syncTarget = () => {
      if (gen !== chatScrollStateRef.current.generation) {
        // A newer message or typing state replaced this scroll target. Do not
        // reposition the stale target, but still remeasure the current content
        // so More below cannot remain hidden until the user manually scrolls.
        queueJumpStateRefresh();
        return;
      }
      applyActiveScrollTarget("auto");
      queueJumpStateRefresh();
    };

    if (!smoothScrollInProgressRef.current) {
      targetSyncRafRef.current = requestAnimationFrame(() => {
        targetSyncRafRef.current = null;
        syncTarget();
      });
    }

    targetSyncTimerRef.current = setTimeout(
      () => {
        targetSyncTimerRef.current = null;
        syncTarget();
      },
      smoothScrollInProgressRef.current ? 800 : 500,
    );
  }, [applyActiveScrollTarget, queueJumpStateRefresh]);

  const schedulePerMessageChecks = useCallback(
    (messageCount) => {
      const checks = Math.max(0, Number(messageCount) || 0);
      queueJumpStateRefresh();

      for (let index = 0; index < checks; index += 1) {
        const timer = setTimeout(() => {
          messageSettleTimersRef.current.delete(timer);
          if (!smoothScrollInProgressRef.current) {
            applyActiveScrollTarget("auto");
          }
          queueJumpStateRefresh();
        }, 500);
        messageSettleTimersRef.current.add(timer);
      }

      if (checks > 0) {
        // iPhone Safari can finish its keyboard/visual-viewport pan after the
        // normal message settle check. Re-measure only the paging-control state
        // once more after that movement; do not reposition the conversation.
        const visibilityTimer = setTimeout(() => {
          messageSettleTimersRef.current.delete(visibilityTimer);
          queueJumpStateRefresh();
        }, 1100);
        messageSettleTimersRef.current.add(visibilityTimer);
      }
    },
    [applyActiveScrollTarget, queueJumpStateRefresh],
  );

  const scrollToBottom = useCallback(
    (behavior = "auto") => {
      const state = chatScrollStateRef.current;
      state.generation += 1;
      state.following = true;
      state.activeTarget = { type: "bottom" };
      state.unreadMyraIds = [];
      manualScrollIntentRef.current = false;
      if (manualScrollIntentTimerRef.current) {
        clearTimeout(manualScrollIntentTimerRef.current);
        manualScrollIntentTimerRef.current = null;
      }
      positionAtBottom(behavior);
      scheduleTargetSync();
    },
    [positionAtBottom, scheduleTargetSync],
  );

  const scrollMyraMessageToTop = useCallback(
    (entryId, behavior = "auto", keepFollowing = true, endEntryId = entryId) => {
      const state = chatScrollStateRef.current;
      state.generation += 1; // this message block is now the latest target
      markMyraMessageRead(entryId);
      state.following = false;
      state.activeTarget = { type: "message", id: entryId, endId: endEntryId, keepFollowing };

      if (messageFitsInView(entryId, endEntryId, false, keepFollowing)) {
        // Fits: rest the consecutive Myra block's last line above the input.
        positionMessageAtBottom(endEntryId, behavior, keepFollowing);
      } else {
        // Too tall: pin the consecutive Myra block's first line to the top.
        positionMessageAtTop(entryId, behavior);
      }

      scheduleTargetSync();
    },
    [markMyraMessageRead, messageFitsInView, positionMessageAtTop, positionMessageAtBottom, scheduleTargetSync],
  );

  const handleJumpToHiddenContent = useCallback(() => {
    const state = chatScrollStateRef.current;
    const el = chatAreaRef.current;
    const target = state.activeTarget;

    // Only page through the currently active Myra block. If the user manually
    // scrolled into older, already-read messages, preserve the original unread
    // behavior below instead of paging through historical content screen by screen.
    if (el && target?.type === "message") {
      const remainingBelow = getActiveTargetContentBelow(target);
      if (remainingBelow !== null && remainingBelow >= CHAT_BOTTOM_TOLERANCE) {
        // clientHeight is the scroll container's actual visible scrollport. The
        // visual-viewport helper is intentionally used for fit detection, but can
        // be temporarily smaller while a mobile keyboard is settling.
        const pageHeight = el.clientHeight;
        if (pageHeight > 0) {
          state.generation += 1;
          state.following = false;
          state.activeTarget = { ...target, paged: true };
          performScroll(el.scrollTop + pageHeight, "smooth");
          queueJumpStateRefresh();
          return;
        }
      }

      // The active block is fully visible. Remove its now-visible entries before
      // applying the original unread-message fallback below.
      pruneVisibleUnreadMyra();
    }

    while (state.unreadMyraIds.length > 0 && !getMyraMessageElement(state.unreadMyraIds[0])) {
      state.unreadMyraIds.shift();
    }

    if (state.unreadMyraIds.length > 0) {
      const nextUnreadId = state.unreadMyraIds[0];
      scrollMyraMessageToTop(nextUnreadId, "auto", false);
      return;
    }

    scrollToBottom("auto");
  }, [getActiveTargetContentBelow, getMyraMessageElement, performScroll, pruneVisibleUnreadMyra, queueJumpStateRefresh, scrollMyraMessageToTop, scrollToBottom]);

  const showJumpToHiddenContent = hasContentBelow;

  useEffect(() => {
    const knownIds = knownHistoryEntryIdsRef.current;
    const newEntries = conversationHistory.filter((entry) => entry?.id !== null && entry?.id !== undefined && !knownIds.has(entry.id));
    conversationHistory.forEach((entry) => {
      if (entry?.id !== null && entry?.id !== undefined) knownIds.add(entry.id);
    });

    if (newEntries.length === 0) {
      scheduleTargetSync();
      return;
    }

    const newUserEntries = newEntries.filter((entry) => entry.type === "user");
    const newMyraEntries = newEntries.filter(isMyraHistoryEntry);
    const state = chatScrollStateRef.current;

    if (newUserEntries.length > 0) {
      // A sent user message always returns the conversation to the bottom, even
      // when the user had manually scrolled up before sending it.
      scrollToBottom("auto");
    }

    if (newMyraEntries.length > 0) {
      if (state.following && state.activeTarget?.type !== "message") {
        const scrollAnchorIndex = newMyraEntries.findIndex((entry) => entry.scrollAnchor === true);
        const firstMyraEntry = newMyraEntries[scrollAnchorIndex >= 0 ? scrollAnchorIndex : 0];
        const lastMyraEntry = newMyraEntries[newMyraEntries.length - 1];
        const remainingMyraEntries = newMyraEntries.slice((scrollAnchorIndex >= 0 ? scrollAnchorIndex : 0) + 1);
        addUnreadMyraIds(remainingMyraEntries.map((entry) => entry.id));
        scrollMyraMessageToTop(firstMyraEntry.id, "smooth", true, lastMyraEntry.id);
      } else if (state.activeTarget?.type === "message" && state.activeTarget.keepFollowing === true) {
        const activeEndId = state.activeTarget.endId || state.activeTarget.id;
        const activeEndIndex = conversationHistory.findIndex((entry) => entry.id === activeEndId);
        const entriesAfterActiveTarget = activeEndIndex >= 0 ? conversationHistory.slice(activeEndIndex + 1) : [];
        const isConsecutiveContinuation = entriesAfterActiveTarget.length > 0 && entriesAfterActiveTarget.every(isMyraHistoryEntry);

        if (isConsecutiveContinuation) {
          const scrollAnchorEntry = entriesAfterActiveTarget.find((entry) => entry.scrollAnchor === true);
          const lastMyraEntry = entriesAfterActiveTarget[entriesAfterActiveTarget.length - 1];
          addUnreadMyraIds(entriesAfterActiveTarget.map((entry) => entry.id));
          state.generation += 1;
          state.activeTarget = { ...state.activeTarget, id: scrollAnchorEntry?.id || state.activeTarget.id, endId: lastMyraEntry.id, includeTyping: false };
          applyActiveScrollTarget("smooth");
          scheduleTargetSync();
        } else {
          addUnreadMyraIds(newMyraEntries.map((entry) => entry.id));
          scheduleTargetSync();
        }
      } else {
        addUnreadMyraIds(newMyraEntries.map((entry) => entry.id));
        scheduleTargetSync();
      }
    } else if (newUserEntries.length === 0) {
      scheduleTargetSync();
    }

    schedulePerMessageChecks(newUserEntries.length + newMyraEntries.length);
  }, [conversationHistory, addUnreadMyraIds, applyActiveScrollTarget, isMyraHistoryEntry, schedulePerMessageChecks, scheduleTargetSync, scrollMyraMessageToTop, scrollToBottom]);

  useEffect(() => {
    const state = chatScrollStateRef.current;
    const target = state.activeTarget;
    const activeEndId = target?.type === "message" ? target.endId || target.id : null;
    const activeEndIndex = activeEndId === null ? -1 : conversationHistoryRef.current.findIndex((entry) => entry.id === activeEndId);
    const typingContinuesActiveBlock = activeEndIndex >= 0 && activeEndIndex === conversationHistoryRef.current.length - 1;

    if (typingVisible && target?.type === "message" && target.keepFollowing === true && typingContinuesActiveBlock) {
      state.generation += 1;
      state.activeTarget = { ...target, includeTyping: true };
      applyActiveScrollTarget("smooth");
      scheduleTargetSync();
      return;
    }

    if (typingVisible && state.following) {
      scrollToBottom("auto");
      return;
    }

    if (!typingVisible && target?.type === "message" && target.includeTyping) {
      state.generation += 1;
      state.activeTarget = { ...target, includeTyping: false };
      applyActiveScrollTarget("auto");
      scheduleTargetSync();
      return;
    }

    queueJumpStateRefresh();
    const timer = setTimeout(queueJumpStateRefresh, 500);
    return () => clearTimeout(timer);
  }, [typingVisible, applyActiveScrollTarget, queueJumpStateRefresh, scheduleTargetSync, scrollToBottom]);

  useEffect(() => {
    scheduleTargetSync();
  }, [currentStep, scheduleTargetSync]);

  useEffect(() => {
    const el = chatAreaRef.current;
    if (!el) return;

    const beginManualScrollIntent = () => {
      manualScrollIntentRef.current = true;
      programmaticScrollRef.current = false;
      smoothScrollInProgressRef.current = false;
      if (programmaticScrollTimerRef.current) {
        clearTimeout(programmaticScrollTimerRef.current);
        programmaticScrollTimerRef.current = null;
      }
      if (manualScrollIntentTimerRef.current) {
        clearTimeout(manualScrollIntentTimerRef.current);
      }
      manualScrollIntentTimerRef.current = setTimeout(() => {
        manualScrollIntentRef.current = false;
        manualScrollIntentTimerRef.current = null;
      }, 900);
    };

    const handleManualScrollKey = (event) => {
      if (!["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "].includes(event.key)) return;
      const target = event.target;
      if (target?.tagName === "INPUT" || target?.tagName === "TEXTAREA" || target?.isContentEditable) return;
      beginManualScrollIntent();
    };

    const handleScroll = () => {
      if (programmaticScrollRef.current || !manualScrollIntentRef.current) {
        queueJumpStateRefresh();
        return;
      }

      const state = chatScrollStateRef.current;
      const atBottom = getDistanceFromBottom() <= CHAT_BOTTOM_TOLERANCE;

      if (atBottom) {
        state.following = true;
        state.activeTarget = { type: "bottom" };
        state.unreadMyraIds = [];
      } else {
        state.following = false;
        state.activeTarget = null;
        pruneVisibleUnreadMyra();
      }

      if (manualScrollIntentTimerRef.current) {
        clearTimeout(manualScrollIntentTimerRef.current);
      }
      manualScrollIntentTimerRef.current = setTimeout(() => {
        manualScrollIntentRef.current = false;
        manualScrollIntentTimerRef.current = null;
      }, 250);

      queueJumpStateRefresh();
    };

    el.addEventListener("wheel", beginManualScrollIntent, { passive: true });
    el.addEventListener("touchstart", beginManualScrollIntent, { passive: true });
    el.addEventListener("pointerdown", beginManualScrollIntent, { passive: true });
    el.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("keydown", handleManualScrollKey);

    return () => {
      el.removeEventListener("wheel", beginManualScrollIntent);
      el.removeEventListener("touchstart", beginManualScrollIntent);
      el.removeEventListener("pointerdown", beginManualScrollIntent);
      el.removeEventListener("scroll", handleScroll);
      window.removeEventListener("keydown", handleManualScrollKey);
    };
  }, [getDistanceFromBottom, pruneVisibleUnreadMyra, queueJumpStateRefresh]);

  useEffect(() => {
    const el = chatAreaRef.current;
    if (!el) return;

    let mutationTimer = null;
    const resizeObserver = typeof ResizeObserver !== "undefined" ? new ResizeObserver(scheduleTargetSync) : null;
    const observeChatChildren = () => {
      if (!resizeObserver) return;
      Array.from(el.children).forEach((child) => resizeObserver.observe(child));
    };

    resizeObserver?.observe(el);
    observeChatChildren();

    const mutationObserver = new MutationObserver(() => {
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(() => {
        observeChatChildren();
        scheduleTargetSync();
      }, 0);
    });

    mutationObserver.observe(el, { childList: true, subtree: true, characterData: true });

    const handleMediaLayout = () => scheduleTargetSync();
    const isIOSSafariFullscreen = window.isIOSSafari === true && displayMode !== "embedded";
    // Keep the shell inside the visual viewport. Safari positions fixed elements
    // against the layout viewport, so keyboard-driven visual viewport panning must
    // update the shell top separately from message-scroll target synchronization.
    const syncAppViewport = () => {
      const vv = window.visualViewport;
      const vh = vv?.height ?? window.innerHeight;
      const top = isIOSSafariFullscreen ? Math.max(0, vv?.offsetTop ?? 0) : 0;
      document.documentElement.style.setProperty("--app-height", `${vh}px`);
      document.documentElement.style.setProperty("--app-top", `${top}px`);
    };
    const handleViewportResize = () => {
      syncAppViewport();
      scheduleTargetSync();
    };
    const handleViewportScroll = () => {
      syncAppViewport();
      // offsetTop can change without a resize while iPhone Safari finishes
      // panning the focused input into view. The shell moves, so re-check only
      // whether content is below; message positioning must remain untouched.
      queueJumpStateRefresh();
    };
    syncAppViewport();

    // iPhone Safari can defer updating scroll geometry while the keyboard is
    // open until another interaction forces layout. Poll only while this chat is
    // mounted and visible so More below is recalculated after that geometry
    // settles, without changing any scroll target or message state.
    const jumpStateInterval = setInterval(() => {
      if (document.visibilityState === "visible" && el.getClientRects().length > 0) {
        // Run the measurement directly. On iPhone Safari with the keyboard open,
        // requestAnimationFrame can remain pending until the next touch/scroll
        // frame, which made the polling loop repeatedly queue no actual check.
        refreshJumpState();
      }
    }, 200);

    el.addEventListener("load", handleMediaLayout, { capture: true });
    el.addEventListener("loadedmetadata", handleMediaLayout, { capture: true });
    window.addEventListener("resize", handleViewportResize);
    window.visualViewport?.addEventListener("resize", handleViewportResize);
    window.visualViewport?.addEventListener("scroll", handleViewportScroll);

    return () => {
      mutationObserver.disconnect();
      resizeObserver?.disconnect();
      clearTimeout(mutationTimer);
      clearInterval(jumpStateInterval);
      el.removeEventListener("load", handleMediaLayout, { capture: true });
      el.removeEventListener("loadedmetadata", handleMediaLayout, { capture: true });
      window.removeEventListener("resize", handleViewportResize);
      window.visualViewport?.removeEventListener("resize", handleViewportResize);
      window.visualViewport?.removeEventListener("scroll", handleViewportScroll);
    };
  }, [displayMode, queueJumpStateRefresh, refreshJumpState, scheduleTargetSync]);

  useEffect(() => {
    if ((window.isIOSSafari !== true && window.isAndroid !== true) || displayMode === "embedded") return;

    const chatEl = chatAreaRef.current;
    if (!chatEl) return;

    let previousTouchY = null;

    const handleTouchStart = (event) => {
      previousTouchY = event.touches?.[0]?.clientY ?? null;
    };

    const handleTouchMove = (event) => {
      if (document.activeElement !== chatInputRef.current || !event.cancelable || event.touches?.length !== 1) return;

      const currentTouchY = event.touches[0].clientY;
      const deltaY = previousTouchY === null ? 0 : currentTouchY - previousTouchY;
      previousTouchY = currentTouchY;

      if (!chatEl.contains(event.target)) {
        event.preventDefault();
        return;
      }

      const atTop = chatEl.scrollTop <= 0;
      const atBottom = chatEl.scrollTop + chatEl.clientHeight >= chatEl.scrollHeight - 1;
      if ((deltaY > 0 && atTop) || (deltaY < 0 && atBottom)) {
        event.preventDefault();
      }
    };

    const clearTouch = () => {
      previousTouchY = null;
    };

    document.addEventListener("touchstart", handleTouchStart, { capture: true, passive: true });
    document.addEventListener("touchmove", handleTouchMove, { capture: true, passive: false });
    document.addEventListener("touchend", clearTouch, { capture: true, passive: true });
    document.addEventListener("touchcancel", clearTouch, { capture: true, passive: true });

    return () => {
      document.removeEventListener("touchstart", handleTouchStart, { capture: true });
      document.removeEventListener("touchmove", handleTouchMove, { capture: true });
      document.removeEventListener("touchend", clearTouch, { capture: true });
      document.removeEventListener("touchcancel", clearTouch, { capture: true });
    };
  }, [displayMode]);

  useEffect(() => {
    return () => {
      if (programmaticScrollTimerRef.current) clearTimeout(programmaticScrollTimerRef.current);
      if (manualScrollIntentTimerRef.current) clearTimeout(manualScrollIntentTimerRef.current);
      if (targetSyncRafRef.current) cancelAnimationFrame(targetSyncRafRef.current);
      if (targetSyncTimerRef.current) clearTimeout(targetSyncTimerRef.current);
      messageSettleTimersRef.current.forEach((timer) => clearTimeout(timer));
      messageSettleTimersRef.current.clear();
      if (jumpStateRafRef.current) cancelAnimationFrame(jumpStateRafRef.current);
      if (jumpShowTimerRef.current) clearTimeout(jumpShowTimerRef.current);
    };
  }, []);

  useEffect(() => {
    const step = new URLSearchParams(search).get("step");
    if (!step) return;
    if (step === "askmyra" || step === "howitworks" || step === "aboutvirdio" || step === "startnow") {
      localStorage.setItem("isV2", "true");
    }

    switch (step) {
      case "askmyra":
        history.replace("/ask-myra");
        break;
      case "howitworks":
        history.replace("/how-it-works");
        break;
      case "aboutvirdio":
        history.replace("/about");
        break;
      // case "startnow":
      //   handleStartAssessment();
      // break;
      default:
        break;
    }
  }, [search, history]);
  useEffect(() => {
    const previousSessionIdExits = window.trSessionId || localStorage.getItem("trSessionId");
    const isAccessHandoff = location.state?.completedFlowData?.isAccessUser === true;
    if (previousSessionIdExits && !isAccessHandoff) {
      localStorage.removeItem("trSessionId");
      resetAssessmentData();
      window.trSessionId = null;
      console.log("Existing session ID found and removed:", previousSessionIdExits);
    }

    if (window.__gsaLandingInitialized) {
      return;
    }
    window.__gsaLandingInitialized = true;
    const enterTime = Date.now();
    landingEnterTimeRef.current = enterTime;
    window.screenTracker.enterScreen("landing");

    // Repeat visitor detection
    const isRepeat = localStorage.getItem("isUserCameBackAgain") === "true";
    if (isRepeat) {
      setIsUserCameBackAgain(true);
    }
    localStorage.setItem("isUserCameBackAgain", "true");

    // URL param detection (variant / gclid)
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid");
    const urlVariant = params.get("variant");
    const resolvedVariant = urlVariant || localStorage.getItem("variant") || null;

    if (urlVariant) {
      localStorage.setItem("variant", urlVariant);
    }

    const isFromGoogle = !!(gclid || resolvedVariant);
    if (resolvedVariant) setUserVariant(resolvedVariant);
    if (isFromGoogle) setIsComeFromGoogle(true);

    // Check whether the user came to the landing page from a subpage this session.
    // Subpages set this marker on page load; we consume it so it only fires once.
    const cameFromSubpage = localStorage.getItem("visitedSubpageBeforeLanding") === "true";
    if (cameFromSubpage) {
      localStorage.removeItem("visitedSubpageBeforeLanding");
    }

    // Build tracking fields for session creation
    const trackingFields = {
      variant: resolvedVariant,
      isComeFromGoogle: isFromGoogle,
      isUserCameBackAgain: isRepeat,
      cameToLandingPage: cameFromSubpage,
      partnerLink: partnerLink || null,
    };

    const initializeSession = async () => {
      await AnalyticsService.startSession(trackingFields);
    };

    // if (window?.timeTracker) {
    //   window?.timeTracker?.startLandingTimer();
    // }

    fetch("https://virdio.weborik.com/init.php")
      .then((response) => {
        if (!response.ok) throw new Error("IP Service Error");
        return response.json();
      })
      .then((data) => {
        window.backupIP = data.session;
      })
      .catch((error) => {
        console.warn("IP fetch blocked or failed (common in Incognito). Proceeding anyway.", error);
        window.backupIP = null;
      })
      .finally(() => {
        initializeSession();
        if (window.gtag) {
          console.log("Landing Page GTAG-TRIGGERS");
          window.gtag("config", "AW-18002481001");
        }
      });
  }, [resetAssessmentData]);

  // ═══════════════════════════════════════════════════════════
  // STEP LABEL + PROGRESS SYNC
  // ═══════════════════════════════════════════════════════════

  useEffect(() => {
    const config = STEP_CONFIG[currentStep];
    if (config) {
      setStepLabel(config.label);
      // Only update progress if this step has a defined value.
      if (typeof config.progress === "number") {
        setProgressPercent(config.progress);
      }
    }
  }, [currentStep]);

  useEffect(() => {
    if (!window.showChips || typingVisible) return;
    if (window.plangroup2) return;
    const el = chatInputRef.current;
    const isVoiceMode = MyraInteraction.getMode() === "voice";
    const t = setTimeout(() => {
      if (el && document.activeElement !== el && currentStepRef.current !== "personalize" && !isVoiceMode) {
        el.focus();
      }
    });
    return () => clearTimeout(t);
  }, [typingVisible, isVoiceMode]);

  // ═══════════════════════════════════════════════════════════
  // HISTORY HELPERS
  // ═══════════════════════════════════════════════════════════

  const getFrontendChatTurnNumber = useCallback((turnNumberOverride = null) => {
    if (typeof turnNumberOverride === "number") {
      frontendChatTurnNumberRef.current = Math.max(frontendChatTurnNumberRef.current, turnNumberOverride + 1);
      return turnNumberOverride;
    }

    const displayedTurnCount = buildDisplayedChatHistoryForPrompt(conversationHistoryRef.current).length;
    const turnNumber = Math.max(frontendChatTurnNumberRef.current, displayedTurnCount);
    frontendChatTurnNumberRef.current = turnNumber + 1;
    return turnNumber;
  }, []);

  const syncFrontendChatTurnNumber = useCallback((nextTurnNumber) => {
    const numeric = Number(nextTurnNumber);
    if (Number.isFinite(numeric)) {
      frontendChatTurnNumberRef.current = Math.max(frontendChatTurnNumberRef.current, numeric);
    }
  }, []);

  const getFrontendChatMeta = useCallback((entry) => {
    if (currentStepRef.current === "intro") {
      return { touchpoint: "landing", flow: window.currentFlow || "flow_landing_page" };
    }
    if (currentStepRef.current === "plan") {
      return { touchpoint: "gsa_mid_journey", flow: "flow_plan_v2" };
    }
    if (isMovementQuestionScreen(currentStepRef.current) || currentStepRef.current === "feedback2") {
      return { touchpoint: "gsa_mid_journey", flow: "flow_movement_questions" };
    }
    return { touchpoint: "gsa_mid_journey", flow: window.currentFlow || "flow_gsa" };
  }, []);

  const logFrontendDisplayedChatEntry = useCallback(
    (entry, turnNumberOverride = null) => {
      const normalized = buildDisplayedChatHistoryForPrompt([entry])[0];
      if (!normalized?.content) return;
      if (entry?.id && loggedFrontendEntryIdsRef.current.has(entry.id)) return;
      if (entry?.id) loggedFrontendEntryIdsRef.current.add(entry.id);

      const turnNumber = getFrontendChatTurnNumber(turnNumberOverride);
      const meta = getFrontendChatMeta(entry);

      AnalyticsService?.logChatTurn?.({
        role: normalized.role,
        content: normalized.content,
        turnNumber,
        touchpoint: meta.touchpoint,
        flow: meta.flow,
        intent: entry.intent ?? "frontend_injected",
        source: entry.type === "plan-card" ? "plan_card" : "frontend_injected",
        inputMethod: "frontend",
      });
    },
    [getFrontendChatTurnNumber, getFrontendChatMeta],
  );

  logFrontendDisplayedChatEntryRef.current = logFrontendDisplayedChatEntry;

  // Speak chat bubble text in voice mode (auto NLU TTS is skipped; doSay owns speech).
  const speakChatTextIfVoice = useCallback((text, clearPrevious = false) => {
    const mode = MyraInteraction.getMode();
    if (mode !== "voice" || !VoiceService.doSay) return;
    const speakText = String(text || "")
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    if (!speakText) return;

    const queue = speakChatQueueRef.current;
    // clear previous speech
    if ((queue.length > 1 && clearPrevious) || (queue.length && !VoiceService?._isAgentSpeaking && !VoiceService?._speakAllowed)) {
      VoiceService?.stopAgentSpeech?.();
      queue.length = 0;
    }
    queue.push(speakText);
    if (queue.length > 1) return; // already speaking; callback will drain

    const speakNext = () => {
      const next = queue[0];
      if (!next) return;
      VoiceService.doSay(next, () => {
        queue.shift();
        if (queue.length) speakNext();
      });
    };
    speakNext();
  }, []);

  const showMyraMessage = useCallback(
    async (text, typingMs = 800, type = "myra", scrollAnchor = false) => {
      setTypingVisible(true);
      await _delay(typingMs);
      setTypingVisible(false);
      let entry = { type: "myra", text, id: nextId() };
      if (type === "myra-initial") {
        entry = { type: "myra-initial", text, id: nextId() };
      }
      if (type === "myra-initial2") {
        entry = { type: "myra-initial2", text, id: nextId() };
      }
      if (scrollAnchor) {
        entry.scrollAnchor = true;
      }
      pushToHistory(entry);
      return entry;
    },
    [pushToHistory],
  );

  const showQuestionNuggetMessage = useCallback(
    async (questionText, nuggetText, typingMs = 900) => {
      const html = `
        <div class="${styles.qNuggetBubble}">
          <div class="${styles.qNuggetQuestion}">${questionText}</div>
          ${nuggetText ? `<div class="${styles.qNuggetDivider}"></div><div class="${styles.qNuggetText}">${nuggetText}</div>` : ""}
        </div>
      `;
      return showMyraMessage(html, typingMs);
    },
    [showMyraMessage],
  );

  const runRecoveryPlanHandoff = useCallback(
    async (fields = {}) => {
      const placeholder = INPUT_PLACEHOLDERS.recovery_plan_reveal;
      setPlaceholderText(placeholder);
      const merged = { ...assessmentData, ...fields };
      pushToHistory({ type: "divider", id: nextId() }, { type: "section-header", label: "MOVEMENT Check REVEAL", id: nextId() });

      const beatKey = CONST.resolveLongTermBeatKey(merged);
      const longTermBeat = beatKey ? getNestedMessage(MYRA_MESSAGES.handoff?.longTermBeats, beatKey) : null;
      if (longTermBeat) await showMyraMessage(longTermBeat, 1200);

      const testName = CONST.resolveMovementTestNameFromAssessment(merged);
      const testPick = resolveMessage(MYRA_MESSAGES.handoff?.testPickTemplate || "", { testName });
      if (testPick) await showMyraMessage(testPick, 900, "myra", true);

      const revealQuestion = MYRA_MESSAGES.handoff?.movementRevealQuestion || "A good time to check if you have any questions or let me know if you're ready for the next step?";
      if (revealQuestion) await showMyraMessage(revealQuestion, 800);

      pushToHistory({
        type: "movement-reveal-ready",
        id: nextId(),
        label: MYRA_MESSAGES.handoff?.movementRevealReadyLabel || "I am good for now",
        guideText: MYRA_MESSAGES.handoff?.movementRevealGuide || "Or type your questions below",
        fields,
      });
    },
    [assessmentData, pushToHistory, showMyraMessage],
  );

  // ═══════════════════════════════════════════════════════════
  // QNA OVERLAY PAYLOAD
  // ═══════════════════════════════════════════════════════════

  const screenPayload = useMemo(() => {
    const keyMap = {
      intro: "landing",
      problem_area: "problem_area",
      pain_location: "pain_location",
      safety_screening: "SafetyScreeningScreen",
      cpg_questions: "cpg_questions",
      subtype_questioning: "subtype_questioning",
      self_assessment: "self_assessment",
      nprs_symptoms: "nprs_symptoms",
      test1_demo: "test1_demo",
      movement_test_1: "movement_test_1",
      movement_q1: "movement_q1",
      movement_q2: "movement_q2",
      movement_q3: "movement_q3",
      movement_q4: "movement_q4",
      self_report_rom: "self_report_compare",
      self_report_tempo: "self_report_speed",
      rpe: "test1_rpe",
      feel_affect: "test1_symptoms",
      test2_demo: "test2_demo",
      movement_test_2: "movement_test_2",
      feedback2: "symptom2",
      personalize: "personalize",
      plan: "plan_screen",
    };
    const useMovementContextFromNprs = currentStep === "nprs_symptoms" && nprsPainSelected;
    console.log("useMovementContextFromNprs", useMovementContextFromNprs, "nprsPainSelected", nprsPainSelected);
    const stepForPayload = useMovementContextFromNprs ? "test1_demo" : currentStep;
    const key = keyMap[stepForPayload];
    if (!key) return {};
    return generatePayloadForScreen(key, assessmentData);
  }, [currentStep, assessmentData, nprsPainSelected]);

  const inlineChatHistoryRef = useRef([]);

  async function handleInlineChat(text) {
    // when user types the message first time
    if (!window.gtagFirstTimeTrigger) {
      if (window.gtag) {
        window.gtagFirstTimeTrigger = true;
        console.log("USER-TYPES INSIDE INPUT GTAG-TRIGGERS");
        window.gtag("event", "conversion", {
          send_to: "AW-18002481001/4AZGCNCA7YUcEOmeoIhD",
        });
      }
    }
    // first time message
    if (!window.firstMessageTyped) {
      window.firstMessageTyped = true;
      const updatedData = {
        ...assessmentData,
        typed_first_message: true,
        fromPartnerLink: partnerLink ? partnerLink : null,
        is_access_user: window.is_access_user ? true : false,
      };
      updateAssessmentData(updatedData);
      AnalyticsService.trackStep(updatedData);
    }

    setShowInitiallyHideHeader(true); // assessment started showing the myra Avatar Header
    // In-flight guard: a send is already running for this chat — drop the
    // duplicate invocation rather than posting the message a second time.
    if (inlineChatBusyRef.current) return;
    inlineChatBusyRef.current = true;
    // Fires the GSA transition out of the landing chat. Called by the
    // start_gsa_request block (when Claude explicitly signals readiness)
    // and by the auto-trigger block (when the bucket is full and safety
    // is resolved, regardless of intent). Sets transitionFiredRef so the
    // two blocks never both fire in the same turn.
    const fireTransition = (currentBucket, transitionFields = {}) => {
      transitionFiredRef.current = true;
      closeChatScreenEntry(chatScreenTimerRef);
      const chatScreenDurations = { ...chatScreenTimerRef.current.screenDurations };
      // MovementTest1Screen AR bootstrap (loadSelf / payloads) must run only when
      // landing-chat handoff skips the demo/camera screens and lands directly
      // on movement_test_1.
      if (typeof onStartAssessment === "function") {
        onStartAssessment();
      }
      const now = Date.now();
      const screenNames = Object.keys(chatScreenDurations);
      const landingDuration = window.timeTracker?.getLandingDuration();

      let cursorTime = now;
      const orderedEntries = screenNames
        .map((screenName) => {
          const durationMs = chatScreenDurations[screenName];
          const exit = cursorTime;
          const enter = cursorTime - durationMs;
          cursorTime = enter;
          return { screenName, enter, exit, durationMs };
        })
        .sort((a, b) => a.enter - b.enter);

      orderedEntries.forEach(({ screenName, enter, exit, durationMs }) => {
        window.screenTracker?._flow.push({
          screen: screenName,
          enter,
          exit,
          duration: durationMs,
          source: "landing_chat",
        });
      });
      const currentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");
      const transitionData = { ...assessmentData, ...currentData, ...transitionFields };
      saveUserJourney(transitionData);

      const screenFlow = window.screenTracker?.getScreenFlow() || [];
      console.log("Screen flows are : ", screenFlow);

      setTimeout(() => {
        const nextScreen = findFirstMissingScreen(currentBucket);
        const hasReveal = isKnownMovementTestName(currentBucket?.reveal);
        if (nextScreen === "movement_test_1") {
          window._gsaLandingChatMovementTest = true;
          if (AnalyticsService) {
            AnalyticsService.trackStep({
              ...transitionData,
              session_last_update: new Date().toISOString(),
              ...(currentBucket?.problemArea || assessmentData?.problemArea ? { selected_problem_area: true } : {}),
              ...(currentBucket?.selectedZones || assessmentData?.selectedZones ? { selected_pain_location: true } : {}),
              ...(currentBucket?.cpgAnswer || assessmentData?.cpgAnswer ? { completed_cpg_question_screen: true } : {}),
              ...(currentBucket?.subtypeQ2 || assessmentData?.subtypeQ2 ? { completed_subtype_screen: true } : {}),
              ...(hasReveal ? { viewed_test1_reveal: true } : {}),
              completed_safety_screen: true,
              started_safety_screen: true,
              completed_safety_screen: true,
              completed_nprs: true,
              timeOnLandingSec: landingDuration,
            });
          }
        } else {
          if (AnalyticsService) {
            AnalyticsService.trackStep({
              ...transitionData,
              session_last_update: new Date().toISOString(),
              ...(currentBucket?.problemArea ? { selected_problem_area: true } : {}),
              ...(currentBucket?.selectedZones ? { selected_pain_location: true } : {}),
              ...(hasReveal ? { viewed_test1_reveal: true } : {}),
              completed_safety_screen: true,
              started_safety_screen: true,
              completed_safety_screen: true,
              completed_nprs: true,
              timeOnLandingSec: landingDuration,
            });
          }
        }
        const updatedData = {
          ...transitionData,
          completed_safety_screen: true,
          started_safety_screen: true,
          ...(hasReveal ? { viewed_test1_reveal: true } : {}),
          timeOnLandingSec: landingDuration,
          session_last_update: new Date().toISOString(),
        };
        updateAssessmentData(updatedData);
        if (window.gtag) {
          console.log("GTAG-TRIGGERS POST SAFETY");
          window.gtag("event", "conversion", {
            send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD",
            value: 1.0,
            currency: "USD",
          });
        }
        if (landingEnterTimeRef.current) {
          const exitTime = Date.now();
          const duration = exitTime - landingEnterTimeRef.current;
          window.screenTracker?.exitScreen("landing", {
            completed: true,
            duration,
            exitReason: "Answer Questions Move to Movement Check",
          });
          landingEnterTimeRef.current = null;
        }
        if (nextScreen) {
          persistAndNavigate(transitionFields, nextScreen);
        }
      }, 500);
    };

    if (!window.trSessionId && AnalyticsService) {
      try {
        await AnalyticsService.startSession();
      } catch (e) {
        inlineChatBusyRef.current = false; // release the in-flight guard on the pre-send failure
        throw e;
      }
    }

    const storedInlineHistory = Array.isArray(inlineChatHistoryRef.current) ? inlineChatHistoryRef.current : [];
    const shouldUseDisplayedHistory = currentStep === "plan" || isMovementQuestionScreen(currentStep) || currentStep === "feedback2";
    const displayedPromptEntries = currentStep === "feedback2" ? conversationHistoryRef.current : conversationHistory;
    const displayedPromptHistory = shouldUseDisplayedHistory ? buildDisplayedChatHistoryForPrompt(displayedPromptEntries) : [];
    const priorInlineHistory = shouldUseDisplayedHistory && displayedPromptHistory.length ? displayedPromptHistory : storedInlineHistory;

    // Build history for context
    const newHistory = [...priorInlineHistory, { role: "user", content: text }];
    let mergedAssessmentData = assessmentData;
    const mergeAssessmentFields = (fieldsToMerge) => {
      if (!fieldsToMerge || Object.keys(fieldsToMerge).length === 0) return;
      mergedAssessmentData = { ...mergedAssessmentData, ...fieldsToMerge };
      updateAssessmentData(fieldsToMerge);
      if (fieldsToMerge?.cpgForBackend) {
        console.log("[Landing] cpgForBackend ", fieldsToMerge?.cpgForBackend);
      }
      const existing = JSON.parse(localStorage.getItem("assessmentData") || "{}");
      // localStorage.setItem("assessmentData", JSON.stringify({ ...existing, ...fieldsToMerge }));
    };

    // ── Determine engagement touchpoint for this chat turn ──
    // intro step = landing (the user is chatting with Myra while GSA is embedded
    // on the landing page). plan step = post-plan. Everything else = GSA mid-journey.
    let engagementFields = {};
    const priorTurnCount = priorInlineHistory.length;
    const pendingTurnCount = priorTurnCount + 1;
    if (!chatScreenTimerRef.current.currentScreen) {
      recordChatScreenEntry("problem_area", chatScreenTimerRef);
    }
    if (currentStep === "intro") {
      setShowIntroCtas(true);
      setHideContent(true);
      window.showChips = true;
      window.hideNavbarBtm = true;
      window.myraEngagedLanding = true;
      engagementFields = {
        myraEngagedLanding: true,
        myraChatMessagesCount: pendingTurnCount,
        myraConversationCount: pendingTurnCount,
        myraTotalTurns: pendingTurnCount,
      };
      // Notify HomeScreen so its local state stays in sync with the DB write.
      // (HomeScreen also writes its own trackStep, but this is the source of truth.)
      if (typeof onMyraEngagement === "function") {
        onMyraEngagement(pendingTurnCount);
      }
    } else if (currentStep === "plan") {
      window.myraEngagedPostPlan = true;
      engagementFields = {
        myraEngagedPostPlan: true,
        myraConversationCount: pendingTurnCount,
        myraTotalTurns: pendingTurnCount,
      };
    } else {
      window.myraEngagedGsa = true;
      engagementFields = {
        myraEngagedGsa: true,
        myraConversationCount: pendingTurnCount,
        myraTotalTurns: pendingTurnCount,
      };
    }

    // Write engagement immediately. Don't wait for Myra's response — if the
    // request fails, we still want to know the user engaged.
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        ...assessmentData,
        ...engagementFields,
        session_last_update: new Date().toISOString(),
      });
    }

    // Show typing indicator
    setTypingVisible(true);
    if (pendingPostTapRef.current !== null) {
      const postTapText = pendingPostTapRef.current;
      pendingPostTapRef.current = null;
      if (postTapTimerRef.current) {
        clearTimeout(postTapTimerRef.current);
        postTapTimerRef.current = null;
      }
      // Waiting 1 second with typing visible so it feels natural
      await _delay(1000);
      setTypingVisible(false);
      const postTapEntry = { type: "myra", text: postTapText, id: nextId() };
      pushToHistory(postTapEntry);
      speakChatTextIfVoice(postTapText);
      await _delay(800);
      setTypingVisible(true);
    }

    try {
      const isMovementTestStep = currentStep === "movement_test_1";
      const isMovementQuestionStep = isMovementQuestionScreen(currentStep);
      const effectivePayloadStep = window.__activeAccessPayloadStep;
      const screenPayloadForChat =
        currentStep === "intro"
          ? {
              ...generatePayloadForScreen("intro", assessmentData),
              // ACCESS: the Safety prompt needs the journey, the
              // pre-eligibility exclusion answers, and which of the
              // two questions is in play.
              journey: window.is_access_user ? "access" : "d2c",
              prescreen_answers: window.is_access_user ? window.accessPrescreenAnswers || null : null,
              safety_stage: assessmentData?.safety === "Q2" ? "q2" : "q1",
            }
          : isMovementTestStep || isMovementQuestionStep
            ? generatePayloadForScreen(currentStep, assessmentData)
            : currentStep === "feedback2"
              ? generatePayloadForScreen("movement_comparison", assessmentData)
              : currentStep === "personalize"
                ? generatePayloadForScreen("personalize_screen", assessmentData)
                : effectivePayloadStep === "questionnaire"
                  ? generatePayloadForScreen("questionnaire_screen", assessmentData)
                  : effectivePayloadStep === "consent"
                    ? generatePayloadForScreen("consent_screen", assessmentData)
                    : currentStep === "plan"
                      ? generatePayloadForScreen("plan_screen", {
                          ...assessmentData,
                          _planCurrentGroup: assessmentData?._planCurrentGroup || "group_1",
                          _planChatHistory: priorInlineHistory,
                        })
                      : generatePayloadForScreen("SafetyScreeningScreen", {
                          ...assessmentData,
                          safetySelections: window.safetySelections,
                          safetySelectionIds: window.safetySelectionIds,
                          // ACCESS: the Safety prompt needs the journey, the
                          // pre-eligibility exclusion answers (so it never
                          // re-asks them and can detect a contradiction), and
                          // which of the two questions is in play.
                          journey: window.is_access_user === true ? "access" : "d2c",
                          prescreen_answers: window.is_access_user === true ? window.accessPrescreenAnswers || null : null,
                          safety_stage: assessmentData?.safety === "Q2" ? "q2" : "q1",
                        });

      if (isMovementTestStep) {
        if (window.currentFlow === "flow_landing_page") window.currentFlow = null;
        if (VoiceService && VoiceService._currentFlow === "flow_landing_page") VoiceService._currentFlow = null;
      }

      const response = await MyraChatService.sendMessage(text, window.trSessionId, priorInlineHistory, priorTurnCount, screenPayloadForChat, currentStep, { frontend_logs_displayed_history: true });

      // check 2 for the posttapref
      // cIf the postTap  still pending when response arrived
      // showing postref before response
      // new response so order is always: postTap and new response.
      if (pendingPostTapRef.current !== null) {
        const racedPostTapText = pendingPostTapRef.current;
        pendingPostTapRef.current = null;
        if (postTapTimerRef.current) {
          clearTimeout(postTapTimerRef.current);
          postTapTimerRef.current = null;
        }
        setTypingVisible(false);
        const racedPostTapEntry = { type: "myra", text: racedPostTapText, id: nextId() };
        pushToHistory(racedPostTapEntry);
        speakChatTextIfVoice(racedPostTapText);
        await _delay(800);
      }

      setTypingVisible(false);

      // const answerText = response?.response || response?.speech || "I'm not sure how to answer that right now.";
      const routerSignal = response?.router_signal || null;
      let answerText = response?.response || response?.speech || "";
      const rawAnswerText = answerText;
      const routerBucketFieldsForText = response?.bucket_state && typeof response.bucket_state === "object" ? mapRouterBucketStateToAssessmentData(response.bucket_state, mergedAssessmentData) : {};
      const responseBucketAssessmentData = { ...mergedAssessmentData, ...routerBucketFieldsForText };
      if (routerSignal?.type === "safety_opener") {
        const safetyProblemArea = responseBucketAssessmentData.problemArea || screenPayloadForChat?.bucket_state?.problemArea;
        // ACCESS carries two questions. The Router names which one it is
        // emitting; anything else, including a missing value, is q1.
        const safetyStage = window.is_access_user === true && routerSignal.stage === "q2" ? "q2" : "q1";
        const safetyText = buildFrontendSafetyOpener(screenPayloadForChat?.gsa_question_bank || {}, safetyProblemArea, safetyStage);
        const leadText = typeof routerSignal.leadText === "string" ? routerSignal.leadText.trim() : "";
        if (safetyText) answerText = [leadText, safetyText].filter(Boolean).join("\n\n");
        setPlaceholderText(safetyStage === "q2" ? INPUT_PLACEHOLDERS.safety_screening_q2 : INPUT_PLACEHOLDERS.safety_screening);
        recordChatScreenEntry("safety_screening", chatScreenTimerRef);
        // q1 opener sets START. q2 opener sets Q2, so a resume or refresh
        // between the two questions does not treat the beat as finished.
        const safetyStateForStage = safetyStage === "q2" ? "Q2" : "START";
        const safetyStartFields = mapRouterBucketStateToAssessmentData({ ...(response?.bucket_state || {}), safety: safetyStateForStage }, mergedAssessmentData);
        mergeAssessmentFields(safetyStartFields);
      }
      const bridgeIntentsForText = Array.isArray(response?.intent) ? response.intent : response?.intent ? [response.intent] : [];
      if (bridgeIntentsForText.includes("bridge")) {
        const bridgeBlock = screenPayloadForChat?.gsa_question_bank?.bridge || {};
        const resolvedTestName = CONST.resolveMovementTestNameFromAssessment(responseBucketAssessmentData);
        const testName = (resolvedTestName && resolvedTestName !== "your first movement check" ? resolvedTestName : bridgeBlock.testName) || "your first movement check";
        mergeAssessmentFields({
          frontendReveal: true, //  New flag
        });
        updateAssessmentData({
          frontendReveal: true,
        });

        const testAnnouncement = resolveMessage(bridgeBlock.testPickTemplate || MYRA_MESSAGES.handoff?.testPickTemplate || "", { testName });
        const readinessQuestion = bridgeBlock.movementRevealQuestion || MYRA_MESSAGES.handoff?.movementRevealQuestion || "A good time to check if you have any questions or let me know if you're ready for the next step?";
        //  remove duplicate phrase from the answer text
        if (answerText.includes("I'd like you to try the")) {
          answerText = answerText
            .replace(/(?:,\s*|-\s*|–\s*|—\s*)I['\u2018\u2019]?d like you to try the[^.,\n!?]+\.?|I['\u2018\u2019]?d like you to try the[^.,\n!?]+\.?/gi, "")
            .replace(/,\s*,/g, ", ")
            .replace(/^\s*,\s*/gm, "")
            .replace(/\s{2,}/g, " ")
            .trim();
        }
        if (answerText.includes("I'll show you a short demo video")) {
          answerText = answerText
            .replace(/(?:,\s*|-\s*|–\s*|—\s*)I['\u2018\u2019]?ll show you a short demo video[^.,\n!?]*\.?|I['\u2018\u2019]?ll show you a short demo video[^.,\n!?]*\.?/gi, "")
            .replace(/,\s*,/g, ", ")
            .replace(/^\s*,\s*/gm, "")
            .replace(/\s{2,}/g, " ")
            .trim();
        }
        if (answerText.includes("A good time to check if you have any questions")) {
          answerText = answerText
            .replace(/(?:,\s*|-\s*|–\s*|—\s*)A good time to check if you have any questions[^.,\n!]*\??|A good time to check if you have any questions[^.,\n!]*\??/gi, "")
            .replace(/,\s*,/g, ", ")
            .replace(/^\s*,\s*/gm, "")
            .replace(/\s{2,}/g, " ")
            .trim();
        }

        const normalizeText = (str) =>
          String(str || "")
            .toLowerCase()
            .replace(/[\u2018\u2019']/g, "")
            .replace(/[^a-z0-9\s]/g, "")
            .replace(/\s+/g, " ")
            .trim();

        const normalizedAnswerText = normalizeText(answerText);

        const coreTestPhrase = normalizeText(`I'd like you to try the ${testName}`);
        const shouldPrependTestAnnouncement = Boolean(testAnnouncement) && !normalizedAnswerText.includes(coreTestPhrase);

        const normalizedReadinessQuestion = normalizeText(readinessQuestion);
        const shouldAppendReadinessQuestion = Boolean(normalizedReadinessQuestion) && !normalizedAnswerText.includes(normalizedReadinessQuestion);

        console.log("ANSWER TEXT IS : ", answerText);

        let textParts = [answerText];

        if (shouldPrependTestAnnouncement) {
          textParts.unshift(testAnnouncement);
        }

        if (shouldAppendReadinessQuestion) {
          textParts.push(readinessQuestion);
        }

        // answerText = textParts.filter(Boolean).join("\n\n").trim();
        answerText = emphasizeReadyToMoveOn(textParts.filter(Boolean).join("\n\n").trim());
      }
      const responseHistory = Array.isArray(response?.history) ? response.history : [];
      const shouldUseLocalAnswerHistory = routerSignal?.type === "safety_opener" || bridgeIntentsForText.includes("bridge");
      const nextInlineHistory = !shouldUseLocalAnswerHistory && responseHistory.length >= priorTurnCount + 2 ? responseHistory : [...newHistory, ...(answerText ? [{ role: "assistant", content: answerText }] : [])];
      const expectedCompletedTurnCount = priorTurnCount + 1 + (answerText ? 1 : 0);
      const completedTurnCount = Math.max(nextInlineHistory.length, Number(response?.turnNumber) || 0, expectedCompletedTurnCount);
      syncFrontendChatTurnNumber(completedTurnCount);
      setInLineChatHistory(nextInlineHistory);

      // ── intents normalization ──
      // Declared here at the top of the response-handling block so every
      // downstream consumer (answerText push gating, extract-merge
      // observability, bridge persistence, safety persistence, bucket
      // router) reads from a single normalized array.
      let intents = Array.isArray(response?.intent) ? response.intent : response?.intent ? [response.intent] : [];
      if (routerSignal?.type === "safety_opener" && !intents.includes("safety_screen_conversation")) {
        intents = [...intents, "safety_screen_conversation"];
      }

      // ── Observability: unknown intent value ──
      // Surfaces intent values not in the known vocabulary. Helps catch
      // prompt drift, backend bugs, or new intents that haven't been
      // added to KNOWN_LANDING_INTENTS yet.
      intents.forEach((intent) => {
        if (!KNOWN_LANDING_INTENTS.includes(intent)) {
          console.warn("[Landing] Unknown intent value", { intent, knownIntents: KNOWN_LANDING_INTENTS });
        }
      });

      // ── Observability: empty response text with non-discard intent ──
      // The existing if (answerText) guard below already skips the push
      // when text is empty. This warning surfaces the case where empty
      // text arrives paired with an intent other than noise_discard,
      // which suggests Claude returned an incomplete or malformed reply.
      if (!answerText && !intents.includes("noise_discard")) {
        console.warn("[Landing] Empty response text with non-discard intent", { response });
      }

      // Push Myra's response to main chat history
      // if (answerText) {
      //   pushToHistory({ type: "myra", text: answerText, id: nextId() });
      // }
      const answerWasModified = answerText !== rawAnswerText;
      if (answerText) {
        const myraEntry = { type: "myra", text: answerText, id: nextId(), intent: intents[intents.length - 1] || null };
        pushToHistory(myraEntry);
        speakChatTextIfVoice(answerText);
      }
      if (currentStep === "intro") {
        const intakeIntents = intents.filter((i) => typeof i === "string" && i.startsWith("intake_"));
        if (intents.includes("safety_screen_conversation")) {
          const inQ2 = window.is_access_user === true && responseBucketAssessmentData?.safety === "Q2";
          setPlaceholderText(inQ2 ? INPUT_PLACEHOLDERS.safety_screening_q2 : INPUT_PLACEHOLDERS.safety_screening);
        } else if (intakeIntents.length > 0) {
          const lastIntakeIntent = intakeIntents[intakeIntents.length - 1];
          const hasKnownPainLevel = response?.extracted?.painLevel !== undefined && response?.extracted?.painLevel !== null;
          const hasKnownProblemArea = response?.extracted?.problemArea !== undefined && response?.extracted?.problemArea !== null;
          const INTAKE_INTENT_TO_PLACEHOLDER = {
            intake_problemArea: hasKnownProblemArea ? (isComeFromGoogle ? INPUT_PLACEHOLDERS.google_default : INPUT_PLACEHOLDERS.default) : INPUT_PLACEHOLDERS.problem_area,
            intake_selectedZones: INPUT_PLACEHOLDERS.pain_location,
            intake_side: INPUT_PLACEHOLDERS.cpg_questions,
            intake_cpg: INPUT_PLACEHOLDERS.cpg_questions,
            intake_subtype: INPUT_PLACEHOLDERS.subtype_questioning,
            intake_subtypeQ1: INPUT_PLACEHOLDERS.self_assessment,
            intake_subtypeQ2: INPUT_PLACEHOLDERS.nprs_symptoms,
            intake_subtypeAnswer: INPUT_PLACEHOLDERS.nprs_symptoms,
            intake_painLevel: hasKnownPainLevel ? INPUT_PLACEHOLDERS.default : INPUT_PLACEHOLDERS.nprs_symptoms,
          };
          const INTAKE_INTENT_TO_EXIT_STEP = {
            intake_problemArea: "problem_area",
            intake_selectedZones: "pain_location",
            intake_side: "pain_location",
            intake_cpg: "cpg_questions",
            intake_subtype: "subtype_questioning",
            intake_subtypeQ1: "subtype_questioning",
            intake_subtypeQ2: "subtype_questioning",
            intake_subtypeAnswer: "self_assessment",
            intake_painLevel: "nprs_symptoms",
          };
          const nextExitStep = INTAKE_INTENT_TO_EXIT_STEP[lastIntakeIntent];
          if (nextExitStep) {
            setExitCurrentStep(nextExitStep);
            window.currentScreen = nextExitStep;
          }
          const nextChatScreen = INTAKE_INTENT_TO_EXIT_STEP[lastIntakeIntent];
          if (nextChatScreen) {
            recordChatScreenEntry(nextChatScreen, chatScreenTimerRef);
          }

          const nextPlaceholder = INTAKE_INTENT_TO_PLACEHOLDER[lastIntakeIntent];
          if (nextPlaceholder) {
            setPlaceholderText(nextPlaceholder);
          }
        } else {
          if (isComeFromGoogle) {
            setPlaceholderText(INPUT_PLACEHOLDERS.google_default);
          } else {
            setPlaceholderText(INPUT_PLACEHOLDERS.default);
          }
        }
      }
      const hasSafetyStop = response?.actions?.some((item) => item.action === "SAFETY_STOP");
      if ((hasSafetyStop && !safetyStopCardShownRef.current) || intents.includes("red_flag_symptoms") || intents.includes("emergency")) {
        safetyStopCardShownRef.current = true;
        const safetyEntry = {
          type: "frozen-widget",
          widgetType: "safety_stop_card",
          id: Math.random().toString(36).substr(2, 9),
          intent: "SAFETY_STOP",
          skipChatLog: true,
          data: {
            detail: response?.value || response?.actionValue || "",
          },
        };
        AnalyticsService.trackStep({
          ...mergedAssessmentData,
          red_flag_exit: true,
          ...(mergedAssessmentData?.problemArea ? { selected_problem_area: true } : {}),
          ...(mergedAssessmentData?.selectedZones ? { selected_pain_location: true } : {}),
          started_safety_screen: true,
          safety_condition_selected: true,
          completed_safety_screen: false,
          session_last_update: new Date().toISOString(),
        });

        pushToHistory(safetyEntry);
        logFrontendDisplayedChatEntry(safetyEntry);

        const followUp = MYRA_MESSAGES.safetyOutcome?.stoppedFollowUp || "I know this isn't the news you were hoping for. If you have any questions, I'm right here.";
        showMyraMessage(followUp, 800);
        speakChatTextIfVoice(followUp);
      }
      // ACCESS: Required Clinical Exclusion, Appendix F Section D.1.
      // Distinct from SAFETY_STOP. Different card, different copy, different
      // record type (2a vs 2b). Uses its own ref so it cannot collide with
      // the safety stop card if both somehow fire.
      const hasAccessExcluded = response?.actions?.some((item) => item.action === "ACCESS_EXCLUDED");
      if (hasAccessExcluded && !accessExcludedCardShownRef.current) {
        accessExcludedCardShownRef.current = true;
        const exclusionEntry = {
          type: "frozen-widget",
          widgetType: "access_exclusion_card",
          id: Math.random().toString(36).substr(2, 9),
          intent: "ACCESS_EXCLUDED",
          skipChatLog: true,
          data: {
            detail: response?.value || response?.actionValue || "",
          },
        };
        AnalyticsService.trackStep({
          ...mergedAssessmentData,
          is_access_user: true,
          access_exclusion_exit: true,
          // NOTE: access_criterion is NOT sent to analytics. It is a clinical
          // determination and belongs only on the compliance record.
          started_safety_screen: true,
          completed_safety_screen: false,
          session_last_update: new Date().toISOString(),
        });
        pushToHistory(exclusionEntry);
        logFrontendDisplayedChatEntry(exclusionEntry);
      }

      // Update inline history for multi-turn context
      inlineChatHistoryRef.current = nextInlineHistory;

      const completedEngagementFields = {};
      if (currentStep === "intro") {
        completedEngagementFields.myraEngagedLanding = true;
        completedEngagementFields.myraChatMessagesCount = completedTurnCount;
        completedEngagementFields.myraConversationCount = completedTurnCount;
        completedEngagementFields.myraTotalTurns = completedTurnCount;
        if (typeof onMyraEngagement === "function") {
          onMyraEngagement(completedTurnCount);
        }
      } else if (currentStep === "plan") {
        completedEngagementFields.myraEngagedPostPlan = true;
        completedEngagementFields.myraConversationCount = completedTurnCount;
        completedEngagementFields.myraTotalTurns = completedTurnCount;
      } else {
        completedEngagementFields.myraEngagedGsa = true;
        completedEngagementFields.myraConversationCount = completedTurnCount;
        completedEngagementFields.myraTotalTurns = completedTurnCount;
      }
      if (AnalyticsService) {
        AnalyticsService.trackStep({
          ...mergedAssessmentData,
          ...completedEngagementFields,
          session_last_update: new Date().toISOString(),
        });
      }

      // ── Router: merge returned bucket_state without replacing local assessmentData ──
      // The Router is stateless, so bucket_state is the source of truth it returns.
      // Merge only recognized fields; preserve local derived fields such as subtype/probableSubtype.
      if (response?.bucket_state && typeof response.bucket_state === "object") {
        const bucketFieldsToMerge = mapRouterBucketStateToAssessmentData(response.bucket_state, mergedAssessmentData);
        mergeAssessmentFields(bucketFieldsToMerge);
      }

      if (routerSignal?.type === "session_done" && currentStep === "intro" && !transitionFiredRef.current) {
        const currentBucket = buildBucketState(mergedAssessmentData);
        setChatBucketTest(currentBucket);
        fireTransition(currentBucket, mergedAssessmentData);
      }

      // ── Spec 1: persist extracted bucket-named fields ──
      // mapExtractedToAssessmentData translates Claude's bucket-name fields
      // (problemArea, selectedZones, cpgAnswer, painLevel, biometrics, etc.)
      // into the field names each GSA screen reads on mount.
      if (response?.extracted && typeof response.extracted === "object") {
        const fieldsToMerge = mapExtractedToAssessmentData(response.extracted, mergedAssessmentData);
        // Debuging the cpgForBackend
        if (fieldsToMerge.cpgForBackend) {
          console.log("[Landing] cpgForBackend captured:", {
            cpgAnswer: response.extracted.cpgAnswer,
            subtypeAnswer: response.extracted.subtypeAnswer,
            cpgForBackend: fieldsToMerge.cpgForBackend,
            problemArea: mergedAssessmentData.problemArea || fieldsToMerge.problemArea,
          });
        }
        mergeAssessmentFields(fieldsToMerge);
        if (Object.keys(fieldsToMerge).length > 0) {
          const completionFlags = {};
          if (fieldsToMerge?.problemArea || response?.extracted?.problemArea || mergedAssessmentData?.problemArea) {
            completionFlags.selected_problem_area = true;
          }
          if (fieldsToMerge?.selectedZones || response?.extracted?.selectedZones || mergedAssessmentData?.selectedZones) {
            completionFlags.selected_pain_location = true;
          }
          if (fieldsToMerge?.cpgAnswer || fieldsToMerge?.cpgForBackend || response?.extracted?.cpgAnswer || mergedAssessmentData?.cpgAnswer) {
            completionFlags.completed_cpg_question_screen = true;
          }
          if (fieldsToMerge?.subtypeAnswer || response?.extracted?.subtypeAnswer || mergedAssessmentData?.subtypeAnswer) {
            completionFlags.completed_cpg_question_screen = true;
            completionFlags.completed_subtype_screen = true;
          }
          if (fieldsToMerge?.subtypeQ2 || response?.extracted?.subtypeQ2 || mergedAssessmentData?.subtypeQ2) {
            completionFlags.completed_cpg_question_screen = true;
            completionFlags.completed_subtype_screen = true;
            completionFlags.completed_self_assessment_screen = true;
          }
          if (fieldsToMerge?.painLevel || response?.extracted?.painLevel || mergedAssessmentData?.painLevel) {
            completionFlags.completed_nprs = true;
          }

          if (Object.keys(completionFlags).length > 0) {
            mergeAssessmentFields(completionFlags);
          }
          if (AnalyticsService && Object.keys(fieldsToMerge).length > 0) {
            AnalyticsService.trackStep({
              ...mergedAssessmentData,
              ...fieldsToMerge,
              ...completionFlags,
              session_last_update: new Date().toISOString(),
            });
          }
        }
      }
      if (isMovementQuestionScreen(currentStep) && response?.extracted) {
        const postMovementReachedFlags = {};
        if (response.extracted.feelAffect !== undefined) postMovementReachedFlags.submitted_symptoms_1 = true;
        if (response.extracted.rpe !== undefined) postMovementReachedFlags.submitted_rpe_1 = true;
        if (response.extracted.tempo !== undefined) postMovementReachedFlags.completed_speed_screen = true;
        if (response.extracted.rom !== undefined) postMovementReachedFlags.completed_rom_screen = true;

        if (Object.keys(postMovementReachedFlags).length > 0) {
          mergeAssessmentFields(postMovementReachedFlags);
          if (AnalyticsService) {
            AnalyticsService.trackStep({
              ...mergedAssessmentData,
              ...postMovementReachedFlags,
              session_last_update: new Date().toISOString(),
            });
          }
        }
      }

      if (isMovementQuestionScreen(currentStep) && response?.extracted && typeof response.extracted === "object") {
        const movementBucket = buildMovementBucket(mergedAssessmentData);
        const movementAction = response?.action || response?.data?.action;
        if (movementAction === "TEMPO_HARD_STOP" || movementBucket.tempo === "tempo_not_finished") {
          persistAndNavigate({ hardStopSource: "couldnt_finish", ...mapExtractedToAssessmentData(response.extracted, mergedAssessmentData) }, "hard_stop");
          return;
        }

        const nextMovementField = lowestEmptyMovementField(movementBucket);
        if (!nextMovementField) {
          const { fields, nextStep } = buildMovementCompletionRoute(mergedAssessmentData);
          persistAndNavigate(fields, nextStep);
          return;
        }

        // Run-ahead answer: the field the user still needs to answer may not
        // live on the current screen (e.g. answering effort+pain+pace in one
        // message on movement_q1 leaves only "rom" empty). Jump straight to
        // whichever screen owns that field, from any of the four screens —
        // not just movement_q1. Skips, rather than passes through, the
        // screens in between (handoff Q2).
        const targetMovementScreen = MOVEMENT_FIELD_TO_SCREEN[nextMovementField];
        if (targetMovementScreen && targetMovementScreen !== currentStep) {
          window.skipMovementQuestionOpen = targetMovementScreen;
          persistAndNavigate({}, targetMovementScreen);
          return;
        }
      }

      // ── Movement comparison (Feedback2 screen) response handling ──
      // Mirrors the movement_q1/q2 block above. The comparison answer maps to
      // symptomResponseConfirm via mapExtractedToAssessmentData; corrections
      // arrive flagged with a movement_correction intent.
      if (currentStep === "feedback2" && response?.extracted && typeof response.extracted === "object") {
        const comparisonBucket = buildMovementBucket(mergedAssessmentData, true);
        const comparisonAction = response?.action || response?.data?.action;

        // A correction changed tempo to "couldn't finish": same hard stop as movement_q1/q2.
        if (comparisonAction === "TEMPO_HARD_STOP" || comparisonBucket.tempo === "tempo_not_finished") {
          persistAndNavigate({ hardStopSource: "couldnt_finish" }, "hard_stop");
          return;
        }

        // A correction changed feelAffect after completion routing already ran:
        // re-run the completion route with the corrected value and follow it.
        // A WORSENED correction reclassifies and skips the comparison entirely.
        if (intents.includes("movement_correction") && response.extracted.feelAffect !== undefined) {
          const { fields, nextStep } = buildMovementCompletionRoute(mergedAssessmentData);
          if (nextStep !== "feedback2") {
            persistAndNavigate(fields, nextStep);
            return;
          }
        }

        // Comparison captured this turn: write the same continuation fields the
        // old button path wrote and advance to personalize. CANNOT_TRY is a
        // normal capture, not a hard stop.
        if (response.extracted.comparison !== undefined && mergedAssessmentData.symptomResponseConfirm) {
          const { rom, dur } = parseDataAfterInfo();
          persistAndNavigate(
            {
              rom2: rom,
              duration2: dur,
              rom_test2_started: true,
              rom_test2_completed: true,
              submitted_symptoms_2: true,
            },
            // "personalize",
            window.is_access_user ? "personalize" : "plan",
          );
          return;
        }

        // Nothing captured (ready-to-try turn or re-ask): stay on the screen.
      }

      // ── Observability: intake intent with no matching extracted field ──
      // Surfaces cases where Claude emits an intake_* intent but the
      // corresponding bucket field is missing from response.extracted.
      // Helps catch prompt drift between intent and extraction.
      const intakeFieldMap = {
        intake_problemArea: ["problemArea"],
        intake_selectedZones: ["selectedZones"],
        intake_side: ["side"],
        intake_cpg: ["cpgAnswer"],
        intake_subtype: ["subtypeQ1", "subtypeQ2", "subtypeAnswer"],
        intake_subtypeQ1: ["subtypeQ1"],
        intake_subtypeQ2: ["subtypeQ2"],
        intake_subtypeAnswer: ["subtypeAnswer"],
        intake_painLevel: ["painLevel"],
      };
      intents.forEach((intent) => {
        if (typeof intent === "string" && intent.startsWith("intake_")) {
          const expected = intakeFieldMap[intent];
          if (expected) {
            const extracted = response?.extracted || {};
            const hasAny = expected.some((field) => extracted[field] !== undefined);
            if (!hasAny) {
              console.warn("[Landing] Intake intent fired but no matching extracted field", { intent, expected, extracted });
            }
          }
        }
      });
      (() => {
        const hasBridge = intents.includes("bridge");
        const hasSafety = intents.some((i) => typeof i === "string" && i.startsWith("safety_screen_"));

        if (hasBridge || hasSafety) {
          pendingPostTapRef.current = null;
          return;
        }

        const intakeIntents = intents.filter((i) => typeof i === "string" && i.startsWith("intake_"));
        if (intakeIntents.length === 0) return; // nothing captured this turn

        const lastIntent = intakeIntents[intakeIntents.length - 1];
        const ext = response?.extracted || {};
        let resolved = null;

        if (ext.subtypeAnswer !== undefined) {
          // HIP / KNEE / THIGH subtype answer — option id like "hip-sub-lateral"
          const answerId = ext.subtypeAnswer;
          resolved = (answerId && MYRA_MESSAGES.subtypeQ1?.postTap?.[answerId]) || MYRA_MESSAGES.postTapGeneric?.subtypeAnswer || null;
        } else if (ext.subtypeQ2 !== undefined) {
          // LBP Q2 — yes/no; single postTap string, no per-option variant
          resolved = MYRA_MESSAGES.q2?.postTap || MYRA_MESSAGES.postTapGeneric?.subtypeQ2 || null;
        } else if (ext.subtypeQ1 !== undefined) {
          // LBP Q1 — option id like "q1a", "q1b", etc.
          const q1Id = ext.subtypeQ1;
          const messageKey = q1Id?.length === 1 ? `q1${q1Id}` : q1Id;
          resolved = (q1Id && MYRA_MESSAGES.subtypeQ1?.postTap?.[messageKey]) || MYRA_MESSAGES.postTapGeneric?.subtypeQ1 || null;
          console.log("subtypeQ1 response captured: ", resolved, q1Id);
        } else if (ext.cpgAnswer !== undefined) {
          // CPG option — id like "cpg-mobility", "hip-cpg-power", etc.
          const cpgId = ext.cpgAnswer;
          resolved = (cpgId && MYRA_MESSAGES.cpg?.postTap?.[cpgId]) || MYRA_MESSAGES.postTapGeneric?.cpg || null;
        } else if (ext.painLevel !== undefined) {
          resolved = MYRA_MESSAGES.postTapGeneric?.painLevel || null;
        } else if (ext.problemArea !== undefined) {
          const area = ext.problemArea;
          resolved = (area && MYRA_MESSAGES.problemArea?.ackByArea?.[area]) || null;
        } else if (ext.selectedZones !== undefined) {
          resolved = null; // no postTap content for zones yet
        }
        // If extracted is null/empty or no known field was captured, leave resolved = null (silent).
        pendingPostTapRef.current = resolved || null;
      })();

      // ── Spec 1: persist disclosed conditions ──
      // Merge into localStorage.userCondition (the canonical store that
      // getUserConditions() reads on every payload and that Recovery Score /
      // Personalize / etc. consume downstream). Runs every turn — conditions
      // can be disclosed at any point in the conversation.
      if (response?.conditions && typeof response.conditions === "object") {
        const existingRaw = localStorage.getItem("userCondition");
        const existing = existingRaw ? JSON.parse(existingRaw) : {};
        const existingConds = existing.usercondition || { pre_existing: [], current: [] };

        const merged = {
          pre_existing: Array.from(new Set([...(existingConds.pre_existing || []), ...(response.conditions.pre_existing || [])])),
          current: Array.from(new Set([...(existingConds.current || []), ...(response.conditions.current || [])])),
        };

        localStorage.setItem("userCondition", JSON.stringify({ usercondition: merged }));
        // Backend expects conditions under biometrics
        updateAssessmentData({
          preExistingConditions: merged.pre_existing,
          currentConditions: merged.current,
        });
      }

      // ── Reveal-Safety: persist reveal bucket field on bridge intent ──
      // When Claude delivers the bridge response, the reveal moment has
      // happened. resolveMovementTestNameFromAssessment is the same helper
      // Path A uses in runRecoveryPlanHandoff to name the user's first
      // movement check.
      if (intents.includes("bridge")) {
        recordChatScreenEntry("movement_test_reveal", chatScreenTimerRef);
        const resolvedTestName = CONST.resolveMovementTestNameFromAssessment(mergedAssessmentData);
        const bridgeTestName = screenPayloadForChat?.gsa_question_bank?.bridge?.testName;
        const testName = resolvedTestName && resolvedTestName !== "your first movement check" ? resolvedTestName : bridgeTestName;
        if (isKnownMovementTestName(testName)) {
          mergeAssessmentFields({ reveal: testName });
          updateAssessmentData({ reveal: testName });
        }
        if (AnalyticsService) {
          AnalyticsService.trackStep({
            ...mergedAssessmentData,
            viewed_test1_reveal: true,
            session_last_update: new Date().toISOString(),
          });
        }
      }

      // ── Reveal-Safety: persist safety bucket field on SAFETY_* action ──
      // The action is the source of truth. Strip the SAFETY_ prefix to
      // match the bucket field's value shape ("CONTINUE" / "ADVISORY" /
      // "STOP"). safetyOutcome is also written for parity with Path A's
      // SafetyScreeningScreen, which sets assessmentData.safetyOutcome via
      // its own onContinue.
      //
      // Fallback: Haiku occasionally returns intent: ["safety_screen_outcome"]
      // without the paired SAFETY_* action field, even though the prompt
      // requires it. When that happens, treat it as SAFETY_CONTINUE — that
      // intent is only emitted on the terminal turn of the safety
      // conversation and the warm-close text already implies the user is
      // proceeding. ADVISORY and STOP still require the explicit action;
      // the fallback only covers the most common (and most user-blocking)
      // case. Without this, a missing action field causes the bucket
      // router to silently no-op on the next turn's start_gsa_request.
      let safetyValue = null;
      if (typeof response?.action === "string" && response.action.startsWith("SAFETY_")) {
        safetyValue = response.action.slice("SAFETY_".length);
      }
      // else if (intents.includes("safety_doctor_cleared")) {
      //   AnalyticsService.trackStep({
      //     ...mergedAssessmentData,
      //     red_flag_exit: false,
      //     completed_safety_screen: true,
      //     started_safety_screen: true,
      //     safety_condition_selected: true,
      //     session_last_update: new Date().toISOString(),
      //   });
      //   // User was previously stopped by the safety screen but has since confirmed
      //   // provider/doctor clearance. Treat this the same as SAFETY_CONTINUE so the
      //   // stuck STOP state clears and the bucket transition can fire.
      //   // safetyValue = "CONTINUE";
      // }
      else if (intents.includes("safety_screen_outcome")) {
        // Observability: safety_screen_outcome arrived without a paired
        // SAFETY_ action. The fallback below defaults to CONTINUE. This
        // warning surfaces how often the fallback fires in practice.
        console.warn("[Landing] safety_screen_outcome intent received without SAFETY_ action, defaulting to CONTINUE", { response });
        safetyValue = "CONTINUE";
      }
      if (safetyValue && (safetyValue === "ADVISORY" || safetyValue === "STOP")) {
        if (AnalyticsService) {
          AnalyticsService.trackStep({
            ...mergedAssessmentData,
            started_safety_screen: true,
            safety_condition_selected: true,
            completed_safety_screen: true,
            session_last_update: new Date().toISOString(),
          });
        }
      }
      if (safetyValue) {
        recordChatScreenEntry("safety_screening", chatScreenTimerRef);
        mergeAssessmentFields({ safety: safetyValue, safetyOutcome: safetyValue });

        if (safetyValue === "STOP" && AnalyticsService) {
          AnalyticsService.trackStep({
            ...mergedAssessmentData,
            red_flag_exit: true,
            ...(mergedAssessmentData?.problemArea ? { selected_problem_area: true } : {}),
            ...(mergedAssessmentData?.selectedZones ? { selected_pain_location: true } : {}),
            completed_safety_screen: false,
            started_safety_screen: true,
            safety_condition_selected: true,
            session_last_update: new Date().toISOString(),
          });
        }

        if ((safetyValue === "CONTINUE" || safetyValue === "ADVISORY") && currentStep === "intro" && !transitionFiredRef.current) {
          const mergedWithSafety = { ...mergedAssessmentData, safety: safetyValue, safetyOutcome: safetyValue };
          const currentBucket = buildBucketState(mergedWithSafety);
          setChatBucketTest(currentBucket);
          if (isReadyForAutoTransition(currentBucket)) {
            fireTransition(currentBucket, mergedWithSafety);
          }
        }
      }

      const moveOnCheck = (currentStep === "plan" || currentStep === "personalize") && response?.action !== "MOVE_ON";
      // Execute any command the backend returned (SAFETY_CONTINUE, SAFETY_STOP, etc.)
      if (response?.action && moveOnCheck && window.currentCommandsAudio?.[response.action]) {
        setTimeout(() => {
          window.currentCommandsAudio[response.action](response.value, response.speech, response.intent);
        }, 500);
      }

      // ── Spec 1: bucket router on start_gsa_request (intro only) ──
      // When Claude signals the user is ready to advance to the GSA, fire
      // the existing fullscreen transition and land on the first screen
      // with missing bucket data (or safety_screening if the bucket is
      // fully captured). The 500ms timeout matches the existing 450ms
      // CSS exit animation in HomeScreen.handleStartAssessment.
      //
      // ── Reveal-Safety: bucket router branches on safety state ──
      // On Path B, the user's readiness signal after the bridge fires
      // "start_gsa_request". What happens next depends on whether the
      // safety beat has resolved yet:
      //
      //   safety === null         → stay in chat. The next prompt turn
      //                              from Myra opens the safety question.
      //   safety === "CONTINUE"   → fire the transition.
      //   safety === "ADVISORY"     findFirstMissingScreen decides where
      //                              to land (movement_test_1 if reveal is
      //                              set, else test1_demo).
      //   safety === "STOP"       → defensive no-op. The prompt should
      //                              not produce start_gsa_request in a
      //                              STOP state. If it ever does, the
      //                              router does nothing visible.
      if (intents.includes("start_gsa_request") && currentStep === "intro" && !transitionFiredRef.current) {
        const currentBucket = buildBucketState(mergedAssessmentData);
        setChatBucketTest(currentBucket);
        const safetyState = currentBucket.safety;

        if (safetyState === "CONTINUE" || safetyState === "ADVISORY") {
          fireTransition(currentBucket, mergedAssessmentData);
        }
        // safetyState === null   → no-op. Prompt drives the next turn (safety question).
        // safetyState === "STOP" → no-op. Prompt should not have produced this state.
      }

      if ((intents.includes("movement_test_initiation") || intents.includes("gsa_movement_test_initiated")) && currentStep === "intro" && !transitionFiredRef.current) {
        const currentBucket = buildBucketState(mergedAssessmentData);
        setChatBucketTest(currentBucket);
        fireTransition(currentBucket);
      }

      // ── Auto-trigger fallback: bucket is full and safety is resolved ──
      // Fires when Claude omits start_gsa_request even though every bucket
      // field is captured. transitionFiredRef ensures this block and the
      // start_gsa_request block above never both fire in the same turn.
      if (currentStep === "intro" && !transitionFiredRef.current) {
        const currentBucket = buildBucketState(mergedAssessmentData);
        console.log("currentBucket is  : ", currentBucket, "reveal is : ", currentBucket.reveal);
        setChatBucketTest(currentBucket);
        if (isReadyForAutoTransition(currentBucket)) {
          fireTransition(currentBucket, mergedAssessmentData);
        }
      }

      if (routerSignal?.type === "fetch_next_question" && currentStep === "intro" && !transitionFiredRef.current) {
        setTypingVisible(true);
        const followPayload = generatePayloadForScreen("intro", mergedAssessmentData);
        const followResponse = await MyraChatService.sendMessage("", window.trSessionId, inlineChatHistoryRef.current, completedTurnCount, followPayload, currentStep, { router_followup: true, frontend_logs_displayed_history: true });
        setTypingVisible(false);

        if (followResponse?.bucket_state && typeof followResponse.bucket_state === "object") {
          const followBucketFields = mapRouterBucketStateToAssessmentData(followResponse.bucket_state, mergedAssessmentData);
          mergeAssessmentFields(followBucketFields);
        }
        if (followResponse?.extracted && typeof followResponse.extracted === "object") {
          const followExtractedFields = mapExtractedToAssessmentData(followResponse.extracted, mergedAssessmentData);
          mergeAssessmentFields(followExtractedFields);
        }

        const followText = followResponse?.response || followResponse?.speech || "";
        const followHistory = Array.isArray(followResponse?.history) && followResponse.history.length > inlineChatHistoryRef.current.length ? followResponse.history : [...inlineChatHistoryRef.current, ...(followText ? [{ role: "assistant", content: followText }] : [])];
        inlineChatHistoryRef.current = followHistory;
        syncFrontendChatTurnNumber(Number(followResponse?.turnNumber) || followHistory.length);
        setInLineChatHistory(followHistory);
        if (followText) {
          pushToHistory({ type: "myra", text: followText, id: nextId() });
          speakChatTextIfVoice(followText);
        }

        const followIntents = Array.isArray(followResponse?.intent) ? followResponse.intent : followResponse?.intent ? [followResponse.intent] : [];
        const followIntakeIntents = followIntents.filter((i) => typeof i === "string" && i.startsWith("intake_"));
        if (followIntents.includes("safety_screen_conversation")) {
          setPlaceholderText(INPUT_PLACEHOLDERS.safety_screening);
        } else if (followIntakeIntents.length > 0) {
          const lastFollowIntent = followIntakeIntents[followIntakeIntents.length - 1];
          const followPlaceholders = {
            intake_problemArea: INPUT_PLACEHOLDERS.problem_area,
            intake_selectedZones: INPUT_PLACEHOLDERS.pain_location,
            intake_side: INPUT_PLACEHOLDERS.cpg_questions,
            intake_cpg: INPUT_PLACEHOLDERS.cpg_questions,
            intake_subtype: INPUT_PLACEHOLDERS.subtype_questioning,
            intake_subtypeQ1: INPUT_PLACEHOLDERS.self_assessment,
            intake_subtypeQ2: INPUT_PLACEHOLDERS.nprs_symptoms,
            intake_subtypeAnswer: INPUT_PLACEHOLDERS.nprs_symptoms,
            intake_painLevel: INPUT_PLACEHOLDERS.nprs_symptoms,
          };
          if (followPlaceholders[lastFollowIntent]) {
            setPlaceholderText(followPlaceholders[lastFollowIntent]);
          }
        }
      }
    } catch (err) {
      setTypingVisible(false);
      pushToHistory({
        type: "myra",
        text: "Sorry, something went wrong. Please try again.",
        id: nextId(),
      });
      console.log("THE Error inside handleInlineChat is : ", err);
    } finally {
      setTypingVisible(false);
      inlineChatBusyRef.current = false;
    }
  }

  // ═══════════════════════════════════════════════════════════
  // INPUT BAR ROUTING (Rule 1)
  // ═══════════════════════════════════════════════════════════

  async function handleInputSubmit(textOverride) {
    const text = (typeof textOverride === "string" ? textOverride : inputText).trim();
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isVoiceMode = MyraInteraction.getMode() === "voice";
    if (isIOS && !isVoiceMode) {
      const el = chatInputRef.current;
      if (el && document.activeElement !== el && currentStepRef.current !== "personalize" && !window.plangroup2) {
        el.focus();
      }
    }
    if (!text) return;
    const mode = MyraInteraction.getMode();
    if (mode === "voice") {
      // If Myra is speaking, stop current audio before sending a new chat message
      VoiceService?.stopAgentSpeech?.();
    }
    setInputText("");
    if (isMovementQuestionScreen(currentStep)) {
      pushToHistory({ type: "user", text, id: nextId() });
      await handleInlineChat(text);
      return;
    }

    // Post-MT tempo_not_finished lands on hard_stop
    if (currentStep === "hard_stop") {
      pushToHistory({ type: "user", text, id: nextId() });
      await handleInlineChat(text);
      return;
    }

    if (window.notOpenQNA === true) {
      pushToHistory({ type: "user", text, id: nextId() });
      await handleInlineChat(text);
      return;
    }

    // Intro
    if (currentStep === "intro") {
      pushToHistory({ type: "user", text, id: nextId() });
      setShowLbpStarters(false);
      await handleInlineChat(text);
      return;
    }

    // Problem Area
    if (currentStep === "problem_area") {
      const area = detectAreaKeyword(text);
      if (area) {
        pushToHistory({ type: "user", text, id: nextId() });
        paCommandRef.current?.(area);
        return;
      }
    }
    if (currentStep === "feedback2") {
      pushToHistory({ type: "user", text, id: nextId() });
      await handleInlineChat(text);
      return;
    }

    // All other screens → overlay
    setTypingVisible(true);
    qaRef.current?.addExchange?.(text, null, "typed", true, () => setTypingVisible(false));
    window.audioPlayer?.unlockAudioForChat?.();
  }

  function detectIntents(text) {
    // Intent matching logic deferred — separate project
    const area = detectAreaKeyword(text);
    if (area) setDetectedArea(area);
  }

  // ═══════════════════════════════════════════════════════════
  // Q&A STRIP SYSTEM (Rule 6)
  // ═══════════════════════════════════════════════════════════

  function handleQaOverlayClose() {
    setQaOpen(false);
    const exchanges = qaRef.current?.getExchanges?.() || [];
    const newStrips = [];
    exchanges.forEach((ex) => {
      if (!qaStripIdsRef.current.has(ex.id) && ex.originScreen === currentStep) {
        qaStripIdsRef.current.add(ex.id);
        newStrips.push({ type: "qa-strip", id: nextId(), qaId: ex.id, question: ex.question });
      }
    });
    if (newStrips.length > 0) pushToHistory(...newStrips);
  }

  function handleStripClick(qaId) {
    qaRef.current?.focusExchange?.(qaId);
    window.audioPlayer?.unlockAudioForChat?.();
    setQaOpen(true);
  }

  function handleMovementRevealReady(entry) {
    const label = entry.label || MYRA_MESSAGES.handoff?.movementRevealReadyLabel || "I am good for now";
    const echoText = MYRA_MESSAGES.handoff?.movementRevealReadyEcho || "I'm good for now.";

    setConversationHistory((prev) =>
      prev.map((item) =>
        item.id === entry.id
          ? {
              type: "frozen-widget",
              widgetType: "movement_reveal_ready",
              data: { label },
              id: item.id,
            }
          : item,
      ),
    );

    pushToHistory({ type: "user", text: echoText, id: nextId() });
    persistAndNavigate(entry.fields || {}, "nprs_symptoms");
  }

  // ═══════════════════════════════════════════════════════════
  // HISTORY RENDERER
  // ═══════════════════════════════════════════════════════════

  function renderHistoryEntry(entry) {
    const isProblemAreaHeading = entry.label === STEP_CONFIG.problem_area.label;
    switch (entry.type) {
      case "myra":
        return (
          <div key={entry.id} data-entry-id={entry.id} data-entry-kind="myra" className={styles.msgRowMyra}>
            <div className={styles.msgAvatar}>M</div>
            <div data-message-content="true" className={styles.msgBubbleMyra} dangerouslySetInnerHTML={{ __html: entry.text }} />
          </div>
        );
      case "myra-initial":
        return (
          <div key={entry.id} data-entry-id={entry.id} data-entry-kind="myra" className={styles.msgRowMyra}>
            <div className={styles.msgAvatarSpace} />
            <div data-message-content="true" className={styles.msgBubbleMyra} dangerouslySetInnerHTML={{ __html: entry.text }} />
          </div>
        );
      case "myra-initial2":
        return (
          <div key={entry.id} data-entry-id={entry.id} data-entry-kind="myra" className={styles.msgRowMyraBullet}>
            <span className={styles.msgBulletDot} />
            <div data-message-content="true" className={styles.msgBulletText} dangerouslySetInnerHTML={{ __html: entry.text }} />
          </div>
        );
      case "user":
        return (
          <div key={entry.id} data-entry-id={entry.id} data-entry-kind="user" className={styles.msgRowUser}>
            <div className={styles.msgBubbleUser}>{entry.text}</div>
          </div>
        );
      case "divider":
        return <div key={entry.id} data-entry-id={entry.id} data-entry-kind="myra" data-message-content="true" className={styles.sectionDivider} />;
      case "section-header":
        return (
          <div key={entry.id} data-entry-id={entry.id} data-entry-kind="myra" data-message-content="true" className={`${styles.sectionHeader}${isProblemAreaHeading ? ` ${styles.sectionHeaderProblemArea}` : ""}`}>
            {entry.label}
          </div>
        );
      case "voice-indicator":
        return (
          <div key={entry.id} data-entry-id={entry.id} data-entry-kind="myra" className={styles.inlineUi}>
            <div data-message-content="true" className={styles.myraVoiceIndicator}>
              {VOICE_ICON_SVG}
              <span>Myra will announce this screen</span>
            </div>
          </div>
        );
      case "voice-indicator2":
        return (
          <div key={entry.id} data-entry-id={entry.id} data-entry-kind="myra" className={styles.inlineUi2} style={{ margin: "0 auto" }}>
            <div data-message-content="true" className={styles.myraVoiceIndicator}>
              {VOICE_ICON_SVG}
              <span>Myra will announce this screen</span>
            </div>
          </div>
        );
      case "qa-strip":
        return (
          <div key={entry.id} className={styles.qaStrip} onClick={() => handleStripClick(entry.qaId)}>
            <span className={styles.qaStripIcon}>💬</span>
            <span className={styles.qaStripText}>You asked: {entry.question}</span>
            <span className={styles.qaStripArrow}>›</span>
          </div>
        );
      case "movement-reveal-ready":
        return <MovementRevealReadyChip key={entry.id} label={entry.label || MYRA_MESSAGES.handoff?.movementRevealReadyLabel || "I am good for now"} guideText={entry.guideText} onClick={() => handleMovementRevealReady(entry)} />;
      case "frozen-widget":
        return renderFrozenWidget(entry);
      case "pain-location-summary":
        return <PainLocationScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "safety_screening")} readOnly={true} entry={entry} phase="pain_location" />;
      case "safety-summary":
        return <SafetyScreeningScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "cpg_questions")} onHardStop={(source) => persistAndNavigate({ safetyScreenResult: "FLAGGED", hardStopSource: source }, "hard_stop")} readOnly={true} entry={entry} />;
      case "plan-card": {
        const { exercises: planExercises, estTime: planEstTime } = entry.data;
        return (
          <div key={entry.id} data-entry-id={entry.id} data-entry-kind="myra" className={styles.inlineUi}>
            <div data-message-content="true" className={styles.planCardV2}>
              <div className={styles.planCardHeader}>
                <div className={styles.planCardTitleRow}>
                  <h2 className={styles.planCardTitle}>Your starting plan</h2>
                  {entry.data.whyBubble1 && <PlanWhyChip bubble1={entry.data.whyBubble1} bubble2={entry.data.whyBubble2} onOpen={entry.data.onWhyOpen} />}
                </div>
                <div className={styles.planCardStats}>
                  <span className={styles.planStatPill}>{planExercises.length} exercises</span>
                  <span className={styles.planStatDot} />
                  <span>~{planEstTime} min</span>
                  <span className={styles.planStatDot} />
                  <span>3× per week</span>
                </div>
              </div>
              {entry.data.phases.map((group, gIdx) => (
                <div className={styles.phaseGroup} key={gIdx}>
                  <div className={styles.phaseLabel}>
                    <span className={styles.phaseNum}>{gIdx + 1}</span>
                    <span>{group.label}</span>
                    {group.duration && <span className={styles.phaseDuration}>~{group.duration}</span>}
                  </div>
                  {group.items.map((ex, i) => {
                    const sideLabel = ex.performance_side ? ` — ${ex.performance_side} Leg` : "";
                    const holdText = ex.hold ? ` | ${ex.hold}s hold` : "";
                    const hasValidImage = typeof ex.image === "string" && ex.image.trim().length > 0;
                    const exerciseIndex = planExercises.indexOf(ex);
                    return (
                      <React.Fragment key={i}>
                        <div className={styles.exerciseRowV2}>
                          <div
                            className={styles.exThumbV2}
                            style={{ backgroundColor: hasValidImage ? "transparent" : "#e2e8f0", position: "relative", cursor: "pointer" }}
                            onClick={() => {
                              if (ex?.video) {
                                setExerciseVideoUrl(ex?.video);
                                const playedAlready = Array.isArray(assessmentData.plan_videos_played) && assessmentData.plan_videos_played.includes(ex.name);
                                const updatedVideoFields = {
                                  ...assessmentData,
                                  plan_video_played: true,
                                  plan_video_play_count: (assessmentData.plan_video_play_count || 0) + 1,
                                  plan_videos_played: playedAlready ? assessmentData.plan_videos_played : [...(assessmentData.plan_videos_played || []), ex.name],
                                };
                                updateAssessmentData(updatedVideoFields);
                                if (AnalyticsService) AnalyticsService.trackStep(updatedVideoFields);
                              }
                            }}
                          >
                            {hasValidImage ? <img src={ex.image} alt={ex.name} className={styles.exerciseThumbnailImage} /> : <span className={styles.exerciseThumbnailLabel}>{ex.name.substring(0, 2).toUpperCase()}</span>}
                            {ex?.video && (
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "rgba(0,0,0,0.28)",
                                  borderRadius: "9px",
                                }}
                              >
                                <div
                                  style={{
                                    width: 22,
                                    height: 22,
                                    borderRadius: "50%",
                                    background: "rgba(13,148,136,0.92)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <svg width="10" height="11" viewBox="0 0 10 11" fill="white">
                                    <polygon points="2,1 9,5.5 2,10" />
                                  </svg>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className={styles.exInfoV2}>
                            <div className={styles.exNameV2}>
                              {ex.name}
                              {sideLabel}
                            </div>
                            <div className={styles.exDoseV2}>
                              {ex.sets} Sets of {ex.reps} Reps{holdText}
                            </div>
                          </div>
                          <button className={styles.exInfoBtnV2} onClick={() => toggleRationale(exerciseIndex)} aria-label="Why this exercise?">
                            i
                          </button>
                        </div>
                        {showRationale[exerciseIndex] && (
                          <div className={styles.planExRationale}>
                            <p>
                              <strong>Why it helps:</strong> {ex.rationale}
                            </p>
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              ))}
              <div style={{ marginTop: 12, padding: "10px 5px", borderTop: "1px solid #f1f5f9", fontSize: 13, color: "#6b7280", display: "none" }}>Your plan has floor &amp; standing exercises. If you need any adjustments, let me know.</div>
            </div>
          </div>
        );
      }
      case "signup-card":
        return (
          <div key={entry.id} className={styles.inlineUi2}>
            <div className={styles.problemAreaChipRow}>
              <button
                className={styles.problemAreaChip}
                style={{
                  background: "#0d9488",
                  color: "white",
                  borderColor: "#0d9488",
                  margin: "5px 0",
                }}
                onClick={entry.data.onSignUp}
              >
                Activate my guided recovery with Myra
              </button>
            </div>
          </div>
        );
      case "pricing-card":
        return <PricingCard key={entry.id} entryId={entry.id} {...entry.data} />;
      case "access-cta":
        if (entry.data?.hidden) return null;
        return <AccessSignupCta key={entry.id} entryId={entry.id} {...entry.data} />;
      case "plan-reaction":
        return <PlanReactionChips key={entry.id} {...entry.data} />;
      case "ready-card":
        return (
          <div key={entry.id} className={styles.inlineUi2}>
            <div className={styles.problemAreaChipRow}>
              <button
                className={styles.problemAreaChip}
                style={{
                  background: "#0d9488",
                  color: "white",
                  borderColor: "#0d9488",
                  margin: "5px 0",
                }}
                disabled={entry.data.currentGroupRef.current !== 2}
                onClick={entry.data.handleAdvanceGroup}
              >
                I'm ready
              </button>
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  function renderFrozenWidget(entry) {
    if (entry.widgetType === "problem_area") {
      const { selectedArea, options = [] } = entry.data;
      return (
        <div key={entry.id} className={styles.frozenStripInline}>
          <div className={styles.frozenStripInlineLabel}>Where do you feel pain?</div>
          <div className={styles.frozenStripInlineRow}>
            {options.map((o) => (
              <div key={o.id} className={`${styles.frozenChip} ${selectedArea === o.id ? styles.selected : ""}`}>
                {o.label}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "movement_reveal_ready") {
      return <MovementRevealReadyFrozen key={entry.id} label={entry.data?.label || MYRA_MESSAGES.handoff?.movementRevealReadyLabel || "I am good for now"} />;
    }

    if (entry.widgetType === "pinpoint") {
      const { zones = { left: [], right: [] }, selections = [] } = entry.data;
      const selectedKeys = new Set(selections.map((s) => `${s.side}:${s.zone}`));
      const pinpointChipStyle = getPinpointChipStyle(zones);
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.pinpointWrap}>
            <div className={styles.pinpointCols}>
              {["left", "right"].map((side) => {
                const sideLabel = side === "left" ? "Left side" : "Right side";
                const zoneList = zones?.[side] || [];
                return (
                  <div key={side} className={styles.pinpointCol}>
                    <div className={styles.pinpointColLabel}>{sideLabel}</div>
                    {zoneList.map((zone) => {
                      const selected = selectedKeys.has(`${side}:${zone}`);
                      return (
                        <div key={`${side}:${zone}`} className={`${styles.pinpointChip} ${styles.frozen} ${selected ? styles.selected : ""}`} style={pinpointChipStyle}>
                          {zone}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            <div className={`${styles.ageConfirm} ${styles.ageHighlight}`}>
              <input type="checkbox" id="ageChk" checked={true} disabled />
              <label htmlFor="ageChk">I confirm I am 18 years of age or older</label>
            </div>
          </div>
        </div>
      );
    }
    if (entry.widgetType === "cpg_options" || entry.widgetType === "option_cards") {
      const { options, selectedId } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {options.map((o) => (
              <div key={o.id} className={styles.chipPair}>
                {/* Chip (non-clickable, locked state) */}
                <div
                  className={`
            ${styles.optionCard}
            ${selectedId === o.id ? styles.selected : ""}
            ${styles.locked}
          `}
                >
                  {o.label}
                </div>

                {/* Helper text BELOW */}
                {/* {o.info && <div className={styles.chipHelper}>{o.info}</div>} */}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "yesno") {
      const { selectedAnswer } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            <div className={styles.chipPair}>
              <button className={`${styles.yesnoBtn} ${selectedAnswer === "yes" || selectedAnswer === "YES" ? styles.selected : ""}`} disabled>
                Yes, that helps
              </button>
            </div>

            <div className={styles.chipPair}>
              <button className={`${styles.yesnoBtn} ${selectedAnswer === "no" || selectedAnswer === "NO" || selectedAnswer === "NO_UNSURE" ? styles.selected : ""}`} disabled>
                No, not really
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (entry.widgetType === "pre_nprs_duration") {
      const { selectedValue } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.durationOptions} style={{ marginTop: "8px" }}>
            {CONST.DURATION_OPTIONS.map((o) => (
              <div key={o.id} className={`${styles.durationOption} ${selectedValue === o.value ? styles.selected : ""}`} style={{ pointerEvents: "none" }}>
                {o.label}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "voice_warning") {
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.voiceWarning}>
            <span className={styles.voiceWarningIcon}>🔊</span>
            {/* <p>Myra will speak out loud during movement sections</p> */}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "demo_video") {
      const { testName: demoTestName, videoUrl } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <p className={styles.paSubtitle}>
            {MYRA_MESSAGES.demoVideo.buttonLabels.frozenDemoLabel} <strong>{demoTestName}</strong>
          </p>
          <div className={styles.videoContainer}>
            <video src={videoUrl} controls playsInline preload="metadata" />
          </div>
        </div>
      );
    }

    if (entry.widgetType === "sr_cards") {
      const { options, selectedId } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {options.map((opt) => (
              <div key={opt.id} className={styles.chipPair}>
                <div className={`${styles.optionCard} ${selectedId === opt.id ? styles.selected : ""} ${styles.locked}`}>{opt.title}</div>
                {/* {opt.subtitle && <div className={styles.chipHelper}>{opt.subtitle}</div>} */}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "rpe_options") {
      const { selectedValue } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {CONST.RPE_OPTIONS2.map((chip) => {
              const isSelected = selectedValue === chip.value;

              return (
                <div
                  key={chip.id}
                  className={styles.chipPair}
                  style={{
                    opacity: isSelected ? 1 : 0.4,
                    pointerEvents: "none",
                  }}
                >
                  <button className={`${styles.optionCard} ${isSelected ? styles.selected : ""}`}>
                    {/* <span className={styles.chipEmojiCircle} aria-hidden="true">
                      <span className={styles.chipEmoji}>{chip.emoji}</span>
                    </span> */}

                    {chip.label}
                  </button>

                  {/* <div className={styles.chipHelper}>{chip.helper}</div> */}
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "affect_options") {
      const { selectedValue } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {CONST.FEEL_AFFECT_OPTIONS.map((o) => (
              <div key={o.id} className={styles.chipPair}>
                <div className={`${styles.optionCard} ${selectedValue === o.value ? styles.selected : ""} ${styles.locked}`}>{o.label}</div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "hard_stop_card") {
      const { detail } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.hardStopCard}>
            <div className={styles.hardStopIcon}>🩺</div>
            <div className={styles.hardStopTitle}>We recommend in-person care</div>
            <p className={styles.hardStopText}>{detail}</p>
          </div>
        </div>
      );
    }
    if (entry.widgetType === "safety_stop_card") {
      const { detail } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.hardStopCard}>
            <div className={styles.hardStopIcon}>🩺</div>
            <div className={styles.hardStopTitle}>We recommend waiting</div>
            {detail && <p className={styles.hardStopText}>{detail}</p>}
          </div>
        </div>
      );
    }
    if (entry.widgetType === "access_exclusion_card") {
      const { detail } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.hardStopCard}>
            <div className={styles.hardStopIcon}>🩺</div>
            <div className={styles.hardStopTitle}>This program is not the right fit right now</div>
            {detail && <p className={styles.hardStopText}>{detail}</p>}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "safety_advisory_card") {
      const { detail, choice } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div
            style={{
              background: "#fffbeb",
              border: "1px solid #f59e0b",
              borderRadius: "0.75rem",
              padding: "1.25rem",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>⚠️</div>
            <p style={{ fontSize: "0.875rem", color: "#4b5563", lineHeight: 1.5 }}>{detail}</p>
            <p style={{ fontSize: "0.8rem", color: "#9ca3af", marginTop: "0.75rem", fontStyle: "italic" }}>{choice === "leave" ? "You chose to come back later." : ""}</p>
          </div>
        </div>
      );
    }

    if (entry.widgetType === "pain_location_text") {
      const { zoneText } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <p style={{ fontSize: "13px", color: "#6b7280", textAlign: "center" }}>Selected: {zoneText}</p>
        </div>
      );
    }

    if (entry.widgetType === "feedback2") {
      const { selectedId, selectedValue } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.feedback2Options}>
            {CONST.FEEDBACK2_OPTIONS.map((o) => {
              const isSelected = selectedId ? selectedId === o.id : selectedValue === o.value;
              return (
                <div key={o.id} className={`${styles.feedback2Btn} ${isSelected ? styles.selected : ""} ${styles.locked}`}>
                  {getFeedback2OptionLabel(o)}
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "personalize_group") {
      const { groupId, result, formData: savedFormData = {}, selectedGoals: savedGoals = [] } = entry.data;
      const group = CONST.PERSONALIZE_GROUPS.find((g) => g.id === groupId);
      if (!group) return null;

      const numberFields = group.fields.filter((f) => f.type === "number");
      const otherFields = group.fields.filter((f) => f.type !== "number");
      const wasSkipped = result === "skipped";

      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.pzGroup} style={{ pointerEvents: "none", opacity: wasSkipped ? 0.55 : 0.9 }}>
            {numberFields.length > 0 &&
              (() => {
                const rows = [];
                for (let i = 0; i < numberFields.length; i += 2) {
                  rows.push(
                    <div className={styles.pzFieldRow} key={numberFields[i].id}>
                      <div className={styles.pzField}>
                        <label className={styles.formLabel}>
                          {numberFields[i].label}
                          <span className={styles.optional}>(optional)</span>
                        </label>
                        <input type="number" className={styles.formInput} value={savedFormData[numberFields[i].id] || ""} disabled readOnly />
                      </div>
                      {i + 1 < numberFields.length && (
                        <div className={styles.pzField}>
                          <label className={styles.formLabel}>
                            {numberFields[i + 1].label}
                            <span className={styles.optional}>(optional)</span>
                          </label>
                          <input type="number" className={styles.formInput} value={savedFormData[numberFields[i + 1].id] || ""} disabled readOnly />
                        </div>
                      )}
                    </div>,
                  );
                }
                return rows;
              })()}
            {otherFields.map((field) => {
              if (field.type === "goals") {
                return (
                  <div className={styles.pzField} key={field.id}>
                    <label className={styles.formLabel}>
                      {field.label}
                      <span className={styles.optional}>((optional, pick any))</span>
                    </label>
                    <div className={styles.pzGoalWrapper}>
                      <div className={styles.pzGoalRow}>
                        {field.options.map((opt) => (
                          <div key={opt.id} className={`${styles.pzGoalItem} ${savedGoals.includes(opt.value) ? styles.selected : ""}`}>
                            <span className={styles.pzGoalLabel}>{opt.label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              }
              if (field.type === "options") {
                return (
                  <div className={styles.pzField} key={field.id}>
                    <label className={styles.formLabel}>{field.label}</label>
                    <div className={styles.pzOptionRow}>
                      {field.options.map((opt) => (
                        <button key={opt.id} className={`${styles.pzOptBtn} ${savedFormData[field.id] === opt.value ? styles.selected : ""}`} disabled>
                          {opt.label}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      );
    }
    if (entry.widgetType === "rcs") {
      const { score = 0, diagnosis = {} } = entry.data;
      const circumferenceFrozen = 2 * Math.PI * 65;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.rcsScreen} style={{ pointerEvents: "none", opacity: 0.9 }}>
            <h2 className={styles.rcsTitle}>Recovery Compass</h2>
            <p className={styles.rcsSubtitle}>The Starting Point of Your Recovery Journey</p>

            <div className={styles.rcsScoreSection}>
              <span className={styles.rcsScoreLabel}>Your Score</span>
              <div className={styles.rcsRingContainer}>
                <svg viewBox="0 0 160 160" className={styles.rcsRingSvg}>
                  <defs>
                    <linearGradient id={`scoreGradFrozen-${entry.id}`} x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#16a34a" />
                      <stop offset="100%" stopColor="#15803d" />
                    </linearGradient>
                  </defs>
                  <circle cx="80" cy="80" r="65" fill="none" stroke="#e5e7eb" strokeWidth="8" />
                  <circle cx="80" cy="80" r="65" fill="none" stroke={`url(#scoreGradFrozen-${entry.id})`} strokeWidth="8" strokeLinecap="round" strokeDasharray={circumferenceFrozen} strokeDashoffset={circumferenceFrozen * (1 - score / 100)} transform="rotate(-90 80 80)" />
                </svg>
                <span className={styles.rcsScoreNumber}>{score}</span>
              </div>
            </div>

            <p className={styles.rcsExplanation}>Your Recovery Compass Score starts at {score}, reflecting your current recovery stage. As you follow your personalized plan over the next 8 weeks, this score is designed to improve steadily, with a goal of reaching closer to 100.</p>

            <div className={styles.rcsDiagnosisCard}>
              <h3 className={styles.rcsDiagnosisHeadline}>{diagnosis.headline}</h3>
              <p className={styles.rcsDiagnosisRelief}>{diagnosis.relief}</p>
            </div>

            <div className={styles.rcsPersonalizationCard}>
              <p className={styles.rcsPersonalizationTitle}>How We've Personalized Your Plan</p>
              <div className={styles.rcsFactors}>
                <div className={styles.rcsFactor}>
                  <span>📊</span>
                  <span>Your Score</span>
                </div>
                <span className={styles.rcsPlus}>+</span>
                <div className={styles.rcsFactor}>
                  <span>📋</span>
                  <span>Your History</span>
                </div>
                <span className={styles.rcsPlus}>+</span>
                <div className={styles.rcsFactor}>
                  <span>👤</span>
                  <span>Your Info</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (entry.widgetType === "questionnaire_summary") {
      const { mainTitle, sections = [] } = entry.data || {};
      return (
        <div key={entry.id} className={styles.inlineUi2} style={{ pointerEvents: "none" }}>
          <div className={qStyles.qWrap} style={{ opacity: 0.92 }}>
            {mainTitle && <div className={qStyles.qTitle}>{mainTitle}</div>}
            {sections.map((section, sIdx) => (
              <React.Fragment key={sIdx}>
                {section.title && <div className={qStyles.qSectionHeader}>{section.title}</div>}
                {(section.questions || []).map((q) => {
                  const opts = q.options || [];
                  const wide = opts.some((a) => String(a.name || "").length > 28);
                  const stops = opts.length === 5 ? ["var(--scale-1)", "var(--scale-2)", "var(--scale-4)", "var(--scale-5)", "var(--scale-6)"] : opts.length === 6 ? ["var(--scale-1)", "var(--scale-2)", "var(--scale-3)", "var(--scale-4)", "var(--scale-5)", "var(--scale-6)"] : ["var(--scale-1)", "var(--scale-2)", "var(--scale-3)", "var(--scale-4)", "var(--scale-5)", "var(--scale-6)"];
                  const rows = opts.map((a, i) => ({ i, w: Number(a.answer_weight) }));
                  const usable = rows.every((r) => Number.isFinite(r.w));
                  const ordered = usable ? [...rows].sort((a, b) => a.w - b.w) : rows;
                  const scale = {};
                  ordered.forEach((row, rank) => {
                    scale[row.i] = stops[Math.min(rank, stops.length - 1)];
                  });
                  return (
                    <div key={q.questionId} className={qStyles.qCard}>
                      <div className={qStyles.qText}>{q.questionText}</div>
                      <div className={`${qStyles.qOptions} ${wide ? qStyles.qOptionsWide : ""}`}>
                        {opts.length > 0 ? (
                          opts.map((a, idx) => {
                            const isSelected = q.selectedAnswerId === a.id;
                            return (
                              <div key={a.id} className={`${qStyles.optBtn} ${isSelected ? qStyles.optSelected : ""} ${qStyles.optLocked}`} style={isSelected ? undefined : { borderColor: scale[idx] }}>
                                <span className={qStyles.optRadio} aria-hidden="true">
                                  <span className={qStyles.optRadioDot} />
                                </span>
                                <span className={qStyles.optLabel}>{a.name}</span>
                              </div>
                            );
                          })
                        ) : (
                          <div className={`${qStyles.optBtn} ${qStyles.optSelected} ${qStyles.optLocked}`}>
                            <span className={qStyles.optLabel}>{q.answerText || "Skipped"}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </React.Fragment>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "consent_summary") {
      const { consentGranted, alignmentError } = entry.data || {};
      return (
        <div key={entry.id} className={styles.inlineUi} style={{ textAlign: "center" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 16px",
              borderRadius: 999,
              background: consentGranted ? "#e6f7f6" : "#fef2f2",
              color: consentGranted ? "#0f766e" : "#991b1b",
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            <span aria-hidden="true">{consentGranted ? "✓" : "•"}</span>
            {consentGranted ? "Enrollment consent recorded" : "Enrollment consent declined"}
          </div>
          {alignmentError && <div className={styles.consentErrMsg}>{alignmentError}</div>}
        </div>
      );
    }

    // Fallback for unknown frozen widget types
    return null;
  }

  // ═══════════════════════════════════════════════════════════
  // STEP ROUTER
  // ═══════════════════════════════════════════════════════════

  function renderScreen() {
    switch (currentStep) {
      case "intro":
        return (
          <IntroScreen
            pushToHistory={pushToHistory}
            showMyraMessage={showMyraMessage}
            setIntroProminent={setIntroProminent}
            setPlaceholderText={setPlaceholderText}
            introAdvanceRef={introAdvanceRef}
            introCtaHandlerRef={introCtaHandlerRef}
            showIntroCtas={showIntroCtas}
            detectedArea={detectedArea}
            qaRef={qaRef}
            introProminent={introProminent}
            setQaOpen={setQaOpen}
            qaStripIdsRef={qaStripIdsRef}
            scrollToBottom={scrollToBottom}
            externalAction={introExternalAction}
            onContinue={(area) => {
              setPlaceholderText(MYRA_MESSAGES.shell.inputPlaceholderAskMyra);
              setIntroProminent(false);
              if (area) setDetectedArea(area);
              // if (displayMode === "embedded" && onStartAssessment) {
              //   // Phase 1: signal landing page to fade out — do NOT advance yet
              //   onStartAssessment();
              // } else {
              // Fullscreen (direct entry): advance immediately
              if (!window.trSessionId && AnalyticsService) AnalyticsService.startSession();
              localStorage.setItem("startedSelf", "1");
              // if (window.gtag) window.gtag("event", "conversion", { send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD", value: 1.0, currency: "USD" });
              setCurrentStep("problem_area");
              // }
            }}
            updateAssessmentData={updateAssessmentData}
            assessmentData={assessmentData}
            setHideContent={setHideContent}
            userVariant={userVariant}
            isComeFromGoogle={isComeFromGoogle}
            isUserCameBackAgain={isUserCameBackAgain}
            handleHomeVideoClicked={handleHomeVideoClicked}
            handleWhoIsMyraClick={handleWhoIsMyraClick}
            onInlineChat={handleInlineChat}
            setShowIntroCtas={setShowIntroCtas}
            setLandingChipArea={setLandingChipArea}
            fromVirdioHealth={fromVirdioHealth}
            setHideCtaBtn={setHideCtaBtn}
            hideCtaBtn={setHideCtaBtn}
            partnerLink={partnerLink}
          />
        );

      case "problem_area":
        return <PainLocationScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} paCommandRef={paCommandRef} detectedArea={detectedArea} scrollToBottom={scrollToBottom} phase={landingChipArea ? "pain_location" : "problem_area"} landingChipArea={landingChipArea} onLandingChipConsumed={() => setLandingChipArea(null)} persistAndNavigate={persistAndNavigate} onContinue={(fields) => persistAndNavigate(fields, "cpg_questions")} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "pain_location":
        return <PainLocationScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} phase="pain_location" persistAndNavigate={persistAndNavigate} onContinue={(fields) => persistAndNavigate(fields, "cpg_questions")} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "safety_screening":
        return <SafetyScreeningScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "movement_test_1")} onHardStop={(source) => persistAndNavigate({ safetyScreenResult: "FLAGGED", hardStopSource: source }, "hard_stop")} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} />;

      case "cpg_questions":
        return <CPGQuestionScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} showQuestionNuggetMessage={showQuestionNuggetMessage} scrollToBottom={scrollToBottom} onContinue={(fields, nextStep) => (nextStep === "nprs_symptoms" ? runRecoveryPlanHandoff(fields) : persistAndNavigate(fields, nextStep))} onHardStop={(source) => persistAndNavigate({ hardStopSource: source }, "hard_stop")} />;

      case "subtype_questioning":
        return <SubtypeQuestionScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} showQuestionNuggetMessage={showQuestionNuggetMessage} scrollToBottom={scrollToBottom} detectedTrigger={detectedTrigger} onContinue={(fields, nextStep) => (nextStep === "nprs_symptoms" ? runRecoveryPlanHandoff(fields) : persistAndNavigate(fields, nextStep))} />;

      case "self_assessment":
        return <SelfAssessmentQ2Screen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} showQuestionNuggetMessage={showQuestionNuggetMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => runRecoveryPlanHandoff(fields)} />;

      case "nprs_symptoms":
        return <PreNPRSScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "safety_screening")} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} />;

      case "movement_test_1":
        return <MovementTest1Screen assessmentData={assessmentData} updateAssessmentData={updateAssessmentData} pushToHistory={pushToHistory} speakChatTextIfVoice={speakChatTextIfVoice} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields, nextStep) => persistAndNavigate(fields, nextStep)} onHardStop={(source) => persistAndNavigate({ hardStopSource: source }, "hard_stop")} chatBucketTest={chatBucketTest} setMode={setMode} />;

      case "movement_q1":
        return <MovementQuestionScreen screenName="movement_q1" assessmentData={assessmentData} pushToHistory={pushToHistory} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} scrollToBottom={scrollToBottom} showMyraMessage={showMyraMessage} speakChatTextIfVoice={speakChatTextIfVoice} />;

      case "movement_q2":
        return <MovementQuestionScreen screenName="movement_q2" assessmentData={assessmentData} pushToHistory={pushToHistory} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} scrollToBottom={scrollToBottom} showMyraMessage={showMyraMessage} speakChatTextIfVoice={speakChatTextIfVoice} />;

      case "movement_q3":
        return <MovementQuestionScreen screenName="movement_q3" assessmentData={assessmentData} pushToHistory={pushToHistory} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} scrollToBottom={scrollToBottom} showMyraMessage={showMyraMessage} speakChatTextIfVoice={speakChatTextIfVoice} />;

      case "movement_q4":
        return <MovementQuestionScreen screenName="movement_q4" assessmentData={assessmentData} pushToHistory={pushToHistory} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} scrollToBottom={scrollToBottom} showMyraMessage={showMyraMessage} speakChatTextIfVoice={speakChatTextIfVoice} />;

      case "self_report_rom":
        return <SelfReportROMScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "self_report_tempo")} setMode={setMode} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "self_report_tempo":
        return <SelfReportTempoScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "rpe")} onHardStop={() => persistAndNavigate({ hardStopSource: "couldnt_finish" }, "hard_stop")} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "rpe":
        return <RPEScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "feel_affect")} setMode={setMode} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "feel_affect":
        return <FeelAffectScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields, nextStep) => persistAndNavigate(fields, nextStep)} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "feedback2":
        return <Feedback2Screen assessmentData={assessmentData} pushToHistory={pushToHistory} speakChatTextIfVoice={speakChatTextIfVoice} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "personalize")} setMode={setMode} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "personalize":
        return <PersonalizeScreen assessmentData={assessmentData} speakChatTextIfVoice={speakChatTextIfVoice} updateAssessmentData={updateAssessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "plan")} setMode={setMode} showQuestionNuggetMessage={showQuestionNuggetMessage} chatInputRef={chatInputRef} />;

      case "plan":
        return (
          <PlanScreen
            assessmentData={assessmentData}
            updateAssessmentData={updateAssessmentData}
            qaRef={qaRef}
            onOpenQnA={() => {
              // window.audioPlayer?.unlockAudioForChat?.();
              setQaOpen(false);
            }}
            pushToHistory={pushToHistory}
            updateHistoryEntryData={updateHistoryEntryData}
            showMyraMessage={showMyraMessage}
            speakChatQueueRef={speakChatQueueRef}
            scrollToBottom={scrollToBottom}
            showQuestionNuggetMessage={showQuestionNuggetMessage}
            conversationHistory={conversationHistory}
            speakChatTextIfVoice={speakChatTextIfVoice}
            logFrontendDisplayedChatEntry={logFrontendDisplayedChatEntry}
            getFrontendChatTurnNumber={getFrontendChatTurnNumber}
            chatInputRef={chatInputRef}
            onAccessQuestionnaire={() => persistAndNavigate({}, "questionnaire")}
          />
        );

      case "questionnaire":
        return <QuestionnaireScreen assessmentData={assessmentData} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} speakChatTextIfVoice={speakChatTextIfVoice} />;

      case "consent_screen":
        return (
          <ConsentScreen
            assessmentData={assessmentData}
            showMyraMessage={showMyraMessage}
            scrollToBottom={scrollToBottom}
            speakChatTextIfVoice={speakChatTextIfVoice}
            onConsentComplete={(consentGranted) => {
              const consentFields = { accessAlignmentConsent: consentGranted, accessAlignmentConsentAt: new Date().toISOString() };
              pushToHistory({ type: "user", text: consentGranted ? "I agree — enroll me." : "Not right now.", id: nextId() }, { type: "frozen-widget", widgetType: "consent_summary", id: nextId(), data: { consentGranted, problemArea: assessmentData?.problemArea } });
              persistAndNavigate(consentFields, "plan");
            }}
          />
        );

      case "hard_stop":
        return <HardStopScreen source={assessmentData.hardStopSource} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} />;

      default:
        return (
          <div className={styles.inlineUi}>
            <p style={{ color: "var(--gray-500)", textAlign: "center" }}>Unknown step: {currentStep}</p>
          </div>
        );
    }
  }

  // ═══════════════════════════════════════════════════════════
  // RENDER — APP SHELL
  // ═══════════════════════════════════════════════════════════

  const handleVoiceClicked = () => {
    setMode("voice");
    MyraInteraction?.switchMode?.("voice", true);
    if (window?.mayraCode) {
      window?.mayraCode.handlePickVoice();
    }
  };
  const handleChatClicked = () => {
    setMode("chat");
    MyraInteraction?.switchMode?.("chat", true);
    if (window?.mayraCode) {
      window?.mayraCode.handlePickChat();
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleInputSubmit();
    }
  };

  useEffect(() => {
    if (mode !== "voice" || !voiceTranscript) return;
    setInputText(voiceTranscript);
    if (window.isFinalVoiceTranscript !== true) return;

    window.isFinalVoiceTranscript = false;
    const debugVoice = document.getElementById("debugVoice");
    if (debugVoice) {
      setTimeout(() => {
        debugVoice.innerHTML = "";
      }, 1000);
    }
    handleInputSubmit(voiceTranscript);
  }, [voiceTranscript, mode]);

  const showVirdioArStatePanel = isVirdioArHost();

  return (
    <>
      {showVirdioArStatePanel && <AssessmentStateFixedPanel assessmentData={assessmentData} currentStep={currentStep} conversationCount={conversationHistory.length} />}
      <div className={`${styles.appShell}${displayMode === "embedded" ? ` ${styles.embedded}` : ""}`}>
        {/* Header */}
        <div className={styles.mainHeader}>
          <CustomHeader
            setShowMemberBlockScreen={() => {}}
            onIntroAction={(type) => {
              setIntroExternalAction({ type });
            }}
            isComeFromGoogle={isComeFromGoogle}
            hideContent={hideContent}
            handleHomeVideoClicked={handleHomeVideoClicked}
            handleWhoIsMyraClick={handleWhoIsMyraClick}
            setNativeWarningArmed={setNativeWarningArmed}
            partnerLink={partnerLink}
          />
          {showInitiallyHideHeader && (
            <div className={styles.header}>
              <div className={styles.headerLeft}>
                <div className={styles.headerAvatar}>M</div>
                <div className={styles.headerInfo}>
                  <h1>{MYRA_MESSAGES.shell.myraName}</h1>
                  <span>{MYRA_MESSAGES.shell.myraRole}</span>
                </div>
              </div>
              {!qaOpen && IS_VOICE_ENABLED && !partnerLink && (
                <div className={styles.modeToggle}>
                  <button className={`${styles.modeBtn} ${mode === "chat" ? styles.active : ""}`} onClick={handleChatClicked}>
                    {CHAT_ICON_SVG}
                    {MYRA_MESSAGES.shell.modeChatLabel}
                  </button>
                  <button className={`${styles.modeBtn} ${mode === "voice" ? styles.active : ""}`} onClick={handleVoiceClicked}>
                    {VOICE_ICON_SVG}
                    {MYRA_MESSAGES.shell.modeVoiceLabel}
                  </button>
                </div>
              )}
              {/* <button
                className={styles.myraFab}
                onClick={() => {
                  window.audioPlayer?.unlockAudioForChat?.();
                }}
                aria-label="Chat with Myra"
              >
                Myra
              </button> */}
              {currentStep !== "hard_stop" && currentStep !== "plan" && (
                <>
                  <div className={styles.headerRight}>
                    {partnerLink && IS_VOICE_ENABLED && !qaOpen && (
                      <div className={styles.modeToggle} style={{ padding: "0", margin: "0" }}>
                        <button className={`${styles.modeBtn} ${mode === "chat" ? styles.active : ""}`} onClick={handleChatClicked}>
                          {CHAT_ICON_SVG}
                          {MYRA_MESSAGES.shell.modeChatLabel}
                        </button>
                        <button className={`${styles.modeBtn} ${mode === "voice" ? styles.active : ""}`} onClick={handleVoiceClicked}>
                          {VOICE_ICON_SVG}
                          {MYRA_MESSAGES.shell.modeVoiceLabel}
                        </button>
                      </div>
                    )}
                    <button className={partnerLink ? styles.partnerHeaderClose : styles.headerClose} onClick={() => setShowExitHandler(true)} title={MYRA_MESSAGES.shell.exitAssessmentTitle}>
                      ×
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* Progress */}
        {currentStep !== "intro" && (
          <>
            <div className={styles.progressBar}>
              <div className={styles.progressFill} style={{ width: `${progressPercent}%` }} />
              <span className={styles.progressLabel}>{progressPercent}% Done</span>
            </div>
            {/* <div className={styles.stepLabel}>{stepLabel}</div> */}
          </>
        )}

        {/* Chat Area */}
        <div className={styles.chatArea} ref={chatAreaRef} style={{ overflowAnchor: "none" }}>
          {/* {currentStep === "intro" && showIntroCtas && (
            <div className={`${styles.inlineUi} ${styles.introCtaInlineUi}`}>
              <div className={styles.introCtaRow}>
                {!hideCtaBtn &&
                  INTRO_CTAS.map((cta) => (
                    <button
                      key={cta.id}
                      className={`${cta.type === "start" ? styles.introCtaBtnStart : styles.introCtaBtn} ${cta.id === "assessment" ? styles.introAssessmentLink : ""} ${ctaUsed.has(cta.id) ? styles.introCtaBtnUsed : ""}`}
                      onClick={() => {
                        setCtaUsed((prev) => new Set(prev).add(cta.id));
                        introCtaHandlerRef.current?.(cta.id);
                      }}
                      disabled={!introProminent || ctaUsed.has(cta.id)}
                    >
                      {cta.label}
                    </button>
                  ))}
              </div>
            </div>
          )} */}
          {conversationHistory.map((entry) => renderHistoryEntry(entry))}
          {typingVisible && (
            <div className={styles.typingRow} data-chat-typing="true">
              <div className={styles.msgAvatar}>M</div>
              <div className={styles.typingDots}>
                <span />
                <span />
                <span />
              </div>
            </div>
          )}
          {renderScreen()}
          <div ref={chatEndSentinelRef} aria-hidden="true" style={{ height: 1, flexShrink: 0, pointerEvents: "none" }} />
        </div>
        {/* <div className={styles.chipStrip} id="chipStrip">
        <div className={styles.chipStripLabel}>{MYRA_MESSAGES.problemArea.whereHurtsLabel}</div>
        <div className={styles.chipStripRow} id="chipStripRow">
          <button className={styles.LandingChip} data-area="LBP">
            My lower back
          </button>
          <button className={styles.LandingChip} data-area="HIP">
            My hip
          </button>
          <button className={styles.LandingChip} data-area="THIGH">
            My thigh
          </button>
          <button className={styles.LandingChip} data-area="KNEE">
            My knee
          </button>
        </div>
      </div> */}
        {!window.showChips && (
          <div className={styles.problemAreaChipGroup} style={{ background: "white" }}>
            <div className={`${styles.problemAreaChipLabel} ${styles.whereHurtsLabel}`}>{isComeFromGoogle ? MYRA_MESSAGES.problemArea.whereHurtsLabel2 : MYRA_MESSAGES.problemArea.whereHurtsLabel}</div>
            <div className={styles.problemAreaChipRow}>
              {PROBLEM_AREA_OPTIONS.map((option) => (
                <button key={option.id} type="button" className={styles.problemAreaChip} onClick={() => handleChipClick(option)} disabled={!introProminent}>
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        )}
        {showVideoOverlay && (
          <div
            className={styles.videoOverlay}
            onClick={(e) => {
              // Close only if clicking outside the video container
              if (e.target === e.currentTarget) {
                setShowVideoOverlay(false);
                if (heroVideoRef.current) {
                  heroVideoRef.current.pause();
                }
              }
            }}
          >
            <div className={styles.videoOverlayContent}>
              <button
                className={styles.videoOverlayClose}
                onClick={() => {
                  setShowVideoOverlay(false);
                  if (heroVideoRef.current) {
                    heroVideoRef.current.pause();
                  }
                }}
                aria-label="Close video"
              >
                ×
              </button>

              <div className={styles.videoContainerOverlay}>
                <video
                  ref={heroVideoRef}
                  src={CONST.HOME_VIDEO_2}
                  autoPlay
                  controls
                  playsInline
                  preload="metadata"
                  onEnded={() => {
                    // Optionally auto-close or show CTA after video ends
                    // setShowVideoOverlay(false);
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {exerciseVideoUrl && (
          <div
            className={styles.videoOverlay}
            onClick={(e) => {
              if (e.target === e.currentTarget) setExerciseVideoUrl(null);
            }}
          >
            <div className={styles.videoOverlayContent}>
              <button className={styles.videoOverlayClose} onClick={() => setExerciseVideoUrl(null)} aria-label="Close video">
                ×
              </button>
              <div className={styles.videoContainerOverlay}>
                <video src={exerciseVideoUrl} autoPlay controls playsInline preload="metadata" />
              </div>
            </div>
          </div>
        )}
        {currentStep === "intro" && showLbpStarters && <LbpStarterCarousel inputText={inputText} setInputText={setInputText} chatInputRef={chatInputRef} assessmentData={assessmentData} updateAssessmentData={updateAssessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} partnerLink={partnerLink} />}

        {/* Input Bar — never disabled, never hidden */}
        <div className={styles.inputBarContainer} style={{ position: "relative" }}>
          {showJumpToHiddenContent && (
            <div
              role="button"
              tabIndex={-1}
              onPointerDown={(event) => {
                keepInputFocusedOnJumpRef.current = document.activeElement === chatInputRef.current;
                if (keepInputFocusedOnJumpRef.current) event.preventDefault();
              }}
              onClick={() => {
                const keepInputFocused = keepInputFocusedOnJumpRef.current;
                handleJumpToHiddenContent();
                if (keepInputFocused) {
                  requestAnimationFrame(() => chatInputRef.current?.focus({ preventScroll: true }));
                }
                keepInputFocusedOnJumpRef.current = false;
              }}
              aria-label="Scroll to more content"
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                bottom: "100%",
                zIndex: 40,
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "8px 14px",
                borderRadius: 22,
                border: "none",
                background: "#0d9488",
                color: "#ffffff",
                fontFamily: '"DM Sans", sans-serif',
                fontSize: 13,
                fontWeight: 700,
                boxShadow: "0 4px 14px rgba(13,148,136,0.45)",
                cursor: "pointer",
                userSelect: "none",
                WebkitUserSelect: "none",
              }}
            >
              <span>More below</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>
          )}

          <div className={styles.inputBar} style={{ position: "relative" }}>
            {mode === "voice" && voiceStatus && <div className={styles.statusBubble}>{voiceStatus}</div>}

            <div className={styles.inputChat}>
              {mode === "voice" ? (
                <>
                  <textarea ref={chatInputRef} type={inputType} className={introProminent ? styles.inputFieldIntroProminent : styles.inputField} value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyDown={handleKeyDown} placeholder={placeholderText} autoComplete="off" rows={inputRows} style={{ resize: "none" }} />
                  <button className={styles.sendBtn} disabled={!inputText.trim()} onClick={handleInputSubmit} title="Send Message">
                    {SEND_ICON}
                  </button>
                </>
              ) : (
                // rows={inputText.split("\n").length > 2 ? 3 : 2}
                <>
                  <textarea ref={chatInputRef} type={inputType} className={introProminent ? styles.inputFieldIntroProminent : styles.inputField} value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyDown={handleKeyDown} placeholder={placeholderText} autoComplete="off" rows={inputRows} style={{ resize: "none" }} />
                  <button className={styles.sendBtn} disabled={!inputText.trim()} onClick={handleInputSubmit} title="Send Message">
                    {SEND_ICON}
                  </button>
                </>
              )}
            </div>
          </div>

          {!partnerLink && (
            <div className={`${styles.cardSurround} ${hideContent ? styles.cardSurroundHidden : ""}`}>
              <div className={styles2.cardFrame}>
                <div className={styles2.cardFooter}>
                  <p className={styles2.disclaimerText}>MyPTMyra provides educational guidance based on your input. It is not a substitute for medical advice, diagnosis, or treatment.</p>
                </div>
              </div>
              <p className={styles2.copyrightText}>&copy; 2026 Virdio Health. All rights reserved.</p>
            </div>
          )}
          {partnerLink && (
            <div className={styles2.partnerCardFooter}>
              <p className={styles2.partnerDisclaimerText}>MyPTMyra provides educational guidance based on your input. It is not a substitute for medical advice, diagnosis, or treatment.</p>
            </div>
          )}
        </div>
        {/* QnA Overlay */}
        <QnAOverlay ref={qaRef} isOpen={qaOpen} onClose={handleQaOverlayClose} screenName={currentStep} screenPayload={screenPayload} setQaOpen={setQaOpen} setTypingVisible={setTypingVisible} />

        {/* Exit Handler */}
        {showExitHandler && (
          <ExitHandler
            currentStep={exitCurrentStep}
            assessmentData={assessmentData}
            onClose={() => setShowExitHandler(false)}
            onOpenQnA={async (question, answer, source) => {
              setShowExitHandler(false);
              pushToHistory({ type: "user", text: question, id: nextId() });
              qaRef.current?.addExchange?.(question, answer, source);
              window.audioPlayer?.unlockAudioForChat?.();
              if (answer) {
                await showMyraMessage(answer, 800);
              }
              setQaOpen(false);
            }}
          />
        )}

        {/* Inactivity Modal */}
        {showInactivityModal && (
          <InactivityModal
            onResume={() => setShowInactivityModal(false)}
            onExit={() => {
              setShowInactivityModal(false);
              setShowExitHandler(true);
            }}
          />
        )}
      </div>
    </>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN: INTRO (New)
// Myra greeting → CTA buttons → advance to Problem Area.
// Inline Q&A (Pattern A) lives in local state, collapses to strips on advance.
// ════════════════════════════════════════════════════════════════

function IntroScreen({ pushToHistory, introProminent, showIntroCtas, showMyraMessage, setIntroProminent, setPlaceholderText, introAdvanceRef, introCtaHandlerRef, detectedArea, qaRef, setQaOpen, qaStripIdsRef, scrollToBottom, externalAction, onContinue, updateAssessmentData, assessmentData, setHideContent, userVariant, isComeFromGoogle, isUserCameBackAgain, handleHomeVideoClicked, handleWhoIsMyraClick, onInlineChat, setShowIntroCtas, setLandingChipArea, setExitCurrentStep, fromVirdioHealth, setHideCtaBtn, hideCtaBtn, partnerLink }) {
  const [phase, setPhase] = useState("loading");
  const [ctaUsed, setCtaUsed] = useState(new Set());
  const [inlineQa, setInlineQa] = useState([]);
  const [ctaTyping, setCtaTyping] = useState(false);
  const [openAccIdx, setOpenAccIdx] = useState(-1);
  const introQaItemsRef = useRef([]);
  const [problemArea, setProblemArea] = useState(null);
  const [showAssessmentSteps, setShowAssessmentSteps] = useState(false);
  console.log("assessmentData : ", assessmentData);

  useEffect(() => {
    MyraInteraction.onScreenEnter("intro");
  }, []);

  // ── Greeting sequence ──
  useEffect(() => {
    let cancelled = false;
    async function greet() {
      setPlaceholderText(isComeFromGoogle ? INPUT_PLACEHOLDERS.google_default : INPUT_PLACEHOLDERS.default);
      if (cancelled) return;
      if (partnerLink) {
        await showMyraMessage(MYRA_MESSAGES.intro?.LinkBullet1, 5, "myra-initial2");
        if (cancelled) return;
        await showMyraMessage(MYRA_MESSAGES.intro?.LinkBullet2, 5, "myra-initial2");
        if (cancelled) return;
        await showMyraMessage(MYRA_MESSAGES.intro?.LinkBullet3, 5, "myra-initial2");
      } else if (isComeFromGoogle) {
        await showMyraMessage(window.bullet1, 5, "myra-initial2");
        if (cancelled) return;
        await showMyraMessage(window.bullet2, 5, "myra-initial2");
        if (cancelled) return;
        await showMyraMessage(window.bullet3, 5, "myra-initial2");
      } else {
        await showMyraMessage(MYRA_MESSAGES.intro?.welcome || "Hi, I'm Myra. I'll help you build a personalized recovery plan for your muscle or joint pain — guided by physical therapy principles.", 5, "myra-initial");
        if (cancelled) return;
        await showMyraMessage(MYRA_MESSAGES.intro?.readyPrompt || "Whenever you're ready, tap below to get started — or, if you already know where it hurts, you can pick from the options.", 5, "myra-initial");
        if (cancelled) return;
      }

      setIntroProminent(true);
      setPhase("ready");
      // Telling the static page that React is ready.
      // If the user already tapped the CTA on the static page,
      // this will replay that tap automatically.
      if (typeof window.__intakeReactReady__ === "function") {
        window.__intakeReactReady__();
      }
    }
    greet();
    return () => {
      cancelled = true;
    };
  }, []);

  // ── Register advance callback for shell input routing ──
  useEffect(() => {
    introAdvanceRef.current = (_text, area) => handleAdvance(area);
    return () => {
      introAdvanceRef.current = null;
    };
  }, []);

  useEffect(() => {
    introCtaHandlerRef.current = (ctaId) => handleCta(ctaId);
    return () => {
      introCtaHandlerRef.current = null;
    };
  }, []);
  useEffect(() => {
    if (!fromVirdioHealth) return;
    if (phase !== "ready") return;

    const autoStart = async () => {
      const trackingFields = {
        variant: userVariant,
        isComeFromGoogle: isComeFromGoogle,
        isUserCameBackAgain: isUserCameBackAgain,
      };

      if (!window.trSessionId) {
        AnalyticsService.startSession(trackingFields);
      }

      // try {
      //   if (window.gtag) {
      //     window.gtag("event", "conversion", {
      //       send_to: "AW-18002481001/4AZGCNCA7YUcEOmeoIhD",
      //     });
      //   }
      // } catch (e) {
      //   console.warn(e);
      // }

      const updatedData = {
        started_assessment: true,
        myraInteractionMode: MyraInteraction.getMode() || "chat",
        isComeFromGoogle: isComeFromGoogle,
        isUserCameBackAgain: isUserCameBackAgain,
        variant: userVariant,
        analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
        EngagedOnLanding: window.EngagedOnLanding || false,
        clicked_landing_cta: true,
        session_last_update: new Date().toISOString(),
      };

      AnalyticsService.trackStep(updatedData);
      updateAssessmentData(updatedData);
      await new Promise((resolve) => setTimeout(resolve, 0));

      if (setHideContent) setHideContent(true);
      if (window.doKeepVideoPlay) window.doKeepVideoPlay();
      window.initFromUserGesture?.();
      if (window.audioPlayer?.ctx?.state === "suspended") window.audioPlayer.ctx.resume();
      if (window.preloadAllAudios) window.preloadAllAudios();
      if (window.videoUnlockPlay) window.videoUnlockPlay();

      pushToHistory({ type: "user", text: "Start with the questions for self assessment.", id: nextId() });
      setShowIntroCtas(true);
      window.showChips = true;
      window.hideNavbarBtm = true;
      await showMyraMessage("To get started, where did your pain initially start, your lower back, hip, thigh, or knee?", 900);
    };

    autoStart();
  }, [phase, fromVirdioHealth]);

  // ── Set flow context for Myra backend during intro ──
  useEffect(() => {
    window.currentCommandsAudio = {
      SHOW_VIDEO_INFO: (value, speech, intent) => {
        handleHomeVideoClicked();
      },
      SHOW_ASSESSMENT_INFO: (value, speech, intent) => {
        setShowAssessmentSteps(true);
      },
      SHOW_MYRA_INFO: (value, speech, intent) => {
        handleWhoIsMyraClick();
      },
    };
    if (typeof window !== "undefined") {
      window.currentFlow = "flow_landing_page";
      if (VoiceService) {
        VoiceService._currentFlow = "flow_landing_page";
      }
    }
  }, []);

  // ── CTA handler (async for typing pacing) ──
  async function handleCta(ctaId) {
    // VIDEO BUTTON: No state change, video is always visible
    if (ctaId === "video") {
      handleHomeVideoClicked();
      return;
    }

    if (ctaId === "start") {
      setHideCtaBtn(true);
      const trackingFields = {
        variant: userVariant,
        isComeFromGoogle: isComeFromGoogle,
        isUserCameBackAgain: isUserCameBackAgain,
      };

      if (!window.trSessionId) {
        AnalyticsService.startSession(trackingFields);
      }
      // Google Ads conversion tracking
      // try {
      //   if (window.gtag) {
      //     window.gtag("event", "conversion", {
      //       send_to: "AW-18002481001/4AZGCNCA7YUcEOmeoIhD",
      //     });
      //   }
      // } catch (e) {
      //   console.warn(e);
      // }

      const updatedData = {
        started_assessment: true,
        myraInteractionMode: MyraInteraction.getMode() || "chat",
        isComeFromGoogle: isComeFromGoogle,
        isUserCameBackAgain: isUserCameBackAgain,
        variant: userVariant,
        analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
        EngagedOnLanding: window.EngagedOnLanding || false,
        clicked_landing_cta: true,
        clicked_start_assessment: true,
        session_last_update: new Date().toISOString(),
      };

      // localStorage.setItem("assessmentData", JSON.stringify(updatedData));
      AnalyticsService.trackStep(updatedData);

      updateAssessmentData(updatedData);
      await new Promise((resolve) => setTimeout(resolve, 0));

      if (setHideContent) {
        setHideContent(true);
      }
      if (window.doKeepVideoPlay) window.doKeepVideoPlay();
      window.initFromUserGesture();
      if (window.audioPlayer?.ctx?.state === "suspended") {
        window.audioPlayer.ctx.resume();
      }
      if (window.preloadAllAudios) {
        window.preloadAllAudios();
      }
      if (window.videoUnlockPlay) {
        window.videoUnlockPlay();
      }
      let message = "Start with the questions for self assessment.";
      if (typeof onInlineChat === "function") {
        pushToHistory({
          type: "user",
          text: message,
          id: nextId(),
        });
        setShowIntroCtas(true);
        window.showChips = true;
        window.hideNavbarBtm = true;
        await showMyraMessage("To get started, where did your pain initially start, your lower back, hip, thigh, or knee?", 900);
        // await onInlineChat(message);
      }

      // handleAdvance(null);
      return;
    }
    setCtaUsed((prev) => new Set(prev).add(ctaId));

    // M1: Collapse any existing inline Q&A to strips before showing new response
    if (introQaItemsRef.current.length > 0) {
      const strips = [];
      introQaItemsRef.current.forEach((item) => {
        const exId = qaRef.current?.addExchange?.(item.question, item.answer, "intro_cta");
        const stripId = nextId();
        if (exId) qaStripIdsRef.current.add(exId);
        strips.push({ type: "qa-strip", id: stripId, qaId: exId || stripId, question: item.question });
      });
      pushToHistory(...strips);
      introQaItemsRef.current = [];
      setInlineQa([]);
    }

    let question, answer, type;
    if (ctaId === "assessment") {
      question = "What's the Assessment?";
      answer = MYRA_MESSAGES.intro?.whatsAssessment || "Here's what we'll do together — about 10 minutes total. Tap any step to learn more.";
      type = "assessment";
    } else if (ctaId === "myra") {
      // question = "Who is Myra?";
      // answer = MYRA_MESSAGES.intro?.whoIsMyra || "I'm Myra, your recovery coach from Virdio Health. I'm powered by AI — not a human — but I'm designed to guide you through understanding and recovering from muscle and joint pain. I work alongside doctors of physical therapy and evidence-based research to help you do recovery at home, under your own guidance. I'm not a doctor, physical therapist, or clinician.";
      // type = "myra";
      await handleWhoIsMyraClick();
      return;
    } else {
      return;
    }

    // M2: Show user bubble immediately, typing dots, then Myra response
    const qaItem = { id: nextId(), question, answer, type };
    setInlineQa([{ ...qaItem, answer: null }]);
    setCtaTyping(true);
    await _delay(400);
    await _delay(1000);
    setCtaTyping(false);
    setInlineQa([qaItem]);
    introQaItemsRef.current.push(qaItem);
  }

  // ── Advance: collapse inline Q&A to strips, proceed ──
  function handleAdvance(preselectedArea) {
    const strips = [];
    introQaItemsRef.current.forEach((item) => {
      const exId = qaRef.current?.addExchange?.(item.question, item.answer, "intro_cta");
      const stripId = nextId();
      if (exId) qaStripIdsRef.current.add(exId);
      strips.push({ type: "qa-strip", id: stripId, qaId: exId || stripId, question: item.question });
    });
    pushToHistory(...strips, { type: "user", text: MYRA_MESSAGES.intro.ctaLabels.startMyAssessment, id: nextId() });
    onContinue(preselectedArea || detectedArea || null);
  }

  useEffect(() => {
    if (!externalAction?.type) return;
    if (externalAction.type === "video" || externalAction.type === "myra") {
      handleCta(externalAction.type);
    }
  }, [externalAction]);
  const PROBLEM_AREA_OPTIONS = [
    { id: "LBP", label: "My lower back" },
    { id: "HIP", label: "My hip" },
    { id: "THIGH", label: "My thigh" },
    { id: "KNEE", label: "My knee" },
  ];

  const handleChipClick = async (option) => {
    window.showChips = true;
    window.hideNavbarBtm = true;
    const selectedArea = option?.id;

    // ── Spec 1: Variant B (chip_conversational) ──
    // When the user is in the chip_conversational variant, tapping a chip
    // fires a synthetic chat message into the embedded card chat instead
    // of advancing the GSA. Variant string is set elsewhere by the
    // variant-selection logic (random / daily / etc.) and lands in
    // localStorage.variant or the ?variant=… URL param.
    // "chip_conversational" is a placeholder — confirm final value with
    // Arjun before launch.
    if (userVariant === "chip_conversational") {
      const phrasePerArea = {
        LBP: "My lower back hurts",
        HIP: "My hip hurts",
        THIGH: "My thigh hurts",
        KNEE: "My knee hurts",
      };
      const message = phrasePerArea[selectedArea];
      if (message && typeof onInlineChat === "function") {
        pushToHistory({ type: "user", text: message, id: nextId() });
        await onInlineChat(message);
      }
      return;
    }

    // ── Variant A (current chip behaviour, default) ──
    requestFlutterLogoutForAssessmentStart();
    console.log("updateAssessmentData", updateAssessmentData);
    setLandingChipArea?.(selectedArea);
    window.problemArea = selectedArea;

    // Update local state
    setProblemArea(selectedArea);

    // Create the updates object (not the full assessmentData)
    const updates = {
      problemArea: selectedArea,
      selected_problem_area: CONST.CLINICAL_PATHS?.[selectedArea]?.name || selectedArea,
      EngagedOnLanding: window.EngagedOnLanding || false,
    };

    console.log("PROBLEM AREA SELECTED:", selectedArea);
    console.log("Updates to apply:", updates);

    // Update assessment data with just the updates
    updateAssessmentData(updates);
    await new Promise((resolve) => setTimeout(resolve, 0));
    setTimeout(() => {
      if (onContinue) {
        onContinue(selectedArea);
      }
    }, 10);
  };
  if (phase === "loading") return null;

  const hasResponded = inlineQa.some((qa) => qa.answer !== null);
  const steps = getAssessmentSteps();

  return (
    <>
      {/* Inline Q&A from CTA taps (Pattern A) */}
      {inlineQa.map((qa) => (
        <React.Fragment key={qa.id}>
          <div className={styles.msgRowUser}>
            <div className={styles.msgBubbleUser}>{qa.question}</div>
          </div>
          {qa.answer && (
            <>
              <div className={styles.msgRowMyra}>
                <div className={styles.msgAvatar}>M</div>
                <div className={styles.msgBubbleMyra}>{qa.answer}</div>
              </div>
              {qa.type === "assessment" && (
                <div className={styles.inlineUi}>
                  <div className={styles.accordion}>
                    {steps.map((s, i) => (
                      <div key={i} className={`${styles.accordionItem} ${openAccIdx === i ? styles.open : ""}`} onClick={() => setOpenAccIdx(openAccIdx === i ? -1 : i)}>
                        <div className={styles.accordionHeader}>
                          <span className={styles.accordionStep}>{i + 1}</span>
                          <span className={styles.accordionTitle}>{s.title}</span>
                          {CHEVRON_DOWN}
                        </div>
                        <div className={styles.accordionBody}>
                          <p>{s.body}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </React.Fragment>
      ))}

      {/* M2: Typing dots while CTA response is loading */}
      {ctaTyping && (
        <div className={styles.typingRow}>
          <div className={styles.msgAvatar}>M</div>
          <div className={styles.typingDots}>
            <span />
            <span />
            <span />
          </div>
        </div>
      )}

      {/* CTA buttons */}
      {/* <div className={`${styles.inlineUi} ${styles.introCtaInlineUi}`}>
        <div className={styles.introCtaRow}>
          {!showIntroCtas &&
            INTRO_CTAS.filter((cta) => {
              if (cta.id === "start" && !setHideCtaBtn) {
                return false;
              }
              return true;
            }).map((cta) => (
              <button key={cta.id} className={`${cta.type === "start" ? styles.introCtaBtnStart : styles.introCtaBtn} ${cta.id === "assessment" ? styles.introAssessmentLink : ""} ${ctaUsed.has(cta.id) ? styles.introCtaBtnUsed : ""}`} onClick={() => handleCta(cta.id)} disabled={!introProminent}>
                {cta.label}
              </button>
            ))}
        </div>
      </div> */}
      {showAssessmentSteps && (
        <>
          <div className={styles.msgRowUser}>
            <div className={styles.msgBubbleUser}>What's the Assessment?</div>
          </div>
          <div className={styles.msgRowMyra}>
            <div className={styles.msgAvatar}>M</div>
            <div className={styles.msgBubbleMyra}>{MYRA_MESSAGES.intro?.whatsAssessment}</div>
          </div>
          <div className={styles.inlineUi}>
            <div className={styles.accordion}>
              {steps.map((s, i) => (
                <div key={i} className={`${styles.accordionItem} ${openAccIdx === i ? styles.open : ""}`} onClick={() => setOpenAccIdx(openAccIdx === i ? -1 : i)}>
                  <div className={styles.accordionHeader}>
                    <span className={styles.accordionStep}>{i + 1}</span>
                    <span className={styles.accordionTitle}>{s.title}</span>
                    {CHEVRON_DOWN}
                  </div>
                  <div className={styles.accordionBody}>
                    <p>{s.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      {/* Floating "Let's get started" after CTA response */}
      {/* {hasResponded && (
        <div className={`${styles.inlineUi} ${styles.introCtaInlineUi}`}>
          <div className={styles.introCtaRow}>
            <button className={styles.introCtaBtnStartFloat} onClick={() => handleAdvance(null)}>
              Start My Assessment
            </button>
          </div>
        </div>
      )} */}
      {/* <div className={styles.problemAreaChipGroup}>
        <div className={styles.problemAreaChipLabel}>{MYRA_MESSAGES.problemArea.whereHurtsLabel}</div>
        <div className={styles.problemAreaChipRow}>
          {PROBLEM_AREA_OPTIONS.map((option) => (
            <button key={option.id} type="button" className={styles.problemAreaChip} onClick={() => handleChipClick(option)}>
              {option.label}
            </button>
          ))}
        </div>
      </div> */}
    </>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 5: CPG QUESTION
// LBP: 2-step branching based on isLegPain.
//   Leg pain → CPG_OPTIONS_LEG → subtype Q1
//   Back only → CPG_OPTIONS_BACK → cpgToSubtype() → Pre-NPRS
// HKT: CLINICAL_PATHS[area].cpgQuestion
//   routesTo "direct" → Pre-NPRS (with Thigh Neural zone routing)
//   routesTo "subtypeQuestion" → Subtype Question
// ════════════════════════════════════════════════════════════════

function CPGQuestionScreen({ assessmentData, pushToHistory, showMyraMessage, showQuestionNuggetMessage, scrollToBottom, onContinue }) {
  const [selectedId, setSelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const problemArea = assessmentData.problemArea;
  const isLBP = problemArea === "LBP";
  const isLegPain = assessmentData.isLegPain;
  const isVoiceMode = MyraInteraction.getMode() === "voice";

  useEffect(() => {
    window.notOpenQNA = false;
  }, []);

  let prompt, nugget, options;
  if (isLBP) {
    options = isLegPain ? CONST.CPG_OPTIONS_LEG : CONST.CPG_OPTIONS_BACK;
    prompt = isLegPain ? MYRA_MESSAGES.cpg?.lbpLegQuestion : MYRA_MESSAGES.cpg?.lbpBackQuestion;
    nugget = isLegPain ? MYRA_MESSAGES.cpg?.lbpLegNugget : MYRA_MESSAGES.cpg?.lbpBackNugget;
  } else {
    const cpgQ = CONST.CLINICAL_PATHS[problemArea].cpgQuestion;
    prompt = MYRA_MESSAGES.cpg?.questionByArea?.[problemArea] || cpgQ.prompt;
    nugget = MYRA_MESSAGES.cpg?.nuggetByArea?.[problemArea];
    options = cpgQ.options;
  }

  useEffect(() => {
    let cancelled = false;
    async function init() {
      const setup = MYRA_MESSAGES.cpg?.setupByArea?.[problemArea];
      if (setup) await showMyraMessage(setup, 800);
      await showQuestionNuggetMessage(prompt, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    window.currentFlow = "flow_cpg";
    VoiceService._currentFlow = "flow_cpg";
    if (window.mayraCode) {
      VoiceService.startFlowWithoutAnnouncement("flow_cpg");
    }
  }, []);

  const handleSelect = useCallback(
    async (id) => {
      if (locked) return;
      setSelectedId(id);
      setLocked(true);

      const opt = options.find((o) => o.id === id);
      if (!opt) return;

      pushToHistory({ type: "frozen-widget", widgetType: "cpg_options", id: nextId(), data: { options, selectedId: id } }, { type: "user", text: opt.label, id: nextId() });

      const postTap = MYRA_MESSAGES.cpg?.postTap?.[id];
      if (postTap) await showMyraMessage(postTap, 900);

      if (isLBP) {
        onContinue(
          {
            cpgValue: opt.value,
            cpgForBackend: opt.value,
            cpgCategory: opt.value,
            q1PostTapFired: false,
            completed_cpg_question_screen: true,
          },
          "subtype_questioning",
        );
        return;
      }

      if (opt.routesTo === "direct") {
        let subtype = opt.directSubtype;

        if (problemArea === "THIGH" && opt.value === "THIGH_NEURAL_INVOLVEMENT") {
          const zones = assessmentData.selectedZones || [];
          const zoneString = zones.join(" ").toLowerCase();
          const singleZone = zones.length === 1;
          if (singleZone && (zoneString.includes("front") || zoneString.includes("anterior"))) {
            subtype = "QUADRICEPS_LOADING_IMPACT_INTOLERANCE";
          } else if (singleZone && (zoneString.includes("outer") || zoneString.includes("lateral"))) {
            subtype = "ITB_FRICTION_SYNDROME";
          } else {
            subtype = "HAMSTRING_LOADING_LENGTHENING_DEFICIT";
          }
        }

        onContinue(
          {
            cpgValue: opt.cpgForBackend,
            cpgForBackend: opt.cpgForBackend,
            cpgOption: opt,
            cpgCategory: opt.value,
            probableSubtype: subtype,
            skipSubtypeQuestion: true,
            q1PostTapFired: false,
            completed_cpg_question_screen: true,
          },
          "nprs_symptoms",
        );
        return;
      }

      const path = CONST.CLINICAL_PATHS[problemArea];
      const subtypeQuestion = path.subtypeQuestions?.[opt.subtypeQuestionIndex || 0];
      const zoneMap = problemArea === "HIP" && opt.id === "hip-cpg-mobility" ? CONST.HIP_MOB_Q1_ZONE_TO_OPTION : problemArea === "THIGH" ? CONST.THIGH_Q1_ZONE_TO_OPTION : null;
      const q1Decision = zoneMap && subtypeQuestion ? CONST.planSubtypeQ1Decision(assessmentData.pinpointSelections, zoneMap, subtypeQuestion.options) : { mode: "plain" };

      if (q1Decision.mode === "skip" && q1Decision.option) {
        let cpgForBackend = opt.cpgForBackend;
        if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[q1Decision.option.value]) {
          cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][q1Decision.option.value];
        }
        onContinue(
          {
            cpgValue: opt.cpgForBackend,
            cpgForBackend,
            cpgOption: opt,
            cpgCategory: opt.value,
            probableSubtype: q1Decision.option.value,
            subtypeQuestions: { q1: q1Decision.option },
            skipSubtypeQuestion: true,
            q1PostTapFired: false,
            completed_cpg_question_screen: true,
          },
          "nprs_symptoms",
        );
        return;
      }

      onContinue(
        {
          cpgValue: opt.cpgForBackend,
          cpgForBackend: opt.cpgForBackend,
          cpgOption: opt,
          cpgCategory: opt.value,
          subtypeQuestionIndex: opt.subtypeQuestionIndex,
          skipSubtypeQuestion: false,
          q1DecisionMode: q1Decision.mode,
          q1ReferencePhrase: q1Decision.referencePhrase || null,
          completed_cpg_question_screen: true,
        },
        "subtype_questioning",
      );
    },
    [locked, options, isLBP, isLegPain, problemArea, assessmentData.selectedZones, assessmentData.pinpointSelections],
  );

  const validateAndSelect = useCallback(() => {
    if (!selectedId && !locked) {
      if (isVoiceMode) VoiceService?.doSay("Please make your selection before we can move to the next screen");
      return;
    }
  }, [selectedId, locked]);

  const CPG_VOICE_MAP = {
    LBP: isLegPain
      ? {
          LEG_SHARP_SHOOTING: "cpg-radiating",
          LEG_DULL_ACHE: "cpg-referred",
          REFERRED_ACHE: "cpg-referred",
          BOTH_NOT_SURE: "cpg-referred",
          STIFFNESS_BLOCK: "cpg-referred",
          WEAKNESS_GIVE_OUT: "cpg-referred",
          MUSCULAR_ACHE: "cpg-referred",
          BURNING_TINGLING: "cpg-radiating",
          PINCHING_CATCHING: "cpg-radiating",
        }
      : {
          BACK_DEEP_STIFF: "cpg-mobility",
          BACK_INSTABILITY: "cpg-coordination",
          BOTH_NOT_SURE: "cpg-coordination",
          LEG_DULL_ACHE: "cpg-mobility",
          REFERRED_ACHE: "cpg-mobility",
          STIFFNESS_BLOCK: "cpg-mobility",
          WEAKNESS_GIVE_OUT: "cpg-coordination",
          MUSCULAR_ACHE: "cpg-mobility",
          BURNING_TINGLING: "cpg-mobility",
          PINCHING_CATCHING: "cpg-coordination",
        },
    HIP: {
      STIFFNESS_BLOCK: "hip-cpg-mobility",
      WEAKNESS_GIVE_OUT: "hip-cpg-power",
      PINCHING_CATCHING: "hip-cpg-motor",
      REFERRED_ACHE: "hip-cpg-mobility",
      MUSCULAR_ACHE: "hip-cpg-mobility",
      BURNING_TINGLING: "hip-cpg-motor",
      BOTH_NOT_SURE: "hip-cpg-mobility",
    },
    THIGH: {
      MUSCULAR_ACHE: "thigh-cpg-muscular",
      BURNING_TINGLING: "thigh-cpg-neural",
      REFERRED_ACHE: "thigh-cpg-referred",
      BACK_DEEP_STIFF: "thigh-cpg-referred",
      STIFFNESS_BLOCK: "thigh-cpg-muscular",
      WEAKNESS_GIVE_OUT: "thigh-cpg-muscular",
      PINCHING_CATCHING: "thigh-cpg-neural",
      BOTH_NOT_SURE: "thigh-cpg-muscular",
    },
    KNEE: {
      AROUND_KNEECAP: "knee-cpg-pfp",
      JOINT_STIFF_UNSTABLE: "knee-cpg-mobility",
      OUTER_LATERAL: "knee-cpg-lateral",
      BACK_OF_KNEE: "knee-cpg-posterior",
      INNER_MEDIAL: "knee-cpg-medial",
      REFERRED_ACHE: "knee-cpg-mobility",
      MUSCULAR_ACHE: "knee-cpg-mobility",
      BURNING_TINGLING: "knee-cpg-lateral",
      STIFFNESS_BLOCK: "knee-cpg-mobility",
      WEAKNESS_GIVE_OUT: "knee-cpg-mobility",
      BOTH_NOT_SURE: "knee-cpg-mobility",
    },
  };

  useScreenVoice({
    screenName: "cpg_questions",
    flowName: "flow_cpg",
    payloadKey: "cpg_questions",
    assessmentData,
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value) => {
        if (value === "continue_command") validateAndSelect();
      },
      MOVE_ON: () => validateAndSelect(),
      SELECT_CPG: (value, speech, intent, extracted, actionValue) => {
        if (locked) return;
        const optionId = CPG_VOICE_MAP?.[problemArea]?.[actionValue];
        if (!optionId) return;
        handleSelect(optionId);
      },
    },
    exitReason: "cpg_selected",
  });

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          {options.map((o) => (
            <div key={o.id} className={styles.chipPair}>
              {/* Clickable chip */}
              <div className={`${styles.optionCard} ${selectedId === o.id ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(o.id)}>
                {o.label}
              </div>

              {/* Helper text BELOW */}
              {/* {o.info && <div className={styles.chipHelper}>{o.info}</div>} */}
            </div>
          ))}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

function SubtypeQuestionScreen({ assessmentData, pushToHistory, showMyraMessage, showQuestionNuggetMessage, scrollToBottom, detectedTrigger, onContinue }) {
  const [selectedId, setSelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const problemArea = assessmentData.problemArea;
  const isLBP = problemArea === "LBP";
  const isVoiceMode = MyraInteraction.getMode() === "voice";

  let prompt, options;
  if (isLBP) {
    prompt = MYRA_MESSAGES.subtypeQ1?.lbpQuestion || "What tends to make it worse?";
    options = CONST.Q1_OPTIONS;
  } else {
    const path = CONST.CLINICAL_PATHS[problemArea];
    const qIndex = assessmentData.subtypeQuestionIndex || 0;
    const question = path.subtypeQuestions[qIndex];
    prompt = question.prompt;
    options = question.options;
    const isZoneBasedQ1 = problemArea === "THIGH" || (problemArea === "HIP" && qIndex === 0);
    if (isZoneBasedQ1) {
      const selectedZones = assessmentData.selectedZones || [];
      let zoneToOptionMap;
      if (problemArea === "HIP") {
        zoneToOptionMap = CONST.HIP_MOB_Q1_ZONE_TO_OPTION;
      } else if (problemArea === "THIGH") {
        zoneToOptionMap = CONST.THIGH_Q1_ZONE_TO_OPTION;
      }
      console.log(" zoneToOptionMap:", zoneToOptionMap);

      if (zoneToOptionMap && selectedZones.length > 0) {
        const matchedOptionIds = new Set();
        selectedZones.forEach((zone) => {
          const zoneName = zone.includes(":") ? zone.split(":")[1] : zone;
          const optionId = zoneToOptionMap[zoneName];

          console.log(` Zone: "${zone}" → OptionId:`, optionId);
          if (optionId) matchedOptionIds.add(optionId);
        });
        console.log(" matchedOptionIds:", Array.from(matchedOptionIds));
        const matchCount = matchedOptionIds.size;

        if (matchCount >= 2) {
          // 2+ hits: Filter to only the matched options
          options = options.filter((o) => matchedOptionIds.has(o.id));
          console.log(
            "Filtered options to:",
            options.map((o) => o.id),
          );
        } else if (matchCount === 1) {
          // console.log(
          //   " Single match, filtered to:",
          //   options.map((o) => o.id),
          // );

          // the cpg screens handles this:
          // The CPG screen should have already set skipSubtypeQuestion = true
          const singleMatchId = Array.from(matchedOptionIds)[0];
          const matchedOption = options.find((o) => o.id === singleMatchId);
          if (matchedOption) {
            pushToHistory({ type: "frozen-widget", widgetType: "option_cards", id: nextId(), data: { options, selectedId: singleMatchId } }, { type: "user", text: matchedOption.label, id: nextId() });
          }
          // const postTap = MYRA_MESSAGES.subtypeQ1?.postTap?.[singleMatchId];
          // if (postTap) {
          //   setTimeout(async () => {
          //     await showMyraMessage(postTap, 900);
          //   }, 10);
          // }
          setLocked(true);

          // Continue to next screen
          let cpgForBackend = assessmentData.cpgForBackend;
          if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[matchedOption.value]) {
            cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][matchedOption.value];
          }
          onContinue(
            {
              probableSubtype: matchedOption.value,
              cpgForBackend,
              subtypeQuestions: { q1: matchedOption },
              q1PostTapFired: true,
              completed_subtype_screen: true,
            },
            "nprs_symptoms",
          );

          return;
        }
        // matchCount === 0: Show all options (unchanged)
      }
    }
  }

  let nugget = null;
  if (isLBP) {
    nugget = MYRA_MESSAGES.subtypeQ1?.lbpNugget;
  } else {
    const nuggetKey = `${problemArea}_${assessmentData.subtypeQuestionIndex || 0}`;
    nugget = MYRA_MESSAGES.subtypeQ1?.nuggetByAreaAndIndex?.[nuggetKey] || null;
  }
  let introMessage = "";
  useEffect(() => {
    let cancelled = false;
    async function init() {
      if (isLBP && detectedTrigger) {
        const matchOpt = CONST.Q1_OPTIONS.find((o) => o.value === detectedTrigger);
        if (matchOpt) {
          await showQuestionNuggetMessage(MYRA_MESSAGES.subtypeQ1?.promptWithPreselect || prompt, "", 900);
          if (!cancelled) {
            setSelectedId(matchOpt.id);
            setReady(true);
          }
          return;
        }
      }

      if (assessmentData.q1ReferencePhrase) {
        await showMyraMessage(resolveMessage(MYRA_MESSAGES.subtypeQ1?.referenceTemplate || "", { referencePhrase: assessmentData.q1ReferencePhrase }), 800);
      } else {
        const setup = MYRA_MESSAGES.subtypeQ1?.setupByArea?.[problemArea];
        if (setup) await showMyraMessage(setup, 800);
      }

      await showQuestionNuggetMessage(prompt, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSelect = useCallback(
    async (id) => {
      if (locked) return;
      setSelectedId(id);
      setLocked(true);

      const opt = options.find((o) => o.id === id);
      if (!opt) return;

      pushToHistory({ type: "frozen-widget", widgetType: "option_cards", id: nextId(), data: { options, selectedId: id } }, { type: "user", text: opt.label, id: nextId() });

      const postTap = MYRA_MESSAGES.subtypeQ1?.postTap?.[id];
      if (postTap) await showMyraMessage(postTap, 900);

      if (isLBP) {
        onContinue(
          {
            subtypeQ1: opt.value,
            subtypeQuestions: { q1: opt },
            q1PostTapFired: true,
            completed_subtype_screen: true,
          },
          "self_assessment",
        );
        return;
      }

      let cpgForBackend = assessmentData.cpgForBackend;
      if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[opt.value]) {
        cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][opt.value];
      }

      onContinue(
        {
          probableSubtype: opt.value,
          cpgForBackend,
          subtypeQuestions: { q1: opt },
          q1PostTapFired: true,
          completed_subtype_screen: true,
        },
        "nprs_symptoms",
      );
    },
    [locked, options, isLBP, problemArea, assessmentData.cpgForBackend],
  );

  const validateAndContinue = useCallback(() => {
    if (!selectedId && !locked) {
      if (isVoiceMode) VoiceService?.doSay("Please make your selection before we can move to the next screen");
    }
  }, [selectedId, locked]);

  useEffect(() => {
    window.currentFlow = "flow_subtype";
    VoiceService._currentFlow = "flow_subtype";
    if (window.mayraCode) {
      VoiceService.startFlowWithoutAnnouncement("flow_subtype");
    }
  }, []);

  const SUBTYPE_VOICE_MAP = {
    LBP: {
      FLEXION_TRIGGER: "q1a",
      EXTENSION_TRIGGER: "q1b",
      ROTATION_TRIGGER: "q1e",
      STATIC_TRIGGER: "q1c",
      UNPREDICTABLE: "q1d",
    },
    HIP_0: {
      LATERAL_HIP: "hip-sub-lateral",
      HIP_FLEXOR: "hip-sub-anterior",
      POSTERIOR_HIP: "hip-sub-posterior",
      ADDUCTOR_GROIN: "hip-sub-rotational",
      DEEP_BUTTOCK: "hip-sub-neuro",
      JOINT_GENERALIZED: "hip-sub-global",
    },
    HIP_1: {
      ADDUCTOR_STRAIN: "hip-sub-adductor",
      ABDUCTOR_WEAKNESS: "hip-sub-abduction",
    },
    THIGH_0: {
      FRONT_THIGH: "thigh-sub-anterior",
      INNER_THIGH: "thigh-sub-medial",
      BACK_THIGH: "thigh-sub-posterior",
      OUTER_THIGH: "thigh-sub-lateral",
    },
    KNEE_0: {
      PATELLAR_TRACKING: "knee-sub-valgus",
      PATELLAR_GRINDING: "knee-sub-maltrack",
      PATELLAR_TENDON: "knee-sub-tendon",
    },
    KNEE_1: {
      KNEE_STIFFNESS: "knee-sub-stiff",
      KNEE_INSTABILITY: "knee-sub-unstable",
    },
  };

  useScreenVoice({
    screenName: "subtype_questioning",
    flowName: "flow_subtype",
    payloadKey: "subtype_questioning",
    assessmentData,
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value) => {
        if (value === "continue_command") validateAndContinue();
      },
      MOVE_ON: () => validateAndContinue(),
      SELECT_SUBTYPE: (value, speech, intent, extracted, actionValue) => {
        if (locked) return;
        const enumValue = actionValue;
        if (!enumValue) return;
        const mapKey = isLBP ? "LBP" : `${problemArea}_${assessmentData.subtypeQuestionIndex || 0}`;
        const optionId = SUBTYPE_VOICE_MAP[mapKey]?.[enumValue];
        if (!optionId) return;
        handleSelect(optionId);
      },
    },
    exitReason: "subtype_selected",
  });

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          {options.map((o) => (
            <div key={o.id} className={styles.chipPair}>
              {/* Clickable chip */}
              <div className={`${styles.optionCard} ${selectedId === o.id ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(o.id)}>
                {o.label}
              </div>

              {/* Helper text BELOW */}
              {/* {o.info && <div className={styles.chipHelper}>{o.info}</div>} */}
            </div>
          ))}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

function SelfAssessmentQ2Screen({ assessmentData, pushToHistory, showMyraMessage, showQuestionNuggetMessage, scrollToBottom, onContinue }) {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const q1Value = assessmentData.subtypeQ1;
  const q2Data = CONST.Q2_MAP[q1Value];
  const isVoiceMode = MyraInteraction.getMode() === "voice";

  useEffect(() => {
    if (!q2Data) return;
    let cancelled = false;
    async function init() {
      if (MYRA_MESSAGES.q2?.transition) await showMyraMessage(MYRA_MESSAGES.q2.transition, 700);
      const q2Nugget = MYRA_MESSAGES.q2?.nuggetByQ1?.[q1Value] || MYRA_MESSAGES.q2?.nuggetByQ1?.c;
      await showQuestionNuggetMessage(q2Data.title, "", 800);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSelect = useCallback(
    async (answer) => {
      if (locked) return;
      setSelectedAnswer(answer);
      setLocked(true);
      let echoText = "";
      if (answer === "YES" || answer === "yes") {
        echoText = "Yes, that helps";
      } else {
        echoText = "No, not really";
      }

      // const echoText = answer === "yes" ? "Yes, that helps" : "No, not really";
      pushToHistory({ type: "frozen-widget", widgetType: "yesno", id: nextId(), data: { selectedAnswer: answer } }, { type: "user", text: echoText, id: nextId() });

      const subtype = CONST.getSubtype(q1Value, answer);
      if (MYRA_MESSAGES.q2?.postTap) await showMyraMessage(MYRA_MESSAGES.q2.postTap, 700);

      onContinue({
        selfAssessmentAnswer: echoText,
        selfAssessmentValue: answer,
        subtypeQ2: answer,
        probableSubtype: subtype,
        q1PostTapFired: true,
      });
    },
    [locked, q1Value, pushToHistory, onContinue, showMyraMessage],
  );

  const validateAndContinue = useCallback(() => {
    if (!selectedAnswer && !locked) {
      if (isVoiceMode) VoiceService?.doSay("Please answer yes or no before we can move to the next screen");
    }
  }, [selectedAnswer, locked]);

  useScreenVoice({
    screenName: "self_assessment",
    flowName: "flow_self_assessment",
    payloadKey: "self_assessment",
    assessmentData,
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted, actionValue) => {
        if (locked) return;
        if (value === "continue_command") {
          validateAndContinue();
          return;
        }
        const answer = actionValue === "YES" || value === "yes" ? "yes" : actionValue === "NO" || value === "no" ? "no" : null;
        if (answer) handleSelect(answer);
      },
      MOVE_ON: () => validateAndContinue(),
      SELECT_Q2: (value, speech, intent, extracted, actionValue, matched) => {
        if (actionValue === "YES" || actionValue === "NO_UNSURE") handleSelect(actionValue);
      },
    },
    exitReason: "self_assessment_answered",
  });

  if (!q2Data) {
    return <div className={styles.inlineUi}>No follow-up question available.</div>;
  }

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          <div className={styles.chipPair}>
            <button className={`${styles.yesnoBtn} ${selectedAnswer === "yes" ? styles.selected : ""}`} onClick={() => handleSelect("yes")} disabled={locked}>
              Yes, that helps
            </button>
          </div>
          <div className={styles.chipPair}>
            <button className={`${styles.yesnoBtn} ${selectedAnswer === "no" ? styles.selected : ""}`} onClick={() => handleSelect("no")} disabled={locked}>
              No, not really
            </button>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

function PreNPRSScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, readOnly = false, showQuestionNuggetMessage, setPlaceholderText }) {
  const [ready, setReady] = useState(false);
  const [painLocked, setPainLocked] = useState(false);
  const painLockedRef = useRef(false);

  // Push setup beat + question + nugget on mount.
  // Set screen-specific placeholder for the chat composer.
  useEffect(() => {
    let cancelled = false;
    async function init() {
      await showMyraMessage(MYRA_MESSAGES.preNprs.NPRS_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(MYRA_MESSAGES.preNprs.painPrompt, MYRA_MESSAGES.preNprs.nugget, 900);
      if (!cancelled) setReady(true);
    }
    init();
    if (setPlaceholderText && MYRA_MESSAGES.preNprs.placeholder) {
      setPlaceholderText(MYRA_MESSAGES.preNprs.placeholder);
    }
    return () => {
      cancelled = true;
    };
  }, []);

  // Voice flow setup
  useEffect(() => {
    window.currentFlow = "flow_nprs_symptoms";
    VoiceService._currentFlow = "flow_nprs_symptoms";
    MyraInteraction?.onScreenEnter?.("nprs_symptoms");
    if (window.mayraCode) {
      VoiceService.startFlowWithoutAnnouncement("flow_nprs_symptoms");
    }
  }, []);

  // Receive a numeric pain value (0–10) from Beacon and advance.
  // Beacon parses "4", "four", "a 4", "about a four", etc. and returns
  // a normalized integer. Anything Beacon can't parse is handed to Claude
  // and arrives back here through the same command channel.
  const handlePainValue = useCallback(
    (val) => {
      if (painLockedRef.current || painLocked || readOnly) return;
      painLockedRef.current = true;
      setPainLocked(true);
      pushToHistory({ type: "user", text: `${val}`, id: nextId() }, { type: "myra", text: MYRA_MESSAGES.preNprs.NPRS_POST_TAP_NUGGET, id: nextId() });
      onContinue({
        painLevel: val,
        completed_nprs: true,
      });
    },
    [painLocked, readOnly, pushToHistory, onContinue],
  );

  useScreenVoice({
    screenName: "nprs_symptoms",
    trackerName: "pre_nprs",
    flowName: "flow_nprs_symptoms",
    payloadKey: "nprs_symptoms",
    assessmentData,
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (extracted && extracted.painLevel !== undefined && extracted.painLevel !== null) {
          const painValue = typeof extracted.painLevel === "number" ? extracted.painLevel : parseInt(extracted.painLevel);
          if (!isNaN(painValue) && painValue >= 0 && painValue <= 10) {
            handlePainValue(painValue);
          }
        }
      },
      SELECT_PAIN_LEVEL: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = Array.isArray(actions) ? actions : Array.isArray(actionValue) ? actionValue : [];
        const painAction = allActions.find((a) => a.action === "SELECT_PAIN_LEVEL");
        const rawPainValue = painAction?.value ?? (!Array.isArray(actionValue) && actionValue !== undefined ? actionValue : value);
        if (rawPainValue !== undefined && rawPainValue !== null) {
          const painValue = typeof rawPainValue === "number" ? rawPainValue : parseInt(rawPainValue);
          if (!isNaN(painValue) && painValue >= 0 && painValue <= 10) {
            handlePainValue(painValue);
          }
        }
      },
    },
    exitReason: "pre_nprs_completed",
  });

  if (!ready) return null;

  // No live UI — the question + nugget bubble is in conversation history,
  // and the user replies through the existing chat composer.
  return null;
}

// ════════════════════════════════════════════════════════════════
// SCREEN 9: TEST INTRO 1
// Mode selection card (conditional) → demo video → "Ready" button.
// Most complex voice integration in the GSA:
//   - Manual flow management (not standard useScreenVoice flow)
//   - 4 startFlow paths based on name + returning status
//   - 9 command handlers including GIVE_NAME and video controls
//   - AR handoff with full window.* global setup
//   - Second (and optionally third) test video preloading
// ════════════════════════════════════════════════════════════════

// Maps each screen's own field to the analytics flag name that was reached
// when the field is filmed in. Names are unchanged from the old paired
// screens (submitted_rpe_1, submitted_symptoms_1, completed_speed_screen,
// completed_rom_screen) — confirm with analytics before renaming (handoff Q4).
const MOVEMENT_FIELD_TO_ANALYTICS_FLAG = {
  rpe: "submitted_rpe_1",
  feelAffect: "submitted_symptoms_1",
  tempo: "completed_speed_screen",
  rom: "completed_rom_screen",
};

function MovementQuestionScreen({ screenName, assessmentData, pushToHistory, showQuestionNuggetMessage, setPlaceholderText, scrollToBottom, showMyraMessage, speakChatTextIfVoice }) {
  const [ready, setReady] = useState(false);
  const hasPromptedRef = useRef(false);
  const screenEnterTimeRef = useRef(null);
  const analyticsFlagFiredRef = useRef(false);
  const helper = MYRA_MESSAGES.movementQuestions?.helper || "Describe it however feels natural.";
  // Four-way lookup keyed by the screen name itself — "movement_q1".."movement_q4"
  // map 1:1 onto MYRA_MESSAGES.movementQuestions.q1..q4, so the copy block
  // carries its own `field` key rather than it being hardcoded here.
  const questionKey = screenName?.replace("movement_", "") || "q1";
  const copy = MYRA_MESSAGES.movementQuestions?.[questionKey];
  const field = copy?.field || null;
  const trackerName = screenName;
  // isFirstMovementScreen stays tied to movement_q1 specifically — it gates
  // the Google Ads conversion event and the stale-pre-test-speech discard,
  // both of which are one-time, first-screen-only behaviors independent of
  // which field each screen now asks about.
  const isFirstMovementScreen = screenName === "movement_q1";
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  useEffect(() => {
    if (window.gtag && isFirstMovementScreen) {
      console.log("GTAG-TRIGGERS FOR RPE AND SYMPTOMS");
      window.gtag("event", "conversion", {
        send_to: "AW-18002481001/LAGZCLqhn6QcEOmeoIhD",
        value: 1.0,
        currency: "USD",
      });
    }
  }, [ready]);

  useEffect(() => {
    window.currentFlow = "flow_movement_questions";
    if (VoiceService) VoiceService._currentFlow = "flow_movement_questions";
    // stop audio when movement question screen is mounted
    if (window.stopAudio) {
      window.stopAudio();
    }
    if (isVoiceMode && VoiceService) {
      VoiceService._startListening().catch((err) => {
        setTimeout(() => {
          VoiceService._startListening().catch((e) => console.error("[RECONNECT] Retry also failed:", e));
        }, 2000);
      });
    }
    window.notOpenQNA = true;
    setPlaceholderText(INPUT_PLACEHOLDERS[trackerName] || helper);
    window.screenTracker?.enterScreen(trackerName);

    return () => {
      window.screenTracker?.exitScreen(trackerName, { completed: true });
      if (window.currentFlow === "flow_movement_questions") {
        window.currentFlow = null;
      }
      if (window.notOpenQNA === true) {
        window.notOpenQNA = false;
      }
    };
  }, [trackerName, setPlaceholderText, helper]);

  // Fires this screen's own "reached" analytics flag once per mount. One
  // field, one screen, one flag — replaces the old six-branch if/else that
  // used window.feelAffectMarked / window.romMarked to infer which half of
  // a paired screen had just been reached.
  useEffect(() => {
    if (analyticsFlagFiredRef.current || !field) return;
    analyticsFlagFiredRef.current = true;
    const flagName = MOVEMENT_FIELD_TO_ANALYTICS_FLAG[field];
    if (!flagName) return;
    AnalyticsService.trackStep({
      ...assessmentData,
      [flagName]: true,
    });
  }, []);
  useEffect(() => {
    const enterTime = Date.now();
    screenEnterTimeRef.current = enterTime;
    window.screenTracker?.enterScreen(trackerName);

    return () => {
      if (screenEnterTimeRef.current) {
        const exitTime = Date.now();
        const duration = exitTime - screenEnterTimeRef.current;
        window.screenTracker?.exitScreen(trackerName, {
          completed: ready,
          duration,
          exitReason: "Questioned Answered",
        });
        screenEnterTimeRef.current = null;
      }
    };
  }, [trackerName, ready]);

  useEffect(() => {
    let cancelled = false;
    async function init() {
      if (hasPromptedRef.current) return;
      hasPromptedRef.current = true;

      // Clear unconditionally, whether or not it matched this screen, so a
      // stale value set for a screen the hop skipped past can never survive
      // into a later screen and silently suppress its question (handoff
      // Section 5 — this is the minimum mitigation the doc calls out; the
      // fuller fix is checking the last assistant message in history
      // instead of relying on a global at all, and needs conversation
      // history threaded into this component as a prop).
      const skipFor = window.skipMovementQuestionOpen;
      window.skipMovementQuestionOpen = null;
      if (skipFor === trackerName) {
        if (!cancelled) setReady(true);
        return;
      }

      const bucket = buildMovementBucket(assessmentData);
      const shouldAsk = field && lowestEmptyMovementField(bucket) === field;
      if (shouldAsk) {
        //  await showQuestionNuggetMessage([copy?.setupBeat, copy?.question]);
        // await showMyraMessage(copy?.setupBeat + " " + copy?.question);
        await showMyraMessage([copy?.setupBeat, copy?.question].filter(Boolean).join(" "));
        if (isVoiceMode) {
          // The first screen starts a new post-test section; discard any stale pre-test speech.
          speakChatTextIfVoice([copy?.setupBeat, copy?.question].filter(Boolean).join(" "), isFirstMovementScreen);
        }
      }
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, [assessmentData, copy, field, helper, isFirstMovementScreen, trackerName, showQuestionNuggetMessage, speakChatTextIfVoice]);

  if (!ready) return null;
  // return (
  //   <div className={styles.inlineUi2}>
  //     <p className={styles.paSubtitle} style={{ textAlign: "center", marginTop: 8 }}>
  //       {/* {helper} */}
  //     </p>
  //   </div>
  // );
  // donot show empty div on this screen, adds extra scroll height and falsely shows More below.
  return null;
}

// SCREEN 10: MOVEMENT Check 1 (AR)
// Placeholder screen — AR/Flutter takes over entirely.
// On mount: clears commands, disables Myra, sets completion handler.
// AR writes dataAfterInfo to localStorage and calls
// window.doNextLocation.push() when complete.
// ════════════════════════════════════════════════════════════════

function MovementTest1Screen({ assessmentData, setMode, updateAssessmentData, pushToHistory, speakChatTextIfVoice, showMyraMessage, scrollToBottom, onContinue, onHardStop, chatBucketTest }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    MyraInteraction?.onScreenEnter?.("movement_test_1");
    if (window.currentFlow === "flow_landing_page") window.currentFlow = null;
    if (VoiceService && VoiceService._currentFlow === "flow_landing_page") VoiceService._currentFlow = null;
  }, []);
  const screenEnterTimeRef = useRef(null);

  useEffect(() => {
    const enterTime = Date.now();
    screenEnterTimeRef.current = enterTime;
    window.screenTracker?.enterScreen("movement_test_1");

    return () => {
      if (screenEnterTimeRef.current) {
        const exitTime = Date.now();
        const duration = exitTime - screenEnterTimeRef.current;
        window.screenTracker?.exitScreen("movement_test_1", {
          completed: true,
          duration,
          exitReason: "completed_test",
        });
        screenEnterTimeRef.current = null;
      }
    };
  }, []);

  const handleARComplete = useCallback(async () => {
    const isVoiceMode = MyraInteraction.getMode() === "voice";
    setMode(isVoiceMode ? "voice" : "chat");
    // stop audio when movement test is completed
    if (window.stopAudio) {
      window.stopAudio();
    }
    // Start flow without announcement so flow gets updated on backend correctly
    if (isVoiceMode && VoiceService) {
      VoiceService.startFlowWithoutAnnouncement?.("flow_movement_questions");
    }
    if (screenEnterTimeRef.current) {
      const exitTime = Date.now();
      const duration = exitTime - screenEnterTimeRef.current;
      window.screenTracker?.exitScreen("movement_test_1", {
        completed: true,
        duration,
        exitReason: "completed_test",
      });
      screenEnterTimeRef.current = null;
    }
    // Hide movement progress UI immediately after AR completion to avoid UI flash
    // while Myra transitions into the completion/confirmation message.
    window.hideMovementProgressUi = true;

    // Re-enable Myra
    window.mayraCode?.setIsVisible(false);
    window.mayraCode?.enableCallback?.();

    // Read AR results from localStorage
    let dataAfterInfo = {};
    try {
      const raw = localStorage.getItem("dataAfterInfo");
      if (raw) dataAfterInfo = JSON.parse(raw);
    } catch (e) {
      /* ignore parse errors */
    }

    const completedTestName = CONST.TEST_MAP[assessmentData.probableSubtype]?.name || assessmentData.testName || assessmentData.rom_test1_name || "the movement";
    pushToHistory({ type: "user", text: "I've done the movement.", id: nextId() });
    await showMyraMessage(getMovementCompletionSummary(completedTestName), 800);
    if (isVoiceMode) {
      const completionText = getMovementCompletionSummary(completedTestName);
      speakChatTextIfVoice(completionText, true);
    }
    console.log("AR completion data:", assessmentData.input_mode_at_test_start, MyraInteraction.getMode());
    let switchModeDuringTest = false;
    if (window.switchedModeDuringTest) {
      switchModeDuringTest = true;
    } else if (assessmentData.input_mode_at_test_start && MyraInteraction.getMode() && assessmentData.input_mode_at_test_start !== MyraInteraction.getMode()) {
      switchModeDuringTest = true;
    } else {
      switchModeDuringTest = false;
    }

    // Determine path: camera vs no-camera
    const noCameraMode = localStorage.getItem("noCameraMode") === "true";
    const nextStep = "movement_q1";
    window.currnetScreen = nextStep;
    window.currentScreen = nextStep;

    onContinue(
      {
        ...dataAfterInfo,
        rom_test1_started: true,
        rom_test1_completed: true,
        viewed_test1_reveal: true,
        completed_safety_screen: true,
        started_safety_screen: true,
        completed_nprs: true,
        noCameraMode,
        switched_to_voice_during_test: switchModeDuringTest,
      },
      nextStep,
    );
  }, [onContinue, assessmentData.probableSubtype, showMyraMessage, pushToHistory, speakChatTextIfVoice]);

  useEffect(() => {
    // Reset per-test transient UI hide flag at test start.
    window.hideMovementProgressUi = false;

    // Clear commands and hide Myra during AR
    window.currentCommandsAudio = {};
    window.mayraCode?.disableCallback();
    window.mayraCode?.setIsVisible(false);

    // Push voice indicator to history
    pushToHistory({ type: "voice-indicator", id: nextId() });

    // AR completion handler — AR calls window.doNextLocation.push() when done
    window.doNextLocation = {
      push: () => {
        handleARComplete();
      },
    };

    // Safety hard stop handler — AR calls this if user can't complete reps
    window.handleARHardStop = () => {
      window.mayraCode?.setIsVisible(false);
      window.mayraCode?.forceStop?.();
      onHardStop("test1_pain");
    };

    return () => {
      window.doNextLocation = null;
      window.handleARHardStop = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Landing bucket router can jump straight to movement_test_1 (skipping TestIntro /
    // CameraPermission). Those screens set localStorage.loadSelf and window payloads;
    // without them, loadROMExercises() in ondemand-camera.js no-ops and Flutter never
    // gets ROM data (checkIsSelf → "self no"), leaving the user on this placeholder.

    if (window._gsaLandingChatMovementTest === true) {
      console.log("inside movement check 1 from landing page chat", chatBucketTest);
      window._gsaLandingChatMovementTest = false;
      const subtype = chatBucketTest.probableSubtype || chatBucketTest.subtype || assessmentData.probableSubtype || assessmentData.subtype || "NEUTRAL_SENSITIVE";
      const test = CONST.TEST_MAP[subtype];
      const testName = chatBucketTest.reveal || test?.name || assessmentData.testName || assessmentData.rom_test1_name || "";
      if (testName) {
        window.selectedSubType = subtype;
        window.problemArea = chatBucketTest.problemArea || "LBP";
        if (subtype === "ROTATIONAL_INTOLERANT") {
          window.assessmentChangeExercise = true;
        }
        window.movementTestPayload = generatePayloadForScreen("movement_test_1", assessmentData);
        window.cameraPayload = generatePayloadForScreen("camera_permission", assessmentData);
        localStorage.setItem("loadSelf", testName);
        localStorage.setItem("cameFromGsaV2", "true");
        const inputModeAtTestStart = MyraInteraction.getMode() || "chat";
        window.input_mode_at_test_start = inputModeAtTestStart;
        // TestIntro / CameraPermission normally persist the movement-test start fields.
        // Landing-chat handoff skips those screens, so persist them here before AR opens.
        const startFields = {
          testName,
          rom_test1_name: testName,
          rom_test1_started: true,
          viewed_test1_reveal: true,
          input_mode_at_test_start: inputModeAtTestStart,
          session_last_update: new Date().toISOString(),
        };
        updateAssessmentData(startFields);
        const existing = JSON.parse(localStorage.getItem("assessmentData") || "{}");
        const updated = { ...existing, ...startFields };
        localStorage.setItem("assessmentData", JSON.stringify(updated));
        if (AnalyticsService) AnalyticsService.trackStep({ ...assessmentData, ...updated });
      }
    }

    if (window.doKeepVideoPlay) window.doKeepVideoPlay();
    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }
    if (window.clickedOnceOpen) {
      return false;
    }

    document.body.classList.remove("videoplay-expanded");

    if (window.mayraCode) {
      window.mayraCode.disableCallback();
    }
    window.currentCommandsAudio = {};

    localStorage.setItem("runStep", "1");
    if (window.loadROMExercises) {
      window.loadROMExercises(true);
    }

    // Modified on Aug 7th - for user tracking

    if (document.querySelector("#assesmentDiv video")) {
      document.querySelector("#assesmentDiv video").pause();
      document.querySelector("#assesmentDiv video").removeAttribute("autoplay");
    }

    window.clickedOnceOpen = true;

    if (document.querySelector(".rom-test-start-button")) {
      document.querySelector(".rom-test-start-button").innerHTML = "Loading Movement Check…";
    }

    console.log("Tried open");
    const startARWithDelay = () => {
      if (window.doCameraScreenStart) {
        setTimeout(() => {
          window.doCameraScreenStart();
          setTimeout(() => setIsVisible(true), 100);
          console.log("Tried open - ready");
        }, 800);
      } else {
        let openIntervalCheck = setInterval(() => {
          if (window.doCameraScreenStart) {
            setTimeout(() => {
              window.doCameraScreenStart();
              setTimeout(() => setIsVisible(true), 100);
              console.log("Tried open - ready");
            }, 800);
            clearInterval(openIntervalCheck);
          } else {
            console.log("Tried open - not ready");
          }
        }, 1000);
      }
    };
    startARWithDelay();

    // if (window.doCameraScreenStart) {
    //   window.doCameraScreenStart();
    //   console.log("Tried open - ready");
    // } else {
    //   let openIntervalCheck = setInterval(() => {
    //     if (window.doCameraScreenStart) {
    //       window.doCameraScreenStart();
    //       console.log("Tried open - ready");
    //       clearInterval(openIntervalCheck);
    //     } else {
    //       console.log("Tried open - not ready");
    //     }
    //   }, 1000);
    // }
  }, []);

  if (window.hideMovementProgressUi) return null;

  return (
    <div data-chat-myra-screen-content="true" className={styles.inlineUi} style={{ textAlign: "center" }}>
      <p style={{ fontWeight: 600, marginBottom: 8 }}>Movement Check in Progress</p>
      <p style={{ color: "#6b7280", fontSize: "14px" }}>Follow Myra's voice instructions to complete the movement.</p>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 11: SELF-REPORT STEP 1 — ROM COMPARISON
// No-camera path only. Three option cards (Got smaller / Got bigger /
// Stayed the same). No hard stop on this screen.
// Uses explicit startFlow — not standard useScreenVoice flow.
// ════════════════════════════════════════════════════════════════

function SelfReportROMScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, setMode, showQuestionNuggetMessage }) {
  const [selectedId, setSelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const ContainerRef = useRef(null);
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const selectedIdRef = useRef(null);
  const problemArea = assessmentData?.problemArea || "LBP";
  const displayOptions = useMemo(() => getSelfReportRomDisplayOptions(CONST.SELF_REPORT_ROM.options), []);
  const questionText = MYRA_MESSAGES.selfReportRom?.SELF_REPORT_QUESTION || CONST.SELF_REPORT_ROM.heading;
  const subheading = MYRA_MESSAGES.selfReportRom?.subheading || CONST.SELF_REPORT_ROM.subheading;
  useEffect(() => {
    VoiceService._currentFlow = "flow_selfreport_compare";
    window.currentFlow = "flow_selfreport_compare";
    if (window?.mayraCode) {
      window.mayraCode?.setIsVisible(false);
    }

    if (MyraInteraction && MyraInteraction?.getMode() === "voice") {
      setMode("voice");
      VoiceService._startListening().catch((err) => {
        setTimeout(() => {
          VoiceService._startListening().catch((e) => console.error("[RECONNECT] Retry also failed:", e));
        }, 2000);
      });
    }
  }, [setMode]);

  // Push divider on mount
  useEffect(() => {
    let cancelled = false;
    async function init() {
      // No Myra chat message — the SR card with heading/subheading serves as the prompt

      await showMyraMessage(MYRA_MESSAGES.selfReportRom.SELF_REPORT_ROM_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(questionText, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);
  useEffect(() => {
    window.screenTracker?.enterScreen("self_report_rom");
    return () => {
      window.screenTracker?.exitScreen("self_report_rom", { completed: locked });
    };
  }, []);
  const handleSelect = useCallback(
    async (id, source = "tap") => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setSelectedId(id);
      selectedIdRef.current = id;
      setLocked(true);

      const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === id);
      const displayOpt = getSelfReportRomDisplayOption(opt);

      // Push frozen widget + user echo
      pushToHistory({ type: "frozen-widget", widgetType: "sr_cards", id: nextId(), data: { heading: questionText, options: displayOptions, selectedId: id, subheading } }, { type: "user", text: displayOpt.title, id: nextId() });

      const replyText = MYRA_MESSAGES.selfReportRom?.replyByValue?.[opt.id] || "";
      const continueWithSelection = async () => {
        await showMyraMessage(replyText || MYRA_MESSAGES.selfReportRom?.SELF_REPORT_ROM_POST_TAP || "Thanks for sharing. One more question.", 800);
        onContinue({
          selfReportRom: opt.id,
          selfReportRomPoints: opt.points,
          completed_rom_screen: true,
        });
      };
      if (source !== "tap" && replyText && VoiceService && isVoiceMode) {
        // Wait for speech completion to avoid clipping audio on fast screen transition.
        VoiceService.doSay(replyText, continueWithSelection);
      } else {
        continueWithSelection();
      }
    },
    [onContinue, pushToHistory, showMyraMessage, displayOptions, questionText, subheading, isVoiceMode],
  );

  // Boilerplate only — skip standard flow
  useScreenVoice({
    screenName: "self_report_compare",
    flowName: "flow_selfreport_compare",
    payloadKey: "self_report_compare",
    assessmentData,
    exitReason: "self_report_rom_completed",
    skipFlow: false,
    commands: {
      SELECT_COMPARE: (value) => {
        if (window.exitHandlerOpen) return;
        const normalized = (value || "").toString().trim().toLowerCase();
        console.log("normalized", normalized);
        const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === normalized);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id, "voice_or_chat");
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === selectedIdRef.current);
          if (opt) {
            onContinue({ selfReportRom: opt.id, selfReportRomPoints: opt.points, completed_rom_screen: true });
          }
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === selectedIdRef.current);
          if (opt) {
            onContinue({ selfReportRom: opt.id, selfReportRomPoints: opt.points, completed_rom_screen: true });
          }
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please make your selection before we can move to the next screen");
          }
        }
      },
    },
  });

  const normalizeRomSelection = (action, value) => {
    const a = (action || "").toString().trim().toUpperCase();
    const v = (value || "").toString().trim().toLowerCase();

    // Direct action aliases for "same ROM"
    if (a === "SELF_REPORT_CONSISTENT" || a === "SYMPTOM_SAME") {
      return "rom_same";
    }

    // Value aliases for "same ROM"
    if (v === "same" || v === "rom_same" || v === "rom-same" || v === "romsame" || v === "consistent" || v === "full_range" || v === "full range") {
      return "rom_same";
    }

    // Value aliases for "smaller ROM"
    if (v === "smaller" || v === "less" || v === "reduced" || v === "rom_smaller" || v === "rom-smaller" || v === "romsmaller") {
      return "rom_smaller";
    }

    // Value aliases for "bigger ROM"
    if (v === "bigger" || v === "larger" || v === "more" || v === "improved" || v === "rom_bigger" || v === "rom-bigger" || v === "rombigger") {
      return "rom_bigger";
    }

    return null;
  };

  const selectRomFromCommand = (action, value) => {
    if (window.exitHandlerOpen) return;

    const normalized = normalizeRomSelection(action, value);
    const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === normalized);

    if (opt && !lockedRef.current) {
      handleSelect(opt.id, "voice_or_chat");
    } else {
      console.warn("[SelfReportROM] Ignored command", {
        action,
        value,
        normalized,
        validOptions: CONST.SELF_REPORT_ROM.options.map((o) => o.id),
      });
    }
  };

  // Manual flow start + command registration
  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;
    window.mayraForwardCode = {
      midjourneyData: generatePayloadForScreen("self_report_compare", assessmentData),
    };
    if (isVoiceMode) {
      mayraCode.startFlow("flow_selfreport_compare", "self_report_compare");
    } else {
      VoiceService.startFlowWithoutAnnouncement("flow_selfreport_compare");
    }

    window.currentCommandsAudio = {
      SELECT_COMPARE: (value) => {
        selectRomFromCommand("SELECT_COMPARE", value);
      },

      SELF_REPORT_CONSISTENT: (value) => {
        selectRomFromCommand("SELF_REPORT_CONSISTENT", value);
      },

      SYMPTOM_SAME: (value) => {
        selectRomFromCommand("SYMPTOM_SAME", value);
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === selectedIdRef.current);
          if (opt) {
            onContinue({ selfReportRom: opt.id, selfReportRomPoints: opt.points, completed_rom_screen: true });
          }
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === selectedIdRef.current);
          if (opt) {
            onContinue({ selfReportRom: opt.id, selfReportRomPoints: opt.points, completed_rom_screen: true });
          }
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please make your selection before we can move to the next screen");
          }
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!ready) return null;

  return (
    <div className={styles.inlineUi2} ref={ContainerRef}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          {displayOptions.map((opt) => (
            <div key={opt.id} className={styles.chipPair}>
              <div className={`${styles.optionCard} ${selectedId === opt.id ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(opt.id, "tap")}>
                {opt.title}
              </div>
              {/* {opt.subtitle && <div className={styles.chipHelper}>{opt.subtitle}</div>} */}
            </div>
          ))}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 12: SELF-REPORT STEP 2 — TEMPO / SPEED
// No-camera path only. Three option cards.
// "Couldn't finish" → safety hard stop.
// Sets cameraUsed: false so backend uses self-report Pillar 4 logic.
// ════════════════════════════════════════════════════════════════

function SelfReportTempoScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, onHardStop, showQuestionNuggetMessage }) {
  const [selectedId, setSelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const selectedIdRef = useRef(null);
  const problemArea = assessmentData?.problemArea || "LBP";
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  if (window?.mayraCode) {
    window.mayraCode?.setIsVisible(false);
  }

  // Push divider on mount
  useEffect(() => {
    let cancelled = false;
    async function init() {
      // Show Myra message
      await showMyraMessage(MYRA_MESSAGES.selfReportTempo.SELF_REPORT_TEMPO_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(CONST.SELF_REPORT_TEMPO.heading, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);
  useEffect(() => {
    window.screenTracker?.enterScreen("self_report_tempo");
    return () => {
      window.screenTracker?.exitScreen("self_report_tempo", { completed: locked });
    };
  }, []);

  const handleSelect = useCallback(
    async (id, source = "tap") => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setSelectedId(id);
      selectedIdRef.current = id;
      setLocked(true);

      const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === id);

      // Push frozen widget + user echo
      pushToHistory({ type: "frozen-widget", widgetType: "sr_cards", id: nextId(), data: { heading: CONST.SELF_REPORT_TEMPO.heading, options: CONST.SELF_REPORT_TEMPO.options, selectedId: id, subheading: CONST.SELF_REPORT_TEMPO.subheading } }, { type: "user", text: opt.title, id: nextId() });

      // "Couldn't finish" → hard stop, no voice reply
      if (opt.outcome === "HARD_STOP") {
        onHardStop();
        return;
      }

      const replyText = MYRA_MESSAGES.selfReportTempo?.replyByValue?.[opt.id] || "";
      const continueWithSelection = async () => {
        await showMyraMessage(replyText || MYRA_MESSAGES.selfReportTempo?.SELF_REPORT_TEMPO_POST_TAP_CONTINUE || "Thanks — one more question about the movement.", 800);
        onContinue({
          selfReportSpeed: opt.id,
          selfReportPace: opt.id,
          selfReportSpeedPoints: opt.points,
          cameraUsed: false,
          completed_speed_screen: true,
        });
      };
      console.log("source", source);
      if (source !== "tap" && replyText && VoiceService && isVoiceMode) {
        // Wait for speech completion to avoid clipping audio on fast screen transition.
        VoiceService.doSay(replyText, continueWithSelection);
      } else {
        continueWithSelection();
      }
    },
    [onContinue, onHardStop, pushToHistory, showMyraMessage],
  );

  // Boilerplate only — skip standard flow
  useScreenVoice({
    screenName: "self_report_speed",
    flowName: "flow_selfreport_speed",
    payloadKey: "self_report_speed",
    assessmentData,
    exitReason: "self_report_tempo_completed",
    skipFlow: false,
    commands: {
      SELECT_SPEED: (value) => {
        if (window.exitHandlerOpen) return;
        const normalized = (value || "").toString().trim().toLowerCase();
        console.log("normalized", normalized);
        const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === normalized);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id, "voice_or_chat");
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === selectedIdRef.current);
          if (opt && opt.outcome !== "HARD_STOP") {
            onContinue({
              selfReportSpeed: opt.id,
              selfReportPace: opt.id,
              selfReportSpeedPoints: opt.points,
              cameraUsed: false,
              completed_speed_screen: true,
            });
          }
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === selectedIdRef.current);
          if (opt && opt.outcome !== "HARD_STOP") {
            onContinue({
              selfReportSpeed: opt.id,
              selfReportPace: opt.id,
              selfReportSpeedPoints: opt.points,
              cameraUsed: false,
              completed_speed_screen: true,
            });
          }
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please make your selection before we can move to the next screen");
          }
        }
      },
    },
  });

  // Manual flow start + command registration
  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;
    window.mayraForwardCode = {
      midjourneyData: generatePayloadForScreen("self_report_speed", assessmentData),
    };
    if (isVoiceMode) {
      mayraCode.startFlow("flow_selfreport_speed", "flow_selfreport_speed");
    } else {
      VoiceService.startFlowWithoutAnnouncement("flow_selfreport_speed");
    }

    window.currentCommandsAudio = {
      SELECT_SPEED: (value) => {
        if (window.exitHandlerOpen) return;
        const normalized = (value || "").toString().trim().toLowerCase();
        console.log("normalized", normalized);
        const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === normalized);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id, "voice_or_chat");
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === selectedIdRef.current);
          if (opt && opt.outcome !== "HARD_STOP") {
            onContinue({
              selfReportSpeed: opt.id,
              selfReportPace: opt.id,
              selfReportSpeedPoints: opt.points,
              cameraUsed: false,
              completed_speed_screen: true,
            });
          }
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === selectedIdRef.current);
          if (opt && opt.outcome !== "HARD_STOP") {
            onContinue({
              selfReportSpeed: opt.id,
              selfReportPace: opt.id,
              selfReportSpeedPoints: opt.points,
              cameraUsed: false,
              completed_speed_screen: true,
            });
          }
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please make your selection before we can move to the next screen");
          }
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!ready) return null;

  return (
    <>
      <div className={styles.inlineUi2}>
        {!locked ? (
          <div className={styles.chipPairStack}>
            {CONST.SELF_REPORT_TEMPO.options.map((opt) => (
              <div key={opt.id} className={styles.chipPair}>
                <div className={`${styles.optionCard} ${selectedId === opt.id ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(opt.id, "tap")}>
                  {opt.title}
                </div>
                {/* {opt.subtitle && <div className={styles.chipHelper}>{opt.subtitle}</div>} */}
              </div>
            ))}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </>
  );
}

// UTILITY: deriveDirectionalChange
// Compares first-half mean vs second-half mean of a per-rep array
// to produce a directional label for the Symptom 1 synthesis.
// Tolerance: ±25% relative change = "same".
// Returns null if input is empty/invalid; caller decides fallback.
// kind: "rom"   → returns "same" | "bigger" | "smaller"
// kind: "tempo" → returns "kept_up" | "slowed_down"
//   (tempo uses rep DURATION; longer late reps = slowed down)
// ════════════════════════════════════════════════════════════════

function deriveDirectionalChange(values, kind) {
  if (!Array.isArray(values) || values.length < 2) return null;

  const half = Math.floor(values.length / 2);
  const firstHalf = values.slice(0, half);
  const secondHalf = values.slice(values.length - half);

  const mean = (arr) => arr.reduce((sum, v) => sum + v, 0) / arr.length;
  const firstMean = mean(firstHalf);
  const secondMean = mean(secondHalf);

  if (firstMean === 0) return kind === "rom" ? "same" : "kept_up";

  const relativeChange = (secondMean - firstMean) / firstMean;
  const TOLERANCE = 0.25;

  if (kind === "rom") {
    if (relativeChange > TOLERANCE) return "bigger";
    if (relativeChange < -TOLERANCE) return "smaller";
    return "same";
  }

  // tempo: secondMean larger than firstMean means later reps took LONGER
  if (kind === "tempo") {
    if (relativeChange > TOLERANCE) return "slowed_down";
    return "kept_up";
  }

  return null;
}

// ════════════════════════════════════════════════════════════════
// AI PROCESSING LOADER
// Shown while Feel Affect waits for backend customSpeech.
// Blocks UI interaction with an overlay.
// ════════════════════════════════════════════════════════════════

function AIProcessingLoader({ isVisible }) {
  if (!isVisible) return null;

  return (
    <div className={styles.msgRowMyra}>
      <div className={styles.msgAvatar}>M</div>
      <div className={styles.typingDots} aria-label="Myra is typing">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 13: RPE (Rate of Perceived Exertion)
// 5 RPE circles (1/3/5/7/9). Uses flow_rpe with manual startFlow.
// Extracts ROM/dur from parseDataAfterInfo() on mount.
// Cleans up window.movementTestPayload.
// ════════════════════════════════════════════════════════════════

function RPEScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, setMode, showQuestionNuggetMessage }) {
  const [selectedRPE, setSelectedRPE] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const selectedRef = useRef(null);
  const ContainerRef = useRef(null);
  const romDurRef = useRef({ rom: [], dur: [] });
  const isVoiceMode = MyraInteraction.getMode() === "voice";

  useEffect(() => {
    if (window?.mayraCode) {
      window.mayraCode?.setIsVisible(false);
    }
    if (MyraInteraction && MyraInteraction?.getMode() === "voice") {
      setMode("voice");
    }
  }, [setMode]);

  // Extract ROM/dur on mount and clean up AR config
  useEffect(() => {
    romDurRef.current = parseDataAfterInfo();
    window.movementTestPayload = null;
  }, []);
  useEffect(() => {
    window.screenTracker?.enterScreen("test1_rpe");
    return () => {
      window.screenTracker?.exitScreen("test1_rpe", { completed: locked });
    };
  }, []);
  const completedTestName = CONST.TEST_MAP[assessmentData?.probableSubtype]?.name || "the movement";
  useEffect(() => {
    if (window?.currnetScreen === "rpe" && ready) {
      if (isVoiceMode) {
        pushToHistory({
          type: "voice-indicator",
          text: `Great job — you completed the ${completedTestName}. Let me ask you a couple of follow-up questions.`,
          id: nextId(),
        });
      }
      window.currnetScreen = "";
    }
  }, [pushToHistory, completedTestName, ready]);

  // Push divider + voice indicator + Myra message on mount
  useEffect(() => {
    let cancelled = false;
    async function init() {
      if (isVoiceMode) {
        pushToHistory({ type: "voice-indicator", id: nextId() });
      }
      await showMyraMessage(MYRA_MESSAGES.rpe.RPE_SETUP_BEAT_BY_PATH.granted, 800);
      await showQuestionNuggetMessage(MYRA_MESSAGES.rpe.RPE_QUESTION, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleContinue = useCallback(() => {
    if (selectedRef.current === null || lockedRef.current) return;
    lockedRef.current = true;
    setLocked(true);

    const { rom, dur } = romDurRef.current;
    onContinue({
      rpe: selectedRef.current,
      rom,
      duration: dur,
    });
  }, [onContinue]);

  useScreenVoice({
    screenName: "test1_rpe",
    flowName: "flow_rpe",
    payloadKey: "test1_rpe",
    assessmentData,
    exitReason: "rpe_completed",
    skipFlow: false,
    commands: {
      SELECT_RPE: (value) => {
        console.log("useScreenVoice: SELECT_RPE");
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        const numVal = parseInt(value);
        // if (isNaN(numVal)) return;

        const responseText = CONST.getRpeResponseText(numVal);
        if (MyraInteraction.getMode() === "voice") {
          VoiceService?.doSay(responseText, () => {
            // setSelectedRPE(numVal);
            // selectedRef.current = numVal;
            handleSelect(numVal);
          });
        } else {
          // setSelectedRPE(numVal);
          // selectedRef.current = numVal;
          handleSelect(numVal);
        }
        // lockedRef.current = true;
        // setLocked(true);
        // VoiceService?.doSay(responseText, () => {
        //   setSelectedRPE(numVal);
        //   selectedRef.current = numVal;
        //   setTimeout(() => {
        //     const { rom, dur } = romDurRef.current;
        //     onContinue({ rpe: numVal, rom, duration: dur });
        //   }, 500);
        // });
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedRef.current !== null) {
          const { rom, dur } = romDurRef.current;
          onContinue({ rpe: selectedRef.current, rom, duration: dur, submitted_rpe_1: true });
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedRef.current !== null) {
          const { rom, dur } = romDurRef.current;
          onContinue({ rpe: selectedRef.current, rom, duration: dur, submitted_rpe_1: true });
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please select how challenging the exercise was before we continue.");
          }
        }
      },
    },
  });

  // Manual flow start + command registration
  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;

    window.mayraForwardCode = {
      midjourneyData: generatePayloadForScreen("test1_rpe", assessmentData),
    };
    VoiceService._currentFlow = "flow_rpe";
    window.currentFlow = "flow_rpe";
    if (isVoiceMode && mayraCode?.startFlow) {
      mayraCode.startFlow("flow_rpe", "rpe");
    } else {
      VoiceService?.startFlowWithoutAnnouncement?.("flow_rpe");
    }

    window.currentCommandsAudio = {
      SELECT_RPE: (value) => {
        console.log("Window currentCommandsAudio : SELECT_RPE");
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        const numVal = parseInt(value);
        // if (isNaN(numVal)) return;

        const responseText = CONST.getRpeResponseText(numVal);
        if (MyraInteraction.getMode() === "voice") {
          VoiceService?.doSay(responseText, () => {
            // setSelectedRPE(numVal);
            // selectedRef.current = numVal;
            handleSelect(numVal);
          });
        } else {
          // setSelectedRPE(numVal);
          // selectedRef.current = numVal;
          handleSelect(numVal);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedRef.current !== null) {
          const { rom, dur } = romDurRef.current;
          onContinue({ rpe: selectedRef.current, rom, duration: dur, submitted_rpe_1: true });
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedRef.current !== null) {
          const { rom, dur } = romDurRef.current;
          onContinue({ rpe: selectedRef.current, rom, duration: dur, submitted_rpe_1: true });
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please select how challenging the exercise was before we continue.");
          }
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelect = useCallback(
    async (val) => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setSelectedRPE(val);
      selectedRef.current = val;
      setLocked(true);

      const label = CONST.RPE_OPTIONS.find((o) => o.value === val)?.label || val;

      // Push frozen widget + user echo
      pushToHistory({ type: "frozen-widget", widgetType: "rpe_options", id: nextId(), data: { selectedValue: val } }, { type: "user", text: `Effort: ${label}`, id: nextId() });

      // Confirmation message
      await showMyraMessage(MYRA_MESSAGES.rpe?.RPE_POST_TAP || "Got it. One last question about how that movement affected your symptoms.", 800);

      // Auto-advance
      const { rom, dur } = romDurRef.current;
      onContinue({ rpe: val, rom, duration: dur, submitted_rpe_1: true });
    },
    [onContinue, pushToHistory, showMyraMessage],
  );

  if (!ready) return null;

  return (
    <>
      <div className={styles.inlineUi2} ref={ContainerRef}>
        {!locked ? (
          <div className={styles.chipPairStack}>
            {CONST.RPE_OPTIONS2.map((chip) => (
              <div key={chip.id} className={styles.chipPair}>
                <button className={`${styles.optionCard} ${selectedRPE === chip.value ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(chip.value)}>
                  {chip.label}
                </button>
                {/* <div className={styles.chipHelper}>{chip.helper}</div> */}
              </div>
            ))}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 14: FEEL AFFECT (Symptom Response 1)
// 3 option cards: IMPROVED / TOLERABLE / WORSENED.
// Enriched mayraForwardCode for backend AI analysis.
// AIProcessingLoader with 60s timeout.
// Subtype override/reclassification logic.
// ════════════════════════════════════════════════════════════════
function FeelAffectScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, showQuestionNuggetMessage }) {
  const [symptomResponse, setSymptomResponse] = useState(null);
  const [locked, setLocked] = useState(false);
  const [isAIProcessing, setIsAIProcessing] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const symptomResponseRef = useRef(null);
  const hasContinuedRef = useRef(false);
  const aiCheckRef = useRef(null);
  const aiTimeoutRef = useRef(null);
  const pendingOptRef = useRef(null); // Store opt for when speech arrives
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const aiProcessingTimeoutRef = useRef(null);
  const startAIProcessingTimeout = () => {
    clearTimeout(aiProcessingTimeoutRef.current);

    aiProcessingTimeoutRef.current = setTimeout(() => {
      console.warn("AI processing timeout reached — forcing reset");

      setIsAIProcessing(false);
      pendingOptRef.current = null;
      hasContinuedRef.current = false;
      lockedRef.current = false;
      setLocked(false);
    }, 60000); // 1 minute
  };
  const clearAIProcessingTimeout = () => {
    clearTimeout(aiProcessingTimeoutRef.current);
  };

  const problemArea = assessmentData.problemArea || "LBP";
  const currentSubtype = assessmentData.probableSubtype || "NEUTRAL_SENSITIVE";

  // Push divider + voice indicator + Myra message on mount
  useEffect(() => {
    let cancelled = false;
    async function init() {
      if (isVoiceMode) {
        pushToHistory({ type: "voice-indicator", id: nextId() });
      }
      await showMyraMessage(MYRA_MESSAGES.feelAffect.FEEL_AFFECT_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(MYRA_MESSAGES.feelAffect.FEEL_AFFECT_QUESTION, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);
  useEffect(() => {
    window.screenTracker?.enterScreen("test1_symptoms");
    return () => {
      window.screenTracker?.exitScreen("test1_symptoms", { completed: locked });
    };
  }, []);

  // Fallback speech by symptom value
  const getFallbackSpeech = useCallback((value) => {
    if (value === "IMPROVED") return "That's great to hear — it tells me a lot about what direction works for you.";
    if (value === "TOLERABLE") return "Thanks for letting me know. That's useful information for building your plan.";
    return "Thanks for telling me — that's actually very useful information. It helps me adjust your classification.";
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      clearInterval(aiCheckRef.current);
      clearTimeout(aiTimeoutRef.current);
      clearTimeout(aiProcessingTimeoutRef.current);
    };
  }, []);

  // Resolve override and routing
  const resolveAndContinue = useCallback(
    async (opt) => {
      if (hasContinuedRef.current) return;
      hasContinuedRef.current = true;
      pendingOptRef.current = null;
      let finalSubtype = currentSubtype;
      let diagnosisChanged = false;
      let degradation = null;
      let timing = null;
      let cpgForBackend = assessmentData.cpgForBackend;
      window.flowSymptomPayload = null;

      if (opt.value === "WORSENED") {
        diagnosisChanged = true;

        if (problemArea === "LBP") {
          finalSubtype = "NEUTRAL_SENSITIVE";
          degradation = "First Test Felt Worse — LBP reclassified to Neutral Sensitive";
        } else {
          const overrideTarget = CONST.CLINICAL_PATHS[problemArea]?.overrideTarget;
          finalSubtype = overrideTarget || currentSubtype;
          degradation = "First Test Felt Worse — reclassified to override target";
          if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[finalSubtype]) {
            cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][finalSubtype];
          }
        }
        timing = "post_test1_symptom";

        // await showMyraMessage(MYRA_MESSAGES.feelAffect?.worsenedOverride || "Thanks for telling me — that's actually very useful information. It helps me adjust your classification. Let's move on to personalizing your plan.", 800);
        onContinue(
          {
            symptomResponse: opt.value,
            symptomResponse1: opt.value,
            submitted_symptoms_2: true,
            diagnosisChanged,
            degradation,
            timing,
            finalPainSubtype: finalSubtype,
            probableSubtype: finalSubtype,
            cpgForBackend,
            wasOverridden: true,
            overrideReason: "First Test Felt Worse",
          },
          // "personalize",
          window.is_access_user ? "personalize" : "plan",
        );
        return;
      }

      if (problemArea === "LBP" && currentSubtype === "ROTATIONAL_INTOLERANT" && opt.value === "IMPROVED") {
        finalSubtype = "FLEXION_INTOLERANT";
        diagnosisChanged = true;
        degradation = "Directional Preference Overwrite — positive extension response";
        timing = "post_test1_symptom";

        await showMyraMessage(MYRA_MESSAGES.feelAffect?.rotationalImprovedOverride || "That's great feedback — it tells me a lot about what direction works for you. Let's move on.", 800);
        onContinue(
          {
            symptomResponse: opt.value,
            symptomResponse1: opt.value,
            submitted_symptoms_2: true,
            diagnosisChanged,
            degradation,
            timing,
            finalPainSubtype: finalSubtype,
            probableSubtype: finalSubtype,
            wasOverridden: true,
            overrideReason: degradation,
          },
          // "personalize",
          window.is_access_user ? "personalize" : "plan",
        );
        return;
      }

      const finalFields = {
        symptomResponse: opt.value,
        symptomResponse1: opt.value,
        submitted_symptoms_2: true,
        diagnosisChanged,
        degradation,
        timing,
        finalPainSubtype: finalSubtype,
        probableSubtype: diagnosisChanged ? finalSubtype : currentSubtype,
        wasOverridden: diagnosisChanged,
        overrideReason: diagnosisChanged ? degradation : null,
      };

      if (diagnosisChanged && cpgForBackend !== assessmentData.cpgForBackend) {
        finalFields.cpgForBackend = cpgForBackend;
      }

      const test2 = CONST.getNegativeTest(finalSubtype, problemArea);
      window.symptomSpeech = "";
      let leaveMessage = opt.label;
      if (opt.value === "IMPROVED" && test2) {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.IMPROVED_HAS_TEST_2;
      } else if (opt.value === "IMPROVED" && !test2) {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.IMPROVED_HAS_TEST_2;
      } else if (opt.value === "TOLERABLE" && test2) {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.TOLERABLE_HAS_TEST_2;
      } else if (opt.value === "TOLERABLE" && !test2) {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.TOLERABLE_HAS_TEST_2;
      } else {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.WORSENED;
      }
      if (window.is_access_user) {
        onContinue(finalFields, "personalize");
      } else {
        onContinue(finalFields, "personalize");
      }
    },
    [currentSubtype, problemArea, assessmentData.cpgForBackend, onContinue, showMyraMessage],
  );

  const showSymptomAckAndContinue = useCallback(
    async (opt, speech) => {
      const isVoiceMode = MyraInteraction.getMode() === "voice";
      clearAIProcessingTimeout();
      setIsAIProcessing(false);

      await showMyraMessage(speech, 800);

      if (isVoiceMode && window.mayraCode) {
        window.mayraCode.doSay(speech, () => {
          resolveAndContinue(opt);
        });
      } else {
        resolveAndContinue(opt);
      }
    },
    [resolveAndContinue, showMyraMessage],
  );

  // Handle the AI processing and speech announcement
  const processWithAI = useCallback(
    (opt, customSpeech) => {
      const isVoiceMode = MyraInteraction.getMode() === "voice";
      const speech = window.symptomSpeech || customSpeech || getFallbackSpeech(opt.value);

      console.log("🤖 processWithAI called:", {
        mode: isVoiceMode ? "voice" : "chat",
        hasSpeech: !!customSpeech,
        value: opt.value,
      });
      setIsAIProcessing(true);
      startAIProcessingTimeout();

      // Announce the AI processing message
      const processingMessage = "Thanks for your effort — let me take a moment to look at your results.";
      // VoiceService?.doSay(processingMessage);

      setTimeout(() => {
        showSymptomAckAndContinue(opt, speech);
      }, 500);
    },
    [getFallbackSpeech, showSymptomAckAndContinue],
  );
  const announceAndContinue = useCallback(
    (opt, customSpeech) => {
      // if (hasContinuedRef.current) return;

      setIsAIProcessing(true);
      startAIProcessingTimeout();
      const speech = window.symptomSpeech || customSpeech || getFallbackSpeech(opt.value);

      showSymptomAckAndContinue(opt, speech);
    },
    [getFallbackSpeech, showSymptomAckAndContinue],
  );

  const handleSelect = useCallback(
    (id) => {
      if (lockedRef.current || isAIProcessing) return;
      lockedRef.current = true;
      setLocked(true);

      const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.id === id);
      setSymptomResponse(opt.value);
      symptomResponseRef.current = opt.value;

      // STORE the opt for potential async speech - UNCOMMENT THIS
      pendingOptRef.current = opt;

      const symptomData = {
        type: "symptom_selection",
        data: { action: "SELECT_SYMPTOM", value: opt.value },
      };
      if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        VoiceService._ws.send(JSON.stringify(symptomData));
        console.log(symptomData);
      } else {
        VoiceService.startFlowWithoutAnnouncement("flow_symptom");
        setTimeout(() => {
          if (VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
            VoiceService._ws.send(JSON.stringify(symptomData));
          }
        }, 1000);
        console.error("WebSocket not connected");
      }

      // Push frozen widget + user echo - UNCOMMENT THIS
      let leaveMessage = opt.label;
      if (opt.value === "IMPROVED") {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.IMPROVED_HAS_TEST_2;
      } else if (opt.value === "TOLERABLE") {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.TOLERABLE_HAS_TEST_2;
      } else {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.WORSENED;
      }
      pushToHistory(
        {
          type: "frozen-widget",
          widgetType: "affect_options",
          id: nextId(),
          data: { selectedValue: opt.value },
        },
        { type: "user", text: opt.label, id: nextId() },
      );

      // Set timeout for fallback speech
      setTimeout(() => {
        if (pendingOptRef.current && !hasContinuedRef.current) {
          console.log("Using fallback speech for:", pendingOptRef.current.value);
          announceAndContinue(pendingOptRef.current, null);
          pendingOptRef.current = null;
        }
      }, 5000);
    },
    [isAIProcessing, pushToHistory, announceAndContinue],
  );
  // useScreenVoice for boilerplate only — flow handled manually
  useScreenVoice({
    screenName: "test1_symptoms",
    trackerName: "symptom1",
    flowName: "flow_symptom",
    payloadKey: "test1_symptoms",
    assessmentData,
    exitReason: "symptom1_completed",
    skipFlow: false,
    commands: {
      SELECT_SYMPTOM: (value, speech, intent) => {
        console.log("SELECT_SYMPTOM triggered with:", { value, speech, intent });

        if (window.exitHandlerOpen) return;

        // If we have speech from backend, use it
        if (speech && pendingOptRef.current) {
          // Clear the timeout since we got speech
          if (window._speechTimeout) {
            clearTimeout(window._speechTimeout);
            window._speechTimeout = null;
          }
          // Process with the custom speech
          processWithAI(pendingOptRef.current, speech);
          pendingOptRef.current = null;
          return;
        }

        const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === value || o.id === value);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && symptomResponseRef.current) {
          const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === symptomResponseRef.current);
          if (opt) resolveAndContinue(opt);
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (symptomResponseRef.current) {
          const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === symptomResponseRef.current);
          if (opt) resolveAndContinue(opt);
        } else {
          if (isVoiceMode) {
            window.VoiceService?.doSay("Please select how the movement made your symptoms feel.");
          }
        }
      },
    },
  });

  // Manual flow start with enriched mayraForwardCode
  const flowStartedRef = useRef(false);

  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;
    if (flowStartedRef.current) return;
    if (assessmentData?.rpe == null) return;

    const { rom, dur } = parseDataAfterInfo();
    const romValues = rom || [];
    const durValues = dur || [];
    let romChange;
    let tempoChange;

    if (assessmentData.cameraUsed === false) {
      const romAnswer = assessmentData.selfReportRom;
      if (romAnswer === "rom_bigger") romChange = "bigger";
      else if (romAnswer === "rom_smaller") romChange = "smaller";
      else romChange = "same";

      const tempoAnswer = assessmentData.selfReportSpeed;
      if (tempoAnswer === "tempo_slower") tempoChange = "slowed_down";
      else tempoChange = "kept_up";
    } else {
      // Camera path: compute from per-rep data captured during Movement Check 1.
      const { rom, dur } = parseDataAfterInfo();
      romChange = deriveDirectionalChange(rom || [], "rom") || "same";
      tempoChange = deriveDirectionalChange(dur || [], "tempo") || "kept_up";
    }

    // Data source for the Claude synthesis prompt: "camera" when the camera
    // tracked the movement, "self_report" when the user answered questions.
    const dataSource = assessmentData.cameraUsed === false ? "self_report" : "camera";
    let whatsNext = /* TODO: source whats_next */ "personalize"; // this will resend after user makes a choise and backend will update it

    window.mayraForwardCode = {
      romChange,
      tempoChange,
      data_source: dataSource,
      whats_next: whatsNext,
      rpe: assessmentData.rpe,
      painLocations: assessmentData.selectedZones,
      symptomDuration: assessmentData.symptomDuration,
      preTestNPRS: assessmentData.painLevel,
      midjourneyData: generatePayloadForScreen("test1_symptoms", assessmentData),
      symptomType: "initial",
    };
    window.flowSymptomPayload = {
      romChange,
      tempoChange,
      data_source: dataSource,
      whats_next: whatsNext,
      rpe: assessmentData.rpe,
      painLocations: assessmentData.selectedZones,
      symptomDuration: assessmentData.symptomDuration,
      preTestNPRS: assessmentData.painLevel,
      midjourneyData: generatePayloadForScreen("test1_symptoms", assessmentData),
      symptomType: true,
    };

    if (isVoiceMode && mayraCode.startFlow) {
      mayraCode.startFlow("flow_symptom", "symptom1");
    } else {
      VoiceService?.startFlowWithoutAnnouncement?.("flow_symptom");
    }

    window.currentCommandsAudio = {
      SELECT_SYMPTOM: (value, speech, intent) => {
        console.log("SELECT_SYMPTOM triggered with:", { value, speech, intent });
        if (window.exitHandlerOpen) return;

        // If we have speech from backend, use it
        if (speech && pendingOptRef.current) {
          if (window._speechTimeout) {
            clearTimeout(window._speechTimeout);
            window._speechTimeout = null;
          }
          processWithAI(pendingOptRef.current, speech);
          pendingOptRef.current = null;
          return;
        }

        const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === value || o.id === value);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && symptomResponseRef.current) {
          const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === symptomResponseRef.current);
          if (opt) resolveAndContinue(opt);
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (symptomResponseRef.current) {
          const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === symptomResponseRef.current);
          if (opt) resolveAndContinue(opt);
        } else {
          if (isVoiceMode) {
            window.VoiceService?.doSay("Please select how the movement made your symptoms feel.");
          }
        }
      },
    };

    flowStartedRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentData?.rpe, assessmentData?.selectedZones, assessmentData?.symptomDuration, assessmentData?.painLevel, assessmentData?.cpgForBackend, assessmentData?.probableSubtype, assessmentData?.problemArea, isVoiceMode, handleSelect, processWithAI, resolveAndContinue]);

  if (!ready) return null;

  return (
    <>
      {!locked ? (
        <div className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {CONST.FEEL_AFFECT_OPTIONS.map((o) => (
              <div key={o.id} className={styles.chipPair}>
                <div className={`${styles.optionCard} ${symptomResponse === o.value ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(o.id)}>
                  {o.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <AIProcessingLoader isVisible={isAIProcessing} />
    </>
  );
}
// ════════════════════════════════════════════════════════════════
// SCREEN 17: FEEDBACK 2 (Symptom Response 2)
// Single screen: Myra setup → question → inline Test 2 demo video → 3 option cards.
// Three buttons (Can't even try / Felt Worse / Felt Better) → two outcomes (WORSE / BETTER).
// Uses flow_symptom / symptom2.
// ════════════════════════════════════════════════════════════════

function Feedback2Screen({ assessmentData, pushToHistory, speakChatTextIfVoice, showMyraMessage, scrollToBottom, onContinue, setMode, showQuestionNuggetMessage }) {
  const [feedback2SelectedId, setFeedback2SelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const feedback2ResponseRef = useRef(null);
  const feedback2SelectedIdRef = useRef(null);
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const ContainerRef = useRef(null);
  const videoRef = useRef(null);

  // Resolve test 1 + test 2 names and the plain-language description for test 2
  const subtype = assessmentData.probableSubtype || assessmentData.finalPainSubtype || "NEUTRAL_SENSITIVE";
  const problemArea = assessmentData.problemArea || "LBP";
  const test1Name = CONST.TEST_MAP[subtype]?.name || "the first movement";
  const test2 = CONST.getNegativeTest(subtype, problemArea);
  const test2Name = test2?.name || "";
  const test2Description = CONST.TEST_PLAIN_DESCRIPTIONS?.[test2Name] || "do this movement";
  const introVideoUrl = CONST.TEST_INTRO_VIDEOS?.[test2Name] || test2?.video || "";
  const testTwo = test2Name ? test2Name : test2Description;

  useEffect(() => {
    if (window?.mayraCode) {
      window.mayraCode?.setIsVisible(false);
    }
    if (MyraInteraction && MyraInteraction?.getMode() === "voice") {
      setMode("voice");
    }
  }, [setMode]);

  // ── Push setup + question on mount ──
  useEffect(() => {
    let cancelled = false;
    async function init() {
      // await showMyraMessage(MYRA_MESSAGES.feedback2.FEEDBACK_2_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(resolveMessage(MYRA_MESSAGES.feedback2.FEEDBACK_2_QUESTION, { test1Name, testTwo }), "", 900);
      if (isVoiceMode) {
        speakChatTextIfVoice(resolveMessage(MYRA_MESSAGES.feedback2.FEEDBACK_2_QUESTION, { test1Name, testTwo }));
      }
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    window.currentFlow = "flow_movement_questions";
    if (VoiceService) VoiceService._currentFlow = "flow_movement_questions";
    window.screenTracker?.enterScreen("symptom2");
    return () => {
      window.screenTracker?.exitScreen("symptom2", { completed: locked });
      if (window.currentFlow === "flow_movement_questions") {
        window.currentFlow = null;
      }
    };
  }, []);

  const handleSelect = useCallback(
    async (id, speech) => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setLocked(true);

      const opt = CONST.FEEDBACK2_OPTIONS.find((o) => o.id === id);
      if (!opt) return;
      setFeedback2SelectedId(opt.id);
      feedback2SelectedIdRef.current = opt.id;
      feedback2ResponseRef.current = opt.value;

      // Pause + clean the inline demo video
      if (videoRef.current) {
        try {
          videoRef.current.pause();
          videoRef.current.removeAttribute("src");
          videoRef.current.load();
        } catch (e) {
          // ignore
        }
      }

      // Push frozen widget + user echo
      // pushToHistory({ type: "user", text: getFeedback2OptionLabel(opt), id: nextId() });

      const ackText = (typeof speech === "string" && speech.trim()) || MYRA_MESSAGES.feedback2?.FEEDBACK_2_ACK || "That locks it in. Let's personalize your plan.";
      if (isVoiceMode) {
        speakChatTextIfVoice(ackText);
      }
      await showMyraMessage(ackText, 700);

      const { rom, dur } = parseDataAfterInfo();
      onContinue({
        symptomResponseConfirm: opt.value,
        rom2: rom,
        duration2: dur,
        rom_test2_started: true,
        rom_test2_completed: true,
        submitted_symptoms_2: true,
      });
    },
    [onContinue, showMyraMessage, isVoiceMode, speakChatTextIfVoice],
  );

  // The Beacon SELECT_SYMPTOM command path is retired on this screen.
  // Comparison answers (typed and voice) route to the movement prompt via
  // flow_movement_questions, same as movement_q1/q2. useScreenVoice removed
  // with it; verify voice input on this screen when voice mode is enabled.

  // Overlay payload registration. The flow_symptom startup and the
  // SELECT_SYMPTOM / continue / move-on command registrations are retired.
  // The screen runs on flow_movement_questions and all answers route to the
  // movement prompt.
  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;

    window.mayraForwardCode = {
      midjourneyData: generatePayloadForScreen("symptom2", assessmentData),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2} ref={ContainerRef}>
      {!locked ? (
        <>
          {introVideoUrl ? (
            <div className={styles.videoContainer}>
              <video ref={videoRef} src={introVideoUrl} controls playsInline preload="metadata" />
            </div>
          ) : null}
          <div className={styles.feedback2Options}>
            {/* {CONST.FEEDBACK2_OPTIONS.map((o) => (
              <div key={o.id} className={`${styles.feedback2Btn} ${feedback2SelectedId === o.id ? styles.selected : ""}`} onClick={() => handleSelect(o.id)}>
                {getFeedback2OptionLabel(o)}
              </div>
            ))} */}
          </div>
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// HARD STOP SCREEN
// Safety termination — hides Myra, shows empathy + recommendation.
// Triggered by: safety symptoms, Test 1 pain, "couldn't finish".
// ════════════════════════════════════════════════════════════════

function HardStopScreen({ source, pushToHistory, showMyraMessage, scrollToBottom }) {
  const [rendered, setRendered] = useState(false);
  const isVoiceMode = MyraInteraction.getMode() === "voice";

  useEffect(() => {
    window.mayraCode?.setIsVisible(false);
    window.mayraCode?.forceStop();

    // Speak empathy message
    const empathyMap = {
      safety: MYRA_MESSAGES.hardStop?.safety?.empathy || "Your safety is my top priority.",
      test1_pain: MYRA_MESSAGES.hardStop?.test1Pain?.empathy || "I'm glad you told me about the pain.",
      couldnt_finish: MYRA_MESSAGES.hardStop?.couldntFinish?.empathy || "No worries at all — that's important information.",
    };
    const speech = empathyMap[source] || empathyMap.safety;
    if (isVoiceMode) {
      VoiceService?.doSay(speech);
    }

    // Screen tracking
    MyraInteraction?.onScreenEnter?.("hard_stop");
    window.screenTracker?.enterScreen("hard_stop");

    // Push conversation entries
    let cancelled = false;
    async function init() {
      await showMyraMessage(speech, 900);
      if (cancelled) return;

      const detailMap = {
        safety: MYRA_MESSAGES.hardStop?.safety?.detail || "Based on what you've shared, I'd strongly recommend seeing a healthcare provider before starting an exercise program. They can evaluate your symptoms and let you know when it's safe to proceed.",
        test1_pain: MYRA_MESSAGES.hardStop?.test1Pain?.detail || "Experiencing pain during that movement tells me we should take a different approach. I'd recommend seeing a healthcare provider who can evaluate things in person.",
        couldnt_finish: MYRA_MESSAGES.hardStop?.couldntFinish?.detail || "Not being able to complete the movement tells me this might need a more hands-on approach. I'd recommend seeing a healthcare provider who can work with you directly.",
      };
      const detail = detailMap[source] || detailMap.safety;

      // Push hard stop card as frozen widget
      pushToHistory({ type: "frozen-widget", widgetType: "hard_stop_card", id: nextId(), data: { detail } });

      await _delay(600);
      if (cancelled) return;

      const followUp = MYRA_MESSAGES.hardStop?.followUp || "I know this isn't the outcome you were hoping for. If you have any questions about what this means or what to expect from an in-person visit, I'm here — just ask.";
      await showMyraMessage(followUp, 800);
      if (!cancelled) setRendered(true);
    }
    init();

    return () => {
      cancelled = true;
      window.screenTracker?.exitScreen("hard_stop", { exitReason: "hard_stop_viewed" });
    };
  }, [source]);

  // No live content needed — everything is in conversation history
  // Input bar stays active so the user can chat with Myra
  return null;
}

// ════════════════════════════════════════════════════════════════
// SCREEN 18: PERSONALIZE
// Grouped form fields (basics, capacity, preferences).
// Group-by-group with Skip/Next per group. Fully skippable.
// Mode-specific flow routing.
// ════════════════════════════════════════════════════════════════

function PersonalizeScreen({ assessmentData, chatInputRef, updateAssessmentData, pushToHistory, speakChatTextIfVoice, showMyraMessage, scrollToBottom, onContinue, setMode, showQuestionNuggetMessage }) {
  const [formData, setFormData] = useState({});
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [ready, setReady] = useState(false);
  const [missingRequired, setMissingRequired] = useState([]);
  const flowStartedRef = useRef(false);
  const initRef = useRef(false);
  const ContainerRef = useRef(null);
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const validSymptomDurations = ["ACUTE", "SUBACUTE", "CHRONIC"];
  const isAccessUser = window.is_access_user === true;
  window.notOpenQNA = true;

  useEffect(() => {
    window.test2AnnounceSkipped = false;
    if (MyraInteraction && MyraInteraction?.getMode() === "voice") {
      setMode("voice");
    }
  }, [setMode]);

  // Close AR camera stream if still open
  useEffect(() => {
    window.closeStream?.();
  }, []);
  useEffect(() => {
    window.screenTracker?.enterScreen("personalize");
    if (isAccessUser) {
      AnalyticsService.trackStep({
        is_access_user: true,
        access_personalize_viewed: true,
        screenFlow: window.screenTracker?.getScreenFlow?.() || [],
      });
    }
    return () => {
      window.screenTracker?.exitScreen("personalize", { completed: true });
    };
  }, []);

  // blur focus on iOS
  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS && chatInputRef?.current) {
      chatInputRef.current.blur();
    }
  }, []);

  // ── Spec 1: pre-fill formData and selectedGoals on mount ──
  // Hydrates fields opportunistically captured during landing chat (or any
  // earlier mid-GSA voice extraction) so the user sees their answers
  // already filled in. Field-name remap matches the voice-extraction
  // handler at lines 6178–6188 (weightLbs → weight, activityLevel →
  // activity, symptomDuration → duration). preExistingConditions and
  // currentConditions are written even though the form has no UI for
  // them — they flow through onContinue → backend regardless.
  const prefillRef = useRef(false);
  useEffect(() => {
    if (prefillRef.current) return;
    prefillRef.current = true;

    const condRaw = localStorage.getItem("userCondition");
    const cond = condRaw ? JSON.parse(condRaw) : {};
    const userConds = cond.usercondition || { pre_existing: [], current: [] };

    const prefill = {};
    if (assessmentData.age) prefill.age = String(assessmentData.age);
    if (assessmentData.weightLbs || assessmentData.weight) prefill.weight = String(assessmentData.weightLbs || assessmentData.weight);
    if (assessmentData.heightFt) prefill.heightFt = String(assessmentData.heightFt);
    if (assessmentData.heightIn) prefill.heightIn = String(assessmentData.heightIn);
    if (assessmentData.activityLevel || assessmentData.activity) prefill.activity = assessmentData.activityLevel || assessmentData.activity;
    const symptomDuration = assessmentData.symptomDuration || (typeof assessmentData.duration === "string" ? assessmentData.duration : null);
    if (validSymptomDurations.includes(symptomDuration)) prefill.duration = symptomDuration;
    if (assessmentData.balance) prefill.balance = assessmentData.balance;
    if (assessmentData.floorCapability) prefill.floorCapability = assessmentData.floorCapability;
    if (userConds.pre_existing?.length) prefill.preExistingConditions = userConds.pre_existing.join(", ");
    if (userConds.current?.length) prefill.currentConditions = userConds.current.join(", ");

    console.log(" duration", assessmentData.duration, "symptomDuration", assessmentData.symptomDuration, prefill.duration);
    if (Object.keys(prefill).length > 0) {
      setFormData((prev) => ({ ...prev, ...prefill }));
    }

    if (assessmentData.goals && Array.isArray(assessmentData.goals) && assessmentData.goals.length > 0) {
      setSelectedGoals(assessmentData.goals);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useScreenVoice for boilerplate — flow handled manually
  // exitReason handled manually in finishPersonalize (dynamic based on skip vs complete)
  useScreenVoice({
    screenName: "personalize",
    flowName: "flow_personalized",
    payloadKey: "personalize",
    assessmentData,
    skipFlow: false,
    commands: {
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        handleNext();
      },
      FORM_QUESTION: () => {
        if (window.exitHandlerOpen) return;
        const missing = getMissingFields();
        if (isVoiceMode) {
          VoiceService?.doSay(`Please enter ${missing}.`);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;

        // Handle continue command
        if (intent === "continue_command" || value === "continue_command") {
          handleNext();
          return;
        }

        // Handle extracted data
        if (extracted && Object.keys(extracted).length > 0) {
          console.log("[VOICE] Updating form with extracted data:", extracted);

          // Update formData state (not demographics - this screen uses formData)
          setFormData((prev) => {
            const updates = {};
            const fieldMappings = {
              age: "age",
              weightLbs: "weight",
              heightFt: "heightFt",
              heightIn: "heightIn",
              activityLevel: "activity",
              symptomDuration: "duration",
              balance: "balance",
              preExistingConditions: "preExistingConditions",
              currentConditions: "currentConditions",
            };

            Object.entries(fieldMappings).forEach(([extractedKey, formKey]) => {
              if (extracted[extractedKey] !== undefined && extracted[extractedKey] !== null) {
                updates[formKey] = extracted[extractedKey];
                console.log(`[VOICE] Updating ${formKey} to:`, extracted[extractedKey]);
              }
            });

            return { ...prev, ...updates };
          });

          // Handle goals - convert from string values to the expected object format
          if (extracted.goals) {
            const goalTextMap = {
              reduce_pain: "Reduce Pain",
              less_stiff: "Reduce Stiffness",
              improve_strength: "Improve Strength",
              improve_flexibility: "Improve Flexibility",
              daily_tasks: "Make Daily Tasks Easier",
              balance: "Improve Balance & Stability",
              picking_up: "Picking Up Things",
              sleep: "Improve Sleep Quality",
              walking: "Improve Walking & Endurance",
              lifting: "Make Bending & Lifting Easier",
              posture: "Improve Sitting & Standing Posture",
              rotational_sports: "Return to Sports (Golf, Tennis, etc.)",
              overhead_sports: "Return to Sports (Basketball, Swimming, etc.)",
              running: "Running, Cycling, etc.",
              fitness: "Fitness: Gym, CrossFit, etc.",
            };

            const goalsArray = Array.isArray(extracted.goals) ? extracted.goals : [extracted.goals];
            const formattedGoals = goalsArray
              .filter((goalValue) => goalTextMap[goalValue])
              .map((goalValue) => ({
                value: goalValue,
                text: goalTextMap[goalValue],
              }));

            if (formattedGoals.length > 0) {
              setSelectedGoals(formattedGoals);
              // Also mark goals as filled in formData
              setFormData((prev) => ({ ...prev, goals: true }));
              console.log("[VOICE] Updating goals to:", formattedGoals);
            }
          }
        }

        // Handle condition disclosure
        if (intent === "condition_disclosure") {
          const conditions = JSON.parse(localStorage.getItem("userCondition") || "{}");
          localStorage.setItem("userCondition", JSON.stringify(conditions));
        }
      },
      FIELD_SKIPPED: (value, speech, intent, extracted) => {
        VoiceService.resetAssembly();
      },
      GIVE_AGE: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        // Process all actions in the batch (user may say age + weight + height together)
        allActions.forEach((a) => {
          if (a.action === "GIVE_AGE" && a.value != null) handleFieldChange("age", String(a.value));
          if (a.action === "GIVE_WEIGHT" && a.value != null) handleFieldChange("weight", String(a.value));
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_WEIGHT: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_WEIGHT" && a.value != null) handleFieldChange("weight", String(a.value));
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_HEIGHT_FT: (value, speech, intent, extracted, actionValue, actions) => {
        // Height ft and inches often come together in one batch
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_HEIGHT_IN: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      // ── Option selectors ──

      SELECT_ACTIVITY_LEVEL: (value, speech, intent, extracted, actionValue) => {
        // PERSONALIZE_GROUPS uses the enum value directly: "SEDENTARY", "LIGHTLY_ACTIVE", etc.
        const validValues = ["SEDENTARY", "LIGHTLY_ACTIVE", "ACTIVE", "VERY_ACTIVE"];
        if (actionValue && validValues.includes(actionValue)) handleFieldChange("activity", actionValue, true);
      },

      SELECT_FLOOR_CAPABILITY: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "YES" ? "yes" : actionValue === "NO" ? "no" : null;
        if (mapped) handleFieldChange("floorCapability", mapped);
      },

      SELECT_BALANCE: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "STEADY" ? "steady" : actionValue === "UNSTEADY" ? "unsteady" : null;
        if (mapped) handleFieldChange("balance", mapped);
      },

      // ── Goals — can fire multiple in one batch ──
      SELECT_GOAL: (value, speech, intent, extracted, actionValue, actions) => {
        const GOAL_MAP = {
          REDUCE_PAIN: "reduce_pain",
          LESS_STIFF: "less_stiff",
          IMPROVE_STRENGTH: "improve_strength",
          IMPROVE_FLEXIBILITY: "improve_flexibility",
          DAILY_TASKS: "daily_tasks",
          BALANCE: "balance",
          PICKING_UP: "picking_up",
          SLEEP: "sleep",
          WALKING: "walking",
          LIFTING: "lifting",
          POSTURE: "posture",
          ROTATIONAL_SPORTS: "rotational_sports",
          OVERHEAD_SPORTS: "overhead_sports",
          RUNNING: "running",
          FITNESS: "fitness",
        };
        const GOAL_LABEL_MAP = {
          reduce_pain: "Reduce Pain",
          less_stiff: "Reduce Stiffness",
          improve_strength: "Improve Strength",
          improve_flexibility: "Improve Flexibility",
          daily_tasks: "Make Daily Tasks Easier",
          balance: "Improve Balance & Stability",
          picking_up: "Picking Up Things",
          sleep: "Improve Sleep Quality",
          walking: "Improve Walking & Endurance",
          lifting: "Make Bending & Lifting Easier",
          posture: "Improve Sitting & Standing Posture",
          rotational_sports: "Return to Sports (Golf, Tennis, etc.)",
          overhead_sports: "Return to Sports (Basketball, Swimming, etc.)",
          running: "Running, Cycling, etc.",
          fitness: "Fitness: Gym, CrossFit, etc.",
        };

        const allActions = actions || [];
        const goalActions = allActions.filter((a) => a.action === "SELECT_GOAL");
        const newGoalValues = goalActions.map((a) => GOAL_MAP[a.value]).filter(Boolean);

        if (newGoalValues.length === 0) return;

        // selectedGoals stores raw value strings (e.g. "reduce_pain"), toggleGoal checks prev.includes(goalValue)
        // setSelectedGoals((prev) => {
        //   const existingSet = new Set(prev);
        //   const toAdd = newGoalValues.filter((v) => !existingSet.has(v));
        //   return [...prev, ...toAdd];
        // });
        setSelectedGoals((prev) => {
          const existingValues = new Set(prev.map((g) => g.value));
          const toAdd = newGoalValues.filter((v) => !existingValues.has(v)).map((v) => ({ value: v, text: GOAL_LABEL_MAP[v] }));
          return [...prev, ...toAdd];
        });
        setFormData((prev) => ({ ...prev, goals: true }));
      },

      SELECT_FREQUENCY: (value, speech, intent, extracted, actionValue) => {
        // scheduleDays options use string values: "2", "3", "4", "5", "6", "7"
        const days = typeof actionValue === "number" ? actionValue : parseInt(actionValue);
        if (!isNaN(days) && days >= 2 && days <= 7) handleFieldChange("scheduleDays", String(days));
      },

      SELECT_DURATION_MINUTES: (value, speech, intent, extracted, actionValue) => {
        // scheduleTime options use string values: "10", "15", "20"
        const minutes = typeof actionValue === "number" ? actionValue : parseInt(actionValue);
        if ([10, 15, 20].includes(minutes)) handleFieldChange("scheduleTime", String(minutes));
      },

      SELECT_SESSIONS_PER_DAY: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "ONE" ? "one" : actionValue === "MULTIPLE" ? "multiple" : null;
        if (mapped) handleFieldChange("sessionPref", mapped);
      },
      SELECT_DURATION: (value, speech, intent, extracted, actionValue) => {
        const validDurations = ["ACUTE", "CHRONIC", "SUBACUTE"];
        if (validDurations.includes(actionValue)) {
          handleFieldChange("duration", actionValue);
        }
      },
    },
  });

  // Mode-specific flow start
  useEffect(() => {
    if (flowStartedRef.current) return;
    flowStartedRef.current = true;

    const mayraCode = window.mayraCode;
    if (!mayraCode) return;

    const mode = MyraInteraction?.getCurrentMode?.();
    const payload = generatePayloadForScreen("personalize", assessmentData);

    if (mode === "voice") {
      window.mayraForwardCode = { midjourneyData: payload };
      mayraCode.startFlow("flow_personalized", "personalized");
    } else if (mode === "chat") {
      const chatAnnouncement = "Let's personalize your plan. I'll need a few details about you.";
      VoiceService?.startFlowWithoutAnnouncement?.("flow_personalized");
      MyraInteraction?.onMyraMessage?.(chatAnnouncement);
    } else {
      const buttonAnnouncement = "Let's personalize your plan. I'll need a few details about you.";
      VoiceService?.startFlowWithoutAnnouncement?.("flow_personalized");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Command registration
  useEffect(() => {
    window.currentCommandsAudio = {
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        handleNext();
      },
      FORM_QUESTION: () => {
        if (window.exitHandlerOpen) return;
        const missing = getMissingFields();
        if (isVoiceMode) {
          VoiceService?.doSay(`Please enter ${missing}.`);
        }
      },
      FIELD_SKIPPED: (value, speech, intent, extracted) => {
        VoiceService.resetAssembly();
        handleNext();
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;

        // Handle continue command
        if (intent === "continue_command" || value === "continue_command") {
          handleNext();
          return;
        }

        // Handle extracted data
        if (extracted && Object.keys(extracted).length > 0) {
          console.log("[VOICE] Updating form with extracted data:", extracted);

          // Update formData state (not demographics - this screen uses formData)
          setFormData((prev) => {
            const updates = {};
            const fieldMappings = {
              age: "age",
              weightLbs: "weight",
              heightFt: "heightFt",
              heightIn: "heightIn",
              activityLevel: "activity",
              symptomDuration: "duration",
              preExistingConditions: "preExistingConditions",
              currentConditions: "currentConditions",
            };

            Object.entries(fieldMappings).forEach(([extractedKey, formKey]) => {
              if (extracted[extractedKey] !== undefined && extracted[extractedKey] !== null) {
                updates[formKey] = extracted[extractedKey];
                console.log(`[VOICE] Updating ${formKey} to:`, extracted[extractedKey]);
              }
            });

            return { ...prev, ...updates };
          });

          // Handle goals - convert from string values to the expected object format
          if (extracted.goals) {
            const goalTextMap = {
              reduce_pain: "Reduce Pain",
              less_stiff: "Reduce Stiffness",
              improve_strength: "Improve Strength",
              improve_flexibility: "Improve Flexibility",
              daily_tasks: "Make Daily Tasks Easier",
              balance: "Improve Balance & Stability",
              picking_up: "Picking Up Things",
              sleep: "Improve Sleep Quality",
              walking: "Improve Walking & Endurance",
              lifting: "Make Bending & Lifting Easier",
              posture: "Improve Sitting & Standing Posture",
              rotational_sports: "Return to Sports (Golf, Tennis, etc.)",
              overhead_sports: "Return to Sports (Basketball, Swimming, etc.)",
              running: "Running, Cycling, etc.",
              fitness: "Fitness: Gym, CrossFit, etc.",
            };

            const goalsArray = Array.isArray(extracted.goals) ? extracted.goals : [extracted.goals];
            const formattedGoals = goalsArray
              .filter((goalValue) => goalTextMap[goalValue])
              .map((goalValue) => ({
                value: goalValue,
                text: goalTextMap[goalValue],
              }));

            if (formattedGoals.length > 0) {
              setSelectedGoals(formattedGoals);
              // Also mark goals as filled in formData
              setFormData((prev) => ({ ...prev, goals: true }));
              console.log("[VOICE] Updating goals to:", formattedGoals);
            }
          }
        }

        // Handle condition disclosure
        if (intent === "condition_disclosure") {
          const conditions = JSON.parse(localStorage.getItem("userCondition") || "{}");
          localStorage.setItem("userCondition", JSON.stringify(conditions));
        }
      },
      GIVE_AGE: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        // Process all actions in the batch (user may say age + weight + height together)
        allActions.forEach((a) => {
          if (a.action === "GIVE_AGE" && a.value != null) handleFieldChange("age", String(a.value));
          if (a.action === "GIVE_WEIGHT" && a.value != null) handleFieldChange("weight", String(a.value));
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_WEIGHT: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_WEIGHT" && a.value != null) handleFieldChange("weight", String(a.value));
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_HEIGHT_FT: (value, speech, intent, extracted, actionValue, actions) => {
        // Height ft and inches often come together in one batch
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_HEIGHT_IN: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      // ── Option selectors ──

      SELECT_ACTIVITY_LEVEL: (value, speech, intent, extracted, actionValue) => {
        // PERSONALIZE_GROUPS uses the enum value directly: "SEDENTARY", "LIGHTLY_ACTIVE", etc.
        const validValues = ["SEDENTARY", "LIGHTLY_ACTIVE", "ACTIVE", "VERY_ACTIVE"];
        if (actionValue && validValues.includes(actionValue)) handleFieldChange("activity", actionValue, true);
      },

      SELECT_FLOOR_CAPABILITY: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "YES" ? "yes" : actionValue === "NO" ? "no" : null;
        if (mapped) handleFieldChange("floorCapability", mapped);
      },

      SELECT_BALANCE: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "STEADY" ? "steady" : actionValue === "UNSTEADY" ? "unsteady" : null;
        if (mapped) handleFieldChange("balance", mapped);
      },

      // ── Goals — can fire multiple in one batch ──
      SELECT_GOAL: (value, speech, intent, extracted, actionValue, actions) => {
        const GOAL_MAP = {
          REDUCE_PAIN: "reduce_pain",
          LESS_STIFF: "less_stiff",
          IMPROVE_STRENGTH: "improve_strength",
          IMPROVE_FLEXIBILITY: "improve_flexibility",
          DAILY_TASKS: "daily_tasks",
          BALANCE: "balance",
          PICKING_UP: "picking_up",
          SLEEP: "sleep",
          WALKING: "walking",
          LIFTING: "lifting",
          POSTURE: "posture",
          ROTATIONAL_SPORTS: "rotational_sports",
          OVERHEAD_SPORTS: "overhead_sports",
          RUNNING: "running",
          FITNESS: "fitness",
        };
        const GOAL_LABEL_MAP = {
          reduce_pain: "Reduce Pain",
          less_stiff: "Reduce Stiffness",
          improve_strength: "Improve Strength",
          improve_flexibility: "Improve Flexibility",
          daily_tasks: "Make Daily Tasks Easier",
          balance: "Improve Balance & Stability",
          picking_up: "Picking Up Things",
          sleep: "Improve Sleep Quality",
          walking: "Improve Walking & Endurance",
          lifting: "Make Bending & Lifting Easier",
          posture: "Improve Sitting & Standing Posture",
          rotational_sports: "Return to Sports (Golf, Tennis, etc.)",
          overhead_sports: "Return to Sports (Basketball, Swimming, etc.)",
          running: "Running, Cycling, etc.",
          fitness: "Fitness: Gym, CrossFit, etc.",
        };

        const allActions = actions || [];
        const goalActions = allActions.filter((a) => a.action === "SELECT_GOAL");
        const newGoalValues = goalActions.map((a) => GOAL_MAP[a.value]).filter(Boolean);

        if (newGoalValues.length === 0) return;

        // selectedGoals stores raw value strings (e.g. "reduce_pain"), toggleGoal checks prev.includes(goalValue)
        // setSelectedGoals((prev) => {
        //   const existingSet = new Set(prev);
        //   const toAdd = newGoalValues.filter((v) => !existingSet.has(v));
        //   return [...prev, ...toAdd];
        // });
        setSelectedGoals((prev) => {
          const existingValues = new Set(prev.map((g) => g.value));
          const toAdd = newGoalValues.filter((v) => !existingValues.has(v)).map((v) => ({ value: v, text: GOAL_LABEL_MAP[v] }));
          return [...prev, ...toAdd];
        });
        setFormData((prev) => ({ ...prev, goals: true }));
      },

      SELECT_FREQUENCY: (value, speech, intent, extracted, actionValue) => {
        // scheduleDays options use string values: "2", "3", "4", "5", "6", "7"
        const days = typeof actionValue === "number" ? actionValue : parseInt(actionValue);
        if (!isNaN(days) && days >= 2 && days <= 7) handleFieldChange("scheduleDays", String(days));
      },

      SELECT_DURATION_MINUTES: (value, speech, intent, extracted, actionValue) => {
        // scheduleTime options use string values: "10", "15", "20"
        const minutes = typeof actionValue === "number" ? actionValue : parseInt(actionValue);
        if ([10, 15, 20].includes(minutes)) handleFieldChange("scheduleTime", String(minutes));
      },

      SELECT_SESSIONS_PER_DAY: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "ONE" ? "one" : actionValue === "MULTIPLE" ? "multiple" : null;
        if (mapped) handleFieldChange("sessionPref", mapped);
      },
      SELECT_DURATION: (value, speech, intent, extracted, actionValue) => {
        const validDurations = ["ACUTE", "CHRONIC", "SUBACUTE"];
        if (validDurations.includes(actionValue)) {
          handleFieldChange("duration", actionValue);
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  // ── Push divider + first group Myra message on mount ──
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;
    let cancelled = false;
    async function init() {
      const group = CONST.PERSONALIZE_GROUPS[0];
      // if (group) {
      //   await showMyraMessage(group.myraIntro, 900);
      // }
      await showMyraMessage(MYRA_MESSAGES.personalize.PERSONALIZE_SETUP_BEAT || "What is your pain level right now? 0 is no pain, 10 is the worst imaginable.", 800);
      if (isVoiceMode) {
        speakChatTextIfVoice(MYRA_MESSAGES.personalize.PERSONALIZE_SETUP_BEAT);
      }
      await showQuestionNuggetMessage(MYRA_MESSAGES.personalize.PERSONALIZE_QUESTION, MYRA_MESSAGES.personalize.PERSONALIZE_NUGGET, 900);
      if (isVoiceMode) {
        speakChatTextIfVoice(MYRA_MESSAGES.personalize.PERSONALIZE_QUESTION);
      }
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  function getMissingFields() {
    const group = CONST.PERSONALIZE_GROUPS[0];
    if (!group) return "the remaining fields";
    const missing = group.fields.filter((f) => !formData[f.id]).map((f) => f.label);
    return missing.length > 0 ? missing.join(", ") : "the remaining fields";
  }

  async function finishPersonalize(skipped) {
    const mode = MyraInteraction?.getMode?.();
    const transitionMsg = MYRA_MESSAGES.personalize?.finishTransition || "Alright — I'm calculating your Recovery Compass Score now.";
    if (isVoiceMode) {
      VoiceService?.doSay(transitionMsg);
    }
    await showMyraMessage(transitionMsg, 800);

    if (skipped && !formData.age) {
      window.screenTracker?.exitScreen("personalize", { exitReason: "conservative_defaults_accepted" });
      onContinue({
        useStandardPlan: true,
        personal_info_skipped: true,
        demographics_provided: false,
      });
    } else {
      window.screenTracker?.exitScreen("personalize", { exitReason: "demographics_completed" });
      onContinue({
        biometrics: {
          age: formData.age || null,
          weight: formData.weight || null,
          height: formData.heightFt && formData.heightIn ? `${formData.heightFt}'${formData.heightIn}"` : null,
          gender: formData.gender || null,
          activityLevel: formData.activity || null,
          floorCapability: formData.floorCapability || null,
          balance: formData.balance || null,
          // balance: assessmentData?.balance || "steady",
        },
        signature: new Date().toISOString(),
        demographics_provided: true,
        completed_demographics: true,
        viewed_plan: true,
        scheduleDays: formData.scheduleDays || null,
        scheduleTime: formData.scheduleTime || null,
        goals: selectedGoals.length > 0 ? selectedGoals : null,
      });
    }
  }

  function handleFieldChange(fieldId, value) {
    // if (fieldId === "activity" && formData.activity === value) {
    //   return;
    // }
    setFormData((prev) => ({ ...prev, [fieldId]: value }));
    if (missingRequired.includes(fieldId)) {
      setMissingRequired((prev) => prev.filter((id) => id !== fieldId));
    }
  }

  function toggleGoal(goalValue, goalLabel) {
    setSelectedGoals((prev) => {
      if (prev.some((g) => g.value === goalValue)) return prev.filter((g) => g.value !== goalValue);
      return [...prev, { value: goalValue, text: goalLabel }];
    });
    setFormData((prev) => ({ ...prev, goals: true }));
  }
  function getFillStatus(fd, goals) {
    const fields = [fd.age, fd.weight, fd.heightFt, fd.heightIn, fd.activity, fd.balance, fd.duration, goals.length > 0 ? "goals" : null];

    const filledCount = fields.filter(Boolean).length;
    const totalCount = fields.length;

    if (filledCount === 0) return "filledNothing";
    if (filledCount === totalCount) return "filledAll";
    return "filledSome";
  }
  const handleNext = useCallback(async () => {
    // Access users must complete required biometrics before continuing —
    // this screen stays optional for regular users but is mandatory for them.
    if (isAccessUser) {
      const requiredFieldIds = ["age", "weight", "heightFt", "heightIn"];
      const missing = requiredFieldIds.filter((id) => !formData[id]);
      if (missing.length > 0) {
        setMissingRequired(missing);
        return;
      }
    }
    setMissingRequired([]);
    // Push frozen widget capturing the user's answers
    const fillStatus = getFillStatus(formData, selectedGoals);
    let leaveMessage = MYRA_MESSAGES.personalize.finishTransition;
    if (fillStatus === "filledNothing") {
      leaveMessage = MYRA_MESSAGES.personalize.PERSONALIZE_CLOSE_BY_STATE.filledNothing;
    } else if (fillStatus === "filledAll") {
      leaveMessage = MYRA_MESSAGES.personalize.PERSONALIZE_CLOSE_BY_STATE.filledAll;
    } else if (fillStatus === "filledSome") {
      leaveMessage = MYRA_MESSAGES.personalize.PERSONALIZE_CLOSE_BY_STATE.filledSome;
    } else {
      leaveMessage = MYRA_MESSAGES.personalize.finishTransition;
    }
    pushToHistory(
      {
        type: "frozen-widget",
        widgetType: "personalize_group",
        id: nextId(),
        data: {
          groupId: CONST.PERSONALIZE_GROUPS[0].id,
          formData: { ...formData },
          selectedGoals: [...selectedGoals],
          result: fillStatus,
        },
      },
      { type: "user", text: summarizeAnswers(formData, selectedGoals), id: nextId() },
      { type: "myra", text: leaveMessage, id: nextId() },
    );
    if (isVoiceMode) {
      speakChatTextIfVoice(leaveMessage);
    }

    // Apply silent defaults for fields no longer collected or left blank
    const symptomDuration = validSymptomDurations.includes(formData.duration) ? formData.duration : "ACUTE";
    const finalFields = {
      age: formData.age || null,
      weight: formData.weight || null,
      heightFt: formData.heightFt || null,
      heightIn: formData.heightIn || null,
      activity: formData.activity || null,
      symptomDuration,
      balance: formData.balance || "steady",
      goals: selectedGoals.length > 0 ? selectedGoals : null,
      // Silent defaults for fields no longer collected in GSA:
      scheduleDays: "4",
      scheduleTime: "15",
      floorCapability: "yes",
      // Status flags:
      completed_demographics: true,
      viewed_plan: true,
      demographics_provided: hasAnyFieldFilled(formData, selectedGoals),
      skipped: !hasAnyFieldFilled(formData, selectedGoals),
    };
    updateAssessmentData({
      biometrics: finalFields,
    });
    if (isAccessUser) {
      AnalyticsService.trackStep({
        is_access_user: true,
        access_personalize_completed: true,
        screenFlow: window.screenTracker?.getScreenFlow?.() || [],
      });
    }
    console.log("Final personalized data to be sent to backend:", formData);
    onContinue(finalFields);
  }, [formData, selectedGoals, pushToHistory, onContinue]);

  function hasAnyFieldFilled(fd, goals) {
    return !!(fd.age || fd.weight || fd.heightFt || fd.heightIn || fd.activity || fd.duration || fd.balance || goals.length > 0);
  }

  function summarizeAnswers(fd, goals) {
    const count = [fd.age, fd.weight, fd.heightFt, fd.activity, fd.duration, fd.balance, goals.length > 0 ? "goals" : null].filter(Boolean).length;
    return count === 0 ? "Skipped" : `${count} field${count > 1 ? "s" : ""} provided`;
  }

  if (!ready) return null;

  const group = CONST.PERSONALIZE_GROUPS[0];
  if (!group) return null;

  const numberFields = group.fields.filter((f) => f.type === "number");
  const otherFields = group.fields.filter((f) => f.type !== "number");

  return (
    <div className={styles.inlineUi} ref={ContainerRef}>
      <div className={styles.pzGroup}>
        {/* Number fields paired */}
        {(() => {
          const rows = [];
          for (let i = 0; i < numberFields.length; i += 2) {
            rows.push(
              <div className={styles.pzFieldRow} key={numberFields[i].id}>
                <div className={styles.pzField}>
                  <label className={styles.formLabel}>
                    {numberFields[i].label}
                    {!isAccessUser && <span className={styles.optional}>(optional)</span>}
                  </label>
                  <input type="number" className={styles.formInput} placeholder={numberFields[i].placeholder} min={numberFields[i].min || ""} max={numberFields[i].max || ""} value={formData[numberFields[i].id] || ""} onChange={(e) => handleFieldChange(numberFields[i].id, e.target.value)} />
                  {isAccessUser && missingRequired.includes(numberFields[i].id) && <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>Required</span>}
                </div>
                {i + 1 < numberFields.length && (
                  <div className={styles.pzField}>
                    <label className={styles.formLabel}>
                      {numberFields[i + 1].label}
                      {!isAccessUser && <span className={styles.optional}>(optional)</span>}
                    </label>
                    <input type="number" className={styles.formInput} placeholder={numberFields[i + 1].placeholder} min={numberFields[i + 1].min || ""} max={numberFields[i + 1].max || ""} value={formData[numberFields[i + 1].id] || ""} onChange={(e) => handleFieldChange(numberFields[i + 1].id, e.target.value)} />
                    {isAccessUser && missingRequired.includes(numberFields[i + 1].id) && <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>Required</span>}
                  </div>
                )}
              </div>,
            );
          }
          return rows;
        })()}

        {/* Options and goals fields */}
        {otherFields.map((field) => {
          if (field.type === "goals") {
            return (
              <div className={styles.pzField} key={field.id}>
                <label className={styles.formLabel}>
                  {field.label}
                  <span className={styles.optional}>(optional, pick any)</span>
                </label>
                <div className={styles.pzGoalWrapper}>
                  <div className={styles.pzGoalRow}>
                    {field.options.map((opt) => (
                      <div
                        key={opt.id}
                        className={`${styles.pzGoalItem} ${selectedGoals.some((g) => g.value === opt.value) ? styles.selected : ""}`}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            toggleGoal(opt.value, opt.label);
                          }
                        }}
                        tabIndex={0}
                        onClick={() => toggleGoal(opt.value, opt.label)}
                      >
                        <span className={styles.pzGoalLabel}>{opt.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          }
          if (field.type === "options") {
            return (
              <div className={styles.pzField} key={field.id}>
                <label className={styles.formLabel}>
                  {field.label}
                  <span className={styles.optional}>(optional)</span>
                </label>
                <div className={styles.pzOptionRow}>
                  {field.options.map((opt) => (
                    <button
                      key={opt.id}
                      className={`${styles.pzOptBtn} ${formData[field.id] === opt.value ? styles.selected : ""}`}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleFieldChange(field.id, opt.value);
                        }
                      }}
                      onClick={() => handleFieldChange(field.id, opt.value)}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>
            );
          }
          return null;
        })}

        {/* Single Next button — no Skip */}
        {isAccessUser && missingRequired.length > 0 && <div style={{ color: "#dc2626", fontSize: 13, textAlign: "center", marginBottom: 8 }}>Please fill in age, weight, and height to continue.</div>}
        <div className={styles.pzActions}>
          <button className={`${styles.videoBtn} ${styles.videoBtnPrimary}`} onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 19: RECOVERY SCORE
// Animated ring display. Gates voice flow on loading completion.
// Backend API call stubbed with getDummyPlan().
// ════════════════════════════════════════════════════════════════
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
async function fetchWithRetry(url, options = {}, opts = {}) {
  const { maxAttempts = 4, initialDelay = 800, factor = 2, jitter = true, timeout = 60000, signal } = opts;

  let attempt = 0;

  while (attempt < maxAttempts) {
    attempt += 1;

    // per-attempt timeout
    const controller = new AbortController();

    // Combine signals: prefer outer signal (if provided), but ensure we can timeout.
    // If a signal was passed, we listen to it and abort our controller when it fires.
    if (signal) {
      if (signal.aborted) {
        controller.abort();
      } else {
        const onAbort = () => controller.abort();
        signal.addEventListener("abort", onAbort, { once: true });
      }
    }

    let timeoutId;
    try {
      // if (timeout) {
      //   timeoutId = setTimeout(() => controller.abort(), timeout);
      // }

      const res = await fetch(url, {
        ...options,
        signal: controller.signal,
      });

      // if server error (5xx) treat as retryable; if 4xx treat as permanent failure
      if (res.ok) {
        clearTimeout(timeoutId);
        return { ok: true, response: await res.json(), attempt };
      } else if (res.status >= 500 && res.status < 600) {
        // retryable server error
        const errText = await res.text().catch(() => "");
        throw new Error(`Server error ${res.status}: ${errText}`);
      } else {
        // client error - do not retry
        const errText = await res.text().catch(() => "");
        return { ok: false, permanentError: true, status: res.status, body: errText };
      }
    } catch (err) {
      console.log("Retry error:", {
        name: err.name,
        message: err.message,
        attempt,
      });
      clearTimeout(timeoutId);

      // If aborted externally, rethrow so caller can handle immediate abort
      if (signal && signal.aborted) {
        throw new DOMException("Aborted", "AbortError");
      }

      // If this was the last attempt, return failure info
      if (attempt >= maxAttempts) {
        return { ok: false, error: err, attempt };
      }

      // compute backoff delay (exponential + jitter)
      let delay = initialDelay * Math.pow(factor, attempt - 1);
      if (jitter) {
        const jitterVal = Math.random() * (delay * 0.25); // up to 25% jitter
        delay = delay - jitterVal;
      }

      // wait and retry
      await sleep(delay);
      // then continue loop for next attempt
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }

  // fallback - should never reach here because loop returns
  return { ok: false, error: new Error("Retries exhausted") };
}
function breakBeforeContinueCta(text = "") {
  return String(text).replace(/\s*(?=\b(?:or\s+)?(?:just\s+)?Ask me anything\b)/i, "\n\n");
}
// this function is used to remove the 5th li from the group3_bubble_1
function removeTheLastBulletFromGroup3(html, keyword = "Staying consistent pays off") {
  if (!html || typeof html !== "string") return html;
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const items = doc.querySelectorAll("li");
    const normalizedKeyword = keyword.trim().toLowerCase();

    items.forEach((li) => {
      const text = (li.textContent || "").trim().toLowerCase();
      if (text.startsWith(normalizedKeyword)) {
        li.remove();
      }
    });

    return doc.body.innerHTML;
  } catch (e) {
    console.warn("[PlanScreen] stripBulletStartingWith failed", e);
    return html; // fallback sending the original
  }
}
function boldenContinueWord(html = "") {
  return String(html)
    .split("\n")
    .map((line) => (/\b(?:or\s+)?(?:just\s+)?ask me anything\b/i.test(line) ? line.replace(/\bcontinue\b/gi, "<strong>$&</strong>") : line))
    .join("\n");
}

// Adds a stable, styles-module class to the group3 bullet list so it can be
// folded (and unfolded via "Show the details") once a reaction chip is
// tapped. Uses the same DOMParser approach as removeTheLastBulletFromGroup3.
function markGroup3ListFoldable(html) {
  if (!html || typeof html !== "string") return html;
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const ul = doc.querySelector("ul");
    if (ul) {
      ul.classList.add(styles.planSupportListFoldable);
      const toggle = doc.createElement("div");
      toggle.className = `${styles.planSupportToggle} ${styles.planSupportToggleHidden}`;
      toggle.setAttribute("data-plan-support-toggle", "true");
      toggle.textContent = "Show the details";
      ul.insertAdjacentElement("afterend", toggle);
    }
    return doc.body.innerHTML;
  } catch (e) {
    console.warn("[PlanScreen] markGroup3ListFoldable failed", e);
    return html;
  }
}

// ── Restructure fallback copy ──
// These fall back strings are used until the corresponding fields exist on
// MYRA_MESSAGES.plan in GSA_MYRA_MESSAGES.js (see dev handoff §4e / guardrail
// on Myra copy living outside JSX). Flagged for the prompts project.
const PLAN_LEAD_IN_FALLBACK = "Alright, here is your plan.";
const PLAN_FEEDBACK_REPLY_LOOKS_GREAT_FALLBACK = "That is good to hear. Sign up and your first session is free, so you can try the plan and see how it feels.";
const PLAN_FEEDBACK_REPLY_CHANGE_IT_FALLBACK = "No problem. Sign up and I will work with you to adjust the plan until it fits you.";
const PLAN_FEEDBACK_REPLY_QUESTION_FALLBACK = "Of course. What can I answer for you?";

// ════════════════════════════════════════════════════════════════
// SCREEN 20: PLAN SCREEN
// Exercise plan display with QnA flow. Sign-up CTA.
// Fires dual gtag events, saveFullData, saveUserJourney.
// ════════════════════════════════════════════════════════════════
function PlanScreen({ assessmentData, updateAssessmentData, setCurrentStep, speakChatQueueRef, qaRef, onOpenQnA, pushToHistory, updateHistoryEntryData, showMyraMessage, scrollToBottom, showQuestionNuggetMessage, scrollToPreviousEcho, conversationHistory = [], speakChatTextIfVoice, logFrontendDisplayedChatEntry, getFrontendChatTurnNumber, chatInputRef, onAccessQuestionnaire }) {
  const [loadingScore, setLoadingScore] = useState(true);
  const [scoreData, setScoreData] = useState(null);
  const initRef = useRef(false);
  const planFlowStartedRef = useRef(false);
  const bubblesShownRef = useRef(false);
  const advancingRef = useRef(false);
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [imgFailed, setImgFailed] = useState(false);

  const history = useHistory();
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  console.log("assessment data is : ", assessmentData);
  const selectedTierRef = useRef(null);
  const activePromoRef = useRef(null);

  // ── Submit refs ──
  const submitQuestionnaireRef = useRef(null);
  const submitConsentRef = useRef(null);

  const activePlanPhaseRef = useRef(null);
  // Switches the live screen-timing entry from one plan phase to the next.
  // Exits whichever phase is currently open (writes its duration into
  // window.screenTracker) before opening the new one, so phases never overlap.
  const enterPlanPhase = useCallback((phaseNum) => {
    const screenName = `plan_phase${phaseNum}`;
    if (activePlanPhaseRef.current === screenName) return;
    if (activePlanPhaseRef.current) {
      window.screenTracker?.exitScreen(activePlanPhaseRef.current, { completed: true });
    }
    window.screenTracker?.enterScreen(screenName);
    activePlanPhaseRef.current = screenName;
    window.currentScreen = screenName;
  }, []);

  // 1 = Group 1 (foundation), 2 = Group 2 (plan card), 3 = Group 3 (sign-up)
  const [currentGroup, setCurrentGroup] = useState(1);
  const currentGroupRef = useRef(1);

  const [showAccessQuestionnaire, setShowAccessQuestionnaire] = useState(false);
  const [showConsentScreen, setShowConsentScreen] = useState(false);

  const [group2Visible, setGroup2Visible] = useState(false);
  const [group3Visible, setGroup3Visible] = useState(false);

  const [showRationale, setShowRationale] = useState({});
  const [showRead, setShowRead] = useState(false);
  const [isAligningAccess, setIsAligningAccess] = useState(false);
  const signupButtonRef = useRef(null);
  const planCardRef = useRef(null);
  window.notOpenQNA = true;

  // ── Restructure analytics (dev handoff §5) ──
  // id of the access-cta history entry currently visible, so the reaction
  // chips can hide it and re-anchor a fresh one below a new reply.
  const planCtaEntryIdRef = useRef(null);
  const planWhyOpenCountRef = useRef(0);
  const trackWhyOpened = useCallback(() => {
    planWhyOpenCountRef.current += 1;
    const updated = {
      ...assessmentData,
      plan_why_opened: true,
      plan_why_open_count: planWhyOpenCountRef.current,
    };
    updateAssessmentData(updated);
    if (AnalyticsService) AnalyticsService.trackStep(updated);
  }, [assessmentData, updateAssessmentData]);

  const planFeedbackCountRef = useRef(0);
  const trackFeedback = useCallback(
    (kind) => {
      planFeedbackCountRef.current += 1;
      const fieldByKind = { looks_great: "plan_feedback_looks_great", change_it: "plan_feedback_change_it", have_question: "plan_feedback_question" };
      const updated = {
        ...assessmentData,
        [fieldByKind[kind]]: true,
        plan_feedback_last: kind,
        plan_feedback_count: planFeedbackCountRef.current,
      };
      updateAssessmentData(updated);
      if (AnalyticsService) AnalyticsService.trackStep(updated);
    },
    [assessmentData, updateAssessmentData],
  );

  const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
  const userConditions = userCondition?.usercondition || {};

  // Keep currentGroupRef in sync
  useEffect(() => {
    currentGroupRef.current = currentGroup;
    window.current_group = currentGroupRef.current;
    updateAssessmentData({ _planCurrentGroup: `group_${currentGroup}` });
  }, [currentGroup]);
  useEffect(() => {
    const updatedData = {
      ...assessmentData,
      plan_phase1: true,
      completed_rom_screen: true,
      completed_speed_screen: true,
    };
    updateAssessmentData(updatedData);
    AnalyticsService.trackStep(updatedData);
  }, []);

  const effectiveAssessmentData = useMemo(() => ({ ...assessmentData, ...(scoreData || {}) }), [assessmentData, scoreData]);
  const planChatHistory = useMemo(() => buildDisplayedChatHistoryForPrompt(conversationHistory), [conversationHistory]);

  const plan = scoreData?.recoveryPlan || scoreData?.planDetails || assessmentData.recoveryPlan || assessmentData.planDetails || CONST.getDummyPlan(assessmentData.problemArea);
  const exercises = plan?.exercises || [];

  // ── Phase grouping helpers (unchanged from original) ──
  const estimatePhaseTime = (items, phaseLabel = "") => {
    if (!items || items.length === 0) return null;
    const isWarmup = phaseLabel.toLowerCase().includes("warm");
    const isCooldown = phaseLabel.toLowerCase().includes("cool");
    const ANNOUNCEMENT_PER_SET_SEC = 20;
    const START_COUNTDOWN_PER_SET_SEC = 5;
    const totalSec = items.reduce((sum, ex, idx) => {
      const sets = parseInt(ex.sets) || 1;
      const reps = parseInt(ex.reps) || 8;
      const hold = parseInt(ex.hold) || 0;
      const baseMovePerRep = isWarmup ? (hold > 0 ? 3 : 4) : isCooldown ? (hold > 0 ? 2 : 5) : hold > 0 ? 2 : 3;
      const repTime = baseMovePerRep + hold;
      const setTime = reps * repTime;
      const setOverhead = sets > 1 ? sets * (ANNOUNCEMENT_PER_SET_SEC + START_COUNTDOWN_PER_SET_SEC) : ANNOUNCEMENT_PER_SET_SEC + START_COUNTDOWN_PER_SET_SEC;
      const restBetweenSets = sets > 1 ? (sets - 1) * (isWarmup || isCooldown ? 10 : 20) : 0;
      const transitionAfter = idx < items.length - 1 ? 15 : 0;
      return sum + sets * setTime + setOverhead + restBetweenSets + transitionAfter;
    }, 0);
    const mins = Math.ceil(totalSec / 60);
    return mins < 1 ? "<1 min" : `~${mins} min`;
  };

  const groupExercisesByPhase = (exList) => {
    if (!exList || exList.length === 0) return [];
    const hasPurpose = exList.some((ex) => ex.purpose || ex.phase);
    if (hasPurpose) {
      const groups = { warmup: [], main: [], cooldown: [] };
      exList.forEach((ex) => {
        const p = (ex.purpose || ex.phase || "main").toLowerCase();
        if (p.includes("warm")) groups.warmup.push(ex);
        else if (p.includes("cool")) groups.cooldown.push(ex);
        else groups.main.push(ex);
      });
      const result = [];
      if (groups.warmup.length) result.push({ label: "Warm up", items: groups.warmup, duration: estimatePhaseTime(groups.warmup, "warm") });
      if (groups.main.length) result.push({ label: "Main work", items: groups.main, duration: estimatePhaseTime(groups.main, "main") });
      if (groups.cooldown.length) result.push({ label: "Cool down", items: groups.cooldown, duration: estimatePhaseTime(groups.cooldown, "cool") });
      return result;
    }
    if (exList.length === 1) return [{ label: "Main work", items: exList, duration: estimatePhaseTime(exList, "main") }];
    if (exList.length === 2)
      return [
        { label: "Warm up", items: [exList[0]], duration: estimatePhaseTime([exList[0]], "warm") },
        { label: "Main work", items: [exList[1]], duration: estimatePhaseTime([exList[1]], "main") },
      ];
    return [
      { label: "Warm up", items: [exList[0]], duration: estimatePhaseTime([exList[0]], "warm") },
      { label: "Main work", items: exList.slice(1, -1), duration: estimatePhaseTime(exList.slice(1, -1), "main") },
      { label: "Cool down", items: [exList[exList.length - 1]], duration: estimatePhaseTime([exList[exList.length - 1]], "cool") },
    ];
  };

  const getTotalTimeFromGroups = (exList) => {
    if (!exList || exList.length === 0) return "";
    const groups = groupExercisesByPhase(exList);
    if (!groups.length) return "";
    let totalMinutes = 0;
    groups.forEach((group) => {
      const d = String(group?.duration || "")
        .toLowerCase()
        .trim();
      if (!d) return;
      if (d.includes("<1")) {
        totalMinutes += 1;
        return;
      }
      const mins = parseInt(d.replace("~", "").split(" ")[0], 10) || 0;
      totalMinutes += mins;
    });
    if (totalMinutes <= 0) return "";
    return `${totalMinutes}-${totalMinutes + 2}`;
  };

  const estTotalTime = getTotalTimeFromGroups(exercises);
  const estTime = estTotalTime || scoreData?.estimatedTime || plan?.estimatedTime || "15-20";

  // ── API request (unchanged from original) ──
  const transformedRequest = useMemo(
    () => ({
      isAccessUser: window.is_access_user === true,
      painLocations: assessmentData?.selectedZones || [],
      cpgClassification: assessmentData?.cpgForBackend,
      ...(assessmentData?.subtypeQuestions && assessmentData?.selfAssessmentAnswer ? { subjectiveResponses: { q1: assessmentData?.subtypeQuestions?.value || "", q2a: assessmentData?.selfAssessmentAnswer || "" } } : {}),
      symptomDuration: assessmentData?.symptomDuration || assessmentData?.biometrics?.symptomDuration || "",
      analyticsId: assessmentData?.analyticsId || window.trSessionId || localStorage.getItem("trSessionId") || null,
      preTestNPRS: assessmentData?.painLevel || 0,
      probableSubtype: assessmentData?.probableSubtype || "",
      diagnosisChanged: assessmentData?.diagnosisChanged || false,
      degradation: assessmentData?.degradation ?? null,
      timing: assessmentData?.timing ?? null,
      signature: assessmentData?.signature || false,
      current_conditions: assessmentData?.biometrics?.currentConditions || userConditions?.current || "",
      pre_existing_conditions: assessmentData?.biometrics?.preExistingConditions || userConditions?.pre_existing || "",
      input_mode: MyraInteraction?.getMode?.() || "chat",
      romTest1: {
        testName: assessmentData?.testName || "",
        symptomaticResponse: assessmentData?.symptomResponse?.value || assessmentData?.symptomResponse1 || assessmentData?.symptomResponse || "",
        rpe: assessmentData?.rpe || 0,
        movementQuality: assessmentData?.romQuality || "",
        cvData: {
          rom: Array.isArray(assessmentData?.rom) ? assessmentData.rom : assessmentData?.rom != null ? [assessmentData.rom] : [],
          duration: Array.isArray(assessmentData?.duration) ? assessmentData.duration : assessmentData?.duration != null ? [assessmentData.duration] : [],
        },
      },
      ...(assessmentData?.testName2 && assessmentData?.symptomResponseConfirm ? { romTest2: { testName: assessmentData?.testName2, symptomaticResponse: assessmentData?.symptomResponseConfirm } } : {}),
      biometrics: assessmentData?.biometrics?.skipped
        ? { skipped: true }
        : {
            skipped: false,
            age: assessmentData?.biometrics?.age || assessmentData?.age || 60,
            activityLevel: assessmentData?.biometrics?.activityLevel || assessmentData?.activityLevel,
            heightFt: assessmentData?.biometrics?.heightFt || assessmentData?.heightFt,
            heightIn: assessmentData?.biometrics?.heightIn || assessmentData?.heightIn,
            weightLbs: assessmentData?.biometrics?.weightLbs || assessmentData?.weightLbs || assessmentData?.biometrics?.weight || assessmentData?.weight,
            floorCapability: assessmentData?.biometrics?.floorCapability || assessmentData?.floorCapability,
            balance: assessmentData?.biometrics?.balance || assessmentData?.balance || "steady",
            goal: assessmentData?.biometrics?.goals || assessmentData?.goals || "",
            sessionPref: assessmentData?.biometrics?.sessionPref || assessmentData?.sessionPref || "one",
            scheduleTime: assessmentData?.biometrics?.scheduleTime || assessmentData?.scheduleTime || "",
            scheduleDays: assessmentData?.biometrics?.scheduleDays || assessmentData?.scheduleDays || "",
            current_conditions: assessmentData?.biometrics?.currentConditions || assessmentData?.currentConditions || userConditions?.current || "",
            pre_existing_conditions: assessmentData?.biometrics?.preExistingConditions || assessmentData?.preExistingConditions || userConditions?.pre_existing || "",
            symptomDuration: assessmentData?.symptomDuration || assessmentData?.biometrics?.symptomDuration || "",
            input_mode: MyraInteraction?.getMode?.() || "chat",
          },
    }),
    [assessmentData, userConditions],
  );
  console.log("PLAN PAYLOAD IS : ", transformedRequest);

  // ── Fetch plan from API ──
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;
    async function calculateScore() {
      if (AnalyticsService) AnalyticsService.startSession();
      try {
        const result = await fetchWithRetry(CONST.SCORE_API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(transformedRequest),
        });
        console.log("api result is : ", result);
        console.log("api response is : ", result.response);
        console.log("api aiResponse is : ", result.aiResponse);
        console.log("api aiResponse from is : ", result.response.aiResponse);

        if (result.ok && result.response) {
          const apiResponse = result.response;
          const userProfile = apiResponse.userProfile || {};
          const recoveryPlan = apiResponse.recoveryPlan || {};
          const aiResponse = apiResponse?.aiResponse;
          const structuredData = {
            finalScore: userProfile.recoveryScore || 0,
            pillar1: userProfile.pillar1 || 0,
            pillar2: userProfile.pillar2 || 0,
            pillar3: userProfile.pillar3 || 0,
            pillar4: userProfile.pillar4 || 0,
            rcsCalculated: userProfile.rcsCalculated || 0,
            totalAdjustment: userProfile.totalAdjustment || 0,
            adjustmentDetails: userProfile.adjustmentDetails || {},
            level: userProfile.level || 1,
            finalPainSubtype: userProfile.finalPainSubtype || "",
            finalCpgClassification: userProfile.finalCpgClassification || "",
            planDetails: userProfile.planDetails || {},
            recoveryPlan: recoveryPlan,
            // New Group 1 and Group 3 bubble fields from API
            group1_bubble_1: recoveryPlan.group1_bubble_1 || apiResponse.group1_bubble_1 || PLAN_GROUP1_BUBBLE_1_FALLBACK,
            group1_bubble_2: recoveryPlan.group1_bubble_2 || apiResponse.group1_bubble_2 || PLAN_GROUP1_BUBBLE_2_FALLBACK,
            group2_closing: PLAN_GROUP2_CLOSING,
            group3_bubble_1: aiResponse?.group3_bubble_1 || result.aiResponse?.group3_bubble_1 || recoveryPlan.group3_bubble_1 || apiResponse.group3_bubble_1 || PLAN_GROUP3_BUBBLE_1_FALLBACK,
            group3_bubble_2: aiResponse?.group3_bubble_2 || result.aiResponse?.group3_bubble_2 || recoveryPlan.group3_bubble_2 || apiResponse.group3_bubble_2 || PLAN_GROUP3_BUBBLE_2_FALLBACK,
            pricing_bubble: PLAN_PRICING_BUBBLE,
            internal_rationale: recoveryPlan.internal_rationale || apiResponse.internal_rationale || null,
            recovery_timeline: recoveryPlan.recovery_timeline || apiResponse.recovery_timeline || null,
            // Legacy fallback
            planRationaleSpeech: recoveryPlan.rationale || recoveryPlan.plan_rationale || "",
            estimatedTime: recoveryPlan.estimatedTime || "10-12 min",
            aiLogId: `api-${Date.now()}`,
            aiLatencyMs: 0,
            planGeneratedAt: new Date().toISOString(),
            exerciseCandidatesCount: recoveryPlan.exercises?.length || 0,
            viewed_plan: true,
          };
          setScoreData(structuredData);
          updateAssessmentData({ ...assessmentData, ...structuredData });
          if (AnalyticsService) AnalyticsService.trackStep(updateAssessmentData);
          setLoadingScore(false);
        }
      } catch {
        const fallback = CONST.getDummyPlan(assessmentData.problemArea);
        setScoreData({
          finalScore: fallback.score,
          planDetails: fallback,
          rcsCalculated: true,
          planRationaleSpeech: "",
          group1_bubble_1: PLAN_GROUP1_BUBBLE_1_FALLBACK,
          group1_bubble_2: PLAN_GROUP1_BUBBLE_2_FALLBACK,
          group2_closing: PLAN_GROUP2_CLOSING,
          group3_bubble_1: PLAN_GROUP3_BUBBLE_1_FALLBACK,
          group3_bubble_2: PLAN_GROUP3_BUBBLE_2_FALLBACK,
          pricing_bubble: PLAN_PRICING_BUBBLE,
          internal_rationale: null,
          recovery_timeline: null,
          aiLogId: `fallback-${Date.now()}`,
          aiLatencyMs: 0,
          planGeneratedAt: new Date().toISOString(),
          exerciseCandidatesCount: fallback.exercises.length,
        });
        updateAssessmentData({ ...assessmentData, ...scoreData });
        setLoadingScore(false);
      }
    }
    calculateScore();
  }, []);

  // ── Show Group 1 bubbles via showMyraMessage once API data arrives ──
  // Runs exactly once. Restored to original behavior per request: Group 1
  // still renders into the chat, same as before. The "Why I built this
  // plan" chip/sheet added alongside this reads the same scoreData fields,
  // so the sheet just re-presents this same content on demand later.
  useEffect(() => {
    if (loadingScore || !scoreData) return;
    if (bubblesShownRef.current) return;
    bubblesShownRef.current = true;

    async function showGroup1Bubbles() {
      const bubble1 = scoreData.group1_bubble_1 || PLAN_GROUP1_BUBBLE_1_FALLBACK;
      const bubble2raw = scoreData.group1_bubble_2 || PLAN_GROUP1_BUBBLE_2_FALLBACK;
      const bubble2 = boldenContinueWord(breakBeforeContinueCta(bubble2raw));
      await showMyraMessage(bubble1, 300, "myra", true);
      if (isVoiceMode) speakChatTextIfVoice(bubble1);
      await showMyraMessage(bubble2, 500, "myra");
      if (isVoiceMode) speakChatTextIfVoice(bubble2);
    }
    showGroup1Bubbles();
  }, [loadingScore, scoreData, isVoiceMode, speakChatTextIfVoice]);

  // ── Analytics + voice flow start ──
  useEffect(() => {
    if (loadingScore || !scoreData || planFlowStartedRef.current) return;
    planFlowStartedRef.current = true;

    if (window.gtag) {
      console.log("GTAG-TRIGGERS FOR PLAN SIGNUP SCREEN");
      window.gtag("event", "conversion", {
        send_to: "AW-18002481001/Kf-vCLqv7YUcEOmeoIhD",
      });
    }
    MyraInteraction?.onScreenEnter?.("plan_screen");
    window.screenTracker?.enterScreen("plan_phase1");
    enterPlanPhase(1);
    window.initFromUserGesture?.();
    window.mayraCode?.setIsVisible(false);

    const payload = generatePayloadForScreen("plan_screen", {
      ...effectiveAssessmentData,
      _planCurrentGroup: currentGroupRef.current ? `group_${currentGroupRef.current}` : "group_1",
      _planChatHistory: planChatHistory,
    });
    VoiceService?.sendMidJourneyData?.(payload);
    VoiceService?.setQnAData?.({
      userProfile: effectiveAssessmentData.biometrics,
      currentPlan: effectiveAssessmentData.planDetails,
      planRationale: effectiveAssessmentData.planRationaleSpeech,
      sessionId: window.trSessionId,
    });
    VoiceService._currentFlow = "flow_plan_v2";
    window.currentFlow = "flow_plan_v2";
    window.mayraCode?.startFlow?.("flow_plan_v2");

    // Persist bubble + rationale data so QNA prompt can read them
    updateAssessmentData({
      group1_bubble_1: scoreData.group1_bubble_1 || PLAN_GROUP1_BUBBLE_1_FALLBACK,
      group1_bubble_2: scoreData.group1_bubble_2 || PLAN_GROUP1_BUBBLE_2_FALLBACK,
      group2_closing: scoreData.group2_closing || PLAN_GROUP2_CLOSING,
      group3_bubble_1: scoreData.group3_bubble_1 || PLAN_GROUP3_BUBBLE_1_FALLBACK,
      group3_bubble_2: scoreData.group3_bubble_2 || PLAN_GROUP3_BUBBLE_2_FALLBACK,
      pricing_bubble: scoreData.pricing_bubble || PLAN_PRICING_BUBBLE,
      internal_rationale: scoreData.internal_rationale,
      recovery_timeline: scoreData.recovery_timeline,
    });

    if (AnalyticsService?.saveFullData) {
      try {
        const sanitized = { ...effectiveAssessmentData };
        if (sanitized.planRationaleSpeech) sanitized.planRationaleSpeech = sanitized.planRationaleSpeech.substring(0, 5000);
        const encoded = utf8ToBase64(JSON.stringify(sanitized));
        AnalyticsService.saveFullData(encoded);
      } catch (e) {
        console.error("saveFullData failed", e);
      }
    }
    saveUserJourney(effectiveAssessmentData);

    return () => {
      if (activePlanPhaseRef.current) {
        window.screenTracker?.exitScreen(activePlanPhaseRef.current, { exitReason: "plan_viewed" });
        activePlanPhaseRef.current = null;
      }
    };
  }, [loadingScore, scoreData]);
  const fetchActivePromo = useCallback(async () => {
    try {
      const res = await fetch(CONST.GET_PROMO);
      if (!res.ok) return null;
      const json = await res.json();
      const data = json?.responseData || {};
      const { tier, discount_percentage, expires } = data;

      if (!tier || !discount_percentage || !expires) return null;

      const discountPercent = parseFloat(discount_percentage);
      if (!Number.isFinite(discountPercent) || discountPercent <= 0) return null;

      const expiresDate = new Date(expires);
      const todayStart = new Date(new Date().toDateString());
      if (Number.isNaN(expiresDate.getTime()) || expiresDate < todayStart) return null;

      return {
        tier, // "weekly" | "four" | "eight" | "all"
        discountPercent,
        appliesToFutureWeeks: true,
        expiresAt: expires,
      };
    } catch (err) {
      console.error("[PlanScreen] Failed to fetch active promo:", err);
      return null;
    }
  }, []);
  // plan phase3 reached in view updating the plan_phase3 to true
  const phase3ReachedTrackedRef = useRef(false);
  const trackReachedPhase3 = useCallback(() => {
    enterPlanPhase(3);
    if (phase3ReachedTrackedRef.current) return;
    phase3ReachedTrackedRef.current = true;

    const updatedData3 = {
      ...assessmentData,
      plan_phase3: true,
      _planCurrentGroup: `group_${currentGroupRef.current}`,
    };
    updateAssessmentData(updatedData3);
    if (AnalyticsService) AnalyticsService.trackStep(updatedData3);
  }, [assessmentData, updateAssessmentData]);

  // ── revealGroup2 — plan card + reaction chips. Factored out of
  // handleAdvanceGroup so the ACCESS questionnaire bridge can call it again
  // after submit, since that path `return`s out of handleAdvanceGroup
  // before this normally runs. The Group 2 closing line ("If you have any
  // questions...") is intentionally no longer pushed on this screen — see
  // dev handoff §2. Copy itself is untouched; PLAN_GROUP2_CLOSING stays
  // imported/available for any other caller of this function.
  const revealGroup2 = useCallback(async () => {
    window.plangroup2 = true;
    if (chatInputRef?.current) {
      chatInputRef.current.blur();
    }
    if (window._planPendingUserEcho) {
      pushToHistory({ type: "user", text: window._planPendingUserEcho, id: nextId() });
      window._planPendingUserEcho = null;
    }
    const planCardEntry = {
      type: "plan-card",
      id: nextId(),
      data: {
        exercises,
        estTime,
        phases: groupExercisesByPhase(exercises),
        whyBubble1: scoreData?.group1_bubble_1 || PLAN_GROUP1_BUBBLE_1_FALLBACK,
        whyBubble2: scoreData?.group1_bubble_2 || PLAN_GROUP1_BUBBLE_2_FALLBACK,
        onWhyOpen: trackWhyOpened,
      },
    };
    pushToHistory(planCardEntry);
    // Normal (non-ACCESS) users should not see the Looks great / Change it /
    // I have a question reaction chips on the recovery plan — only ACCESS
    // users get this intermediate feedback step before the sign-up CTA.
    if (window.is_access_user === true) {
      pushToHistory({
        type: "plan-reaction",
        id: nextId(),
        data: {
          pushToHistory,
          showMyraMessage,
          updateHistoryEntryData,
          isVoiceMode,
          speakChatTextIfVoice,
          trackFeedback,
          ctaEntryIdRef: planCtaEntryIdRef,
          ctaOnSignUp: window.is_access_user === true ? handleAccessConsentGate : handleSignUp,
          onReachedPhase3: trackReachedPhase3,
          replies: {
            looks_great: MYRA_MESSAGES.plan?.feedbackLooksGreat || PLAN_FEEDBACK_REPLY_LOOKS_GREAT_FALLBACK,
            change_it: MYRA_MESSAGES.plan?.feedbackChangeIt || PLAN_FEEDBACK_REPLY_CHANGE_IT_FALLBACK,
            have_question: MYRA_MESSAGES.plan?.feedbackQuestion || PLAN_FEEDBACK_REPLY_QUESTION_FALLBACK,
          },
        },
      });
    }
    const updatedData = {
      ...assessmentData,
      plan_phase2: true,
      _planCurrentGroup: `group_${currentGroupRef.current}`,
    };
    updateAssessmentData(updatedData);
    AnalyticsService.trackStep(updatedData);
  }, [scoreData, showMyraMessage, updateAssessmentData, isVoiceMode, speakChatTextIfVoice, exercises, estTime, assessmentData, pushToHistory, chatInputRef, updateHistoryEntryData, trackWhyOpened, trackFeedback, trackReachedPhase3]);

  const handleAccessConsentGate = useCallback(() => {
    window.__activeAccessPayloadStep = "consent";
    window._accessSignupLocked = true;
    setShowConsentScreen(true);
    setTimeout(() => scrollToBottom?.("smooth"), 150);
  }, [scrollToBottom]);

  // ── revealGroup3 — bubbles + pricing card. Also factored out so the
  // questionnaire-resume path can call it alongside revealGroup2.
  const revealGroup3 = useCallback(async () => {
    window.plangroup3 = true;
    const bubble1 = scoreData?.group3_bubble_1?.replace(/<ul>|<\/ul>|<li>|<\/li>/g, "") || PLAN_GROUP3_BUBBLE_1_FALLBACK;
    const rawBubble2 = scoreData?.group3_bubble_2 || PLAN_GROUP3_BUBBLE_2_FALLBACK;
    const bubble2 = markGroup3ListFoldable(removeTheLastBulletFromGroup3(rawBubble2, "Staying consistent pays off"));
    // remove the last bullet from the bubble2 for speech
    const bubble2ForSpeech = removeTheLastBulletFromGroup3(rawBubble2, "Staying consistent pays off");
    await showMyraMessage(bubble1, 400);
    if (isVoiceMode) speakChatTextIfVoice(bubble1);
    await showMyraMessage(bubble2, 400);
    if (isVoiceMode) speakChatTextIfVoice(bubble2ForSpeech);

    // ACCESS users don't have pricing tiers or promos — Medicare covers the
    // cost per the alignment consent already collected — so skip the
    // pricing intro bubble and tiers card entirely and just show the
    // single free-session signup CTA.
    // const isAccessUser = localStorage.getItem("accessUser") === "1";
    const ctaEntry = {
      type: "access-cta",
      id: nextId(),
      data: {
        onSignUp: window.is_access_user === true ? handleAccessConsentGate : handleSignUp,
        onReachedPhase3: trackReachedPhase3,
      },
    };
    pushToHistory(ctaEntry);
    planCtaEntryIdRef.current = ctaEntry.id;

    // const pricingIntro = scoreData?.pricing_intro || PLAN_PRICING_INTRO_FALLBACK;
    // await showMyraMessage(pricingIntro, 400);
    // if (isVoiceMode) speakChatTextIfVoice(pricingIntro);
    // const activePromo = await fetchActivePromo();
    // activePromoRef.current = activePromo || PLAN_PRICING_PROMO_FALLBACK;

    // pushToHistory({
    //   type: "pricing-card",
    //   id: nextId(),
    //   data: {
    //     tiers: scoreData?.pricing_tiers || PLAN_PRICING_TIERS_FALLBACK,
    //     promo: activePromo || PLAN_PRICING_PROMO_FALLBACK,
    //     onSignUp: handleSignUp,
    //     onTierSelect: (tierId) => {
    //       selectedTierRef.current = tierId;
    //     },
    //     assessmentData,
    //     updateAssessmentData,
    //     onReachedPhase3: trackReachedPhase3,
    //   },
    // });
  }, [scoreData, showMyraMessage, isVoiceMode, speakChatTextIfVoice, fetchActivePromo, pushToHistory, assessmentData, updateAssessmentData, trackReachedPhase3]);

  // ── Called by the inline ACCESS questionnaire once the user submits ──
  // const handleQuestionnaireComplete = useCallback(
  //   async (submittedQuestionnaireData) => {
  //     setShowAccessQuestionnaire(false);
  //     if (submittedQuestionnaireData) {
  //       pushToHistory({
  //         type: "frozen-widget",
  //         widgetType: "questionnaire_summary",
  //         id: nextId(),
  //         data: submittedQuestionnaireData,
  //       });
  //     }
  //     await revealGroup2();
  //     await revealGroup3();
  //   },
  //   [revealGroup2, revealGroup3, pushToHistory],
  // );
  const handleQuestionnaireComplete = useCallback(
    async (submittedQuestionnaireData) => {
      setShowAccessQuestionnaire(false);
      if (submittedQuestionnaireData) {
        pushToHistory({
          type: "frozen-widget",
          widgetType: "questionnaire_summary",
          id: nextId(),
          data: submittedQuestionnaireData,
        });
      }
      // While the UI overlays are open, `currentStep` can still be `plan`.
      // This marker lets the chat/payload builder send the correct
      // questionnaire/consent payloads.
      window.__activeAccessPayloadStep = "consent";
      setShowConsentScreen(true);
      setTimeout(() => scrollToBottom?.("smooth"), 150);
    },
    [pushToHistory, scrollToBottom],
  );
  const ACCESS_DIAGNOSIS_BY_AREA = {
    LBP: { code: "M54.59", display: "Other low back pain" },
    HIP: { code: "M25.559", display: "Pain in unspecified hip" },
    THIGH: { code: "M79.659", display: "Pain in unspecified thigh" },
    KNEE: { code: "M25.569", display: "Pain in unspecified knee" },
  };

  const handleConsentComplete = useCallback(
    async (consentGranted) => {
      setShowConsentScreen(false);
      window.__activeAccessPayloadStep = null;
      const consentFields = {
        accessAlignmentConsent: consentGranted,
        accessAlignmentConsentAt: new Date().toISOString(),
      };
      updateAssessmentData(consentFields);
      try {
        const existingStored = JSON.parse(localStorage.getItem("assessmentData") || "{}");
        localStorage.setItem("assessmentData", JSON.stringify({ ...existingStored, ...assessmentData, ...consentFields }));
      } catch (e) {
        console.warn("[PlanScreen] Failed to persist consent fields to localStorage", e);
      }
      if (AnalyticsService) {
        AnalyticsService.trackStep({ ...assessmentData, ...consentFields, session_last_update: new Date().toISOString() });
      }
      const consentSummaryId = nextId();
      pushToHistory({ type: "user", text: consentGranted ? "I agree — enroll me." : "Not right now.", id: nextId() }, { type: "frozen-widget", widgetType: "consent_summary", id: consentSummaryId, data: { consentGranted, problemArea: assessmentData?.problemArea } });

      // ── Fire the enrollment alignment call right here, regardless of
      // consentGranted. No auth token exists yet at this point (Register/
      // Verify haven't happened) so this goes out without an Authorization
      // header. Not awaited — it shouldn't block the sign-up transition.
      // The body is also cached to localStorage so Settings can reuse the
      // exact same payload for the later baseline-reporting call.
      if (window.is_access_user === true) {
        setIsAligningAccess(true);
        // Clear any stale result from a previous attempt so Settings never
        // reads a leftover flag from an earlier run of this screen.
        localStorage.removeItem("accessAlignmentError");
        localStorage.removeItem("accessEnrollmentAlignmentCompleted");
        try {
          const accessPreferences = JSON.parse(localStorage.getItem("virdio_lbp_preferences") || "null");
          const accessConsentEvidence = JSON.parse(localStorage.getItem("virdio_access_alignment_consent") || "null");
          const diagnosis = ACCESS_DIAGNOSIS_BY_AREA[assessmentData?.problemArea];

          // Same pre-flight guard the old Settings-screen call used (minus
          // userData/token — no session exists yet at this point).
          if (!accessPreferences?.mbi || !diagnosis || accessConsentEvidence?.decision !== "granted") {
            throw new Error("We could not complete Medicare ACCESS enrollment. Please try again.");
          }

          const mbiWithoutDashes = String(accessPreferences?.mbi || "")
            .replace(/[^0-9A-Z]/gi, "")
            .toUpperCase();

          const alignmentRequestBody = {
            insuranceCode: mbiWithoutDashes,
            firstName: accessPreferences?.firstName,
            lastName: accessPreferences?.lastName,
            birthDate: accessPreferences ? `${accessPreferences.dobY}-${String(accessPreferences.dobM).padStart(2, "0")}-${String(accessPreferences.dobD).padStart(2, "0")}` : null,
            gender: accessPreferences?.sex,
            track: "MSK",
            variant: new URLSearchParams(window.location.search).get("variant") || localStorage.getItem("variant") || null,
            eligibilityLinkToken: accessPreferences?.eligibilityLinkToken || null,
            isProviderReferral: false,
            switchConsentAttestation: accessPreferences?.switchConsentAttestation === true,
            switchConsentEvidence: accessPreferences?.switchConsentEvidence || null,
            consentEvidence: accessConsentEvidence,
            conditionValidationMethod: "clinical-assessment-by-participant",
            assessmentSessionId: assessmentData?.analyticsId || window.trSessionId || localStorage.getItem("trSessionId") || null,
            conditionClassification: {
              cpg: assessmentData?.finalCpgClassification || assessmentData?.cpgForBackend || assessmentData?.cpgValue || null,
              subtype: assessmentData?.finalPainSubtype || assessmentData?.probableSubtype || assessmentData?.subtype || null,
              side: assessmentData?.side || null,
              problemArea: assessmentData?.problemArea || null,
            },
            conditions: diagnosis
              ? [
                  {
                    resourceType: "Condition",
                    clinicalStatus: { coding: [{ system: "http://terminology.hl7.org/CodeSystem/condition-clinical", code: "active" }] },
                    verificationStatus: { coding: [{ system: "http://terminology.hl7.org/CodeSystem/condition-ver-status", code: "confirmed" }] },
                    category: [{ coding: [{ system: "http://terminology.hl7.org/CodeSystem/condition-category", code: "problem-list-item" }] }],
                    code: { coding: [{ system: "http://hl7.org/fhir/sid/icd-10-cm", code: diagnosis.code, display: diagnosis.display }] },
                  },
                ]
              : [],
          };
          localStorage.setItem("accessAlignmentRequestBody", JSON.stringify(alignmentRequestBody));

          const alignmentResponse = await fetch(CONST.ACCESS_ALIGNMENT_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(alignmentRequestBody),
          });
          const alignmentBody = await alignmentResponse.json();
          const alignmentData = alignmentBody?.responseData || alignmentBody;
          const alignmentCode = alignmentData?.code || alignmentData?.resultAction?.code;
          if (alignmentResponse.ok && ["aligned", "aligned-switch-approved"].includes(alignmentCode)) {
            localStorage.setItem("accessEnrollmentAlignmentCompleted", "1");
          } else {
            throw new Error(alignmentBody?.errorData?.message || alignmentBody?.responseMessage || "Medicare ACCESS enrollment could not be completed.");
            // CMS: already aligned to another participant — show API display text, do not advance.
            // updateHistoryEntryData?.(consentSummaryId, { alignmentError: alignmentBody?.display || alignmentBody?.responseMessage || "Medicare ACCESS enrollment could not be completed." });
            // return;
          }
        } catch (e) {
          console.warn("[PlanScreen] Alignment request failed", e);
          localStorage.setItem("accessAlignmentError", e?.message || "We could not complete Medicare ACCESS enrollment. Please try again.");
          // don't advance the group, show the error message
          // updateHistoryEntryData?.(consentSummaryId, { alignmentError: e?.message || "We could not complete Medicare ACCESS enrollment. Please try again." });
          // return;
        } finally {
          setIsAligningAccess(false);
        }
      }

      handleSignUp();
    },
    [assessmentData, updateAssessmentData, pushToHistory, updateHistoryEntryData, revealGroup2, revealGroup3],
  );
  // ── handleAdvanceGroup — moves from Group 1→2 or Group 2→3 ──
  // Called ONLY from window.currentCommandsAudio when backend returns
  // intent: "advance_group". Never called automatically.
  const handleAdvanceGroup = useCallback(
    async (source) => {
      if (showAccessQuestionnaire) {
        submitQuestionnaireRef.current?.handleSubmit?.();
        return;
      }
      if (showConsentScreen) {
        submitConsentRef.current?.handleSubmit?.();
        return;
      }
      if (advancingRef.current) {
        console.log("[PLAN] advance_group ignored");
        return;
      }

      advancingRef.current = true;

      setTimeout(() => {
        advancingRef.current = false;
      }, 3000);
      const grp = currentGroupRef.current;
      // continue to sign up on group 2
      if (grp >= 2) {
        if (window.is_access_user === true) {
          handleAccessConsentGate();
          return;
        }
        handleSignUp();
        return;
      }

      const nextGrp = grp + 1;
      setCurrentGroup(nextGrp);
      enterPlanPhase(nextGrp);
      currentGroupRef.current = nextGrp;
      window.current_group = nextGrp;
      updateAssessmentData({ _planCurrentGroup: `group_${nextGrp}` });

      if (nextGrp === 2) {
        await revealGroup2();
      }

      if (nextGrp === 2 || nextGrp === 3) {
        await revealGroup3();
      }
    },
    [scoreData, showMyraMessage, updateAssessmentData, logFrontendDisplayedChatEntry, getFrontendChatTurnNumber, isVoiceMode, speakChatTextIfVoice, exercises, estTime, assessmentData, pushToHistory, fetchActivePromo, chatInputRef, trackReachedPhase3, revealGroup2, revealGroup3, showAccessQuestionnaire, showConsentScreen],
  );

  const handleAdvanceGroupWithAck = useCallback(async () => {
    if (showAccessQuestionnaire) {
      submitQuestionnaireRef.current?.handleSubmit?.();
      return;
    }
    if (showConsentScreen) {
      submitConsentRef.current?.handleSubmit?.();
      return;
    }
    const ack = getPlanAdvanceAck(currentGroupRef.current);
    if (currentGroupRef.current < 2) {
      await showMyraMessage(ack, 300);
      if (isVoiceMode) speakChatTextIfVoice(ack);
    }
    // blur focus on group 2 (recovery plan card)
    if (currentGroupRef.current === 2 && chatInputRef?.current) {
      chatInputRef.current.blur();
    }
    await handleAdvanceGroup();
  }, [handleAdvanceGroup, showMyraMessage, showAccessQuestionnaire, showConsentScreen]);

  // ── Register advance_group in window.currentCommandsAudio ──
  // This is how the backend signal reaches the UI.
  // When user types "continue", backend returns intent: "advance_group"
  // which fires window.currentCommandsAudio["advance_group"]
  useEffect(() => {
    if (loadingScore || !scoreData) return;

    window.currentCommandsAudio = {
      advance_group: () => {
        if (window.exitHandlerOpen) return;
        handleAdvanceGroupWithAck();
      },
      ANSWER_QNA_QUESTION: (value, speech, intent) => {
        if (window.exitHandlerOpen) return;
        if (intent === "advance_group") {
          handleAdvanceGroup();
          return;
        }
        if (intent === "signup_request") {
          handleAdvanceGroup();
          return;
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (window.exitHandlerOpen) return;
        if (intent === "advance_group") {
          handleAdvanceGroup();
          return;
        }
        if (intent === "signup_request") {
          handleAdvanceGroup();
          return;
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        handleAdvanceGroupWithAck();
        return;
      },
      SIGN_UP: () => {
        if (window.exitHandlerOpen) return;
        // setTimeout(() => handleSignUp(), 3000);
        handleAdvanceGroupWithAck();
        return;
      },
    };
  }, [loadingScore, scoreData, handleAdvanceGroup, handleAdvanceGroupWithAck]);

  // ── useScreenVoice (same commands) ──
  useScreenVoice({
    screenName: "plan_screen",
    flowName: "flow_plan_v2",
    payloadKey: "plan_screen",
    assessmentData: { ...effectiveAssessmentData, _planChatHistory: planChatHistory },
    exitReason: "sign-up",
    commands: {
      advance_group: () => {
        if (window.exitHandlerOpen) return;
        handleAdvanceGroupWithAck();
      },
      ANSWER_QNA_QUESTION: (value, speech, intent) => {
        if (window.exitHandlerOpen) return;
        if (intent === "advance_group") {
          handleAdvanceGroup();
          return;
        }
        if (intent === "signup_request") {
          handleAdvanceGroup();
          return;
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (window.exitHandlerOpen) return;
        if (intent === "advance_group") {
          handleAdvanceGroup();
          return;
        }
        if (intent === "signup_request") {
          handleAdvanceGroup();
          return;
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        handleAdvanceGroupWithAck();
        return;
      },
      SIGN_UP: () => {
        if (window.exitHandlerOpen) return;
        // setTimeout(() => handleSignUp(), 3000);
        handleAdvanceGroupWithAck();
        return;
      },
    },
  });

  // ── Screen tracking ──
  useEffect(() => {
    if (!loadingScore && scoreData) {
      enterPlanPhase(1);
    }
    return () => {
      if (activePlanPhaseRef.current) {
        window.screenTracker?.exitScreen(activePlanPhaseRef.current, { completed: true, exitReason: "plan_screen_completed" });
        activePlanPhaseRef.current = null;
      }
    };
  }, [loadingScore, scoreData, enterPlanPhase]);

  // ── Sign-up ──
  const utf8ToBase64 = (str) => {
    try {
      const utf8Bytes = new TextEncoder().encode(str);
      let bin = "";
      utf8Bytes.forEach((b) => {
        bin += String.fromCharCode(b);
      });
      return btoa(bin);
    } catch {
      return btoa(str.replace(/[^\x00-\x7F]/g, ""));
    }
  };

  const latestAssessmentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");
  const finalGSADuration = window.timeTracker?.getGSADuration?.();
  const updatedAssessmentData = {
    ...latestAssessmentData,
    ...assessmentData,
    exercises,
    final_conversion_type: "signup",
    gsaDurationSec: finalGSADuration,
    viewed_plan: true,
    completed_assessment: true,
    session_last_update: new Date().toISOString(),
  };
  function computePricingFieldsFromRefs() {
    const tiers = scoreData?.pricing_tiers || PLAN_PRICING_TIERS_FALLBACK;
    const tierId = selectedTierRef.current || null;
    if (!tierId) return {};

    const promo = activePromoRef.current;
    const appliedPromo = promo && (promo.tier === "all" || promo.tier === tierId) ? promo : null;
    const productId = tierId === "weekly" ? "2" : tierId === "four" ? "3" : tierId === "eight" ? "1" : null;

    return {
      selectedPricingTier: tierId,
      subscriptionPlan: tierId,
      productId,
      selectedPricingPromo: appliedPromo
        ? {
            tier: appliedPromo.tier,
            discountPercentage: appliedPromo.discountPercent,
            appliesToFutureWeeks: !!appliedPromo.appliesToFutureWeeks,
            expiresAt: appliedPromo.expiresAt || null,
          }
        : null,
      discountPercentage: appliedPromo?.discountPercent,
    };
  }

  async function handleSignUp(overrideFields = {}) {
    window.__suppressNativeUnloadWarning = false;
    if (isSigningUp) return;

    // Stop voice activity and release microphone before redirecting to registration.
    if (isVoiceMode && VoiceService) {
      VoiceService.stopAllVoiceActivity?.();
      VoiceService._releaseMic?.();
      VoiceService.forceStop?.();
      VoiceService._awaitingPcmFinish = true;
      VoiceService._startListeningInProgress = true;
      VoiceService._pendingDoSayCallback = null;
    }
    // clear the speak chat queue
    if (isVoiceMode && speakChatQueueRef?.current?.length > 0) {
      speakChatQueueRef.current.length = 0;
    }
    const pricingFields = { ...computePricingFieldsFromRefs(), ...overrideFields };
    const freshStoredAssessmentData = (() => {
      try {
        return JSON.parse(localStorage.getItem("assessmentData") || "{}");
      } catch (e) {
        return {};
      }
    })();
    const mergedAssessmentData = { ...freshStoredAssessmentData, ...assessmentData, ...pricingFields };
    localStorage.setItem("assessmentData2", JSON.stringify(mergedAssessmentData));
    localStorage.setItem("assessmentData2", JSON.stringify(mergedAssessmentData));
    updateAssessmentData(pricingFields);
    setIsSigningUp(true);
    const resetTimer = setTimeout(() => {
      setIsSigningUp(false);
    }, 5000);

    if (window.gtag) window.gtag("event", "conversion", { send_to: "AW-18002481001/mZpjCLO7gYYcEOmeoIhD" });
    if (AnalyticsService) {
      try {
        await new Promise((resolve) => {
          AnalyticsService.trackStep({ ...updatedAssessmentData, signup_started: true, session_last_update: new Date().toISOString() }, resolve);
          setTimeout(resolve, 2000);
        });
      } catch (err) {
        console.error("trackStep before redirect failed:", err);
      }
    }
    await saveUserJourney(updatedAssessmentData);
    localStorage.removeItem("accessUser");
    history.push("/register");
    // var subDomain = "live";
    // if (window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com" && window.location.host !== "virdiohealth.com" && window.location.host !== "www.virdiohealth.com") {
    //   subDomain = "uat";
    // }
    // window.location.replace("https://" + subDomain + ".virdiohealth.com/register?self-assessment=true&fromsite=" + window.location.host + "&data=" + window.trSessionId);
  }

  function toggleRationale(index) {
    setShowRationale((prev) => ({ ...prev, [index]: !prev[index] }));
  }

  // ── Loading state ──
  if (loadingScore || !scoreData) {
    return (
      <div data-chat-myra-screen-content="true" data-chat-loading="true" className={styles.inlineUi}>
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <div className={styles.aiProcessingSpinner} />
          <p style={{ fontWeight: 600, marginTop: 16, color: "#1f2937" }}>Building your recovery plan</p>
          <p style={{ color: "#6b7280", fontSize: "14px", marginTop: 4 }}>This may take a moment…</p>
        </div>
      </div>
    );
  }

  // ── Render ──
  // Group 1 bubbles are in conversationHistory via showMyraMessage above.
  // This component only renders the inline widgets for Group 2 and Group 3.
  return (
    <>
      {showAccessQuestionnaire && <QuestionnaireScreen submitQuestionnaireRef={submitQuestionnaireRef} assessmentData={assessmentData} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onSubmitComplete={handleQuestionnaireComplete} speakChatTextIfVoice={speakChatTextIfVoice} />}
      {showConsentScreen && <ConsentScreen submitConsentRef={submitConsentRef} assessmentData={assessmentData} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onConsentComplete={handleConsentComplete} speakChatTextIfVoice={speakChatTextIfVoice} />}
      {isAligningAccess && (
        <div data-chat-myra-screen-content="true" data-chat-loading="true" className={styles.inlineUi}>
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div className={styles.aiProcessingSpinner} />
          </div>
        </div>
      )}
      {/* ══════════════════════════════════════════════════════ */}
      {/* GROUP 2 — Exercise Plan Card                           */}
      {/* Visible only after backend signals advance_group       */}
      {/* ══════════════════════════════════════════════════════ */}
      {group2Visible && (
        <div className={styles.inlineUi} ref={planCardRef}>
          <div className={styles.planCardV2}>
            <div className={styles.planCardHeader}>
              <h2 className={styles.planCardTitle}>Your starting plan</h2>
              <div className={styles.planCardStats}>
                <span className={styles.planStatPill}>{exercises.length} exercises</span>
                <span className={styles.planStatDot} />
                <span>~{estTime} min</span>
                <span className={styles.planStatDot} />
                <span>3× per week</span>
              </div>
            </div>

            {groupExercisesByPhase(exercises).map((group, gIdx) => (
              <div className={styles.phaseGroup} key={gIdx}>
                <div className={styles.phaseLabel}>
                  <span className={styles.phaseNum}>{gIdx + 1}</span>
                  <span>{group.label}</span>
                  {group.duration && <span className={styles.phaseDuration}>~{group.duration}</span>}
                </div>
                {group.items.map((ex, i) => {
                  const sideLabel = ex.performance_side ? ` — ${ex.performance_side} Leg` : "";
                  const holdText = ex.hold ? ` | ${ex.hold}s hold` : "";
                  const hasValidImage = typeof ex.image === "string" && ex.image.trim().length > 0 && !imgFailed;
                  const exerciseIndex = exercises.indexOf(ex);
                  return (
                    <React.Fragment key={i}>
                      <div className={styles.exerciseRowV2}>
                        <div className={styles.exThumbV2} style={{ backgroundColor: hasValidImage ? "transparent" : "#e2e8f0" }}>
                          {hasValidImage ? <img src={ex.image} alt={ex.name} className={styles.exerciseThumbnailImage} onError={() => setImgFailed(true)} /> : <span className={styles.exerciseThumbnailLabel}>{ex.name.substring(0, 2).toUpperCase()}</span>}
                        </div>
                        <div className={styles.exInfoV2}>
                          <div className={styles.exNameV2}>
                            {ex.name}
                            {sideLabel}
                          </div>
                          <div className={styles.exDoseV2}>
                            {ex.sets} Sets of {ex.reps} Reps{holdText}
                          </div>
                        </div>
                        <button className={styles.exInfoBtnV2} onClick={() => toggleRationale(exerciseIndex)} aria-label="Why this exercise?">
                          i
                        </button>
                      </div>
                      {showRationale[exerciseIndex] && (
                        <div className={styles.planExRationale}>
                          <p>
                            <strong>Why it helps:</strong> {ex.rationale}
                          </p>
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            ))}

            <div
              style={{
                marginTop: 12,
                padding: "10 5",
                borderTop: "1px solid #f1f5f9",
                fontSize: 13,
                color: "#6b7280",
              }}
            >
              Your plan has floor &amp; standing exercises. If you need any adjustments, let me know.
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════ */}
      {/* GROUP 3 — Sign-up CTA chip                             */}
      {/* Coaching + offer bubbles go via showMyraMessage above  */}
      {/* Only the CTA chip is rendered as an inline widget here */}
      {/* ══════════════════════════════════════════════════════ */}
      {group3Visible && (
        <div>
          <button style={{ background: "#0d9488", color: "white" }} ref={signupButtonRef} onClick={handleSignUp} disabled={isSigningUp} className={styles.introCtaBtn}>
            Start my recovery with Myra
          </button>
        </div>
      )}

      {/* Read transcript overlay (legacy fallback) */}
      {showRead && (
        <div className={styles.overlay}>
          <div className={styles.overlayCard}>
            <button className={styles.overlayClose} onClick={() => setShowRead(false)} aria-label="Close">
              ×
            </button>
            <h3 className={styles.overlayTitle}>Myra's analysis</h3>
            <div className={styles.transcript}>
              {(scoreData?.planRationaleSpeech || "").split(/\n+/).map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
            <button className={styles.overlayCtaSingle} onClick={handleSignUp}>
              Sign Up — It's Free
            </button>
          </div>
        </div>
      )}
    </>
  );
}

let _journeySaveChain = Promise.resolve();

function saveUserJourney(assessmentData) {
  // Serialize every save (per-event AND the 5s interval) through one chain so
  // the server receives snapshots strictly in order. Combined with the events
  // merge below, each snapshot is a superset of the previous one, so the blind
  // `SET journey_data = ?` on the server can only ever grow the row.
  _journeySaveChain = _journeySaveChain.then(() => _doSaveUserJourney(assessmentData));
  return _journeySaveChain.catch((e) => console.error("[saveUserJourney] save failed", e));
}

function _doSaveUserJourney(assessmentData) {
  const screenFlow = window.screenTracker?.getScreenFlow() || [];
  const arEntry1 = screenFlow.find((s) => s.screen === "movement_test_1");
  const arEntry2 = screenFlow.find((s) => s.screen === "movement_test_2");

  // Always merge with the latest localStorage snapshot so periodic saves
  // (fired every 5s from the interval) carry the most recent state even when
  // the React state hasn't re-rendered yet.
  const latestStored = (() => {
    try {
      return JSON.parse(localStorage.getItem("assessmentData") || "{}");
    } catch {
      return {};
    }
  })();

  // Event arrays are append-only accumulators that trackFlutterEvent writes
  // straight to localStorage; React state lags behind. Never let a stale
  // snapshot shrink them — keep whichever array is longer.
  const pickEvents = (a, b) => ((a?.length || 0) >= (b?.length || 0) ? a : b) || [];
  const data = { ...latestStored, ...assessmentData };
  data.test1Events = pickEvents(latestStored.test1Events, assessmentData.test1Events);
  data.test2Events = pickEvents(latestStored.test2Events, assessmentData.test2Events);

  const sessionId = window.trSessionId || data?.analyticsId || data?.session_id;
  if (!sessionId) {
    console.warn("[saveUserJourney] No sessionId — skipping save");
    return;
  }

  const payload = {
    session_id: sessionId,
    analyticsId: sessionId,
    saved_at: new Date().toISOString(),
    screen_flow: screenFlow,
    myra_engagement: {
      landing: {
        engaged: window.myraEngagedLanding || data?.myraEngagedLanding || false,
        messageCount: window.landingMessageCount || data?.myraConversationCount || 0,
        topic: window.landingTopic || null,
      },
      gsa: {
        engaged: window.myraEngagedGsa || false,
        messageCount: window.gsaMessageCount || 0,
        topic: window.flowGsaTopic || null,
      },
      post_plan: {
        engaged: window.myraEngagedPlanV2 || false,
        messageCount: window.planV2MessageCount || 0,
        topic: window.planV2Topic || null,
      },
    },
    test1: {
      videoWatched: data.test1VideoWatched,
      videoDuration: data.test1VideoDuration,
      arDuration: arEntry1?.duration || null,
      rom: data.rom,
      symptomResponse: data.symptomResponse,
      testEvents: data.test1Events || [],
    },
    test2: {
      videoWatched: data.test2VideoWatched,
      videoDuration: data.test2VideoDuration,
      arDuration: arEntry2?.duration || null,
      rom: data.rom2,
      symptomResponse: data.symptomResponseConfirm,
      testEvents: data.test2Events || [],
    },
    plan: {
      aiLogId: data.aiLogId,
      latencyMs: data.aiLatencyMs,
    },
  };

  console.log("[saveUserJourney] Saving journey snapshot:", {
    sessionId,
    saved_at: payload.saved_at,
    screenCount: screenFlow.length,
    lastScreen: screenFlow[screenFlow.length - 1]?.screen || "none",
    test1EventCount: payload.test1.testEvents.length,
    test2EventCount: payload.test2.testEvents.length,
  });

  return fetch(CONST.JOURNEY_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ journeyData: payload }),
  });
}

// function saveUserJourney(assessmentData) {
//   const screenFlow = window.screenTracker?.getScreenFlow() || [];
//   const arEntry1 = screenFlow.find((s) => s.screen === "movement_test_1");
//   const arEntry2 = screenFlow.find((s) => s.screen === "movement_test_2");
//   // Always merge with the latest localStorage snapshot so periodic
//   // saves (fired every 5s from the interval) carry the most recent state
//   // even when the React state hasn't re-rendered yet.
//   const latestStored = (() => {
//     try {
//       return JSON.parse(localStorage.getItem("assessmentData") || "{}");
//     } catch {
//       return {};
//     }
//   })();
//   const data = { ...latestStored, ...assessmentData };
//   const sessionId = window.trSessionId || data?.analyticsId || data?.session_id;
//   if (!sessionId) {
//     console.warn("[saveUserJourney] No sessionId — skipping save");
//     return;
//   }

//   const payload = {
//     session_id: sessionId,
//     analyticsId: sessionId,
//     saved_at: new Date().toISOString(),
//     screen_flow: screenFlow,
//     myra_engagement: {
//       landing: {
//         engaged: window.myraEngagedLanding || assessmentData?.myraEngagedLanding || false,
//         messageCount: window.landingMessageCount || assessmentData?.myraConversationCount || 0,
//         topic: window.landingTopic || null,
//       },
//       gsa: {
//         engaged: window.myraEngagedGsa || false,
//         messageCount: window.gsaMessageCount || 0,
//         topic: window.flowGsaTopic || null,
//       },
//       post_plan: {
//         engaged: window.myraEngagedPlanV2 || false,
//         messageCount: window.planV2MessageCount || 0,
//         topic: window.planV2Topic || null,
//       },
//     },
//     test1: {
//       videoWatched: assessmentData.test1VideoWatched,
//       videoDuration: assessmentData.test1VideoDuration,
//       arDuration: arEntry1?.duration || null,
//       rom: assessmentData.rom,
//       symptomResponse: assessmentData.symptomResponse,
//       testEvents: assessmentData.test1Events || [],
//     },
//     test2: {
//       videoWatched: assessmentData.test2VideoWatched,
//       videoDuration: assessmentData.test2VideoDuration,
//       arDuration: arEntry2?.duration || null,
//       rom: assessmentData.rom2,
//       symptomResponse: assessmentData.symptomResponseConfirm,
//       testEvents: assessmentData.test2Events || [],
//     },
//     plan: {
//       aiLogId: assessmentData.aiLogId,
//       latencyMs: assessmentData.aiLatencyMs,
//     },
//   };

//   console.log("[saveUserJourney] Saving journey snapshot:", {
//     sessionId,
//     saved_at: payload.saved_at,
//     screenCount: screenFlow.length,
//     lastScreen: screenFlow[screenFlow.length - 1]?.screen || "none",
//   });

//   fetch(CONST.JOURNEY_API_URL, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ journeyData: payload }),
//   }).catch(() => {});
// }

// ════════════════════════════════════════════════════════════════
// CROSS-CUTTING: EXIT HANDLER
// Context-aware exit overlay with structured reason capture.
// Myra-routed reasons open QnA overlay with deterministic message.
// ════════════════════════════════════════════════════════════════

function ExitHandler({ currentStep, assessmentData, onClose, onOpenQnA }) {
  const [showLeaving, setShowLeaving] = useState(false);
  const [showPainReferral, setShowPainReferral] = useState(false);
  const [showModePicker, setShowModePicker] = useState(false);
  const [pendingReason, setPendingReason] = useState(null);
  const [feedback, setFeedback] = useState("");

  // Set exit handler flag
  useEffect(() => {
    window.exitHandlerOpen = true;
    return () => {
      window.exitHandlerOpen = false;
    };
  }, []);

  // Determine context
  function getContext() {
    const step = currentStep || "";
    if (step.includes("personalize")) return "personalize";
    if (step.includes("movement_test") || step.includes("self_report") || step.includes("test1_demo") || step.includes("test2_demo") || step.includes("camera") || step.includes("rpe") || step.includes("feel_affect") || step.includes("feedback2")) return "movement_test";
    return "gsa";
  }

  const ctx = getContext();
  const config = CONST.EXIT_CONFIGS[ctx];

  function handleTile(reason) {
    if (reason === "leave") {
      setShowLeaving(true);
      return;
    }

    if (reason === "pain") {
      setShowPainReferral(true);
      // Analytics
      if (AnalyticsService) {
        AnalyticsService.trackStep({
          ...assessmentData,
          event_name: "exit_gsa",
          exitReason: reason || "want_to_leave",
          exitStep: currentStep,
          context_type: ctx,
          outcome: "PAIN_REFERRAL",
          comm_mode: MyraInteraction?.getCurrentMode?.() || "button",
          timestamp: new Date().toISOString(),
          screenFlow: window.screenTracker?.getScreenFlow() || [],
        });
      }
      return;
    }

    // Myra-routed: check if communication mode is selected
    const currentMode = MyraInteraction?.getCurrentMode?.();
    if (!currentMode) {
      setPendingReason(reason);
      setShowModePicker(true);
      return;
    }

    routeToMyra(reason);
  }

  async function routeToMyra(reason, mode = "chat") {
    const msg = CONST.EXIT_MYRA_MESSAGES[reason];
    const tileTitle = config.tiles.find((t) => t.reason === reason)?.title || reason;
    const flowToStart = window.currentFlow || VoiceService._currentFlow;
    window.audioPlayer?.ttsPcmAbort?.();
    if (window?.videoController) {
      window?.videoController?.pause();
    }

    // Analytics
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        ...assessmentData,
        exitReason: reason || "want_to_leave",
        exitStep: currentStep,
        context_type: ctx,
        outcome: "MYRA_CHAT",
        comm_mode: MyraInteraction?.getCurrentMode?.() || "button",
        timestamp: new Date().toISOString(),
        screenFlow: window.screenTracker?.getScreenFlow() || [],
      });
    }
    if (mode === "voice") {
      const granted = await window.requestMicrophonePermission({
        onGrant: () => {
          if (VoiceService._flowReady) {
            VoiceService._speakAllowed = true;
            VoiceService.startFlowWithoutAnnouncement(flowToStart, "", msg);
          } else {
            VoiceService._speakAllowed = true;
            VoiceService.startFlowWithoutAnnouncement(flowToStart, "", msg);
            VoiceService._ws.send(JSON.stringify({ type: "say", text: msg }));
          }
        },
        onDeny: () => {
          MyraInteraction.switchMode("chat");
          onOpenQnA(tileTitle, msg, "exit_" + reason);
        },
      });
    } else if (mode === "chat") {
      onOpenQnA(tileTitle, msg, "exit_" + reason);
    }
    onClose();
  }

  function handleModeSelected(mode) {
    MyraInteraction?.switchMode?.(mode);
    setShowModePicker(false);
    if (pendingReason) {
      routeToMyra(pendingReason, mode);
    }
  }

  async function confirmExit() {
    window.__suppressNativeUnloadWarning = false;
    // Analytics
    let tracked = false;
    if (AnalyticsService) {
      for (let i = 0; i < 3; i++) {
        try {
          // eslint-disable-next-line no-loop-func
          await new Promise((resolve, reject) => {
            AnalyticsService.trackStep(
              {
                ...assessmentData,
                event_name: "exit_gsa",
                exitReason: "want_to_leave",
                exitStep: currentStep,
                context_type: ctx,
                outcome: "EXIT",
                feedback: feedback.trim() || null,
                comm_mode: MyraInteraction?.getCurrentMode?.() || "button",
                timestamp: new Date().toISOString(),
                screenFlow: window.screenTracker?.getScreenFlow() || [],
              },
              () => {
                tracked = true;
                resolve();
              },
            );

            // Failsafe timeout
            setTimeout(() => {
              reject(new Error("trackStep timeout"));
            }, 3000);
          });

          if (tracked) {
            break;
          }
        } catch (err) {
          console.error(`trackStep retry ${i + 1} failed`, err);
        }

        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }

    const sessionid = window.trSessionId || localStorage.getItem("trSessionId");
    // Goodbye message
    const goodbye = MYRA_MESSAGES.exit?.confirmExitGoodbye || "Thanks for giving the assessment a try. If you ever want to come back, I'll be here. Take care.";
    VoiceService?.doSay(goodbye);
 
    // Full cleanup
    window.audioPlayer?.ttsPcmAbort?.();
    window.mayraCode?.forceStop();
    window.mayraCode?.setIsVisible(false);
    window.destroyOwnedResources?.();
    window.destroyFlutterResources?.();
    window.exitHandlerOpen = false;
    localStorage.setItem("loadAfterReloadAutoHome", "1");
    localStorage.removeItem("trSessionId");
    localStorage.removeItem("assessmentData");
    localStorage.removeItem("userCondition");
    window.trSessionId = null;

    onClose();

    // reload page with dev team skipped
    setTimeout(() => {
      if (tracked || sessionid.startsWith("dev-team-skipped")) {
        window.location.href = "/?gsa=v2";
      }
    }, 1500);
  }

  if (!config) return null;

  // Determine which sub-screen to show
  let content;

  if (showModePicker) {
    content = (
      <>
        <h2 className={styles.exitHeading}>Choose How to Chat with Myra</h2>
        <p className={styles.exitSubheading}>Pick your preferred way to communicate before we connect you.</p>
        <div className={styles.modeSelectOptions}>
          <button className={styles.modeSelectBtn} onClick={() => handleModeSelected("voice")}>
            <span className={styles.modeSelectIcon}>🎤</span>
            <div>
              <span className={styles.modeSelectLabel}>Talk</span>
              <span className={styles.modeSelectDesc}>Voice — recommended</span>
            </div>
          </button>
          <button className={styles.modeSelectBtn} onClick={() => handleModeSelected("chat")}>
            <span className={styles.modeSelectIcon}>💬</span>
            <div>
              <span className={styles.modeSelectLabel}>Chat</span>
              <span className={styles.modeSelectDesc}>Type your responses</span>
            </div>
          </button>
          <button className={styles.modeSelectBtn} onClick={() => handleModeSelected("button")}>
            <span className={styles.modeSelectIcon}>👆</span>
            <div>
              <span className={styles.modeSelectLabel}>Tap Responses</span>
              <span className={styles.modeSelectDesc}>Use on-screen buttons</span>
            </div>
          </button>
        </div>
        <button
          className={styles.ehBack}
          onClick={() => {
            setShowModePicker(false);
            setPendingReason(null);
          }}
        >
          Go back
        </button>
      </>
    );
  } else if (showPainReferral) {
    content = (
      <>
        <div style={{ textAlign: "center", fontSize: "32px", marginBottom: 8 }}>🩺</div>
        <h2 className={styles.exitHeading}>We Recommend Seeing a Provider</h2>
        <p className={styles.exitSubheading} style={{ textAlign: "left" }}>
          If you're experiencing increased pain, we'd strongly recommend consulting with a healthcare provider before continuing. They can evaluate your symptoms and let you know when it's safe to proceed with an exercise program.
        </p>
        <p className={styles.exitSubheading} style={{ textAlign: "left", marginBottom: 16 }}>
          You can always come back and restart the assessment when you're ready.
        </p>
        <button
          className={styles.btnSafe}
          onClick={() => {
            window.location.href = "/";
          }}
          style={{ width: "100%" }}
        >
          Find a Provider
        </button>
        <button className={styles.ehBack} onClick={() => setShowPainReferral(false)}>
          Go back
        </button>
      </>
    );
  } else if (showLeaving) {
    content = (
      <>
        <h2 className={styles.ehLeavingHeading}>Before you go</h2>
        <p className={styles.ehLeavingSub}>Your progress won't be saved, but you can restart anytime.</p>
        <textarea className={styles.ehFeedbackArea} placeholder="Any feedback on how we can improve? (optional)" value={feedback} onChange={(e) => setFeedback(e.target.value)} />
        <button className={styles.ehExitBtn} onClick={confirmExit}>
          Exit to landing page
        </button>
        <button
          className={styles.ehBack}
          onClick={() => {
            setShowLeaving(false);
          }}
        >
          Stay here
        </button>
      </>
    );
  } else {
    content = (
      <>
        <h2 className={styles.exitHeading}>{config.heading}</h2>
        <p className={styles.exitSubheading}>{config.subheading}</p>
        {config.tiles.map((tile) => (
          <div key={tile.reason} className={styles.ehTile} onClick={() => handleTile(tile.reason)}>
            <div className={styles.ehTileTitle}>{tile.title}</div>
            <div className={styles.ehTileDesc}>{tile.desc}</div>
          </div>
        ))}
        <button className={styles.ehBack} onClick={onClose}>
          I changed my mind — take me back
        </button>
      </>
    );
  }

  return (
    <div
      className={styles.exitOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.exitCard}>
        <div className={styles.exitCardInner}>{content}</div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
// FLUTTER MESSAGE RESOLVER BRIDGE
// Flutter calls window.getMessage({ path, mode, flow, test, vars })
// via callNative("getMessage", { ... }) to fetch any string from
// MYRA_MESSAGES.js.
//
// Handles all three node shapes documented in MYRA_MESSAGES.js:
//   Shape 1 — plain string (mode/flow ignored)
//   Shape 2 — { voice, chat }
//   Shape 3 — { app: {voice, chat}, gsa: { test1: {voice, chat}, test2: {...} } }
//
// Resolver order for Shape 3 (gsa flow):
//   gsa[test][mode] → gsa.test1[mode] → app[mode]
// Empty string at any level falls through to the next candidate.
//
// {var} substitution is delegated to resolveMessage from GSA_MYRA_MESSAGES.js
// so this bridge stays consistent with the rest of the React-side callers.
//
// Returns "" on any miss — Dart side has per-call-site fallback strings.
// ─────────────────────────────────────────────────────────────
window.getMessage = (args) => {
  let requestId = null;
  let path = null;
  try {
    console.log("[getMessage] ENTER", typeof args);
    const params = typeof args === "string" ? JSON.parse(args) : args;
    console.log("[getMessage] parsed params:", params);

    requestId = params?.requestId; // Flutter passes this in for push-back
    const { path: p, mode = "voice", flow = "app", test = "test1", vars = {} } = params || {};
    path = p;

    if (!path) {
      console.warn("[getMessage] no path in params");
      deliverResult(requestId, "");
      return "";
    }

    console.log("[getMessage] MYRA_MESSAGES typeof:", typeof MYRA_MESSAGES, "isObject:", MYRA_MESSAGES != null && typeof MYRA_MESSAGES === "object");

    // 1. Walk dot-delimited path through MYRA_MESSAGES.
    let node = MYRA_MESSAGES;
    for (const part of path.split(".")) {
      if (node == null || typeof node !== "object") {
        console.warn("[getMessage] path walk failed at part:", part, "path:", path);
        deliverResult(requestId, "");
        return "";
      }
      node = node[part];
    }
    if (node == null) {
      console.warn("[getMessage] node null after walk:", path);
      deliverResult(requestId, "");
      return "";
    }

    console.log("[getMessage] node found:", typeof node, node && typeof node === "object" ? Object.keys(node) : node);

    // 2. Resolve by shape.
    let template = "";
    if (typeof node === "string") {
      template = node;
    } else if (node.voice !== undefined || node.chat !== undefined) {
      // Shape 2 — voice/chat split.
      template = node[mode] || node.voice || node.chat || "";
    } else if (node.app !== undefined || node.gsa !== undefined) {
      // Shape 3 — full flow split.
      const candidates = flow === "gsa" ? [node.gsa?.[test]?.[mode], node.gsa?.test1?.[mode], node.app?.[mode]] : [node.app?.[mode]];
      template = candidates.find((s) => s != null && s !== "") || "";
    } else {
      console.warn("[getMessage] node has no recognised shape:", Object.keys(node));
      deliverResult(requestId, "");
      return "";
    }

    if (!template) {
      console.warn("[getMessage] template empty after shape resolution for", path);
      deliverResult(requestId, "");
      return "";
    }

    // 3. Delegate {var} substitution to the existing helper.
    const out = resolveMessage(template, vars || {});
    console.log("[getMessage] RESOLVED", path, "→", String(out).slice(0, 80), "(id=" + requestId + ")");
    deliverResult(requestId, out);
    return out; // legacy return — kept for direct-from-console debugging
  } catch (e) {
    console.error("[getMessage] error resolving", args, e);
    deliverResult(requestId, "");
    return "";
  }
};

// Helper — pushes the resolved value back to Flutter.
// No-op if no requestId or deliverMessages not registered.
function deliverResult(requestId, value) {
  if (requestId == null) {
    console.warn("[getMessage] deliverResult: no requestId, skipping push");
    return;
  }
  if (typeof window.deliverMessages !== "function") {
    console.warn("[getMessage] deliverResult: window.deliverMessages not registered (id=" + requestId + ")");
    return;
  }
  try {
    const payload = JSON.stringify({ requestId, value: value || "" });
    console.log("[getMessage] deliverResult: pushing id=" + requestId + " length=" + (value || "").length);
    window.deliverMessages(payload);
  } catch (e) {
    console.error("[getMessage] deliverResult error", e);
  }
}

window.startedInApp = (value) => {
  console.log("window.startedInApp called with value:", value, " (type:", typeof value, ")");
  if (value == "true") {
    window.inApp = true;
  } else {
    window.inApp = false;
  }

  console.log("window.startedInApp set to:", value, " (type:", typeof value, ")", "window.inApp is now:", window.inApp, " (type:", typeof window.inApp, ")");
};

// ─────────────────────────────────────────────────────────────
// FLUTTER ANALYTICS BRIDGE
// Flutter calls window.flutterAnalytics.trackEvent(name, params)
// via TunnelWeb.dart using tn.callNative("trackEvent", {...})
// ─────────────────────────────────────────────────────────────
window.trackFlutterEvent = (eventData) => {
  console.log("_trackEvent", eventData);

  if (!eventData) {
    console.warn("trackFlutterEvent: eventData is required.");
    return;
  }

  let eventInfo;

  try {
    eventInfo = typeof eventData === "string" ? JSON.parse(eventData) : eventData;
  } catch (error) {
    console.warn("trackFlutterEvent: invalid eventData JSON.", eventData, error);
    return;
  }

  if (!eventInfo || typeof eventInfo !== "object") {
    console.warn("trackFlutterEvent: eventData must be an object.");
    return;
  }

  const eventName = eventInfo.event_name;

  if (!eventName) {
    console.warn("trackFlutterEvent: event_name is required.", eventInfo);
    return;
  }

  const latestAssessmentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");

  const eventTimestamp = new Date().toISOString();

  const eventPayload = {
    ...eventInfo,
    event_timestamp: eventTimestamp,
  };

  const runStep = localStorage.getItem("runStep");

  const eventKey = runStep === "2" ? "test2Events" : "test1Events";

  const existingEvents = Array.isArray(latestAssessmentData[eventKey]) ? latestAssessmentData[eventKey] : [];

  const updatedAssessmentData = {
    ...latestAssessmentData,
    session_last_update: eventTimestamp,
    [eventKey]: [...existingEvents, [eventName, eventPayload]],
  };

  saveUserJourney(updatedAssessmentData);

  localStorage.setItem("assessmentData", JSON.stringify(updatedAssessmentData));

  if (window.updateAssessmentDataGlobal) {
    window.updateAssessmentDataGlobal(updatedAssessmentData);
  }
};

window.flutterAnalyticsBridgeReady = true;

// ════════════════════════════════════════════════════════════════
// CROSS-CUTTING: INACTIVITY MODAL
// Triggered by AUTO_PAUSE command from backend.
// Resume or exit options.
// ════════════════════════════════════════════════════════════════

function InactivityModal({ onResume, onExit }) {
  return (
    <div
      className={styles.exitOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onResume();
      }}
    >
      <div className={styles.exitCard}>
        <div className={styles.exitCardInner} style={{ textAlign: "center" }}>
          <h2 className={styles.exitHeading}>Still there?</h2>
          <p className={styles.exitSubheading}>Take your time — I've paused the assessment. When you're ready, just tap below to continue.</p>
          <button className={styles.btnSafe} onClick={onResume} style={{ width: "100%", marginTop: 12 }}>
            I'm ready — let's continue
          </button>
          <button className={styles.ehBack} onClick={onExit}>
            I want to exit
          </button>
        </div>
      </div>
    </div>
  );
}
